(function () {
  if (window.__coveoHeadlessSearchPageInstalled) return;
  window.__coveoHeadlessSearchPageInstalled = true;
  window.__coveoHeadlessSearchPageBuildRevision =
    "20260802-commerce-transport-v1";
  if (typeof window !== "undefined" && window.__coveoClientOnlyDistanceFilter == null) {
    window.__coveoClientOnlyDistanceFilter = false;
  }
  const COMMERCE_ESM =
    "https://static.cloud.coveo.com/shopify/v1/headless/commerce.esm.js";
  const SEARCH_PAGE_RESULTS_PER_PAGE = 32;
  const COVEO_PRODUCT_NAVIGATION_PENDING_TIMEOUT_MS = 1500;

  function replaceCoveoHistoryUrl(nextHref) {
    const historyRuntime = window.MarineMaxCoveoSearchHistory;
    if (typeof historyRuntime?.replaceUrl === "function") {
      return historyRuntime.replaceUrl(nextHref);
    }
    try {
      const currentState = window.history.state;
      const nextState =
        currentState &&
        typeof currentState === "object" &&
        !Array.isArray(currentState)
          ? Object.assign({}, currentState)
          : {};
      window.history.replaceState(nextState, "", nextHref);
      return true;
    } catch (_) {
      return false;
    }
  }

  function clearCoveoProductNavigationPending() {
    try {
      if (window.__coveoProductNavigationPendingTimer) {
        clearTimeout(window.__coveoProductNavigationPendingTimer);
      }
      window.__coveoProductNavigationPendingTimer = 0;
      window.__coveoProductNavigationPendingUntil = 0;
      window.__coveoProductNavigationPending = false;
      window.__coveoProductNavigationHref = "";
    } catch (_) { }
  }

  function setCoveoProductNavigationPending(href) {
    try {
      const timeoutMs = Math.max(
        400,
        Number(COVEO_PRODUCT_NAVIGATION_PENDING_TIMEOUT_MS) || 1500,
      );
      if (window.__coveoProductNavigationPendingTimer) {
        clearTimeout(window.__coveoProductNavigationPendingTimer);
      }
      window.__coveoProductNavigationPending = true;
      window.__coveoProductNavigationHref = String(href || "");
      window.__coveoProductNavigationPendingUntil = Date.now() + timeoutMs;
      window.__coveoProductNavigationPendingTimer = window.setTimeout(
        function () {
          if (document.visibilityState === "visible") {
            clearCoveoProductNavigationPending();
          }
        },
        timeoutMs + 50,
      );
    } catch (_) { }
  }

  function isCoveoProductNavigationPendingActive() {
    try {
      if (!window.__coveoProductNavigationPending) {
        return false;
      }
      const until = Number(window.__coveoProductNavigationPendingUntil || 0);
      if (until > 0 && until <= Date.now() && document.visibilityState === "visible") {
        clearCoveoProductNavigationPending();
        return false;
      }
      return true;
    } catch (_) {
      return false;
    }
  }

  function shouldTrackCoveoProductNavigationPending(event, anchor) {
    if (!anchor || !anchor.getAttribute) return false;
    if (event?.defaultPrevented) return false;
    const target = String(anchor.getAttribute("target") || "").trim().toLowerCase();
    if (target && target !== "_self") return false;
    if (anchor.hasAttribute("download")) return false;
    if (event?.metaKey || event?.ctrlKey || event?.shiftKey || event?.altKey) {
      return false;
    }
    if (typeof event?.button === "number" && event.button !== 0) return false;
    return true;
  }

  function wireCoveoProductNavigationPendingReset() {
    if (window.__coveoProductNavigationPendingResetWired) return;
    window.__coveoProductNavigationPendingResetWired = true;
    const clearIfVisible = function () {
      if (document.visibilityState === "visible") {
        clearCoveoProductNavigationPending();
      }
    };
    window.addEventListener("pageshow", function () {
      window.setTimeout(clearIfVisible, 0);
    });
    window.addEventListener("focus", clearIfVisible);
    window.addEventListener("popstate", clearIfVisible);
    document.addEventListener("visibilitychange", clearIfVisible);
  }

  function resolveSearchBaseUrl() {
    const raw = window.FoxTheme?.routes?.search_url;
    if (raw && typeof raw === "string") {
      try {
        const u = new URL(raw, window.location.origin);
        return `${u.origin}${u.pathname}`;
      } catch (_) { }
    }
    return `${window.location.origin}/search`;
  }

  function buildSearchResultsUrl(query) {
    try {
      const url = new URL(resolveSearchBaseUrl(), window.location.origin);
      const trimmed = String(query || "").trim();
      if (trimmed) {
        url.searchParams.set("q", trimmed);
      }
      url.searchParams.set("type", "product");
      return url.toString();
    } catch (_) {
      const fallback = "/search";
      const trimmed = String(query || "").trim();
      return trimmed
        ? `${fallback}?q=${encodeURIComponent(trimmed)}&type=product`
        : `${fallback}?type=product`;
    }
  }

  const coveoFacetSchema = window.MarineMaxCoveoFacetSchema;
  const REQUIRED_COVEO_FACET_SCHEMA_FUNCTIONS = [
    "conditionValuesRepresentAll",
    "ensureCanonicalConditionFacetValues",
    "ensureConditionFacetPresence",
    "facetIdsMatchAvailability",
    "facetIdsMatchBoatType",
    "facetIdsMatchCondition",
    "facetIdsMatchEngineType",
    "facetIdsMatchLength",
    "facetIdsMatchMake",
    "facetIdsMatchModel",
    "facetIdsMatchPrice",
    "facetIdsMatchPromotions",
    "facetIdsMatchYear",
    "facetItemNumericBounds",
    "facetItemNumericValue",
    "facetItemRawValue",
    "facetUsesPagedBoatOptionsUi",
    "getCanonicalConditionOptionLabel",
    "getCoveoCanonicalFacetIdForFriendlyUrlKey",
    "getCoveoFriendlyUrlFacetKey",
    "getFacetDisplayLabel",
    "isCoveoFriendlyUrlRangeKey",
    "isNumericalRangeFacet",
    "normalizeFacetStateValues",
    "numericalRangeUiKind",
    "shouldSuppressFacetValue",
    "shouldUseRangeFacetUi",
    "sortConditionFacetValues",
  ];
  const missingCoveoFacetSchemaFunctions =
    REQUIRED_COVEO_FACET_SCHEMA_FUNCTIONS.filter(function (name) {
      return typeof coveoFacetSchema?.[name] !== "function";
    });
  if (
    missingCoveoFacetSchemaFunctions.length > 0 ||
    typeof coveoFacetSchema?.COVEO_CONDITION_ALL_LABEL !== "string" ||
    !Array.isArray(coveoFacetSchema?.COVEO_CONDITION_OPTION_LABELS)
  ) {
    throw new Error(
      "[Coveo Facets] Missing or invalid headless-search-page-facet-schema.js",
    );
  }
  const {
    COVEO_CONDITION_ALL_LABEL,
    COVEO_CONDITION_OPTION_LABELS,
    conditionValuesRepresentAll,
    ensureCanonicalConditionFacetValues,
    ensureConditionFacetPresence,
    facetIdsMatchAvailability,
    facetIdsMatchBoatType,
    facetIdsMatchCondition,
    facetIdsMatchEngineType,
    facetIdsMatchLength,
    facetIdsMatchMake,
    facetIdsMatchModel,
    facetIdsMatchPrice,
    facetIdsMatchPromotions,
    facetIdsMatchYear,
    facetItemNumericBounds,
    facetItemNumericValue,
    facetItemRawValue,
    facetUsesPagedBoatOptionsUi,
    getCanonicalConditionOptionLabel,
    getCoveoCanonicalFacetIdForFriendlyUrlKey,
    getCoveoFriendlyUrlFacetKey,
    getFacetDisplayLabel,
    isCoveoFriendlyUrlRangeKey,
    isNumericalRangeFacet,
    normalizeFacetStateValues,
    numericalRangeUiKind,
    shouldSuppressFacetValue,
    shouldUseRangeFacetUi,
    sortConditionFacetValues,
  } = coveoFacetSchema;

  const createCoveoFilterUrlState =
    window.MarineMaxCoveoFilterUrlState?.create;
  if (typeof createCoveoFilterUrlState !== "function") {
    throw new Error(
      "[Coveo Filter URL State] Missing headless-search-page-filter-url-state.js",
    );
  }
  const coveoFilterUrlState = createCoveoFilterUrlState({
    conditionValuesRepresentAll,
    defaultConditionValues: COVEO_CONDITION_OPTION_LABELS,
    facetIdsMatchCondition,
    getCanonicalConditionOptionLabel,
    getCoveoCanonicalFacetIdForFriendlyUrlKey,
    getCoveoFriendlyUrlFacetKey,
    getCurrentHref() {
      return window.location.href;
    },
    getOrigin() {
      return window.location.origin;
    },
    isCoveoFriendlyUrlRangeKey,
    isSupportedSort(value) {
      return Object.prototype.hasOwnProperty.call(SORT_DEFINITIONS, value);
    },
    replaceUrl(nextHref) {
      replaceCoveoHistoryUrl(nextHref);
    },
  });
  const {
    COVEO_URL_LEGACY_FACET_PREFIX,
    COVEO_URL_LEGACY_PARAM_PAGE,
    COVEO_URL_LEGACY_PARAM_SORT,
    COVEO_URL_LEGACY_RANGE_PREFIX,
    COVEO_URL_PARAM_PAGE,
    COVEO_URL_PARAM_SORT,
    formatCoveoUrlRangeValue,
    getCoveoUrlStateLookupKeys,
    hasCoveoUrlState,
    isInternalCoveoUrlFacet,
    isManagedCoveoUrlParamKey,
    normalizeCoveoUrlFacetId,
    parseCoveoUrlRangeValue,
    readCoveoUrlState,
    readInitialCoveoUrlState,
    syncCoveoStateToUrl: syncCoveoUrlStateSnapshot,
  } = coveoFilterUrlState;

  const createCoveoFilterHydration =
    window.MarineMaxCoveoFilterHydration?.create;
  if (typeof createCoveoFilterHydration !== "function") {
    throw new Error(
      "[Coveo Filter Hydration] Missing headless-search-page-filter-hydration.js",
    );
  }
  const COVEO_FILTER_HYDRATION_WINDOW_KEYS = Object.freeze({
    inFlight: "__coveoPendingUrlHydrationInFlight",
    meta: "__coveoPendingUrlHydrationMeta",
    pendingState: "__coveoPendingInitialUrlState",
    primaryRequestPatched:
      "__coveoPendingUrlFiltersAppliedToPrimaryRequest",
    promise: "__coveoPendingUrlHydrationPromise",
    revision: "__coveoPendingUrlHydrationRevision",
  });
  const coveoFilterHydration = createCoveoFilterHydration({
    facetIdsMatchMake,
    facetIdsMatchModel,
    getCoveoCanonicalFacetIdForFriendlyUrlKey,
    getCoveoUrlStateLookupKeys,
    isInternalCoveoUrlFacet,
    normalizeCoveoUrlFacetId,
    setTimeout(callback, delay) {
      return window.setTimeout(callback, delay);
    },
    statePort: {
      read(key) {
        const windowKey = COVEO_FILTER_HYDRATION_WINDOW_KEYS[key];
        return windowKey ? window[windowKey] : undefined;
      },
      write(key, value) {
        const windowKey = COVEO_FILTER_HYDRATION_WINDOW_KEYS[key];
        if (windowKey) window[windowKey] = value;
      },
    },
    warn() {
      console.warn.apply(console, arguments);
    },
  });
  const {
    beginHydrationLease: beginPendingInitialCoveoUrlHydration,
    buildDesiredFacetSelectionSnapshot:
      buildDesiredPendingInitialCoveoFacetSelectionSnapshot,
    facetRangesEqual: areCoveoFacetRangesEqual,
    facetValueSetsEqual: areCoveoFacetValueSetsEqual,
    getFacetPriority: getCoveoPendingUrlHydrationFacetPriority,
    getPendingRegularFacetEntries:
      getPendingInitialCoveoRegularFacetEntries,
    getPendingState: getPendingInitialCoveoUrlState,
    primePendingState: primePendingInitialCoveoHydrationState,
    recordPrimaryRequestPatch: recordPendingInitialCoveoPrimaryRequestPatch,
    resolvePendingFacetRange: resolvePendingInitialCoveoFacetRange,
    resolvePendingFacetValues: resolvePendingInitialCoveoFacetValues,
    retirePendingHydration: retirePendingInitialCoveoUrlHydration,
    scheduleHydration: schedulePendingInitialCoveoUrlHydrationLease,
    waitForRetiredHydration: waitForRetiredInitialCoveoUrlHydration,
    wasFacetAppliedToPrimaryRequest:
      wasPendingInitialCoveoFacetAppliedToPrimaryRequest,
    wasPrimaryRequestPatched: werePendingUrlFiltersAppliedToPrimaryRequest,
  } = coveoFilterHydration;

  function buildCoveoAppProxyUrl(marketId) {
    let url =
      "/apps/coveo?marketId=" +
      encodeURIComponent(marketId != null ? String(marketId) : "");
    try {
      const ci =
        typeof window !== "undefined" ? window.__coveoCustomerIdentity : null;
      if (ci && ci.id != null) {
        url += "&customer_id=" + encodeURIComponent(String(ci.id));
      }
      if (ci && ci.email) {
        url += "&customer_email=" + encodeURIComponent(String(ci.email));
      }
    } catch (_) { }
    return url;
  }

  function primePendingInitialCoveoUrlState() {
    const state = readInitialCoveoUrlState();
    removeLegacyInferredCollectionMakeFromUrlState(state);
    if (state?.conditionAllSelected) {
      coveoConditionSelectionShadow.selectAll();
    } else {
      coveoConditionSelectionShadow.replace(
        getConditionValuesFromUrlState(state),
      );
    }
    primePendingInitialCoveoHydrationState(
      hasCoveoUrlState(state) ? state : null,
    );
    // Facet hydration can finish before the sort controls are wired and clear
    // the pending URL state. Keep the requested sort separately so shared PLP
    // links such as `?sort=nearest` cannot race back to the default sort.
    window.__coveoPendingInitialSortValue = state?.sort || null;

    const sortValue = state?.sort;
    const sortPayload = sortValue ? SORT_DEFINITIONS[sortValue] : null;
    if (sortPayload && window.__coveoSetActiveSortPayload) {
      window.__coveoSetActiveSortPayload(sortPayload);
    }
    if (sortValue && window.__coveoSetActiveSortValue) {
      window.__coveoSetActiveSortValue(sortValue);
    }
  }

  const COVEO_NUMERIC_FACET_DOMAIN_MAX = 1000000;

  const COVEO_PRICE_SLIDER_STEP = 1000;
  const COVEO_RANGE_COMMIT_LOCK_MS = 1200;

  const COVEO_YEAR_FACET_ID = String(
    getCoveoCanonicalFacetIdForFriendlyUrlKey("year") || "year1",
  );

  const createCoveoFilterRequestPlanner =
    window.MarineMaxCoveoFilterRequestPlanner?.create;
  if (typeof createCoveoFilterRequestPlanner !== "function") {
    throw new Error(
      "[Coveo Filter Request Planner] Missing headless-search-page-filter-request-planner.js",
    );
  }
  const coveoFilterRequestPlanner = createCoveoFilterRequestPlanner({
    coveoPriceFacetApiScale,
    facetIdsMatchCondition,
    facetIdsMatchLength,
    facetIdsMatchPrice,
    facetIdsMatchYear,
    facetItemNumericBounds,
    getCoveoFacetRequestFieldId,
    getCoveoFriendlyUrlFacetKey,
    isNumericalRangeFacet,
    requestFacetMatchesFacetId,
    toCoveoPriceFacetApiValue,
    tryFacetNumericDomain,
    initialManagedRangeFacets: [
      {
        displayName: "Length",
        facetId: "length_overall",
      },
      {
        displayName: "Price Range",
        facetId: "price",
        interval: "continuous",
      },
    ],
    yearFacetId: COVEO_YEAR_FACET_ID,
  });
  const {
    buildPendingRangeValue: buildPendingInitialCoveoRangeValue,
    buildSyntheticYearFacetRequest,
    getSelectedRequestFacetValues: getSelectedCoveoRequestFacetValues,
    planEmptyFacetValuesSanitization:
      planCoveoEmptyFacetValuesSanitization,
    planFacetOnlyTargetSelfSelection:
      planCoveoFacetOnlyTargetSelfSelection,
    planManagedRangeTargetRemoval: planCoveoManagedRangeTargetRemoval,
    planAuthoritativeConditionFacet:
      planCoveoAuthoritativeConditionFacet,
    planPendingFacetRequests: planPendingInitialCoveoFacetRequests,
    planPriceFacetDomainSanitization:
      planCoveoPriceFacetDomainSanitization,
    planUrlMakeContext: planCoveoUrlMakeContext,
    resolveRangeKind: resolveCoveoRangeKindForFacet,
  } = coveoFilterRequestPlanner;

  const COVEO_FILTER_CHECK_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none"><path d="M9.8335 0.833252L3.646 7.02075L0.833496 4.20825" stroke="white" stroke-width="1.6666" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  let coveoLastSyncedLocationCtxKey = null;

  function formatPriceDisplay(n) {
    const num = Number(n);
    if (!Number.isFinite(num)) return "";
    const rounded = Math.round(num);
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(rounded);
    } catch (_) {
      return "$" + String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }

  function parsePriceInputValue(raw) {
    if (raw == null) return NaN;
    const str = String(raw).replace(/[^0-9.\-]/g, "");
    if (!str) return NaN;
    const n = parseFloat(str);
    return Number.isFinite(n) ? n : NaN;
  }

  function normalizeCoveoFacetPriceDollars(n) {
    if (!Number.isFinite(n)) return n;
    const abs = Math.abs(n);
    if (abs >= 1000000000) {
      return n / 100;
    }
    if (abs >= 1000000000 && Number.isInteger(n)) {
      const asDollars = n / 100;
      if (asDollars >= 500 && asDollars <= 50000000) return asDollars;
    }
    return n;
  }

  function coveoPriceFacetApiScale(nums) {
    const arr = Array.isArray(nums) ? nums : [];
    return arr.some(function (n) {
      return (
        Number.isFinite(n) &&
        Math.abs(n) >= 1000000000 &&
        normalizeCoveoFacetPriceDollars(n) !== n
      );
    })
      ? 100
      : 1;
  }

  function toCoveoPriceFacetApiValue(dollars, scale) {
    const n = Number(dollars);
    if (!Number.isFinite(n)) return n;
    return Number(scale) === 100 ? Math.round(n * 100) : n;
  }

  function normalizeRangeBoundsForUiKind(bounds, kind) {
    if (!bounds) return null;
    if (kind === "price") {
      return {
        lo: normalizeCoveoFacetPriceDollars(bounds.lo),
        hi: normalizeCoveoFacetPriceDollars(bounds.hi),
      };
    }
    return bounds;
  }

  function formatLengthFeetWhole(n) {
    if (!Number.isFinite(n)) return "";
    return String(Math.round(Number(n)));
  }

  function formatLengthBubbleDisplay(n) {
    const num = Number(n);
    if (!Number.isFinite(num)) return "";
    return `${num.toFixed(1)}\u2032`;
  }

  function roundPriceToStep(n, mode) {
    const num = Number(n);
    if (!Number.isFinite(num)) return num;
    const step = COVEO_PRICE_SLIDER_STEP;
    if (mode === "floor") return Math.floor(num / step) * step;
    if (mode === "ceil") return Math.ceil(num / step) * step;
    return Math.round(num / step) * step;
  }

  function normalizePriceBoundaryDisplayValue(n) {
    const num = roundPriceToStep(n, "round");
    if (!Number.isFinite(num)) return num;
    const abs = Math.abs(num);
    const niceSteps = [];
    if (abs >= 1000000) niceSteps.push(1000000);
    if (abs >= 100000) niceSteps.push(100000);
    if (abs >= 10000) niceSteps.push(10000);
    for (let i = 0; i < niceSteps.length; i++) {
      const step = niceSteps[i];
      const rounded = Math.round(num / step) * step;
      const threshold = Math.max(1000, step * 0.05);
      if (Math.abs(num - rounded) <= threshold) {
        return rounded;
      }
    }
    return num;
  }

  function formatPriceBoundaryDisplay(n) {
    return formatPriceDisplay(normalizePriceBoundaryDisplayValue(n));
  }

  function formatCompactPriceSummaryValue(n) {
    const num = Number(n);
    if (!Number.isFinite(num)) return "";
    const abs = Math.abs(num);
    if (abs >= 1000000) {
      return `${(num / 1000000).toFixed(1).replace(/\.0$/, "")}M`;
    }
    if (abs >= 1000) {
      return `${(num / 1000).toFixed(1).replace(/\.0$/, "")}K`;
    }
    return String(Math.round(num));
  }

  function formatCompactPriceBubbleValue(n) {
    return formatCompactPriceSummaryValue(n);
  }

  function getCoveoQuerySummaryElements() {
    const els = Array.from(
      document.querySelectorAll("[data-coveo-query-summary]"),
    );
    if (els.length) return els;
    const fallback = document.getElementById("coveo-query-summary");
    return fallback ? [fallback] : [];
  }

  function syncCoveoToolbarPresentation(controller, container) {
    const toolbar = container?.querySelector?.(".coveo-search-toolbar");
    if (!toolbar || toolbar.dataset.coveoToolbarReady === "1" ||
      isCoveoFilterPresentationPending(controller, container)) return;

    // Keep the first labels behind placeholders until their fonts have settled.
    // Later requests retain the ready toolbar instead of flashing placeholders.
    if (!controller?.state?.error && document.fonts?.status === "loading" &&
      !toolbar._coveoToolbarFontsReady) {
      if (!toolbar._coveoToolbarFontWait) {
        toolbar._coveoToolbarFontWait = document.fonts.ready.then(function () {
          toolbar._coveoToolbarFontsReady = true;
          const lifecycle = container?._coveoPageLifecycleOwner;
          if (container?.isConnected === false ||
            (lifecycle && (!lifecycle.active || !lifecycle.isCurrent()))) return;
          syncCoveoToolbarPresentation(container?._coveoSearch || controller, container);
        });
      }
      return;
    }
    toolbar.dataset.coveoToolbarReady = "1";
    toolbar.classList.remove("coveo-toolbar--pending");
    toolbar.setAttribute("aria-busy", "false");
  }

  function getCoveoLocationHintElements() {
    return Array.from(
      document.querySelectorAll("[data-coveo-location-hint]"),
    );
  }

  function buildCoveoLocationDisplayLabel(loc) {
    if (!loc) return "";
    const zip =
      loc.type === "zip"
        ? String(loc.zip || "").trim()
        : String(loc.approxZip || "").trim();
    const cityState = [loc.city, loc.state]
      .map((value) => (value ? String(value).trim() : ""))
      .filter(Boolean);
    const parts = [];
    if (cityState.length === 2) {
      parts.push(cityState[0] + ", " + cityState[1]);
    } else if (cityState.length === 1) {
      parts.push(cityState[0]);
    }
    if (zip) parts.push(zip);
    if (parts.length) return parts.join(" ");
    if (loc.type === "geo") return "Current location";
    return loc.type === "zip" && zip ? "ZIP " + zip : "";
  }

  function syncCoveoToolbarLocationHint() {
    const hintEls = getCoveoLocationHintElements();
    if (!hintEls.length) return;

    const loc = window.CoveoLocationService?.getStoredLocation?.(true) || null;
    const label = buildCoveoLocationDisplayLabel(loc);
    const activeSortValue = String(window.__coveoActiveSortValue?.() || "").trim();
    let text = "";

    if (label) {
      if (activeSortValue === "nearest") {
        text = "Nearest to " + label;
      } else {
        text = "Location: " + label;
      }
    }

    hintEls.forEach(function (el) {
      if (!text) {
        el.textContent = "";
        el.classList.add("hidden");
        el.setAttribute("aria-hidden", "true");
        el.removeAttribute("title");
        return;
      }
      el.textContent = text;
      el.classList.remove("hidden");
      el.setAttribute("aria-hidden", "false");
      el.setAttribute("title", text);
    });
  }

  function syncCoveoToolbarSearchPlaceholders() {
    const isMobile = window.matchMedia("(max-width: 767.98px)").matches;
    document
      .querySelectorAll(".coveo-toolbar-search-input[data-placeholder-mobile]")
      .forEach(function (input) {
        const mobilePlaceholder =
          input.getAttribute("data-placeholder-mobile") || "Search";
        const desktopPlaceholder =
          input.getAttribute("data-placeholder-desktop") ||
          input.getAttribute("placeholder") ||
          mobilePlaceholder;
        input.setAttribute(
          "placeholder",
          isMobile ? mobilePlaceholder : desktopPlaceholder,
        );
      });
  }

  window.addEventListener("resize", syncCoveoToolbarSearchPlaceholders);
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      syncCoveoToolbarSearchPlaceholders,
      { once: true },
    );
  } else {
    syncCoveoToolbarSearchPlaceholders();
  }

  function getCoveoFacetRequestFieldId(facet) {
    if (!facet || typeof facet !== "object") return "";
    return String(
      facet.facetId ||
      facet.field ||
      facet.facetField ||
      facet.parameter ||
      "",
    ).toLowerCase();
  }

  function sanitizeCoveoFacetPriceDomainsForApiLimit(body) {
    if (!body || !Array.isArray(body.facets)) return;
    const plan = planCoveoPriceFacetDomainSanitization({
      facets: body.facets,
      maxDomain: COVEO_NUMERIC_FACET_DOMAIN_MAX,
    });
    if (plan.changed) body.facets = plan.facets;
  }

  function getCoveoManagedRangeKind(facetId) {
    const id = String(facetId || "").trim().toLowerCase();
    if (!id) return "";
    if (/(?:^|[._-])year(?:$|[._-])|model_year|year1|year_iiq/.test(id)) {
      return "year";
    }
    if (/(?:^|[._-])price(?:$|[._-])|ec_price|price_display|promo_price|listprice/.test(id)) {
      return "price";
    }
    if (/(?:^|[._-])length(?:$|[._-])|length_overall|ec_length/.test(id)) {
      return "length";
    }
    return "";
  }

  function getCoveoFacetServerStateKey(facetId) {
    const rawFacetId = String(facetId || "");
    return getCoveoManagedRangeKind(rawFacetId) || rawFacetId;
  }

  function facetIdsMatchManagedRange(facetId) {
    return !!getCoveoManagedRangeKind(facetId);
  }

  function requestFacetIdsMatchManagedRange(leftFacetId, rightFacetId) {
    const leftKind = getCoveoManagedRangeKind(leftFacetId);
    return !!leftKind && leftKind === getCoveoManagedRangeKind(rightFacetId);
  }

  function getCoveoManagedRangeClearTombstones(createIfMissing) {
    if (!window.__coveoManagedRangeClearTombstones && createIfMissing) {
      window.__coveoManagedRangeClearTombstones = {};
    }
    return window.__coveoManagedRangeClearTombstones || null;
  }

  function getCoveoManagedRangeClearKind(facetId) {
    const id = String(facetId || "").trim().toLowerCase();
    if (/(?:year|model_year)/.test(id)) return "year";
    if (/(?:price|listprice)/.test(id)) return "price";
    if (/(?:length|ec_length)/.test(id)) return "length";
    return "";
  }

  function setCoveoManagedRangeClearTombstone(facetId, cleared) {
    const kind = getCoveoManagedRangeClearKind(facetId);
    if (!kind) return;
    const tombstones = getCoveoManagedRangeClearTombstones(true);
    if (cleared) tombstones[kind] = true;
    else delete tombstones[kind];
  }

  function hasCoveoManagedRangeClearTombstone(facetId) {
    const kind = getCoveoManagedRangeClearKind(facetId);
    const tombstones = getCoveoManagedRangeClearTombstones(false);
    return !!(kind && tombstones?.[kind]);
  }

  function lastCoveoRequestHasSelectedManagedRange(facetId) {
    const facets = window.__coveoLastCommerceRequest?.body?.facets;
    if (!Array.isArray(facets)) return false;
    return facets.some(function (facet) {
      if (!requestFacetIdsMatchManagedRange(getCoveoFacetRequestFieldId(facet), facetId)) {
        return false;
      }
      return [facet.values, facet.currentValues].some(function (values) {
        return Array.isArray(values) && values.some(function (value) {
          return value?.state === "selected";
        });
      });
    });
  }

  function getCoveoYearFacetSelection() {
    const sel = window.__coveoYearFacetSelection;
    if (!sel || typeof sel !== "object") return null;
    return sel;
  }

  function setCoveoYearFacetSelection(sel) {
    if (!sel || sel.fullRange) {
      window.__coveoYearFacetSelection = null;
      setCoveoManagedRangeClearTombstone(COVEO_YEAR_FACET_ID, true);
      return;
    }
    const lo = Math.round(Number(sel.lo));
    const hi = Math.round(Number(sel.hi));
    if (!Number.isFinite(lo) || !Number.isFinite(hi)) {
      window.__coveoYearFacetSelection = null;
      return;
    }
    window.__coveoYearFacetSelection = {
      lo: Math.min(lo, hi),
      hi: Math.max(lo, hi),
      fullRange: false,
    };
    setCoveoManagedRangeClearTombstone(COVEO_YEAR_FACET_ID, false);
  }

  function clearCoveoYearFacetSelection() {
    window.__coveoYearFacetSelection = null;
  }

  /** Committed length/price slider ranges — stable chip labels while Coveo toggles bucket values. */
  function getCoveoFacetRangeSelection(facetId) {
    const map = window.__coveoFacetRangeSelections;
    if (!map || !facetId) return null;
    const sel = map[String(facetId)];
    if (!sel || sel.fullRange) return null;
    return sel;
  }

  function setCoveoFacetRangeSelection(facetId, sel) {
    if (!facetId) return;
    if (!window.__coveoFacetRangeSelections) {
      window.__coveoFacetRangeSelections = {};
    }
    const id = String(facetId);
    if (!sel || sel.fullRange) {
      delete window.__coveoFacetRangeSelections[id];
      setCoveoManagedRangeClearTombstone(facetId, true);
      return;
    }
    const lo = Number(sel.lo);
    const hi = Number(sel.hi);
    if (!Number.isFinite(lo) || !Number.isFinite(hi)) {
      delete window.__coveoFacetRangeSelections[id];
      return;
    }
    window.__coveoFacetRangeSelections[id] = {
      lo: Math.min(lo, hi),
      hi: Math.max(lo, hi),
      fullRange: false,
    };
    setCoveoManagedRangeClearTombstone(facetId, false);
  }

  function clearCoveoFacetRangeSelection(facetId) {
    if (window.__coveoFacetRangeSelections && facetId) {
      delete window.__coveoFacetRangeSelections[String(facetId)];
    }
  }

  function clearAllCoveoFacetRangeSelections() {
    window.__coveoFacetRangeSelections = {};
  }
  const coveoRangeUiState = window.CoveoRangeUiStateModule?.create?.({
    buildCoveoFacetValueCacheContextKey,
    getActiveCoveoLocationContext,
    roundPriceToStep,
  });
  if (!coveoRangeUiState) {
    throw new Error("[Coveo Range UI] Missing headless-search-page-range-state.js");
  }
  const {
    beginCoveoRangeUiInteraction,
    cancelCoveoRangeUiInteraction,
    clearAllCoveoPendingRangeUiSnapshots,
    clearCoveoPendingRangeUiSnapshot,
    deferCoveoRangeUiRender,
    finishCoveoRangeUiInteraction,
    getCoveoLiveRangeUiSnapshot,
    getCoveoPendingRangeUiMap,
    getCoveoPendingRangeUiRawSnapshot,
    getCoveoPendingRangeUiSnapshot,
    getCoveoStableRangeDomain,
    getCoveoStickyRangeUiSnapshot,
    hasActiveCoveoRangeUiInteraction,
    hasCoveoPendingRangeUiSnapshots,
    isCoveoRangeUiFrozen,
    normalizeCoveoFacetRangeSelectionCandidate,
    normalizeCoveoYearSelectionCandidate,
    rememberCoveoStableRangeDomain,
    setCoveoLiveRangeUiSnapshot,
    setCoveoPendingRangeUiSnapshot,
    setCoveoRangeUiFrozen,
    setCoveoStickyRangeUiSnapshot,
    syncCoveoPendingRangeUiSelectionToDomain,
  } = coveoRangeUiState;

  function readYearRangeDomainFromContainer(container) {
    if (!container) return null;
    let lo = parseFloat(String(container.getAttribute("data-range-lo") || ""));
    let hi = parseFloat(String(container.getAttribute("data-range-hi") || ""));
    const minInput = container.querySelector(".coveo-mobile-range-input--min");
    const maxInput = container.querySelector(".coveo-mobile-range-input--max");
    if (!Number.isFinite(lo)) {
      lo = parseFloat(String(minInput?.getAttribute("min") || ""));
    }
    if (!Number.isFinite(hi)) {
      hi = parseFloat(String(maxInput?.getAttribute("max") || ""));
    }
    if (!Number.isFinite(lo) || !Number.isFinite(hi)) return null;
    return {
      lo: Math.round(Math.min(lo, hi)),
      hi: Math.round(Math.max(lo, hi)),
    };
  }

  function readYearSelectionFromRangeContainer(container) {
    if (!container) return null;
    if ((container.getAttribute("data-range-kind") || "") !== "year") return null;

    const minInput = container.querySelector(".coveo-mobile-range-input--min");
    const maxInput = container.querySelector(".coveo-mobile-range-input--max");
    const minField = container.querySelector(".coveo-mobile-length-input--min");
    const maxField = container.querySelector(".coveo-mobile-length-input--max");
    if (!minInput || !maxInput) return null;

    let lo = parseFloat(String(minField?.value ?? minInput.value ?? ""));
    let hi = parseFloat(String(maxField?.value ?? maxInput.value ?? ""));
    if (!Number.isFinite(lo) || !Number.isFinite(hi)) return null;

    return normalizeCoveoYearSelectionCandidate(
      { lo, hi },
      readYearRangeDomainFromContainer(container),
    );
  }

  function resolveCoveoYearFacetSelectionForRequest() {
    const pendingMap = getCoveoPendingRangeUiMap(false);
    if (pendingMap && typeof pendingMap === "object") {
      for (const [facetId, pending] of Object.entries(pendingMap)) {
        if (!facetIdsMatchYear(facetId) || pending?.kind !== "year") continue;
        const selection = normalizeCoveoYearSelectionCandidate(
          pending,
          {
            lo: pending.rangeLo,
            hi: pending.rangeHi,
          },
        );
        if (selection) {
          return { selection, source: "pending" };
        }
      }
    }

    const stored = normalizeCoveoYearSelectionCandidate(
      getCoveoYearFacetSelection(),
      null,
    );
    if (stored) {
      return { selection: stored, source: "memory" };
    }
    return null;
  }

  async function clearCoveoFacetControllerSelectionForUiClear(
    facet,
    facetId,
    options,
  ) {
    const isCurrent =
      typeof options?.isCurrent === "function"
        ? options.isCurrent
        : () => true;
    if (!isCurrent()) return false;
    if (!facet) return false;
    const id = String(facetId || facet.facetId || facet.state?.facetId || "");
    const facetState = facet.state || {};
    const hasActiveSelection =
      facetState.hasActiveValues === true ||
      normalizeFacetStateValues(facetState).some(function (value) {
        return value?.state === "selected";
      });
    if (!hasActiveSelection) return false;
    const isRangeLike =
      facetIdsMatchYear(id) ||
      facetIdsMatchPrice(id) ||
      facetIdsMatchLength(id) ||
      isNumericalRangeFacet(facet);
    if (isRangeLike && typeof facet.setRanges === "function") {
      try {
        await Promise.resolve(facet.setRanges([]));
        return true;
      } catch (_) { }
      if (!isCurrent()) return false;
    }
    if (typeof facet.deselectAll === "function") {
      if (!isCurrent()) return false;
      try {
        await Promise.resolve(facet.deselectAll());
        return true;
      } catch (_) { }
    }
    return false;
  }

  async function clearCoveoYearFacetControllers(facetGen, options) {
    const isCurrent = typeof options?.isCurrent === "function"
      ? options.isCurrent : () => true;
    if (!isCurrent()) return false;
    setCoveoManagedRangeClearTombstone(COVEO_YEAR_FACET_ID, true);
    clearCoveoYearFacetSelection();
    const facets = flattenFacetControllers(facetGen).filter((facet) =>
      facetIdsMatchYear(facet.facetId || facet.state?.facetId),
    );
    const ids = new Set([
      COVEO_YEAR_FACET_ID,
      ...facets.map((facet) => facet.facetId || facet.state?.facetId),
      ...Object.keys(getCoveoPendingRangeUiMap(false) || {}).filter(facetIdsMatchYear),
    ]);
    ids.forEach(clearCoveoPendingRangeUiSnapshot);
    let controllerOwnedSearch = false;
    for (const facet of new Set(facets)) {
      if (!isCurrent()) return controllerOwnedSearch;
      const didSearch = await clearCoveoFacetControllerSelectionForUiClear(
        facet, facet.facetId || facet.state?.facetId, { isCurrent },
      );
      controllerOwnedSearch = didSearch || controllerOwnedSearch;
    }
    return controllerOwnedSearch;
  }

  const coveoFilterMutations = window.MarineMaxCoveoFilterMutations;
  if (
    typeof coveoFilterMutations?.beginCoveoUiMutation !== "function" ||
    typeof coveoFilterMutations?.cancelCoveoUiMutations !== "function" ||
    typeof coveoFilterMutations?.enqueueCoveoUiMutation !== "function"
  ) {
    throw new Error(
      "[Coveo Filters] Missing headless-search-page-filter-mutations.js",
    );
  }
  const {
    beginCoveoUiMutation,
    cancelCoveoUiMutations,
    enqueueCoveoUiMutation,
  } = coveoFilterMutations;

  const coveoFilterStateApi = window.MarineMaxCoveoFilterState;
  const collapseFacetAccordions =
    coveoFilterStateApi?.collapseFacetAccordions;
  const createCoveoFilterState = coveoFilterStateApi?.create;
  const createMultiSelectionShadow =
    coveoFilterStateApi?.createMultiSelectionShadow;
  const readSelectedDrawerFacetValues =
    coveoFilterStateApi?.readSelectedDrawerFacetValues;
  const resolveStoredDistanceActivationRadius =
    coveoFilterStateApi?.resolveStoredDistanceActivationRadius;
  if (
    typeof collapseFacetAccordions !== "function" ||
    typeof createCoveoFilterState !== "function" ||
    typeof createMultiSelectionShadow !== "function" ||
    typeof readSelectedDrawerFacetValues !== "function" ||
    typeof resolveStoredDistanceActivationRadius !== "function"
  ) {
    throw new Error(
      "[Coveo Filter State] Missing headless-search-page-filter-state.js",
    );
  }
  const COVEO_CONDITION_FACET_ID = String(
    getCoveoCanonicalFacetIdForFriendlyUrlKey("condition") || "condition_iiq",
  ).trim();
  const coveoConditionSelectionShadow = createMultiSelectionShadow({
    allValues: COVEO_CONDITION_OPTION_LABELS,
    canonicalizeValue: getCanonicalConditionOptionLabel,
  });
  const coveoFilterState = createCoveoFilterState({
    facetItemRawValue,
    findFacetController,
    flattenFacetControllers,
    getFacetDisplayLabel,
    normalizeFacetStateValues,
    shouldSuppressFacetValue,
  });
  const {
    buildDrawerDesiredSelectionSnapshot,
    buildFacetSelectionSnapshot,
    facetSelectionSnapshotsMatch,
    pruneSyncedPendingFilterState,
    resetPendingFilterSessionState,
    snapshotHasSelectedFacetMatching,
  } = coveoFilterState;

  function resolveRangeBoundsFromFacetState(facet, kind) {
    const selected = normalizeFacetStateValues(facet.state || {}).filter(
      (v) => v.state === "selected",
    );
    if (!selected.length) return null;

    const explicit = [];
    selected.forEach((v) => {
      const start = v.start ?? v.value?.start;
      const end = v.end ?? v.value?.end;
      if (start == null || end == null) return;
      const lo = parseFloat(String(start));
      const hi = parseFloat(String(end));
      if (Number.isFinite(lo) && Number.isFinite(hi)) {
        explicit.push({ lo, hi });
      }
    });
    if (explicit.length >= 1) {
      const lo = Math.min(...explicit.map((b) => b.lo));
      const hi = Math.max(...explicit.map((b) => b.hi));
      return normalizeRangeBoundsForUiKind({ lo, hi }, kind);
    }

    const bounds = selected
      .map((v) => facetItemNumericBounds(v))
      .filter(Boolean);
    if (!bounds.length) return null;
    const lo = Math.min(...bounds.map((b) => b.lo));
    const hi = Math.max(...bounds.map((b) => b.hi));
    return normalizeRangeBoundsForUiKind({ lo, hi }, kind);
  }

  function resolveRangeChipBounds(facet, facetId, kind) {
    if (facetIdsMatchYear(facetId)) {
      if (hasCoveoManagedRangeClearTombstone(facetId)) return null;
      const syn = facet?._isSyntheticYearFacet
        ? facet.state?._syntheticSelected
        : null;
      if (syn && Number.isFinite(syn.min) && Number.isFinite(syn.max)) {
        return {
          lo: Math.round(syn.min),
          hi: Math.round(syn.max),
        };
      }
      const yearSel = getCoveoYearFacetSelection();
      if (yearSel) return { lo: yearSel.lo, hi: yearSel.hi };
    } else {
      const stored = getCoveoFacetRangeSelection(facetId);
      if (stored) return { lo: stored.lo, hi: stored.hi };
    }
    return facet ? resolveRangeBoundsFromFacetState(facet, kind) : null;
  }

  /**
   * Headless may send `values: []` on facets; Coveo commerce API rejects empty arrays.
   * Omit `values` when empty (numericalRange facets should not send values unless selected).
   */
  function sanitizeCoveoFacetEmptyValuesForApi(body, options) {
    if (!body || !Array.isArray(body.facets)) return;
    const plan = planCoveoEmptyFacetValuesSanitization({
      facets: body.facets,
      dropEmptyFacets: !!options?.dropEmptyFacets,
      preserveFacetId: String(options?.preserveFacetId || ""),
    });
    if (plan.changed) body.facets = plan.facets;
  }

  function cloneCoveoFacetRequestTemplate(facet) {
    if (!facet || typeof facet !== "object") return null;
    try {
      return JSON.parse(JSON.stringify(facet));
    } catch (_) {
      return Object.assign({}, facet);
    }
  }

  function rememberCoveoFacetRequestTemplates(facets) {
    if (!Array.isArray(facets)) return;
    if (!window.__coveoFacetRequestTemplates) {
      window.__coveoFacetRequestTemplates = {};
    }
    facets.forEach(function (facet) {
      const facetId = getCoveoFacetRequestFieldId(facet);
      if (!facetId || !facetIdsMatchManagedRange(facetId)) return;
      window.__coveoFacetRequestTemplates[facetId] =
        cloneCoveoFacetRequestTemplate(facet);
    });
  }

  function getCoveoFacetRequestTemplate(facetId) {
    const templates = window.__coveoFacetRequestTemplates || {};
    const ids = Object.keys(templates);
    for (let i = 0; i < ids.length; i++) {
      if (requestFacetMatchesFacetId(templates[ids[i]], facetId)) {
        return cloneCoveoFacetRequestTemplate(templates[ids[i]]);
      }
    }
    return null;
  }

  function stripCoveoFacetOnlyTargetSelfSelection(body, targetFacetId) {
    if (!body || !Array.isArray(body.facets) || !targetFacetId) return false;
    const plan = planCoveoFacetOnlyTargetSelfSelection({
      facets: body.facets,
      targetFacetId,
    });
    if (plan.changed) body.facets = plan.facets;
    return plan.changed;
  }

  function stripCoveoManagedRangeSelectionsForDomain(body, targetFacetId) {
    if (!body || !Array.isArray(body.facets) || !targetFacetId) return false;
    const plan = planCoveoManagedRangeTargetRemoval({
      facets: body.facets,
      targetFacetId,
    });
    if (plan.changed) body.facets = plan.facets;
    return plan.changed;
  }

  function neutralizeCoveoRangeFacetValues(facet) {
    if (!facet || typeof facet !== "object") return false;
    const values = Array.isArray(facet.values) ? facet.values : [];
    facet.values = values.map(function (value) {
      return Object.assign({}, value, { state: "idle" });
    });
    delete facet.currentValues;
    delete facet.domain;
    delete facet.facetDomain;
    delete facet.range;
    facet.freezeCurrentValues = false;
    facet.preventAutoSelect = false;
    return true;
  }

  function stripExplicitlyClearedCoveoManagedRanges(body) {
    if (!body || !Array.isArray(body.facets)) return false;
    let changed = false;
    body.facets.forEach(function (facet) {
      const facetId = getCoveoFacetRequestFieldId(facet);
      if (!hasCoveoManagedRangeClearTombstone(facetId)) return;
      neutralizeCoveoRangeFacetValues(facet);
      changed = true;
    });
    return changed;
  }

  function canonicalizeCoveoFacetCacheContextValue(value) {
    if (value == null) return null;
    if (typeof value === "number") return Number.isFinite(value) ? value : null;
    if (typeof value === "boolean") return value;
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (/^-?(?:\d+\.?\d*|\.\d+)$/.test(trimmed)) {
        const numeric = Number(trimmed);
        if (Number.isFinite(numeric)) return numeric;
      }
      return trimmed;
    }
    if (Array.isArray(value)) {
      return value.map(canonicalizeCoveoFacetCacheContextValue);
    }
    if (typeof value === "object") {
      const out = {};
      Object.keys(value)
        .sort()
        .forEach(function (key) {
          if (value[key] === undefined) return;
          out[key] = canonicalizeCoveoFacetCacheContextValue(value[key]);
        });
      return out;
    }
    return String(value);
  }

  function serializeCoveoFacetSelectionForCache(value) {
    if (!value || typeof value !== "object") return "";
    const rawCandidate =
      value.value != null && typeof value.value !== "object"
        ? value.value
        : value.rawValue ?? value.displayValue ?? value.label ?? "";
    const raw = String(rawCandidate ?? "").trim();
    if (raw) return raw;

    const start = Number(value.start ?? value.value?.start);
    const end = Number(value.end ?? value.value?.end);
    if (Number.isFinite(start) && Number.isFinite(end)) {
      return `${Math.min(start, end)}..${Math.max(start, end)}`;
    }

    return "";
  }

  function buildCoveoRangeSelectionCacheContext(excludeFacetId) {
    const excluded = String(excludeFacetId || "");
    function isExcludedRange(facetId) {
      if (!excluded) return false;
      return requestFacetIdsMatchManagedRange(facetId, excluded);
    }
    const selections = [];
    const pendingMap = getCoveoPendingRangeUiMap(false);
    if (pendingMap && typeof pendingMap === "object") {
      Object.keys(pendingMap)
        .sort()
        .forEach(function (facetId) {
          if (isExcludedRange(facetId)) return;
          const pending = pendingMap[facetId];
          const kind = String(pending?.kind || "").trim().toLowerCase();
          if (!kind) return;
          const domain =
            Number.isFinite(Number(pending?.rangeLo)) &&
              Number.isFinite(Number(pending?.rangeHi))
              ? {
                lo: Number(pending.rangeLo),
                hi: Number(pending.rangeHi),
              }
              : null;
          const normalized = kind === "year"
            ? normalizeCoveoYearSelectionCandidate(pending, domain)
            : normalizeCoveoFacetRangeSelectionCandidate(pending, domain, kind);
          if (!normalized || normalized.fullRange) return;
          selections.push({
            facetId: String(facetId || "").trim().toLowerCase(),
            kind,
            source: "pending",
            lo: normalized.lo,
            hi: normalized.hi,
          });
        });
    }

    const committedMap = window.__coveoFacetRangeSelections;
    if (committedMap && typeof committedMap === "object") {
      Object.keys(committedMap)
        .sort()
        .forEach(function (facetId) {
          if (isExcludedRange(facetId)) return;
          const stored = committedMap[facetId];
          const kind = facetIdsMatchPrice(facetId)
            ? "price"
            : facetIdsMatchLength(facetId)
              ? "length"
              : "numeric";
          const normalized = normalizeCoveoFacetRangeSelectionCandidate(
            stored,
            null,
            kind,
          );
          if (!normalized || normalized.fullRange) return;
          selections.push({
            facetId: String(facetId || "").trim().toLowerCase(),
            kind,
            source: "committed",
            lo: normalized.lo,
            hi: normalized.hi,
          });
        });
    }

    const yearSelection = normalizeCoveoYearSelectionCandidate(
      getCoveoYearFacetSelection(),
      null,
    );
    if (
      yearSelection &&
      !yearSelection.fullRange &&
      !isExcludedRange(COVEO_YEAR_FACET_ID || "year")
    ) {
      selections.push({
        facetId: String(COVEO_YEAR_FACET_ID || "year").trim().toLowerCase(),
        kind: "year",
        source: "committed",
        lo: yearSelection.lo,
        hi: yearSelection.hi,
      });
    }

    selections.sort(function (a, b) {
      const keyA = `${a.facetId}::${a.source}::${a.kind}`;
      const keyB = `${b.facetId}::${b.source}::${b.kind}`;
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      if (a.lo !== b.lo) return a.lo - b.lo;
      return a.hi - b.hi;
    });

    return selections;
  }

  function buildCoveoFacetValueCacheContextKey(body, options) {
    if (!body || typeof body !== "object") return "";
    const excludeFacetId = String(options?.excludeFacetId || "");
    const facets = Array.isArray(body.facets) ? body.facets : [];
    const facetState = facets
      .filter(function (facet) {
        const requestId = String(
          facet?.facetId || facet?.field || facet?.facetField || facet?.parameter || "",
        ).toLowerCase();
        if (!excludeFacetId) return true;
        return !(
          requestId === excludeFacetId.toLowerCase() ||
          (typeof requestFacetIdsMatchManagedRange === "function" &&
            requestFacetIdsMatchManagedRange(requestId, excludeFacetId))
        );
      })
      .map(function (facet) {
      const facetId = String(
        facet.facetId || facet.field || facet.facetField || "",
      ).toLowerCase();
      const selectedByRaw = new Map();
      [facet.values, facet.currentValues].forEach(function (valueList) {
        if (!Array.isArray(valueList)) return;
        valueList.forEach(function (value) {
          if (!value || value.state !== "selected") return;
          const serialized = serializeCoveoFacetSelectionForCache(value);
          if (!serialized) return;
          selectedByRaw.set(serialized, serialized);
        });
      });
      return {
        facetId,
        selected: Array.from(selectedByRaw.values()).sort(),
      };
      })
      .filter(function (facet) {
        return facet.facetId && facet.selected.length > 0;
      })
      .sort(function (a, b) {
        return a.facetId.localeCompare(b.facetId);
      });

    let viewUrl = String(body.context?.view?.url || "").trim();
    if (viewUrl) {
      try {
        const parsed = new URL(
          viewUrl,
          window.location?.origin || "https://example.invalid",
        );
        if (excludeFacetId) {
          Array.from(parsed.searchParams.keys()).forEach(function (key) {
            let keyFacetId = "";
            if (key.startsWith(COVEO_URL_LEGACY_RANGE_PREFIX)) {
              keyFacetId = key.slice(COVEO_URL_LEGACY_RANGE_PREFIX.length);
            } else if (
              typeof getCoveoCanonicalFacetIdForFriendlyUrlKey === "function"
            ) {
              keyFacetId = getCoveoCanonicalFacetIdForFriendlyUrlKey(key);
            }
            if (
              keyFacetId &&
              (String(keyFacetId).toLowerCase() === excludeFacetId.toLowerCase() ||
                (typeof requestFacetIdsMatchManagedRange === "function" &&
                  requestFacetIdsMatchManagedRange(keyFacetId, excludeFacetId)))
            ) {
              parsed.searchParams.delete(key);
            }
          });
        }
        parsed.searchParams.sort();
        viewUrl = `${parsed.origin}${parsed.pathname}${parsed.search}`;
      } catch (_) { }
    }

    const locCtx =
      typeof getActiveCoveoLocationContext === "function"
        ? getActiveCoveoLocationContext() || null
        : null;
    const custom = body.context?.custom || {};
    const geo = body.context?.location || {};
    const selectedRadiusCandidate =
      window.__coveoSelectedRadiusMiles != null
        ? Number(window.__coveoSelectedRadiusMiles)
        : NaN;
    const contextRadiusCandidate = Number(locCtx?.location_radius_miles);
    /*
     * The live distance state is authoritative. A just-cleared engine request
     * can still carry the previous radius in body.context for one render; using
     * that stale value here would incorrectly reuse the radius-constrained
     * Length domain for All inventory.
     */
    const radiusCandidate = Number.isFinite(selectedRadiusCandidate)
      ? selectedRadiusCandidate
      : Number.isFinite(contextRadiusCandidate)
        ? contextRadiusCandidate
        : null;
    const requestUrl = String(options?.requestUrl || "");
    let endpoint = "";
    if (requestUrl) {
      try {
        endpoint = new URL(
          requestUrl,
          window.location?.origin || "https://example.invalid",
        ).pathname;
      } catch (_) {
        endpoint = requestUrl;
      }
    }
    return JSON.stringify(canonicalizeCoveoFacetCacheContextValue({
      query: String(body.query || "").trim(),
      aq: String(body.aq || "").trim(),
      cq: String(body.cq || "").trim(),
      dq: String(body.dq || "").trim(),
      facets: facetState,
      managedRanges: buildCoveoRangeSelectionCacheContext(excludeFacetId),
      endpoint,
      market: {
        country: body.country ?? body.context?.country ?? "",
        currency: body.currency ?? body.context?.currency ?? "",
        language: body.language ?? body.context?.language ?? "",
        trackingId: body.trackingId ?? "",
      },
      location: {
        type: custom.location_type ?? locCtx?.location_type ?? "",
        zip: custom.location_zip ?? locCtx?.location_zip ?? "",
        lat:
          custom.location_lat ?? geo.latitude ?? locCtx?.location_lat ?? null,
        lng:
          custom.location_lng ?? geo.longitude ?? locCtx?.location_lng ?? null,
        radius: radiusCandidate ?? null,
      },
      viewUrl,
    }));
  }

  function getCoveoFacetServerCacheEntry(facetId) {
    if (!facetId) return null;
    const cache = window.__coveoFacetServerValueCache;
    const snapshot = window.__coveoLastCommerceRequest;
    if (!cache || !snapshot?.body) return null;
    const entry = cache[getCoveoFacetServerStateKey(facetId)];
    if (!entry || typeof entry !== "object") return null;
    const currentKey = buildCoveoFacetValueCacheContextKey(snapshot.body, {
      excludeFacetId: facetId,
      requestUrl: snapshot.url,
    });
    if (!currentKey || entry.contextKey !== currentKey) return null;
    if (
      facetIdUsesRangeServerDomainRefresh(facetId) &&
      !deriveCoveoManagedRangeServerDomain(facetId, entry.facet)
    ) {
      return null;
    }
    return entry;
  }

  function getCoveoFacetServerCache(facetId) {
    const entry = getCoveoFacetServerCacheEntry(facetId);
    if (!entry || !Array.isArray(entry.values)) return null;
    return entry.values;
  }

  function getCoveoFacetServerFacetState(facetId) {
    const entry = getCoveoFacetServerCacheEntry(facetId);
    if (!entry || !entry.facet || typeof entry.facet !== "object") return null;
    return entry.facet;
  }

  function getCoveoFacetServerValueRequests(createIfMissing) {
    if (!window.__coveoFacetServerValueRequests && createIfMissing) {
      window.__coveoFacetServerValueRequests = {};
    }
    return window.__coveoFacetServerValueRequests || null;
  }

  function getCoveoFacetServerLatestRequestKeys(createIfMissing) {
    if (!window.__coveoFacetServerLatestRequestKeyByFacet && createIfMissing) {
      window.__coveoFacetServerLatestRequestKeyByFacet = {};
    }
    return window.__coveoFacetServerLatestRequestKeyByFacet || null;
  }

  function getCoveoFacetServerAbortControllers(createIfMissing) {
    if (!window.__coveoFacetServerAbortControllers && createIfMissing) {
      window.__coveoFacetServerAbortControllers = {};
    }
    return window.__coveoFacetServerAbortControllers || null;
  }

  function getCoveoFacetServerRequestPromise(record) {
    return isReusableCoveoFacetServerRequest(record) ? record.promise : null;
  }

  function isReusableCoveoFacetServerRequest(record) {
    return !!(
      record &&
      !record.aborted &&
      !record.controller?.signal?.aborted &&
      record.promise &&
      typeof record.promise.then === "function"
    );
  }

  function abortCoveoFacetServerRequest(record) {
    if (!record || record.aborted) return;
    record.aborted = true;
    try {
      record.controller?.abort?.();
    } catch (_) { }
  }

  function setCoveoFacetServerCache(facetId, body, facetState, contextKey) {
    if (!facetId || !body || !facetState || typeof facetState !== "object") return;
    if (!window.__coveoFacetServerValueCache) {
      window.__coveoFacetServerValueCache = {};
    }
    const values = Array.isArray(facetState.values) ? facetState.values : [];
    window.__coveoFacetServerValueCache[getCoveoFacetServerStateKey(facetId)] = {
      contextKey:
        contextKey ||
        buildCoveoFacetValueCacheContextKey(body, {
          excludeFacetId: facetId,
          requestUrl: window.__coveoLastCommerceRequest?.url,
        }),
      values: values,
      facet: facetState,
    };
  }

  /*
   * Keep pending-state access in the runtime adapter. The request planner only
   * receives explicit values/selectors and never reads the hydration store.
   */
  function applyCoveoUrlMakeContextToRequestBody(body) {
    if (!body || typeof body !== "object") return false;
    let makeValues = getSelectedCoveoRequestFacetValues(
      body,
      facetIdsMatchMake,
    );
    if (!makeValues.length) {
      const pendingMake = getPendingInitialCoveoRegularFacetEntries().find(
        function (entry) {
          return facetIdsMatchMake(entry.facetId);
        },
      );
      makeValues = pendingMake?.values || [];
    }
    const plan = planCoveoUrlMakeContext({
      context: body.context,
      makeValues,
    });
    if (plan.changed) body.context = plan.context;
    return plan.changed;
  }

  function applyPendingInitialCoveoUrlStateToFacetRequests(body, options) {
    const state = getPendingInitialCoveoUrlState();
    if (!state || !body || typeof body !== "object") {
      return { applied: false, facetIds: [] };
    }
    if (!Array.isArray(body.facets)) body.facets = [];
    const pendingRegularEntries =
      getPendingInitialCoveoRegularFacetEntries(state);
    const plan = planPendingInitialCoveoFacetRequests({
      facets: body.facets,
      pendingRegularEntries,
      resolveFacetRange(facetId) {
        return resolvePendingInitialCoveoFacetRange(facetId, state);
      },
      resolveFacetValues(facetId) {
        return resolvePendingInitialCoveoFacetValues(facetId, state);
      },
      synthesizeMissingManagedRanges:
        options?.synthesizeMissingManagedRanges === true,
    });
    plan.selectionEffects.forEach(function (effect) {
      if (effect.kind === "year") {
        setCoveoYearFacetSelection(effect.selection);
        return;
      }
      if (effect.kind === "range") {
        setCoveoFacetRangeSelection(effect.facetId, effect.range);
      }
    });
    body.facets = plan.facets;
    return {
      applied: plan.appliedFacetIds.length > 0,
      facetIds: plan.appliedFacetIds,
    };
  }

  /**
   * A commerce response can briefly omit the selected Price/Length value while
   * its controller is rebuilding. Rehydrate committed peer ranges before the
   * next request so a late domain refresh cannot lose the narrowing context.
   */
  function applyCoveoStoredRangeSelectionsToFacetRequests(body) {
    if (!body || typeof body !== "object") return false;
    const storedMap = window.__coveoFacetRangeSelections;
    if (!storedMap || typeof storedMap !== "object") return false;

    const facets = Array.isArray(body.facets) ? body.facets.slice() : [];
    let changed = false;
    Object.keys(storedMap).forEach(function (facetId) {
      const kind = facetIdsMatchPrice(facetId)
        ? "price"
        : facetIdsMatchLength(facetId)
          ? "length"
          : "";
      if (!kind || hasCoveoManagedRangeClearTombstone(facetId)) return;
      const selection = normalizeCoveoFacetRangeSelectionCandidate(
        storedMap[facetId],
        null,
        kind,
      );
      if (!selection || selection.fullRange) return;

      let index = facets.findIndex(function (facet) {
        return requestFacetMatchesFacetId(facet, facetId);
      });
      const sourceFacet =
        index >= 0 ? facets[index] : getCoveoFacetRequestTemplate(facetId);
      if (!sourceFacet) return;
      const rangeValue = buildPendingInitialCoveoRangeValue(
        facetId,
        sourceFacet,
        selection,
      );
      if (!rangeValue) return;

      const nextFacet = Object.assign({}, sourceFacet, {
        values: [rangeValue],
      });
      delete nextFacet.currentValues;
      delete nextFacet.domain;
      delete nextFacet.facetDomain;
      delete nextFacet.range;
      if (index >= 0) facets[index] = nextFacet;
      else facets.push(nextFacet);
      changed = true;
    });

    if (changed) body.facets = facets;
    return changed;
  }

  function applyCoveoYearSelectionToFacetRequests(body) {
    if (!body || typeof body !== "object") return;
    const resolved = resolveCoveoYearFacetSelectionForRequest();
    const sel = resolved?.selection || null;
    const syntheticFacet = buildSyntheticYearFacetRequest(sel);
    if (sel?.fullRange) {
      clearCoveoYearFacetSelection();
      setCoveoManagedRangeClearTombstone(COVEO_YEAR_FACET_ID, true);
    } else if (syntheticFacet) {
      setCoveoYearFacetSelection(sel);
    }
    const cleared = hasCoveoManagedRangeClearTombstone(COVEO_YEAR_FACET_ID);
    const facets = Array.isArray(body.facets) ? body.facets : [];
    const retainedFacets = [];
    let appliedToExistingYearFacet = false;

    for (const facet of facets) {
      if (!facet || typeof facet !== "object") continue;
      const requestId = getCoveoFacetRequestFieldId(facet);
      if (!facetIdsMatchYear(requestId)) {
        retainedFacets.push(facet);
        continue;
      }
      if (cleared || appliedToExistingYearFacet) continue;
      if (syntheticFacet) {
        retainedFacets.push(syntheticFacet);
        appliedToExistingYearFacet = true;
      } else if (
        !sel?.fullRange && requestId === COVEO_YEAR_FACET_ID &&
        isNumericalRangeFacet({ state: facet }) &&
        [facet.field, facet.facetField, facet.parameter].every((field) =>
          !field || String(field).trim().toLowerCase() === COVEO_YEAR_FACET_ID,
        )
      ) {
        // Preserve the configured backend descriptor when no Year was selected.
        retainedFacets.push(facet);
        appliedToExistingYearFacet = true;
      }
      // Historical aliases are URL inputs only, never outbound facet fields.
    }
    if (syntheticFacet && !appliedToExistingYearFacet) {
      retainedFacets.push(syntheticFacet);
    }
    body.facets = retainedFacets;
  }

  const COVEO_YEAR_CQ_RE =
    /\(\s*@(?:year1|year_iiq)\s*>=\s*\d+\s+AND\s+@(?:year1|year_iiq)\s*<=\s*\d+\s*\)/gi;

  function escapeCoveoQueryStringLiteral(value) {
    return String(value || "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }

  function normalizeCoveoBrandScopeCandidate(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function sanitizeCoveoBrandScopeCandidate(value) {
    const normalized = normalizeCoveoBrandScopeCandidate(value);
    if (!normalized) return "";
    return normalizeCoveoBrandScopeCandidate(
      normalized
        .replace(/\bfor sale\b/gi, " ")
        .replace(/\bboats?\b/gi, " ")
        .replace(/\bpontoons?\b/gi, " ")
        .replace(/\binventory\b/gi, " ")
        .replace(/\bcollection\b/gi, " ")
        .replace(/\bcollections\b/gi, " ")
        .replace(/\bbrokerage\b/gi, " ")
        .replace(/\bclearance\b/gi, " ")
        .replace(/\bsale\b/gi, " ")
        .replace(/\bused\b/gi, " ")
        .replace(/\bnew\b/gi, " ")
        .replace(/\barrivals?\b/gi, " ")
        .replace(/\blatest\b/gi, " ")
        .replace(/\bfeatured\b/gi, " ")
        .replace(/\byachts?\b/gi, " ")
        .replace(/\bcenter console\b/gi, " ")
        .replace(/\bconsole\b/gi, " ")
        .replace(/\bfishing\b/gi, " "),
    );
  }

  function formatCoveoHandleAsTitle(value) {
    return String(value || "")
      .split("-")
      .filter(Boolean)
      .map(function (part) {
        return part.charAt(0).toUpperCase() + part.slice(1);
      })
      .join(" ");
  }

  function getCoveoCollectionBrandScopeValues() {
    const collectionRoot = document.getElementById("coveo-headless-collection");
    if (!collectionRoot) return [];

    const values = new Set();
    const addCandidate = function (value) {
      const normalized = sanitizeCoveoBrandScopeCandidate(value);
      if (!normalized) return;
      if (normalized.length < 2) return;
      values.add(normalized);
    };

    const explicit = String(
      collectionRoot.dataset.collectionBrandScope || "",
    ).trim();
    if (explicit) {
      explicit
        .split(/[|,;]/)
        .map(normalizeCoveoBrandScopeCandidate)
        .filter(Boolean)
        .forEach(addCandidate);
    }

    return Array.from(values).filter(function (value) {
      if (!value || /\d/.test(value)) return false;
      if (/^(for|sale)$/i.test(value)) return false;
      return true;
    });
  }

  function getLegacyInferredCollectionBrandScopeValues() {
    const collectionRoot = document.getElementById("coveo-headless-collection");
    if (!collectionRoot) return [];
    const candidates = [
      collectionRoot.dataset.collectionTitle,
      formatCoveoHandleAsTitle(collectionRoot.dataset.collectionHandle),
    ]
      .map(sanitizeCoveoBrandScopeCandidate)
      .filter(Boolean);
    return Array.from(new Set(candidates));
  }

  function removeLegacyInferredCollectionMakeFromUrlState(state) {
    if (!(state?.facetValues instanceof Map)) return false;
    const collectionRoot = document.getElementById("coveo-headless-collection");
    if (!collectionRoot) return false;
    if (String(collectionRoot.dataset.collectionBrandScope || "").trim()) {
      return false;
    }

    const legacyValues = new Set(
      getLegacyInferredCollectionBrandScopeValues()
        .map(normalizeCoveoFacetValueToken)
        .filter(Boolean),
    );
    if (!legacyValues.size) return false;

    let removed = false;
    const retainedMakeValues = [];
    state.facetValues.forEach(function (values, facetKey) {
      const normalizedKey = normalizeCoveoUrlFacetId(facetKey);
      if (normalizedKey !== "make" && !facetIdsMatchMake(normalizedKey)) {
        return;
      }
      const retained = (Array.isArray(values) ? values : []).filter(
        function (value) {
          const isLegacy = legacyValues.has(normalizeCoveoFacetValueToken(value));
          if (isLegacy) removed = true;
          return !isLegacy;
        },
      );
      if (retained.length) {
        state.facetValues.set(facetKey, retained);
        retainedMakeValues.push(...retained);
      } else {
        state.facetValues.delete(facetKey);
      }
    });

    if (!removed) return false;
    try {
      const url = new URL(window.location.href);
      const makeKeys = [];
      url.searchParams.forEach(function (_value, key) {
        const normalizedKey = normalizeCoveoUrlFacetId(key);
        if (
          normalizedKey === "make" ||
          (normalizedKey.startsWith(COVEO_URL_LEGACY_FACET_PREFIX) &&
            facetIdsMatchMake(
              normalizedKey.slice(COVEO_URL_LEGACY_FACET_PREFIX.length),
            ))
        ) {
          makeKeys.push(key);
        }
      });
      makeKeys.forEach(function (key) {
        url.searchParams.delete(key);
      });
      Array.from(new Set(retainedMakeValues)).forEach(function (value) {
        url.searchParams.append("make", value);
      });
      replaceCoveoHistoryUrl(url.toString());
    } catch (_) { }
    return true;
  }

  function getCoveoCollectionBrandScopeClause() {
    const brandScopes = getCoveoCollectionBrandScopeValues();
    if (!brandScopes.length) return "";

    const clauses = [];
    brandScopes.forEach(function (brandScope) {
      const escaped = escapeCoveoQueryStringLiteral(brandScope);
      clauses.push(`@ec_brand=="${escaped}"`);
      clauses.push(`@make_name_iiq=="${escaped}"`);
      clauses.push(`@make_name=="${escaped}"`);
      clauses.push(`@ec_make=="${escaped}"`);
      clauses.push(`@manufacturer=="${escaped}"`);
      clauses.push(`@ec_manufacturer=="${escaped}"`);
    });

    return Array.from(new Set(clauses)).join(" OR ");
  }

  function hasCoveoCollectionBrandScopeUiSuppression() {
    const collectionRoot = document.getElementById("coveo-headless-collection");
    if (!collectionRoot) return false;
    return getCoveoCollectionBrandScopeValues().length > 0;
  }

  function shouldHideCollectionBrandFacetFromUi(facetId) {
    const normalizedFacetId = String(facetId || "").trim().toLowerCase();
    return normalizedFacetId === "permanentid";
  }

  function isAutoAppliedCollectionBrandFacetValue(facetId, value) {
    if (!shouldHideCollectionBrandFacetFromUi(facetId)) return false;
    const normalizedValue = normalizeCoveoFacetValueToken(value);
    if (!normalizedValue) return false;
    return getCoveoCollectionBrandScopeValues()
      .map(normalizeCoveoFacetValueToken)
      .some(function (candidate) {
        return candidate === normalizedValue;
      });
  }

  function normalizeCoveoFacetValueToken(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }

  function isCoveoCollectionBrandFacetDescriptor(facet) {
    const field = String(
      facet?.field || facet?.facetField || facet?.facetId || "",
    ).trim().toLowerCase();
    return (
      field === "make_name_iiq" ||
      field === "make_name" ||
      field === "ec_brand" ||
      field === "ec_make" ||
      field === "manufacturer" ||
      field === "ec_manufacturer"
    );
  }

  function buildCoveoCollectionHiddenBrandFacet(primaryBrand) {
    return {
      initialNumberOfValues: 10,
      facetId: "make_name_iiq",
      displayName: "Make",
      numberOfValues: 10,
      field: "make_name_iiq",
      type: "regular",
      values: [
        {
          value: primaryBrand,
          state: "selected",
        },
      ],
      freezeCurrentValues: false,
      preventAutoSelect: false,
    };
  }

  function applyCoveoCollectionBrandScopeToFacetRequests(body) {
    if (!body || typeof body !== "object") return;
    const brandScopes = getCoveoCollectionBrandScopeValues();
    if (!brandScopes.length) return;
    const activeSortValue = String(
      window.__coveoActiveSortValue?.() || "",
    ).trim();
    if (!getActiveCoveoLocationContext() && activeSortValue !== "nearest") {
      return;
    }

    const normalizedTargets = new Set(
      brandScopes.map(normalizeCoveoFacetValueToken).filter(Boolean),
    );
    if (!normalizedTargets.size) return;

    const facets = Array.isArray(body.facets) ? body.facets : [];
    let applied = false;

    facets.forEach(function (facet) {
      if (!isCoveoCollectionBrandFacetDescriptor(facet)) return;
      const values = Array.isArray(facet.values) ? facet.values : [];
      values.forEach(function (value) {
        const raw = normalizeCoveoFacetValueToken(value?.value);
        if (!raw || !normalizedTargets.has(raw)) return;
        value.state = "selected";
        applied = true;
      });
    });

    if (!applied) {
      const primaryBrand = brandScopes[brandScopes.length - 1] || brandScopes[0];
      if (!primaryBrand) return;
      facets.push(buildCoveoCollectionHiddenBrandFacet(primaryBrand));
      body.facets = facets;
    }
  }

  function applyCoveoCollectionMembershipScopeToFacetRequests(body) {
    if (!body || typeof body !== "object") return false;
    const collectionRoot = document.getElementById("coveo-headless-collection");
    const membership = collectionRoot?._coveoCollectionScopeMembership;
    const collectionHandle = normalizeCoveoCollectionHandleValue(
      collectionRoot?.dataset?.collectionHandle,
    );
    if (
      !isCompleteCoveoCollectionMembershipForHandle(
        membership,
        collectionHandle,
      )
    ) {
      return false;
    }
    const membershipField =
      membership?._coveoCanonicalMembershipField === "ec_product_id"
        ? "ec_product_id"
        : "permanentid";
    const membershipIds = Array.from(
      membershipField === "ec_product_id"
        ? membership?.productGids || []
        : membership?.variantGids || [],
    )
      .map(function (value) {
        return String(value || "").trim();
      })
      .filter(Boolean)
      .sort();
    if (!membershipIds.length) return false;

    const facets = Array.isArray(body.facets) ? body.facets.slice() : [];
    const retainedFacets = facets.filter(function (facet) {
      const facetId = String(
        facet?.facetId || facet?.field || facet?.facetField || "",
      )
        .trim()
        .toLowerCase();
      return facetId !== "permanentid" && facetId !== "ec_product_id";
    });
    retainedFacets.push({
      initialNumberOfValues: membershipIds.length,
      facetId: membershipField,
      displayName: "Collection membership",
      numberOfValues: membershipIds.length,
      field: membershipField,
      type: "regular",
      values: membershipIds.map(function (value) {
        return { value: value, state: "selected" };
      }),
      freezeCurrentValues: true,
      preventAutoSelect: false,
    });
    body.facets = retainedFacets;
    return true;
  }

  function getCoveoCollectionScopeClause(handleOverride) {
    let rawHandle = String(handleOverride || "").trim();
    if (!rawHandle) {
      const collectionRoot = document.getElementById("coveo-headless-collection");
      rawHandle = String(collectionRoot?.dataset?.collectionHandle || "").trim();
    }
    if (!rawHandle) return "";
    if (rawHandle.toLowerCase() === "all") return "";
    const escaped = escapeCoveoQueryStringLiteral(rawHandle);
    return `@ec_collection_handle=="${escaped}"`;
  }

  function buildCoveoCollectionMembershipFieldClause(fieldName, values) {
    const normalizedValues = Array.from(values || [])
      .map(function (value) {
        return String(value || "").trim();
      })
      .filter(Boolean)
      .sort();
    if (!normalizedValues.length) return "";

    const chunkSize = 100;
    const clauses = [];
    for (let index = 0; index < normalizedValues.length; index += chunkSize) {
      const chunk = normalizedValues.slice(index, index + chunkSize);
      const encodedValues = chunk
        .map(function (value) {
          return `"${escapeCoveoQueryStringLiteral(value)}"`;
        })
        .join(",");
      clauses.push(`@${fieldName}==(${encodedValues})`);
    }
    return clauses.length === 1
      ? clauses[0]
      : `(${clauses.join(" OR ")})`;
  }

  function getCoveoCanonicalCollectionScopeClause(handleOverride) {
    const collectionRoot = document.getElementById("coveo-headless-collection");
    const membership = collectionRoot?._coveoCollectionScopeMembership;
    const normalizedHandle = normalizeCoveoCollectionHandleValue(
      handleOverride || collectionRoot?.dataset?.collectionHandle,
    );
    if (
      !isCompleteCoveoCollectionMembershipForHandle(
        membership,
        normalizedHandle,
      )
    ) {
      return "";
    }

    /*
     * The Commerce index uses Shopify variant GIDs as `permanentid` (the same
     * value rendered into data-coveo-product-key). Scoping Search to the
     * canonical Shopify collection membership keeps geo filtering server-side
     * without guessing a Make from the collection title.
     */
    const membershipField =
      membership._coveoCanonicalMembershipField === "ec_product_id"
        ? "ec_product_id"
        : "permanentid";
    return buildCoveoCollectionMembershipFieldClause(
      membershipField,
      membershipField === "ec_product_id"
        ? membership.productGids
        : membership.variantGids,
    );
  }

  function hasCoveoCanonicalCollectionMembership(handleOverride) {
    const collectionRoot = document.getElementById("coveo-headless-collection");
    const membership = collectionRoot?._coveoCollectionScopeMembership;
    const normalizedHandle = normalizeCoveoCollectionHandleValue(
      handleOverride || collectionRoot?.dataset?.collectionHandle,
    );
    return isCompleteCoveoCollectionMembershipForHandle(
      membership,
      normalizedHandle,
    );
  }

  function removeCoveoScopeClause(cq, clause) {
    const normalizedClause = String(clause || "").trim();
    if (!normalizedClause) return String(cq || "").trim();
    return String(cq || "")
      .split(/\s+AND\s+/i)
      .filter(function (part) {
        const normalizedPart = String(part || "")
          .trim()
          .replace(/^\((.*)\)$/s, "$1")
          .trim();
        return normalizedPart !== normalizedClause;
      })
      .join(" AND ")
      .trim();
  }

  function getCoveoServerCollectionScopeClause(handleOverride) {
    const handleClause = getCoveoCollectionScopeClause(handleOverride);
    if (!handleClause) return "";
    return (
      getCoveoCanonicalCollectionScopeClause(handleOverride) ||
      '@permanentid=="__marinemax_incomplete_collection_membership__"'
    );
  }

  function applyCoveoCollectionScopeToRequestCq(body, options) {
    if (!body || typeof body !== "object") return;
    const opts = options || {};
    const handleClause = getCoveoCollectionScopeClause(
      opts.collectionHandle,
    );
    const collectionScopeClause = opts.skipCollectionScope
      ? ""
      : opts.useCanonicalMembership
        ? getCoveoServerCollectionScopeClause(opts.collectionHandle)
        : handleClause;
    const scopeClauses = [
      collectionScopeClause,
      getCoveoCollectionBrandScopeClause(),
    ].filter(Boolean);
    let currentCq = String(body.cq || "").trim();
    if (opts.skipCollectionScope && handleClause) {
      currentCq = removeCoveoScopeClause(currentCq, handleClause);
    }
    if (
      opts.useCanonicalMembership &&
      collectionScopeClause &&
      collectionScopeClause !== handleClause
    ) {
      currentCq = removeCoveoScopeClause(currentCq, handleClause);
    }
    if (!scopeClauses.length) {
      if (currentCq) body.cq = currentCq;
      else delete body.cq;
      return;
    }
    const missingClauses = scopeClauses.filter(function (clause) {
      return !currentCq.includes(clause);
    });
    if (!missingClauses.length) {
      if (currentCq) body.cq = currentCq;
      else delete body.cq;
      return;
    }

    const nextClause = missingClauses
      .map(function (clause) {
        return clause.includes(" OR ") ? `(${clause})` : clause;
      })
      .join(" AND ");
    body.cq = currentCq ? `(${currentCq}) AND ${nextClause}` : nextClause;
  }

  function getCoveoCollectionHandleFromViewUrl(value) {
    try {
      const parsed = new URL(String(value || ""), window.location.origin);
      const match = parsed.pathname.match(/\/collections\/([^/?#]+)/i);
      return normalizeCoveoCollectionHandleValue(
        match ? decodeURIComponent(match[1]) : "",
      );
    } catch (_) {
      return "";
    }
  }

  function normalizeCoveoCollectionHandleValue(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }

  function coveoProductHasCollectionHandle(product, handle) {
    if (!product || !handle) return false;
    const target = normalizeCoveoCollectionHandleValue(handle);
    const af = product.additionalFields || {};
    const rawCandidates = [
      product.ec_collection_handle,
      af.ec_collection_handle,
      af.collection_handle,
      af.ec_collection,
    ];

    for (const raw of rawCandidates) {
      if (raw == null || raw === "") continue;
      const values = Array.isArray(raw)
        ? raw
        : String(raw)
            .split(/[|,;]/)
            .map((v) => v.trim())
            .filter(Boolean);
      if (
        values.some((v) => normalizeCoveoCollectionHandleValue(v) === target)
      ) {
        return true;
      }
    }
    return false;
  }

  function filterCoveoProductsByCollectionHandle(products, handle) {
    const list = Array.isArray(products) ? products : [];
    if (!list.length || !handle) return list;

    const productsWithField = list.filter((p) => {
      const af = p?.additionalFields || {};
      return (
        p?.ec_collection_handle != null ||
        af.ec_collection_handle != null ||
        af.collection_handle != null ||
        af.ec_collection != null
      );
    });

    if (!productsWithField.length) return list;
    return list.filter((p) => coveoProductHasCollectionHandle(p, handle));
  }

  function normalizeCoveoCollectionProductPath(value) {
    const raw = String(value || "").trim();
    if (!raw) return "";
    let path = "";
    if (raw.startsWith("/")) {
      path = raw.split("?")[0];
    } else {
      try {
        path = new URL(raw, window.location.origin).pathname;
      } catch (_) {
        return "";
      }
    }
    if (!path) return "";
    return String(path)
      .replace(/\/+$/, "")
      .toLowerCase();
  }

  function buildCoveoCollectionMembership(handle) {
    return {
      handle: normalizeCoveoCollectionHandleValue(handle),
      productPaths: new Set(),
      productHandles: new Set(),
      productGids: new Set(),
      variantGids: new Set(),
    };
  }

  const COVEO_COLLECTION_MEMBERSHIP_CACHE_VERSION = 4;
  const COVEO_COLLECTION_MEMBERSHIP_CACHE_TTL_MS = 30 * 60 * 1000;
  const COVEO_COLLECTION_LISTING_MEMBERSHIP_CACHE_TTL_MS = 5 * 60 * 1000;
  const COVEO_COLLECTION_MEMBERSHIP_CACHE_PREFIX =
    "marinemax:coveo-collection-membership:";

  function getCoveoCollectionMembershipCacheKey(handle) {
    const normalizedHandle = normalizeCoveoCollectionHandleValue(handle);
    return normalizedHandle
      ? `${COVEO_COLLECTION_MEMBERSHIP_CACHE_PREFIX}${normalizedHandle}`
      : "";
  }

  function readCachedCoveoCollectionMembership(handle) {
    const normalizedHandle = normalizeCoveoCollectionHandleValue(handle);
    const cacheKey = getCoveoCollectionMembershipCacheKey(normalizedHandle);
    if (!cacheKey) return null;

    try {
      const raw = window.sessionStorage?.getItem(cacheKey);
      if (!raw) return null;
      const cached = JSON.parse(raw);
      if (
        Number(cached?.version) !== COVEO_COLLECTION_MEMBERSHIP_CACHE_VERSION ||
        cached?.handle !== normalizedHandle ||
        Number(cached?.expiresAt) <= Date.now()
      ) {
        window.sessionStorage?.removeItem(cacheKey);
        return null;
      }

      const membership = buildCoveoCollectionMembership(normalizedHandle);
      [
        ["productPaths", membership.productPaths],
        ["productHandles", membership.productHandles],
        ["productGids", membership.productGids],
        ["variantGids", membership.variantGids],
      ].forEach(function (entry) {
        const values = Array.isArray(cached?.[entry[0]])
          ? cached[entry[0]]
          : [];
        values.forEach(function (value) {
          const normalizedValue = String(value || "").trim();
          if (normalizedValue) entry[1].add(normalizedValue);
        });
      });
      membership._coveoProductListingComplete = cached?.complete === true;
      membership._coveoShopifyPaginationComplete =
        cached?.shopifyPaginationComplete === true;
      membership._coveoMembershipSource = String(cached?.source || "");
      membership._coveoCanonicalMembershipField =
        cached?.canonicalField === "ec_product_id"
          ? "ec_product_id"
          : "permanentid";
      membership._coveoListingTotal =
        cached?.listingTotal != null &&
        Number.isFinite(Number(cached.listingTotal))
        ? Number(cached.listingTotal)
        : null;
      return hasCoveoCollectionMembershipIdentifiers(membership)
        ? membership
        : null;
    } catch (_) {
      return null;
    }
  }

  function cacheCoveoCollectionMembership(membership) {
    const cacheKey = getCoveoCollectionMembershipCacheKey(membership?.handle);
    if (!cacheKey || !hasCoveoCollectionMembershipIdentifiers(membership)) {
      return;
    }

    try {
      const membershipTtl =
        membership._coveoMembershipSource === "productListing"
          ? COVEO_COLLECTION_LISTING_MEMBERSHIP_CACHE_TTL_MS
          : COVEO_COLLECTION_MEMBERSHIP_CACHE_TTL_MS;
      window.sessionStorage?.setItem(
        cacheKey,
        JSON.stringify({
          version: COVEO_COLLECTION_MEMBERSHIP_CACHE_VERSION,
          handle: membership.handle,
          expiresAt: Date.now() + membershipTtl,
          complete: membership._coveoProductListingComplete === true,
          shopifyPaginationComplete:
            membership._coveoShopifyPaginationComplete === true,
          source: String(membership._coveoMembershipSource || ""),
          canonicalField:
            membership._coveoCanonicalMembershipField === "ec_product_id"
              ? "ec_product_id"
              : "permanentid",
          listingTotal: Number.isFinite(membership._coveoListingTotal)
            ? membership._coveoListingTotal
            : null,
          productPaths: Array.from(membership.productPaths || []),
          productHandles: Array.from(membership.productHandles || []),
          productGids: Array.from(membership.productGids || []),
          variantGids: Array.from(membership.variantGids || []),
        }),
      );
    } catch (_) { }
  }

  function hasCoveoCollectionMembershipIdentifiers(membership) {
    return !!(
      membership &&
      (membership.variantGids?.size > 0 || membership.productGids?.size > 0)
    );
  }

  function isCompleteCoveoCollectionMembershipForHandle(
    membership,
    handle,
  ) {
    const normalizedHandle = normalizeCoveoCollectionHandleValue(handle);
    const canonicalField =
      membership?._coveoCanonicalMembershipField === "ec_product_id"
        ? "ec_product_id"
        : "permanentid";
    const hasCanonicalIdentifiers =
      canonicalField === "ec_product_id"
        ? membership?.productGids?.size > 0
        : membership?.variantGids?.size > 0;
    return !!(
      normalizedHandle &&
      normalizedHandle !== "all" &&
      membership &&
      membership.handle === normalizedHandle &&
      membership._coveoProductListingComplete === true &&
      hasCanonicalIdentifiers
    );
  }

  function addCoveoProductsToCollectionMembership(
    membership,
    products,
    collectionHandle,
  ) {
    const resolvedMembership =
      membership || buildCoveoCollectionMembership(collectionHandle);
    (Array.isArray(products) ? products : []).forEach(function (product) {
      const additionalFields = product?.additionalFields || {};
      const permanentId = String(
        product?.permanentid || additionalFields.permanentid || "",
      ).trim();
      if (permanentId) resolvedMembership.variantGids.add(permanentId);

      const productId = String(
        product?.ec_product_id || additionalFields.ec_product_id || "",
      ).trim();
      if (productId) resolvedMembership.productGids.add(productId);

      const productPath = normalizeCoveoCollectionProductPath(
        product?.clickUri || product?.uri || additionalFields.clickUri || "",
      );
      if (productPath) {
        resolvedMembership.productPaths.add(productPath);
        const productHandle =
          productPath.split("/").filter(Boolean).pop() || "";
        if (productHandle) resolvedMembership.productHandles.add(productHandle);
      }
    });
    return resolvedMembership;
  }

  async function fetchCoveoCollectionMembership(handle, signal) {
    const normalizedHandle = normalizeCoveoCollectionHandleValue(handle);
    if (!normalizedHandle || normalizedHandle === "all") {
      return buildCoveoCollectionMembership(normalizedHandle);
    }

    const cachedMembership = readCachedCoveoCollectionMembership(
      normalizedHandle,
    );
    if (cachedMembership) return cachedMembership;

    const membership = buildCoveoCollectionMembership(normalizedHandle);

    const maxPages = 20;
    const pageSize = 250;
    let paginationComplete = false;

    for (let page = 1; page <= maxPages; page += 1) {
      const url = new URL(
        `/collections/${encodeURIComponent(normalizedHandle)}/products.json`,
        window.location.origin,
      );
      url.searchParams.set("limit", String(pageSize));
      url.searchParams.set("page", String(page));

      const response = await fetch(url.toString(), {
        credentials: "same-origin",
        signal,
      });
      if (!response.ok) {
        throw new Error(
          `Collection membership request failed (${response.status})`,
        );
      }

      const payload = await response.json().catch(function () {
        return {};
      });
      const products = Array.isArray(payload?.products) ? payload.products : [];

      products.forEach(function (product) {
        const productHandle = normalizeCoveoCollectionHandleValue(product?.handle);
        if (productHandle) {
          membership.productHandles.add(productHandle);
          membership.productPaths.add(`/products/${productHandle}`);
        }

        const productId = String(product?.id || "").trim();
        if (productId) {
          membership.productGids.add(`gid://shopify/Product/${productId}`);
        }

        const variants = Array.isArray(product?.variants) ? product.variants : [];
        variants.forEach(function (variant) {
          const variantId = String(variant?.id || "").trim();
          if (variantId) {
            membership.variantGids.add(
              `gid://shopify/ProductVariant/${variantId}`,
            );
          }
        });
      });

      if (products.length < pageSize) {
        paginationComplete = true;
        break;
      }
    }

    membership._coveoShopifyPaginationComplete = paginationComplete;
    membership._coveoMembershipSource = "shopify";
    cacheCoveoCollectionMembership(membership);
    return membership;
  }

  async function ensureCoveoCollectionMembership(
    container,
    handle,
    lifecycle,
    requestSignal,
  ) {
    if (!container || !handle) return null;

    const normalizedHandle = normalizeCoveoCollectionHandleValue(handle);
    if (!normalizedHandle || normalizedHandle === "all") {
      return null;
    }

    const existing = container._coveoCollectionScopeMembership;
    if (existing?.handle === normalizedHandle) {
      return existing;
    }

    if (
      container._coveoCollectionScopeMembershipPromise &&
      container._coveoCollectionScopeMembershipHandle === normalizedHandle
    ) {
      return container._coveoCollectionScopeMembershipPromise;
    }

    container._coveoCollectionScopeMembershipHandle = normalizedHandle;
    container._coveoCollectionScopeMembershipPromise =
      fetchCoveoCollectionMembership(
        normalizedHandle,
        requestSignal || lifecycle?.signal,
      )
        .then(function (membership) {
          if (lifecycle && !lifecycle.active) return null;
          container._coveoCollectionScopeMembership = membership;
          return membership;
        })
        .catch(function (err) {
          if (err?.name === "AbortError" || (lifecycle && !lifecycle.active)) {
            return null;
          }
          console.warn(
            "[Coveo Collection] Failed to load canonical collection membership:",
            err,
          );
          container._coveoCollectionScopeMembership = null;
          return null;
        })
        .finally(function () {
          if (lifecycle && !lifecycle.active) return;
          container._coveoCollectionScopeMembershipPromise = null;
          try {
            if (
              !window.__coveoCollectionScopePrefetchLoading &&
              !container._coveoCollectionMembershipManagedRender &&
              container._coveoSearch &&
              container._coveoMod
            ) {
              render(
                container._coveoSearch,
                container,
                container._coveoMod,
                container._coveoSubControllers || {},
              );
            }
          } catch (_) { }
        });

    return container._coveoCollectionScopeMembershipPromise;
  }

  function coveoProductMatchesCollectionMembership(product, membership) {
    if (!product || !membership) return false;

    const af = product.additionalFields || {};
    const idCandidates = [
      product.permanentid,
      product.ec_product_id,
      af.permanentid,
      af.ec_product_id,
      af.productid,
    ]
      .map(function (value) {
        return String(value || "").trim();
      })
      .filter(Boolean);

    if (
      idCandidates.some(function (value) {
        return (
          membership.variantGids.has(value) || membership.productGids.has(value)
        );
      })
    ) {
      return true;
    }

    const pathCandidates = [
      product.clickUri,
      product.uri,
      af.clickUri,
      af.uri,
    ]
      .map(normalizeCoveoCollectionProductPath)
      .filter(Boolean);

    if (
      pathCandidates.some(function (path) {
        return membership.productPaths.has(path);
      })
    ) {
      return true;
    }

    return pathCandidates.some(function (path) {
      const lastSegment = String(path).split("/").filter(Boolean).pop() || "";
      return membership.productHandles.has(lastSegment);
    });
  }

  function filterCoveoProductsByCollectionMembership(products, membership) {
    const list = Array.isArray(products) ? products : [];
    if (!list.length || !membership) return list;

    const hasMembershipData =
      membership.productPaths.size > 0 ||
      membership.productHandles.size > 0 ||
      membership.productGids.size > 0 ||
      membership.variantGids.size > 0;
    if (!hasMembershipData) return list;

    return list.filter(function (product) {
      return coveoProductMatchesCollectionMembership(product, membership);
    });
  }

  /** Strip stale year cq fragments so year filtering travels through `body.facets`. */
  function applyCoveoYearSelectionToRequestCq(body) {
    let cq = String(body.cq || "")
      .replace(COVEO_YEAR_CQ_RE, "")
      .replace(/\s+AND\s+AND\s+/gi, " AND ")
      .replace(/^\s*AND\s+|\s+AND\s*$/gi, "")
      .trim();
    if (cq) {
      body.cq = cq;
    } else {
      delete body.cq;
    }
  }

  function facetControllersIncludeYear(facets) {
    if (!Array.isArray(facets)) return false;
    return facets.some((f) => isUsableYearFacetController(f));
  }

  function isUsableYearFacetController(facet) {
    if (!facetIdsMatchYear(facet?.facetId || facet?.state?.facetId)) {
      return false;
    }
    return normalizeFacetStateValues(facet?.state || {}).length > 0;
  }

  function buildSyntheticYearFacetStub() {
    const dom = defaultYearFacetDomain();
    const sel = getCoveoYearFacetSelection();
    let minNum = dom.lo;
    let maxNum = dom.hi;
    if (sel && !sel.fullRange) {
      minNum = sel.lo;
      maxNum = sel.hi;
    }
    return {
      _isSyntheticYearFacet: true,
      facetId: COVEO_YEAR_FACET_ID,
      state: {
        facetId: COVEO_YEAR_FACET_ID,
        displayName: "Year",
        type: "numericalRange",
        values: [],
        domain: { min: dom.lo, max: dom.hi },
        _syntheticSelected: { min: minNum, max: maxNum },
      },
    };
  }

  function findSearchSubmitButton(container) {
    if (!container) return null;
    const inputIds = [
      "coveo-search-page-input",
      "coveo-collection-search-input",
    ];
    for (const id of inputIds) {
      const input = container.querySelector(`input#${id}`);
      if (!input) continue;
      const form = input.closest("form");
      if (!form) continue;
      return (
        form.querySelector('button[type="submit"]') ||
        form.querySelector("button")
      );
    }
    return container.querySelector('button[type="submit"]') || null;
  }

  function wireSearchSubmitButtonClassToggle(container, lifecycle) {
    const btn = findSearchSubmitButton(container);
    if (!btn) return;

    const media = window.matchMedia("(max-width: 767.98px)");

    const apply = () => {
      const isMobile = !!media.matches;
      btn.classList.toggle("btn--primary", !isMobile);
      btn.classList.toggle("btn--secondary", isMobile);
      btn.classList.toggle("btn--thirdary", isMobile);
    };

    apply();

    if (media.addEventListener) {
      lifecycle?.listen(media, "change", apply) ||
        media.addEventListener("change", apply);
    } else if (media.addListener) {
      media.addListener(apply);
      lifecycle?.addCleanup(function () {
        media.removeListener?.(apply);
      });
    } else {
      lifecycle?.listen(window, "resize", apply) ||
        window.addEventListener("resize", apply);
    }
  }

  /**
   * Coveo can dispatch while `render` reads facet controllers (lazy facet build).
   * Synchronous `engine.subscribe(() => render())` then re-enters `render` → stack overflow.
   * This coalesces UI updates to a later microtask and replays if dispatch happens mid-pass.
   */
  function createAsyncCoveoRender(fn) {
    let inFlight = false;
    let pendingAgain = false;
    return function scheduleCoveoUiRender() {
      if (inFlight) {
        pendingAgain = true;
        return;
      }
      inFlight = true;
      queueMicrotask(function flushCoveoUiRender() {
        try {
          do {
            pendingAgain = false;
            fn();
          } while (pendingAgain);
        } finally {
          inFlight = false;
        }
      });
    };
  }

  function getCoveoPageLifecycleRuntime() {
    const runtime = window.MarineMaxCoveoPageLifecycle;
    if (!runtime || typeof runtime.create !== "function") {
      throw new Error("Coveo page lifecycle runtime is unavailable");
    }
    return runtime;
  }

  function createCoveoPageLifecycleOwner(container, mode) {
    const runtime = getCoveoPageLifecycleRuntime();
    const currentOwner = runtime.get(container, mode);
    const owner = currentOwner?.active
      ? currentOwner
      : runtime.create(container, mode);

    if (!currentOwner?.active) {
      owner.own(container, "_coveoPageLifecycleOwner", owner);
      const pageToken = Object.freeze({ mode, root: container });
      owner.own(container, "_coveoPageLifecycleToken", pageToken);
      owner.claim(window, "__coveoActivePageLifecycleOwner", pageToken);
      owner.addCleanup(function () {
        if (window.__coveoActivePageLifecycleOwner !== pageToken) return;
        delete window.__coveoClientOnlyDistanceFilter;
        delete window.__coveoSuppressInitialCollectionDistance;
      });
      owner.addCleanup(function () {
        const initializations = container._coveoPageInitializationPromises;
        if (initializations instanceof Map) {
          initializations.delete(mode);
          if (initializations.size === 0) {
            delete container._coveoPageInitializationPromises;
          }
        }
      });
      owner.addCleanup(function () {
        cancelCoveoUiMutations(container, "lifecycle-destroyed");
        if (container._coveoDeferredProductRenderTimer) {
          window.clearTimeout(container._coveoDeferredProductRenderTimer);
          container._coveoDeferredProductRenderTimer = null;
        }

        const facetContent = container.querySelector?.(
          "#CoveoFiltersDrawerContent",
        );
        if (facetContent?._coveoDeferredFacetRenderTimer) {
          window.clearTimeout(facetContent._coveoDeferredFacetRenderTimer);
          facetContent._coveoDeferredFacetRenderTimer = null;
        }
        const rangeTimers = facetContent?._coveoRangeUiUnlockTimerByFacet;
        if (rangeTimers && typeof rangeTimers === "object") {
          Object.values(rangeTimers).forEach(function (timerId) {
            window.clearTimeout(timerId);
          });
          facetContent._coveoRangeUiUnlockTimerByFacet = {};
        }
        const facetDisposers = facetContent?._coveoFacetLoadMoreDisposers;
        if (Array.isArray(facetDisposers)) {
          facetDisposers.splice(0).forEach(function (dispose) {
            try {
              dispose();
            } catch (_) { }
          });
        }

        const recommendationGrid = container.querySelector?.(
          '[id^="coveo-recommendations-grid-"]',
        );
        if (recommendationGrid?.id) {
          window.MarineMaxHeadlessRecommendationsRuntime?.destroy?.(
            recommendationGrid.id,
          );
        }

        delete container.dataset.coveoActiveFiltersStripWired;
        delete container.dataset.coveoFiltersDrawerWired;
        delete container.dataset.coveoUiMutationBusy;
        container.classList?.remove("is-coveo-ui-busy");
        [
          "_coveoCollectionMode",
          "_coveoCollectionListingTemplateRequest",
          "_coveoCollectionMembershipManagedRender",
          "_coveoCollectionPrefetchRenderPending",
          "_coveoCollectionResolvedQuery",
          "_coveoCollectionRouteIntentRevision",
          "_coveoCollectionScopeMembership",
          "_coveoCollectionScopeMembershipHandle",
          "_coveoCollectionScopeMembershipPromise",
          "_coveoDeferredProductRenderTimer",
          "_coveoEnsureDistanceProductPool",
          "_coveoEngine",
          "_coveoGetCollectionCountDebug",
          "_coveoMod",
          "_coveoBeginCollectionRouteIntent",
          "_coveoResolveActiveControllerBundle",
          "_coveoResolveDispatchController",
          "_coveoSearch",
          "_coveoSubControllers",
          "_coveoSuppressProductRenderUntil",
          "_coveoUiMutationInFlight",
          "_coveoUiMutationLeaseRecord",
          "_coveoUiMutationQueue",
          "_coveoWillUseServerDistanceFiltering",
        ].forEach(function (key) {
          delete container[key];
        });
      });
    }
    return owner;
  }

  function destroyCoveoHeadlessPage(root, mode) {
    const container =
      root && typeof root === "object"
        ? root
        : document.getElementById(
            mode === "collection"
              ? "coveo-headless-collection"
              : "coveo-headless-search",
          );
    if (!container) return false;
    const runtime = window.MarineMaxCoveoPageLifecycle;
    return !!runtime?.destroy?.(container, mode);
  }

  window.destroyCoveoHeadlessSearchPage = function (root) {
    return destroyCoveoHeadlessPage(root, "search");
  };
  window.destroyCoveoHeadlessCollectionPage = function (root) {
    return destroyCoveoHeadlessPage(root, "collection");
  };

  /*
   * Theme sections can evaluate their initializer more than once for the same
   * DOM root. Share the first run so a duplicate script cannot build another
   * controller and spend another Search/Product Listing request.
   */
  function runCoveoPageInitializationOnce(container, key, initialize) {
    if (!container || typeof initialize !== "function") {
      return Promise.resolve();
    }
    if (!container._coveoPageInitializationPromises) {
      container._coveoPageInitializationPromises = new Map();
    }
    const initializations = container._coveoPageInitializationPromises;
    if (initializations.has(key)) {
      return initializations.get(key);
    }

    let initializationPromise;
    initializationPromise = Promise.resolve()
      .then(initialize)
      .catch(function (error) {
        if (initializations.get(key) === initializationPromise) {
          initializations.delete(key);
        }
        throw error;
      });
    initializations.set(key, initializationPromise);
    return initializationPromise;
  }

  window.initCoveoHeadlessSearchPage = function (engine, config) {
    const container = document.getElementById("coveo-headless-search");
    if (!container) return Promise.resolve();

    const lifecycle = createCoveoPageLifecycleOwner(container, "search");

    return runCoveoPageInitializationOnce(container, "search", async function () {
      try {
      if (!lifecycle.active) return lifecycle;
      window.__coveoSuppressInitialCollectionDistance = false;
      coveoLastSyncedLocationCtxKey = null;
      initializeStoredLocationDistanceRadius();
      primePendingInitialCoveoUrlState();
      const mod = await import(COMMERCE_ESM);
      if (!lifecycle.active) return lifecycle;
      const buildSearch = mod.buildSearch || mod.search;
      const buildSearchBox = mod.buildSearchBox;

      if (!buildSearch) {
        return lifecycle;
      }

      const search = buildSearch(engine);
      search.__coveoControllerType = "search";
      let restoredFromSearchHistory = false;
      window.__coveoClientOnlyDistanceFilter = false;
      const searchBox = buildSearchBox ? buildSearchBox(engine) : null;
      lifecycle.claim(window, "CoveoSearchController", search);
      lifecycle.claim(window, "CoveoSearchBoxController", searchBox || null);
      window.CoveoCommerceModule = mod;

      let facetGen, paginationCtrl, summaryCtrl, sortCtrl;
      try {
        facetGen = search.facetGenerator && search.facetGenerator();
        paginationCtrl = search.pagination && search.pagination();
        summaryCtrl = search.summary && search.summary();
        sortCtrl = typeof search.sort === "function" ? search.sort() : null;
      } catch (_) { }

      const subControllers = {
        facetGen,
        paginationCtrl,
        summaryCtrl,
        sortCtrl,
      };
      lifecycle.own(container, "_coveoSearch", search);
      lifecycle.own(container, "_coveoMod", mod);
      lifecycle.own(container, "_coveoSubControllers", subControllers);
      const urlParams = new URLSearchParams(window.location.search);
      let q = urlParams.get("q") || "";
      /**
       * Cause forwarded from the standalone search box (header) via localStorage.
       * When set to "querySuggestion" we route the query through
       * `searchBox.selectSuggestion(...)` so the Coveo "Search Suggestion Query"
       * analytics model receives the click event (Coveo Delivery Assurance fix).
       */
      let queryCause = "";

      try {
        const stored = localStorage.getItem("coveo_standalone_search_box_data");
        if (stored) {
          const parsed = JSON.parse(stored);
          if (parsed?.value) {
            q = parsed.value;
            queryCause = String(parsed.cause || "");
            localStorage.removeItem("coveo_standalone_search_box_data");
            const url = new URL(window.location.href);
            url.searchParams.set("q", q);
            replaceCoveoHistoryUrl(url.toString());
          }
        }
      } catch (_) { }

      // Tracks whether a path that already executes the search (e.g.
      // `searchBox.selectSuggestion`) has been taken. The trailing
      // `executeFirstSearch()` below should be skipped in that case to
      // avoid sending duplicate queries.
      let searchAlreadyTriggered = false;

      setLastSubmittedKeywordQuery(search, container, q);
      lifecycle.addCleanup(function () {
        delete container._coveoLastSubmittedKeywordQuery;
        delete search._coveoLastSubmittedKeywordQuery;
      });
      if (q) {
        let querySet = false;

        if (
          queryCause === "querySuggestion" &&
          searchBox &&
          typeof searchBox.selectSuggestion === "function"
        ) {
          // Coveo Delivery Assurance fix: when the query came from the
          // header's standalone search box suggestion list, we re-play
          // the suggestion selection on the search page's engine. This
          // dispatches `selectQuerySuggestion` (which records the
          // "Search Suggestion Query" click event) and then executes
          // the search via the search box's `performSearch()`.
          try {
            if (typeof searchBox.updateText === "function") {
              searchBox.updateText(q);
            }
            searchBox.selectSuggestion(q);
            querySet = true;
            searchAlreadyTriggered = true;
          } catch (err) {
            console.warn(
              "[Coveo Headless] selectSuggestion failed; falling back to updateQuery:",
              err,
            );
          }
        }

        if (!querySet && mod.loadQueryActions) {
          const queryActions = mod.loadQueryActions(engine);
          if (queryActions?.updateQuery) {
            engine.dispatch(queryActions.updateQuery({ query: q }));
            querySet = true;
          }
        }
        if (!querySet && mod.loadSearchActions) {
          const searchActions = mod.loadSearchActions(engine);
          if (searchActions?.prepareForSearchWithQuery) {
            await engine.dispatch(
              searchActions.prepareForSearchWithQuery({ query: q }),
            );
            querySet = true;
          }
        }
        if (!querySet && searchBox?.updateText) {
          searchBox.updateText(q);
        }
      }
      if (!lifecycle.active) return lifecycle;

      const form =
        container.querySelector("#coveo-search-page-form") ||
        document.getElementById("coveo-search-page-form");
      const input =
        container.querySelector("#coveo-search-page-input") ||
        document.getElementById("coveo-search-page-input");
      if (form && input) {
        const clearBtn = form.querySelector("[data-coveo-clear-toolbar-search]");
        const stabilizeMobileSearchPageUi = (options) => {
          const opts = options || {};
          const run = () => {
            const isMobileViewport = window.matchMedia("(max-width: 767.98px)").matches;
            if (!isMobileViewport) return;

            const drawerEl = document.getElementById("CoveoFiltersDrawer");
            const isDrawerOpen = !!drawerEl?.hasAttribute("open");

            document.body.classList.remove("search-open");
            document
              .querySelectorAll(".predictive-search-open")
              .forEach((el) => el.classList.remove("predictive-search-open"));
            document
              .querySelectorAll(".header__coveo-search-wrapper, .hero-search")
              .forEach((el) => el.classList.remove("coveo-suggestions-visible"));
            document
              .querySelectorAll("#coveo-search-suggestions, #coveo-recent-queries, #hero-search-suggestions")
              .forEach((el) => {
                el.classList.add("hidden");
                if (
                  el.id === "coveo-search-suggestions" ||
                  el.id === "hero-search-suggestions"
                ) {
                  el.innerHTML = "";
                }
              });
            document
              .querySelectorAll(".header__search .search__content, predictive-search .search__content")
              .forEach((el) => el.classList.add("hidden"));

            if (!isDrawerOpen) {
              document.documentElement.classList.remove("coveo-filters-scroll-lock");
              document.body.classList.remove(
                "coveo-filters-scroll-lock",
                "modal-showing",
                "modal-show",
              );
              if (drawerEl) {
                drawerEl.removeAttribute("active");
                drawerEl.classList.remove("coveo-filters-keyboard-open");
              }
            }

            if (opts.blurInput) {
              try {
                input.blur();
              } catch (_) {}
              try {
                if (
                  document.activeElement &&
                  typeof document.activeElement.blur === "function"
                ) {
                  document.activeElement.blur();
                }
              } catch (_) {}
            }
          };

          const delay = Number(opts.delay || 0);
          if (delay > 0) {
            lifecycle.setTimeout(run, delay);
          } else {
            run();
          }
        };
        lifecycle.claim(
          window,
          "__coveoStabilizeSearchPageUi",
          stabilizeMobileSearchPageUi,
        );
        if (!window.__coveoSearchPageUiStabilizerWired) {
          window.__coveoSearchPageUiStabilizerWired = true;
          window.addEventListener("pageshow", () => {
            window.__coveoStabilizeSearchPageUi?.({ delay: 0 });
          });
          window.addEventListener("orientationchange", () => {
            window.__coveoStabilizeSearchPageUi?.({ delay: 60 });
          });
          window.addEventListener("resize", () => {
            window.__coveoStabilizeSearchPageUi?.({ delay: 0 });
          });
        }
        const syncToolbarSearchClearButton = (rawValue) => {
          if (!clearBtn) return;
          const hasValue = String(rawValue ?? "").length > 0;
          clearBtn.classList.toggle("hidden", !hasValue);
          clearBtn.setAttribute("aria-hidden", hasValue ? "false" : "true");
        };
        if (q) input.value = q;
        const headerInput = document.querySelector(
          "#coveo-search-wrapper input[name='q']",
        );
        if (headerInput) headerInput.value = q || "";
        stabilizeMobileSearchPageUi({ delay: 0 });

        const runSearch = async (val) => {
          const trimmed = (val ?? input.value ?? "").trim();
          stabilizeMobileSearchPageUi({ blurInput: true, delay: 0 });
          setLastSubmittedKeywordQuery(search, container, trimmed);
          if (!trimmed) {
            await clearKeywordQuery(search, engine, mod, container);
            await dispatchCoveoSearch(search, engine, mod);
            stabilizeMobileSearchPageUi({ delay: 120 });
            return;
          }
          if (mod.loadSearchActions) {
            const searchActions = mod.loadSearchActions(engine);
            if (searchActions?.prepareForSearchWithQuery) {
              await engine.dispatch(
                searchActions.prepareForSearchWithQuery({ query: trimmed }),
              );
            }
            if (searchActions?.executeSearch) {
              await engine.dispatch(searchActions.executeSearch());
            } else if (search.executeFirstSearch) {
              await search.executeFirstSearch();
            }
          } else if (mod.loadQueryActions) {
            const queryActions = mod.loadQueryActions(engine);
            if (queryActions?.updateQuery) {
              await engine.dispatch(
                queryActions.updateQuery({ query: trimmed }),
              );
            }
            if (search.executeFirstSearch) {
              await search.executeFirstSearch();
            }
          } else if (searchBox && searchBox.updateText) {
            searchBox.updateText(trimmed);
            if (searchBox.submit) searchBox.submit();
          } else if (search.executeFirstSearch) {
            await search.executeFirstSearch();
          }
          const url = new URL(window.location.href);
          if (trimmed) url.searchParams.set("q", trimmed);
          else url.searchParams.delete("q");
          replaceCoveoHistoryUrl(url.toString());
          if (headerInput) headerInput.value = trimmed;
          syncToolbarSearchClearButton(trimmed);
          stabilizeMobileSearchPageUi({ delay: 120 });
        };

        lifecycle.listen(form, "submit", async (e) => {
          e.preventDefault();
          await runSearch(input.value.trim());
        });

        lifecycle.listen(input, "input", (e) => {
          const val = e.target.value;
          if (searchBox?.updateText) searchBox.updateText(val);
          syncToolbarSearchClearButton(val);
          // Keep typed text in sync with the Headless search box,
          // but only execute a query on explicit submit/Enter.
        });

        if (clearBtn) {
          lifecycle.listen(clearBtn, "click", async (e) => {
            e.preventDefault();
            input.value = "";
            if (searchBox?.updateText) searchBox.updateText("");
            syncToolbarSearchClearButton("");
            await runSearch("");
            input.focus();
          });
        }

        syncToolbarSearchClearButton(input.value || "");
      }

      try {
        if (mod.loadPaginationActions && engine) {
          const paginationActions = mod.loadPaginationActions(engine);
          if (paginationActions?.setPageSize) {
            engine.dispatch(
              paginationActions.setPageSize({
                pageSize: SEARCH_PAGE_RESULTS_PER_PAGE,
              }),
            );
          } else if (paginationActions?.updatePageSize) {
            engine.dispatch(
              paginationActions.updatePageSize({
                pageSize: SEARCH_PAGE_RESULTS_PER_PAGE,
              }),
            );
          }
        }
      } catch (_) { }

      try {
        const historyRuntime = window.MarineMaxCoveoSearchHistory;
        if (typeof historyRuntime?.restoreEngine === "function") {
          const restoreResult = historyRuntime.restoreEngine(engine, {
            allow: !searchAlreadyTriggered,
          });
          restoredFromSearchHistory = restoreResult?.restored === true;
          if (restoreResult?.requiresFreshSearch === true) {
            searchAlreadyTriggered =
              (await dispatchCoveoSearch(search, engine, mod)) === true;
          }
        }
      } catch (_) {
        restoredFromSearchHistory = false;
      }

      /**
       * Coveo recommended subscribing to BOTH the engine and individual
       * controllers so the UI never reads stale state. Without the engine
       * subscription, the year/length/price filter UI could revert to its
       * previous selection after a search even though Coveo had returned
       * fresh results, and the "no results" view could show old products.
       *
       * Reference (Coveo Delivery Assurance call, 2026-05-07):
       *   engine.subscribe(() => setResults(resultList.state.results));
       */
      const doRender = createAsyncCoveoRender(() => {
        if (lifecycle.active) {
          render(search, container, mod, subControllers);
        }
      });
      lifecycle.subscribe(search, doRender);
      lifecycle.subscribe(paginationCtrl, doRender);
      lifecycle.subscribe(summaryCtrl, doRender);
      lifecycle.subscribe(facetGen, doRender);
      lifecycle.subscribe(sortCtrl, doRender);
      lifecycle.subscribe(engine, doRender);

      lifecycle.own(container, "_coveoEngine", engine);
      wireActiveFiltersStrip(container, lifecycle);
      wireFiltersDrawer(
        search,
        subControllers,
        engine,
        mod,
        container,
        lifecycle,
      );
      wireSortDropdown(search, subControllers, engine, mod, lifecycle);
      doRender();
      if (restoredFromSearchHistory) {
        window.MarineMaxCoveoSearchHistory?.restoreScroll?.(engine);
      }

      // Swap `btn--primary` <-> `btn--secondary` for search submit button.
      wireSearchSubmitButtonClassToggle(container, lifecycle);

      lifecycle.setTimeout(() => {
        wireDistanceFilter(search, engine, mod, lifecycle);
      }, 100);

      wireCoveoHeadlessProductClickAnalytics(lifecycle);

      // When the search page was reached through a query suggestion click,
      // `searchBox.selectSuggestion(q)` already dispatched `executeSearch`
      // (and recorded the suggestion click event). Triggering
      // `executeFirstSearch` again would send a duplicate query.
      if (
        !searchAlreadyTriggered &&
        !restoredFromSearchHistory &&
        typeof search.executeFirstSearch === "function"
      ) {
        search.executeFirstSearch();
      }
      return lifecycle;
      } catch (err) {
        lifecycle.destroy();
        console.error("[Coveo Headless] Search page init error:", err);
        throw err;
      }
    });
  };

  /**
   * "New Arrivals" = inventory received date (Shopify metafield iiq.created_at).
   * Coveo may index it under any of these sortable field names.
   */
  const COVEO_INVENTORY_RECEIVED_DATE_SORT_FIELDS = [
    "inventory_received_date",
    "ec_custom_field_inventory_received_date",
    "iiq_created_at",
    "iiq.created_at",
    "iiq.createdat",
    "ec_custom_field_iiq-created_at",
    "iiq_inventory_received_date",
    "iiq.inventory_received_date",
  ];
  const COVEO_NEWEST_SORT_PRIMARY_FIELD =
    COVEO_INVENTORY_RECEIVED_DATE_SORT_FIELDS[0];

  function isInventoryReceivedDateSortField(field) {
    const f = String(field || "").trim().toLowerCase();
    if (!f) return false;
    return COVEO_INVENTORY_RECEIVED_DATE_SORT_FIELDS.some(function (name) {
      return f === String(name).toLowerCase();
    });
  }

  const SORT_DEFINITIONS = {
    relevance: {
      sortCriteria: "relevance",
      by: "relevancy",
    },
    nearest: {
      sortCriteria: "fields",
      by: "fields",
      fields: [
        {
          field: "distance",
          direction: "asc",
          displayName: "Nearest",
        },
      ],
    },
    "ec_price ascending": {
      sortCriteria: "fields",
      by: "fields",
      fields: [
        {
          field: "ec_price",
          direction: "asc",
          displayName: "Price (Low to High)",
        },
      ],
    },
    "ec_price descending": {
      sortCriteria: "fields",
      by: "fields",
      fields: [
        {
          field: "ec_price",
          direction: "desc",
          displayName: "Price (High to Low)",
        },
      ],
    },
    "date descending": {
      sortCriteria: "fields",
      by: "fields",
      fields: [
        {
          field: COVEO_NEWEST_SORT_PRIMARY_FIELD,
          direction: "desc",
          displayName: "New Arrivals",
        },
      ],
    },
    "length_overall descending": {
      sortCriteria: "fields",
      by: "fields",
      fields: [
        {
          field: "length_overall",
          direction: "desc",
          displayName: "Length (Long to Short)",
        },
      ],
    },
    "length_overall ascending": {
      sortCriteria: "fields",
      by: "fields",
      fields: [
        {
          field: "length_overall",
          direction: "asc",
          displayName: "Length (Short to Long)",
        },
      ],
    },
  };

  // Coveo Product Listing currently returns 32 products per page even when a
  // larger page size is requested. Keep the controller and API pagination in
  // lockstep so prefetching a collection cannot skip or repeat listing pages.
  const COVEO_COLLECTION_CLIENT_DISTANCE_PAGE_SIZE =
    SEARCH_PAGE_RESULTS_PER_PAGE;
  const COVEO_COLLECTION_CLIENT_DISTANCE_MAX_PRODUCTS = 1000;

  function buildHeadlessCommerceSortCriterion(payload, mod) {
    if (!payload || typeof payload !== "object") return null;
    if (payload.sortCriteria === "relevance") {
      return typeof mod?.buildRelevanceSortCriterion === "function"
        ? mod.buildRelevanceSortCriterion()
        : { by: mod?.SortBy?.Relevance || "relevance" };
    }

    const fields = Array.isArray(payload.fields)
      ? payload.fields
          .map(function (field) {
            const name = String(field?.name || field?.field || "").trim();
            if (!name) return null;
            return {
              name: name,
              direction:
                field?.direction === "desc"
                  ? mod?.SortDirection?.Descending || "desc"
                  : mod?.SortDirection?.Ascending || "asc",
              displayName: String(field?.displayName || "").trim(),
            };
          })
          .filter(Boolean)
      : [];
    if (!fields.length) return null;
    return typeof mod?.buildFieldsSortCriterion === "function"
      ? mod.buildFieldsSortCriterion(fields)
      : { by: mod?.SortBy?.Fields || "fields", fields: fields };
  }

  (function installCommerceRequestInfrastructure() {
    let activeSortPayload = SORT_DEFINITIONS.relevance;
    let activeSortValue = "relevance";
    window.__coveoActiveSortPayload = () => activeSortPayload;
    window.__coveoSetActiveSortPayload = (p) => {
      if (p) activeSortPayload = p;
    };
    window.__coveoActiveSortValue = () => activeSortValue;
    window.__coveoSetActiveSortValue = (v) => {
      if (v) activeSortValue = String(v);
    };
    const createCoveoRequestPipeline =
      window.MarineMaxCoveoRequestPipeline?.create;
    if (typeof createCoveoRequestPipeline !== "function") {
      throw new Error(
        "[Coveo Request Pipeline] Missing headless-search-page-request-pipeline.js",
      );
    }
    const coveoRequestPipeline = createCoveoRequestPipeline({
      applyAuthoritativeConditionSelectionToFacetRequests,
      applyCoveoCollectionBrandScopeToFacetRequests,
      applyCoveoCollectionMembershipScopeToFacetRequests,
      applyCoveoCollectionScopeToRequestCq,
      applyCoveoStoredRangeSelectionsToFacetRequests,
      applyCoveoUrlMakeContextToRequestBody,
      applyCoveoYearSelectionToFacetRequests,
      applyCoveoYearSelectionToRequestCq,
      applyPendingInitialCoveoUrlStateToFacetRequests,
      applyStoredLocationContextWithoutRadiusToRequestBody,
      collectionDistanceResultsPerPage:
        COVEO_COLLECTION_CLIENT_DISTANCE_PAGE_SIZE,
      defaultResultsPerPage: SEARCH_PAGE_RESULTS_PER_PAGE,
      documentObject: document,
      facetIdUsesRangeServerDomainRefresh,
      facetIdsMatchLength,
      getActiveCoveoLocationContext,
      getCoveoCollectionHandleFromViewUrl,
      getCoveoFacetRequestFieldId,
      getPendingInitialCoveoUrlState,
      isCollectionInitialDistanceSuppressed,
      normalizeCoveoCollectionHandleValue,
      recordPendingInitialCoveoPrimaryRequestPatch,
      rememberCoveoFacetRequestTemplates,
      sanitizeCoveoFacetEmptyValuesForApi,
      sanitizeCoveoFacetPriceDomainsForApiLimit,
      sortDefinitions: SORT_DEFINITIONS,
      stripCoveoFacetOnlyTargetSelfSelection,
      stripCoveoManagedRangeSelectionsForDomain,
      stripExplicitlyClearedCoveoManagedRanges,
      stripInactiveCoveoDistanceRadiusFromRequestBody,
      windowObject: window,
    });
    window.__coveoPrepareFacetValuesOnlyRequestBody =
      coveoRequestPipeline.patchRequestBody;
    const installCoveoCommerceTransport =
      window.MarineMaxCoveoCommerceTransport?.install;
    if (typeof installCoveoCommerceTransport !== "function") {
      throw new Error(
        "[Coveo Commerce Transport] Missing headless-search-page-commerce-transport.js",
      );
    }
    installCoveoCommerceTransport({
      addCoveoProductsToCollectionMembership,
      documentObject: document,
      requestManagedRangeDomainRefresh: requestCoveoManagedRangeDomainRefresh,
      requestPipeline: coveoRequestPipeline,
      windowObject: window,
    });
  })();

  const COVEO_SERVER_DISTANCE_FIELD_KEYS = [
    "distance",
    "distance_miles",
    "distanceMiles",
  ];

  function getCoveoServerDistanceMiles(product) {
    const raw = getProductField(product, COVEO_SERVER_DISTANCE_FIELD_KEYS);
    if (raw == null || raw === "") return NaN;
    const miles = Number(raw);
    return Number.isFinite(miles) && miles >= 0 ? miles : NaN;
  }

  function getCoveoServerNearestAppliedSort(state) {
    const candidates = [
      state?.response?.sort || null,
      state?.searchResponse?.sort || null,
      state?.data?.response?.sort || null,
    ];
    for (const candidate of candidates) {
      if (candidate?.appliedSort) return candidate.appliedSort;
      if (candidate?.sortCriteria) return candidate;
    }
    return null;
  }

  function isCoveoServerDistanceSort(appliedSort) {
    const field = String(appliedSort?.fields?.[0]?.field || "").replace(
      /^@/,
      "",
    );
    const direction = String(
      appliedSort?.fields?.[0]?.direction || "",
    ).toLowerCase();
    return (
      appliedSort?.sortCriteria === "fields" &&
      field === "distance" &&
      direction === "asc"
    );
  }

  function getCoveoServerNearestScopeKey(state) {
    const body = window.__coveoLastCommerceRequest?.body || {};
    const storedLocation =
      window.CoveoLocationService?.getStoredLocation?.(true) || null;
    const facets = Array.isArray(body.facets)
      ? body.facets.map(function (facet) {
        const activeValues = Array.isArray(facet?.values)
          ? facet.values
            .filter(function (value) {
              return String(value?.state || "").toLowerCase() !== "idle";
            })
            .map(function (value) {
              return {
                value: value?.value,
                start: value?.start,
                end: value?.end,
                state: value?.state,
              };
            })
          : [];
        return { field: facet?.field, values: activeValues };
      })
      : body.facets || null;
    return JSON.stringify({
      query: body.query || "",
      cq: body.cq || "",
      facets,
      location: {
        lat: Number(storedLocation?.lat),
        lng: Number(storedLocation?.lng),
        zip: storedLocation?.zip || storedLocation?.approxZip || "",
      },
      total:
        state?.response?.pagination?.totalEntries ??
        state?.pagination?.totalEntries ??
        null,
    });
  }

  function logCoveoServerNearestPage(products, state, subControllers) {
    const requestedSort = new URL(window.location.href).searchParams.get("sort");
    const activeSortValue = String(
      window.__coveoActiveSortValue?.() || requestedSort || "",
    ).trim();
    if (activeSortValue !== "nearest") {
      return;
    }
    if (!Array.isArray(products) || products.length === 0) return;

    const paginationState = subControllers?.paginationCtrl?.state || {};
    const responsePagination =
      state?.response?.pagination || state?.pagination || {};
    const zeroBasedPage = Number(
      responsePagination.page ?? paginationState.page ?? 0,
    );
    const page = Number.isFinite(zeroBasedPage) ? zeroBasedPage + 1 : 1;
    const pageSize = Number(
      responsePagination.perPage ??
      responsePagination.pageSize ??
      paginationState.pageSize ??
      SEARCH_PAGE_RESULTS_PER_PAGE,
    );
    const totalResults = Number(
      responsePagination.totalEntries ??
        responsePagination.totalResults ??
        paginationState.totalEntries ??
        paginationState.totalResults ??
        products.length,
    );
    const collectionContainer = document.getElementById(
      "coveo-headless-collection",
    );
    const collectionHandle = String(
      collectionContainer?.dataset?.collectionHandle || "",
    ).trim();
    const collectionTitle = String(
      collectionContainer?.dataset?.collectionTitle || "",
    ).trim();
    const collectionMode = String(
      collectionContainer?._coveoCollectionMode || "",
    ).trim();
    if (collectionHandle && collectionMode !== "search") return;
    const rows = products.map(function (product, index) {
      const miles = getCoveoServerDistanceMiles(product);
      return {
        position: index + 1,
        overallPosition:
          (page - 1) * (Number.isFinite(pageSize) ? pageSize : products.length) +
          index +
          1,
        title: getCoveoCardTitleText(product),
        dealer: String(
          getProductField(product, [
            "location.name",
            "location_name",
            "iiq-dealer.name",
            "iiq_dealer_name",
            "dealer_name",
          ]) || "",
        ).trim(),
        miles,
        productKey: String(
          product?.permanentid || product?.ec_product_id || product?.clickUri || "",
        ),
      };
    });
    const scopeKey = getCoveoServerNearestScopeKey(state);
    let validationState = window.__coveoServerNearestValidationState;
    if (!validationState || validationState.scopeKey !== scopeKey) {
      validationState = { scopeKey, signatures: {}, pages: {} };
      window.__coveoServerNearestValidationState = validationState;
    }

    const signature = rows
      .map(function (row) {
        return `${row.productKey}:${Number.isFinite(row.miles) ? row.miles : "null"}`;
      })
      .join("|");
    if (validationState.signatures[page] === signature) return;
    validationState.signatures[page] = signature;

    const finiteRows = rows.filter((row) => Number.isFinite(row.miles));
    const missingDistance = rows.length - finiteRows.length;
    const ascendingOrderValid = rows.every(function (row, index) {
      if (!Number.isFinite(row.miles)) return false;
      if (index === 0) return true;
      return row.miles >= rows[index - 1].miles;
    });
    const minMiles = finiteRows.length
      ? Math.min(...finiteRows.map((row) => row.miles))
      : null;
    const maxMiles = finiteRows.length
      ? Math.max(...finiteRows.map((row) => row.miles))
      : null;
    const previousPage = validationState.pages[page - 1] || null;
    const nextPage = validationState.pages[page + 1] || null;
    const crossPageIssues = [];
    if (
      previousPage &&
      Number.isFinite(previousPage.maxMiles) &&
      Number.isFinite(minMiles) &&
      minMiles < previousPage.maxMiles
    ) {
      crossPageIssues.push(
        `Page ${page} starts at ${minMiles} miles before page ${page - 1} ends at ${previousPage.maxMiles} miles.`,
      );
    }
    if (
      nextPage &&
      Number.isFinite(nextPage.minMiles) &&
      Number.isFinite(maxMiles) &&
      maxMiles > nextPage.minMiles
    ) {
      crossPageIssues.push(
        `Page ${page} ends at ${maxMiles} miles after page ${page + 1} starts at ${nextPage.minMiles} miles.`,
      );
    }
    validationState.pages[page] = {
      minMiles,
      maxMiles,
      productCount: rows.length,
    };

    const appliedSort = getCoveoServerNearestAppliedSort(state);
    const sentSort = window.__coveoLastCommerceRequest?.body?.sort || null;
    const sentSortConfirmed = isCoveoServerDistanceSort(sentSort);
    const appliedSortConfirmed = appliedSort
      ? isCoveoServerDistanceSort(appliedSort)
      : null;
    const isCorrectOrder =
      missingDistance === 0 &&
      ascendingOrderValid &&
      crossPageIssues.length === 0 &&
      sentSortConfirmed &&
      appliedSortConfirmed !== false;
    const roundMiles = (value) =>
      Number.isFinite(value) ? Math.round(value * 10) / 10 : null;
    const summary = {
      collectionHandle: collectionHandle || null,
      collectionTitle: collectionTitle || null,
      collectionMode: collectionMode || null,
      page,
      productCount: rows.length,
      totalResults: Number.isFinite(totalResults) ? totalResults : null,
      productsWithDistance: finiteRows.length,
      missingDistance,
      minMiles: roundMiles(minMiles),
      maxMiles: roundMiles(maxMiles),
      ascendingOrderValid,
      crossPageOrderValid:
        previousPage || nextPage ? crossPageIssues.length === 0 : null,
      sentSortConfirmed,
      appliedSortConfirmed,
      isCorrectOrder,
      issues: crossPageIssues,
    };
    const tableRows = rows.map(function (row) {
      return {
        position: row.position,
        overallPosition: row.overallPosition,
        title: row.title,
        dealer: row.dealer,
        miles: roundMiles(row.miles),
        productKey: row.productKey,
      };
    });

    window.__coveoServerNearestValidationLast = { summary, rows: tableRows };
    if (collectionHandle) {
      window.__coveoCollectionNearestOrderLast = {
        summary,
        rows: tableRows,
      };
    }
    window.__coveoServerNearestValidationHistory =
      window.__coveoServerNearestValidationHistory || [];
    window.__coveoServerNearestValidationHistory.push({
      loggedAt: Date.now(),
      summary,
      rows: tableRows,
    });
    if (window.__coveoServerNearestValidationHistory.length > 100) {
      window.__coveoServerNearestValidationHistory.shift();
    }

    const label = collectionHandle
      ? `[Coveo Collection Nearest] ${collectionHandle} | Page ${page} ${
          isCorrectOrder ? "PASS" : "FAIL"
        } | ${rows.length} of ${
          Number.isFinite(totalResults) ? totalResults : "?"
        } boats`
      : `[Coveo Server Nearest] Page ${page} ${
          isCorrectOrder ? "PASS" : "FAIL"
        } | ${rows.length} boats`;
    if (console.group) console.group(label);
    if (isCorrectOrder) console.info(label, summary);
    else console.error(label, summary);
    if (console.table) console.table(tableRows);
    else console.log(tableRows);
    if (console.groupEnd) console.groupEnd();
    if (collectionHandle) {
      tableRows.forEach(function (row) {
        console.log(
          `[Coveo Collection Nearest Row] ${collectionHandle} | #${row.overallPosition} | ${
            row.miles == null ? "n/a" : `${row.miles} mi`
          } | ${row.title}${row.dealer ? ` | ${row.dealer}` : ""}`,
        );
      });
    }
  }

  function logCoveoCollectionNearestDomOrder(
    productsEl,
    collectionContainer,
    subControllers,
  ) {
    const requestedSort = new URL(window.location.href).searchParams.get("sort");
    const activeSortValue = String(
      window.__coveoActiveSortValue?.() || requestedSort || "",
    ).trim();
    const collectionHandle = String(
      collectionContainer?.dataset?.collectionHandle || "",
    ).trim();
    const collectionMode = String(
      collectionContainer?._coveoCollectionMode || "",
    ).trim();
    if (
      activeSortValue !== "nearest" ||
      !collectionHandle ||
      collectionMode !== "search" ||
      !productsEl
    ) {
      return;
    }

    const storedLocation = getRawCoveoStoredLocation(true);
    const userLat = Number(storedLocation?.lat);
    const userLng = Number(storedLocation?.lng);
    const haversine = window.CoveoLocationService?.haversineDistanceMiles;
    if (
      !Number.isFinite(userLat) ||
      !Number.isFinite(userLng) ||
      typeof haversine !== "function"
    ) {
      return;
    }

    const urlPage = Number(
      new URL(window.location.href).searchParams.get(COVEO_URL_PARAM_PAGE),
    );
    const paginationPage = Number(
      subControllers?.paginationCtrl?.state?.page,
    );
    const page = Number.isFinite(urlPage) && urlPage > 0
      ? urlPage
      : Number.isFinite(paginationPage)
        ? paginationPage + 1
        : 1;
    const cards = getCoveoDistanceGridItems(productsEl);
    if (!cards.length) return;
    const paginationPageSize = Number(
      subControllers?.paginationCtrl?.state?.pageSize,
    );
    const pageSize =
      Number.isFinite(paginationPageSize) && paginationPageSize > 0
        ? paginationPageSize
        : SEARCH_PAGE_RESULTS_PER_PAGE;

    const rows = cards.map(function (card, index) {
      const dealerLat = Number(card.getAttribute("data-dealer-lat"));
      const dealerLng = Number(card.getAttribute("data-dealer-lng"));
      const miles =
        Number.isFinite(dealerLat) && Number.isFinite(dealerLng)
          ? haversine(userLat, userLng, dealerLat, dealerLng)
          : NaN;
      const anchor = card.matches("a[href]")
        ? card
        : card.querySelector('a[href*="/products/"]');
      return {
        position: index + 1,
        overallPosition: (page - 1) * pageSize + index + 1,
        title: String(
          card.querySelector(
            ".coveo-search-card__title, .coveo-boat-card__title, h3",
          )?.textContent || anchor?.getAttribute("aria-label") || "",
        ).trim(),
        dealer: String(card.getAttribute("data-dealer-place") || "").trim(),
        miles: Number.isFinite(miles) ? Math.round(miles * 10) / 10 : null,
        productKey: String(anchor?.getAttribute("href") || "").trim(),
      };
    });
    const totalResults = getCoveoTotalCountFromControllerState(
      collectionContainer?._coveoSearch,
      subControllers,
    );
    const signature = rows
      .map(function (row) {
        return `${row.productKey}:${row.miles}`;
      })
      .join("|");
    const scopeKey = `${collectionHandle}:${userLat}:${userLng}:${
      Number.isFinite(totalResults) ? totalResults : "?"
    }`;
    let validationState = window.__coveoCollectionNearestDomValidationState;
    if (!validationState || validationState.scopeKey !== scopeKey) {
      validationState = { scopeKey, signatures: {}, pages: {} };
      window.__coveoCollectionNearestDomValidationState = validationState;
    }
    if (validationState.signatures[page] === signature) return;
    validationState.signatures[page] = signature;

    const finiteMiles = rows
      .map(function (row) {
        return row.miles;
      })
      .filter(Number.isFinite);
    const missingDistance = rows.length - finiteMiles.length;
    const ascendingOrderValid = rows.every(function (row, index) {
      if (!Number.isFinite(row.miles)) return false;
      return index === 0 || row.miles >= rows[index - 1].miles;
    });
    const minMiles = finiteMiles.length ? Math.min(...finiteMiles) : null;
    const maxMiles = finiteMiles.length ? Math.max(...finiteMiles) : null;
    const previousPage = validationState.pages[page - 1] || null;
    const crossPageOrderValid = !(
      previousPage &&
      Number.isFinite(previousPage.maxMiles) &&
      Number.isFinite(minMiles) &&
      minMiles < previousPage.maxMiles
    );
    validationState.pages[page] = { minMiles, maxMiles, productCount: rows.length };
    const isCorrectOrder =
      missingDistance === 0 && ascendingOrderValid && crossPageOrderValid;
    const summary = {
      collectionHandle,
      page,
      productCount: rows.length,
      totalResults,
      minMiles,
      maxMiles,
      missingDistance,
      ascendingOrderValid,
      crossPageOrderValid: previousPage ? crossPageOrderValid : null,
      isCorrectOrder,
      source: "rendered collection cards",
    };
    window.__coveoCollectionNearestOrderLast = { summary, rows };

    const label = `[Coveo Collection Nearest DOM] ${collectionHandle} | Page ${page} ${
      isCorrectOrder ? "PASS" : "FAIL"
    } | ${rows.length} of ${
      Number.isFinite(totalResults) ? totalResults : "?"
    } boats`;
    if (console.group) console.group(label);
    if (isCorrectOrder) console.info(label, summary);
    else console.error(label, summary);
    if (console.table) console.table(rows);
    else console.log(rows);
    if (console.groupEnd) console.groupEnd();
  }

  function wireSortDropdown(
    search,
    subControllers = {},
    engine,
    mod,
    lifecycle,
  ) {
    const root = lifecycle?.root || document;
    const sortWrapper =
      root.querySelector?.("#coveo-sort") ||
      document.getElementById("coveo-sort");
    const trigger =
      root.querySelector?.("#coveo-sort-trigger") ||
      document.getElementById("coveo-sort-trigger");
    const dropdown =
      root.querySelector?.("#coveo-sort-dropdown") ||
      document.getElementById("coveo-sort-dropdown");
    const triggerText = trigger?.querySelector(".coveo-sort-trigger-text");
    if (!trigger || !dropdown) return;
    const collectionContainer = document.getElementById(
      "coveo-headless-collection",
    );
    const mutationContainer =
      root?.nodeType === 1
        ? root
        : sortWrapper?.closest?.(
            "#coveo-headless-search, #coveo-headless-collection",
          ) || document.documentElement;
    let sortIntentRevision = 0;
    let activeSortIntentAbortController = null;
    const listen = function (target, type, listener, options) {
      if (lifecycle) return lifecycle.listen(target, type, listener, options);
      target.addEventListener(type, listener, options);
      return listener;
    };
    const schedule = function (callback, delay) {
      return lifecycle
        ? lifecycle.setTimeout(callback, delay)
        : window.setTimeout(callback, delay);
    };

    const defaultSort = sortWrapper?.dataset?.defaultSort || "relevance";
    const getSortLabel = (value, fallback) => {
      const match = Array.from(
        dropdown.querySelectorAll(".coveo-sort-option"),
      ).find(function (btn) {
        return btn.dataset.value === value;
      });
      return String(match?.textContent || fallback || value || "").trim();
    };
    const setActiveSort = (value) => {
      const payload = SORT_DEFINITIONS[value];
      if (payload && window.__coveoSetActiveSortPayload) {
        window.__coveoSetActiveSortPayload(payload);
      }
      if (window.__coveoSetActiveSortValue) {
        window.__coveoSetActiveSortValue(value);
      }
    };
    const createSortIntent = function (retiredInitialHydration) {
      if (activeSortIntentAbortController) {
        try {
          activeSortIntentAbortController.abort("superseded-sort");
        } catch (_) {
          activeSortIntentAbortController.abort();
        }
      }
      const abortController =
        typeof AbortController === "function" ? new AbortController() : null;
      activeSortIntentAbortController = abortController;
      const revision = sortIntentRevision + 1;
      sortIntentRevision = revision;
      return Object.freeze({
        retiredInitialHydration,
        signal: abortController?.signal || null,
        isCurrent() {
          const lifecycleIsCurrent =
            !lifecycle ||
            (lifecycle.active &&
              lifecycle.isCurrent() &&
              root?.isConnected !== false);
          return (
            revision === sortIntentRevision &&
            lifecycleIsCurrent &&
            abortController?.signal?.aborted !== true
          );
        },
      });
    };
    lifecycle?.addCleanup(function () {
      if (!activeSortIntentAbortController) return;
      try {
        activeSortIntentAbortController.abort("sort-lifecycle-destroyed");
      } catch (_) {
        activeSortIntentAbortController.abort();
      }
      activeSortIntentAbortController = null;
    });
    const requestedInitialSortValue =
      getPendingInitialCoveoUrlState()?.sort ||
      window.__coveoPendingInitialSortValue ||
      defaultSort;
    const initialSortValue =
      requestedInitialSortValue === "nearest" &&
      !hasReusableStoredLocationForNearestSort()
        ? defaultSort
        : requestedInitialSortValue;
    setActiveSort(initialSortValue);
    window.__coveoPendingInitialSortValue = null;

    listen(trigger, "click", function (e) {
      e.stopPropagation();
      const open = !dropdown.classList.contains("hidden");
      dropdown.classList.toggle("hidden", open);
      trigger.setAttribute("aria-expanded", String(!open));
    });
    listen(document, "click", function () {
      dropdown.classList.add("hidden");
      trigger.setAttribute("aria-expanded", "false");
    });

    markSelectedSortOption(dropdown, initialSortValue);
    updateSortTriggerLabel(getSortLabel(initialSortValue, defaultSort));

    const findMatchingCriterion = (ourValue, availableSorts) => {
      if (!Array.isArray(availableSorts)) return null;
      const isCriterionType = (criterion, type) =>
        criterion?.sortCriteria === type || criterion?.by === type;
      const getFieldName = (field) => field?.field || field?.name;
      const map = {
        relevance: (c) => isCriterionType(c, "relevance"),
        "ec_price ascending": (c) =>
          isCriterionType(c, "fields") &&
          c.fields?.some(
            (f) =>
              getFieldName(f) === "ec_price" &&
              (f.direction === "asc" || f.by === "asc"),
          ),
        "ec_price descending": (c) =>
          isCriterionType(c, "fields") &&
          c.fields?.some(
            (f) =>
              getFieldName(f) === "ec_price" &&
              (f.direction === "desc" || f.by === "desc"),
          ),
        "date descending": (c) =>
          isCriterionType(c, "fields") &&
          c.fields?.some(
            (f) =>
              isInventoryReceivedDateSortField(getFieldName(f)) &&
              (f.direction === "desc" || f.by === "desc"),
          ),
        "length_overall descending": (c) =>
          isCriterionType(c, "fields") &&
          c.fields?.some(
            (f) =>
              (getFieldName(f) === "length_overall" ||
                getFieldName(f) === "ec_length") &&
              (f.direction === "desc" || f.by === "desc"),
          ),
        "length_overall ascending": (c) =>
          isCriterionType(c, "fields") &&
          c.fields?.some(
            (f) =>
              (getFieldName(f) === "length_overall" ||
                getFieldName(f) === "ec_length") &&
              (f.direction === "asc" || f.by === "asc"),
          ),
      };
      const fn = map[ourValue];
      return fn ? availableSorts.find(fn) : null;
    };

    const runSearchWithCurrentSort = async (selectedValue, options) => {
      const opts = options || {};
      const isCurrent = function () {
        const callerIsCurrent =
          typeof opts.isCurrent !== "function" || opts.isCurrent();
        return (
          callerIsCurrent &&
          (!lifecycle ||
            (lifecycle.active &&
              lifecycle.isCurrent() &&
              root?.isConnected !== false))
        );
      };
      const activeSearch = await resolveCoveoDispatchController(search, {
        isCurrent,
        resetPagination: true,
        routeIntent: opts.routeIntent || null,
        signal: opts.signal || null,
      });
      if (!isCurrent() || !activeSearch) return false;
      const activeBundle =
        collectionContainer?._coveoResolveActiveControllerBundle?.();
      const activeSubControllers =
        activeBundle?.subControllers || subControllers;
      const sortCtrl = activeSubControllers.sortCtrl;
      const payload = SORT_DEFINITIONS[selectedValue];
      const availableSorts = sortCtrl?.state?.availableSorts;
      const matching = findMatchingCriterion(selectedValue, availableSorts);
      let criterion =
        matching || buildHeadlessCommerceSortCriterion(payload, mod);

      if (selectedValue === "nearest") {
        await syncCoveoEngineLocationContext(engine, mod);
        if (!isCurrent()) return false;
      }

      const isProductListing =
        String(activeSearch?.__coveoControllerType || "").toLowerCase() ===
        "productlisting";
      if (isProductListing && mod?.loadPaginationActions && engine) {
        try {
          const paginationActions = mod.loadPaginationActions(engine);
          if (paginationActions?.setPageSize) {
            await engine.dispatch(
              paginationActions.setPageSize({
                pageSize:
                  selectedValue === "nearest"
                  ? COVEO_COLLECTION_CLIENT_DISTANCE_PAGE_SIZE
                  : SEARCH_PAGE_RESULTS_PER_PAGE,
              }),
            );
            if (!isCurrent()) return false;
          }
        } catch (_) { }
      }
      if (selectedValue === "nearest" && isProductListing) {
        criterion =
          typeof mod?.buildRelevanceSortCriterion === "function"
            ? mod.buildRelevanceSortCriterion()
            : { by: mod?.SortBy?.Relevance || "relevance" };
      }

      if (mod?.loadSortActions && engine && criterion) {
        try {
          const sortActions = mod.loadSortActions(engine);
          if (sortActions?.applySort) {
            await engine.dispatch(sortActions.applySort(criterion));
            if (!isCurrent()) return false;
            return await dispatchCoveoSearch(activeSearch, engine, mod, {
              isCurrent,
              routeIntent: opts.routeIntent || null,
              signal: opts.signal || null,
              syncLocation: selectedValue === "nearest" ? false : undefined,
            });
          }
        } catch (_) { }
      }
      if (!isCurrent()) return false;
      if (sortCtrl?.sortBy && criterion) {
        try {
          sortCtrl.sortBy(criterion);
          return true;
        } catch (_) { }
      }
      if (!isCurrent()) return false;
      return await dispatchCoveoSearch(activeSearch, engine, mod, {
        isCurrent,
        routeIntent: opts.routeIntent || null,
        syncLocation: selectedValue === "nearest" ? false : undefined,
      });
    };

    function updateSortTriggerLabel(label) {
      if (!triggerText) return;
      const valueEl = triggerText.querySelector(".coveo-sort-trigger-value");
      if (valueEl) {
        valueEl.textContent = label;
      } else {
        triggerText.innerHTML =
          '<strong class="coveo-sort-trigger-prefix">Sort by:</strong><span class="coveo-sort-trigger-value">' +
          escapeHtml(label) +
          "</span>";
      }
      trigger.setAttribute("aria-label", `Sort by: ${label}`);
    }

    const applySortSelection = function (value, label, intent) {
      const sortIntent =
        intent || createSortIntent(retirePendingInitialCoveoUrlHydration());
      if (!sortIntent.isCurrent()) return Promise.resolve();
      if (value === "nearest") {
        window.__coveoServerNearestValidationState = null;
      }
      const previousValue = String(
        window.__coveoActiveSortValue?.() || initialSortValue || defaultSort,
      ).trim();
      const previousLabel = getSortLabel(previousValue, defaultSort);
      setActiveSort(value);
      updateSortTriggerLabel(label);
      markSelectedSortOption(dropdown, value);
      return enqueueCoveoUiMutation(
        mutationContainer,
        async function (lease) {
          const isSortIntentCurrent = function () {
            const leaseIsCurrent =
              !lease ||
              typeof lease.isCurrent !== "function" ||
              lease.isCurrent();
            return leaseIsCurrent && sortIntent.isCurrent();
          };
          await waitForRetiredInitialCoveoUrlHydration(
            sortIntent.retiredInitialHydration,
            3000,
          );
          if (!isSortIntentCurrent()) return;

          /*
           * Reserve the collection route only when this sort reaches the
           * front of the mutation queue. A filter or location mutation that
           * finishes while the sort is queued may legitimately reserve its
           * own route; creating ours at click time would make the queued sort
           * stale before it ever gets a chance to dispatch.
           */
          const routeIntent =
            collectionContainer?._coveoBeginCollectionRouteIntent?.() || null;
          const isCurrent = function () {
            const routeIsCurrent =
              !routeIntent ||
              typeof routeIntent.isCurrent !== "function" ||
              routeIntent.isCurrent();
            return isSortIntentCurrent() && routeIsCurrent;
          };
          if (!isCurrent()) return;

          const endMutation = beginCoveoUiMutation(mutationContainer, 900);
          try {
            const dispatched = await runSearchWithCurrentSort(value, {
              isCurrent,
              routeIntent,
              signal: sortIntent.signal,
            });
            if (!dispatched && isCurrent()) {
              setActiveSort(previousValue);
              updateSortTriggerLabel(previousLabel);
              markSelectedSortOption(dropdown, previousValue);
              const activeBundle =
                collectionContainer?._coveoResolveActiveControllerBundle?.();
              syncCoveoStateToUrl(
                activeBundle?.controller || search,
                activeBundle?.subControllers || subControllers,
                collectionContainer || mutationContainer,
              );
              console.warn(
                `[Coveo Sort] ${label} was not applied; restored ${previousLabel}.`,
              );
            }
          } finally {
            endMutation();
          }
        },
        value === "nearest" ? 30000 : 5000,
      );
    };

    if (
      requestedInitialSortValue === "nearest" &&
      initialSortValue !== "nearest"
    ) {
      let retryTimerId = null;
      if (window.__coveoInitialNearestRetryTimer) {
        clearTimeout(window.__coveoInitialNearestRetryTimer);
      }
      const retryDeadline = Date.now() + 10000;
      const retryInitialNearestSort = async function () {
        const currentSortValue = String(
          window.__coveoActiveSortValue?.() || "",
        ).trim();
        if (currentSortValue !== initialSortValue) return;
        if (hasReusableStoredLocationForNearestSort()) {
          delete window.__coveoInitialNearestRetryTimer;
          retryTimerId = 0;
          await applySortSelection(
            "nearest",
            getSortLabel("nearest", "Nearest"),
            createSortIntent(null),
          );
          return;
        }
        if (Date.now() < retryDeadline) {
          retryTimerId = schedule(
            retryInitialNearestSort,
            250,
          );
          window.__coveoInitialNearestRetryTimer = retryTimerId;
        }
      };
      retryTimerId = schedule(
        retryInitialNearestSort,
        0,
      );
      window.__coveoInitialNearestRetryTimer = retryTimerId;
      lifecycle?.addCleanup(function () {
        if (window.__coveoInitialNearestRetryTimer === retryTimerId) {
          delete window.__coveoInitialNearestRetryTimer;
        }
      });
    }

    const applyPendingSortSelection = async function () {
      const pending = window.__coveoPendingSortSelection;
      if (!pending || !pending.value) return;
      window.__coveoPendingSortSelection = null;
      await applySortSelection(
        String(pending.value),
        String(pending.label || pending.value),
        pending.intent ||
          createSortIntent(retirePendingInitialCoveoUrlHydration()),
      );
    };
    if (lifecycle) {
      lifecycle.claim(
        window,
        "__coveoApplyPendingSortSelection",
        applyPendingSortSelection,
      );
    } else {
      window.__coveoApplyPendingSortSelection = applyPendingSortSelection;
    }

    listen(dropdown, "click", function (e) {
      const opt = e.target.closest(".coveo-sort-option");
      if (!opt) return;
      e.stopPropagation();

      const value = opt.dataset.value;
      const label = opt.textContent.trim();
      const payload = SORT_DEFINITIONS[value];
      if (!payload) return;
      const sortIntent = createSortIntent(
        retirePendingInitialCoveoUrlHydration(),
      );

      dropdown.classList.add("hidden");
      trigger.setAttribute("aria-expanded", "false");

      if (
        value === "nearest" &&
        typeof window.__coveoPromptLocationForNearestSort === "function"
      ) {
        window.__coveoPendingSortSelection = {
          value: value,
          label: label,
          intent: sortIntent,
        };
        window.__coveoPromptLocationForNearestSort();
        return;
      }

      applySortSelection(value, label, sortIntent);
    });
  }

  function markSelectedSortOption(dropdown, activeValue) {
    if (!dropdown) return;
    dropdown.querySelectorAll(".coveo-sort-option").forEach(function (btn) {
      const selected = btn.dataset.value === activeValue;
      btn.setAttribute("aria-selected", String(selected));
    });
  }

  function parseDiscreteYearValue(raw) {
    if (raw == null || raw === "") return NaN;
    const s = String(raw).trim();
    const word = s.match(/\b(19\d{2}|20\d{2})\b/);
    if (word) return parseInt(word[1], 10);
    const n = parseFloat(String(s).replace(/[^0-9.-]/g, ""));
    if (
      Number.isFinite(n) &&
      n >= 1900 &&
      n <= 2100 &&
      Math.abs(n - Math.round(n)) < 1e-6
    ) {
      return Math.round(n);
    }
    return NaN;
  }

  function uniqueSortedNumbers(nums) {
    const s = Array.from(new Set(nums.filter((n) => Number.isFinite(n))));
    s.sort((a, b) => a - b);
    return s;
  }

  function collectYearPointsFromFacetValues(values, state) {
    const pts = [];
    if (Array.isArray(values)) {
      values.forEach((v) => {
        const y = parseDiscreteYearValue(facetItemRawValue(v));
        if (Number.isFinite(y)) pts.push(y);
        const bounds = facetItemNumericBounds(v, {
          allowNumericValueFallback: true,
        });
        if (bounds) {
          if (Number.isFinite(bounds.lo)) pts.push(bounds.lo);
          if (Number.isFinite(bounds.hi)) pts.push(bounds.hi);
        }
      });
    }
    const dom = tryFacetNumericDomain(state || {});
    if (dom) {
      pts.push(dom.lo, dom.hi);
    }
    return uniqueSortedNumbers(pts);
  }

  function defaultYearFacetDomain() {
    const now = new Date().getFullYear();
    return { lo: Math.max(1990, now - 45), hi: now + 1 };
  }

  function tryFacetNumericDomain(state) {
    if (!state || typeof state !== "object") return null;
    const minMaxEnvelope =
      state.min != null || state.max != null
        ? { min: state.min, max: state.max }
        : state.lowerBound != null || state.upperBound != null
          ? { min: state.lowerBound, max: state.upperBound }
          : null;
    const candidates = [
      state.domain,
      state.facetDomain,
      state.range,
      minMaxEnvelope,
    ].filter(Boolean);
    for (let i = 0; i < candidates.length; i++) {
      const d = candidates[i];
      if (d == null || typeof d !== "object") continue;
      const lo = parseFloat(
        String(
          d.min ?? d.start ?? d.from ?? d.lowerBound ?? d.low ?? "",
        ).replace(/[^0-9.-]/g, ""),
      );
      const hi = parseFloat(
        String(d.max ?? d.end ?? d.to ?? d.upperBound ?? d.high ?? "").replace(
          /[^0-9.-]/g,
          "",
        ),
      );
      if (
        !Number.isNaN(lo) &&
        !Number.isNaN(hi) &&
        hi > lo &&
        Number.isFinite(lo) &&
        Number.isFinite(hi)
      ) {
        return { lo: Math.min(lo, hi), hi: Math.max(lo, hi) };
      }
    }
    return null;
  }

  function deriveCoveoManagedRangeServerDomain(facetId, facetState) {
    if (!facetIdsMatchManagedRange(facetId) || !facetState) return null;
    const explicitDomain = tryFacetNumericDomain(facetState);
    if (explicitDomain && explicitDomain.hi > explicitDomain.lo) {
      if (facetIdsMatchLength(facetId)) {
        const lo = Math.max(COVEO_LENGTH_SLIDER_MIN, explicitDomain.lo);
        const hi = Math.min(COVEO_LENGTH_SLIDER_MAX, explicitDomain.hi);
        return hi > lo ? { lo, hi } : null;
      }
      return explicitDomain;
    }

    if (
      !facetIdsMatchLength(facetId) ||
      facetState._mmDefaultManagedRangeBaseline !== true ||
      String(facetState.type || "").toLowerCase() !== "numericalrange" ||
      String(facetState.interval || "").toLowerCase() !== "even" ||
      facetState.moreValuesAvailable !== false
    ) {
      return null;
    }
    const values = Array.isArray(facetState.values) ? facetState.values : [];
    if (
      !values.length ||
      !values.every(function (value) {
        return String(value?.state || "idle").toLowerCase() === "idle";
      }) ||
      !(Number(facetState.numberOfValues) >= values.length)
    ) {
      return null;
    }
    const bounds = values.map(facetItemNumericBounds).filter(Boolean).sort(function (a, b) {
      return a.lo - b.lo;
    });
    if (!bounds.length) return null;
    for (let i = 1; i < bounds.length; i++) {
      if (Math.abs(bounds[i].lo - bounds[i - 1].hi) > 1e-6) return null;
    }
    const hi = Math.min(
      COVEO_LENGTH_SLIDER_MAX,
      Math.max.apply(null, bounds.map(function (bound) { return bound.hi; })),
    );
    return hi > COVEO_LENGTH_SLIDER_MIN
      ? { lo: COVEO_LENGTH_SLIDER_MIN, hi }
      : null;
  }

  function buildNumericPointsFromDomain(dom, maxSteps) {
    const lo = dom.lo;
    const hi = dom.hi;
    const span = hi - lo;
    const cap = maxSteps == null ? 48 : maxSteps;
    const steps = Math.min(cap, Math.max(8, Math.ceil(span)));
    const out = [];
    for (let i = 0; i <= steps; i++) {
      out.push(lo + (span * i) / steps);
    }
    const s = Array.from(new Set(out));
    s.sort((a, b) => a - b);
    return s;
  }

  const COVEO_LENGTH_SLIDER_MIN = 0;
  const COVEO_LENGTH_SLIDER_MAX = 400;
  const COVEO_LENGTH_UI_SNAP_STEPS = 64;
  const COVEO_LENGTH_CHIP_PRIME = "\u2019";

  const COVEO_FACET_DEPENDENCIES = [
    {
      id: "model_requires_make",
      childMatcher: facetIdsMatchModel,
      parentMatcher: facetIdsMatchMake,
      disabledBadge: "Select make first",
      disabledMessage: "Select a make first",
    },
  ];

  function getFacetDependencyConfig(facetId) {
    return (
      COVEO_FACET_DEPENDENCIES.find(function (dependency) {
        return typeof dependency?.childMatcher === "function" &&
          dependency.childMatcher(facetId);
      }) || null
    );
  }

  function isFacetDependencySatisfied(snapshot, facetId) {
    const dependency = getFacetDependencyConfig(facetId);
    if (!dependency) return true;
    return snapshotHasSelectedFacetMatching(snapshot, dependency.parentMatcher);
  }

  function isFacetDependencyBlocked(snapshot, facetId) {
    return !isFacetDependencySatisfied(snapshot, facetId);
  }

  function clearDependentFacetSelectionsForParent(
    content,
    facetGen,
    facetId,
    clearLive,
    options,
  ) {
    const isCurrent =
      typeof options?.isCurrent === "function"
        ? options.isCurrent
        : () => true;
    if (!isCurrent()) return Promise.resolve();
    const matchingDependencies = COVEO_FACET_DEPENDENCIES.filter(function (dependency) {
      return typeof dependency?.parentMatcher === "function" &&
        dependency.parentMatcher(facetId);
    });
    if (!matchingDependencies.length) return Promise.resolve();

    if (!clearLive) {
      matchingDependencies.forEach(function (dependency) {
        clearDrawerFacetSelectionsByMatcher(
          content,
          facetGen,
          dependency.childMatcher,
        );
      });
      return Promise.resolve();
    }

    return (async function () {
      for (const dependency of matchingDependencies) {
        if (!isCurrent()) return;
        await clearLiveFacetSelectionsByMatcher(
          facetGen,
          dependency.childMatcher,
          { isCurrent },
        );
        if (!isCurrent()) return;
      }
    })();
  }

  async function applyParentFacetSelectionSnapshotBatch(
    search,
    engine,
    mod,
    facetGen,
    facetId,
    value,
    desiredChecked,
    options,
  ) {
    const isCurrent =
      typeof options?.isCurrent === "function"
        ? options.isCurrent
        : () => true;
    if (!isCurrent()) {
      return { supported: false, appliedCount: 0, didSync: false };
    }
    const currentSnapshot = buildFacetSelectionSnapshot(facetGen);
    const desiredSnapshot = new Map(currentSnapshot);
    desiredSnapshot.set(
      `${String(facetId || "")}\u001E${String(value || "")}`,
      !!desiredChecked,
    );

    COVEO_FACET_DEPENDENCIES.forEach(function (dependency) {
      if (
        typeof dependency?.parentMatcher !== "function" ||
        !dependency.parentMatcher(facetId) ||
        typeof dependency?.childMatcher !== "function"
      ) {
        return;
      }
      Array.from(desiredSnapshot.keys()).forEach(function (key) {
        const sepIdx = key.indexOf("\u001E");
        if (sepIdx === -1) return;
        if (dependency.childMatcher(key.slice(0, sepIdx))) {
          desiredSnapshot.set(key, false);
        }
      });
    });

    const batchResult = await applyFacetSelectionSnapshotBatch(
      engine,
      mod,
      desiredSnapshot,
      currentSnapshot,
      { isCurrent },
    );
    if (!isCurrent()) {
      return { supported: false, appliedCount: 0, didSync: false };
    }
    if (!batchResult?.supported) {
      return { supported: false, appliedCount: 0, didSync: false };
    }

    const appliedCount = Number(batchResult.appliedCount || 0);
    let didSync = false;
    try {
      didSync = await waitForFacetSelectionSnapshotSync(
        facetGen,
        desiredSnapshot,
      );
    } catch (_) { }
    if (!isCurrent()) {
      return { supported: false, appliedCount: 0, didSync: false };
    }
    if (appliedCount > 0) {
      await dispatchCoveoSearch(search, engine, mod, { isCurrent });
    }
    return { supported: true, appliedCount, didSync };
  }

  function coveoLocationContextCacheKey(locCtx) {
    if (!locCtx) return "";
    try {
      return JSON.stringify({
        lat: locCtx.location?.latitude,
        lng: locCtx.location?.longitude,
        location_type: locCtx.location_type,
        location_lat: locCtx.location_lat,
        location_lng: locCtx.location_lng,
        location_zip: locCtx.location_zip,
        location_timestamp: locCtx.location_timestamp,
        location_precision: locCtx.location_precision,
        location_radius_miles: locCtx.location_radius_miles,
      });
    } catch (_) {
      return String(locCtx.location_zip || locCtx.location_lat || "");
    }
  }

  function setCoveoDomDistanceAppliedCtxKey(ctxKey) {
    try {
      window.__coveoDomDistanceAppliedCtxKey = ctxKey || "";
    } catch (_) { }
  }

  function isCollectionInitialDistanceSuppressed() {
    try {
      return !!(
        window.__coveoSuppressInitialCollectionDistance &&
        document.getElementById("coveo-headless-collection")
      );
    } catch (_) {
      return false;
    }
  }

  function getActiveCoveoStoredLocation(usePersistent) {
    if (isCollectionInitialDistanceSuppressed()) return null;
    try {
      return window.CoveoLocationService?.getStoredLocation?.(usePersistent);
    } catch (_) {
      return null;
    }
  }

  function getRawCoveoStoredLocation(usePersistent) {
    try {
      return window.CoveoLocationService?.getStoredLocation?.(usePersistent);
    } catch (_) {
      return null;
    }
  }

  function getActiveCoveoLocationContext(radiusMiles) {
    if (isCollectionInitialDistanceSuppressed()) return null;
    try {
      const resolvedRadius =
        normalizeDistanceRadiusMiles(radiusMiles) ??
        getExplicitDistanceRadiusMiles(getRawCoveoStoredLocation(true));
      return window.CoveoLocationService?.getContextForCoveo?.(resolvedRadius);
    } catch (_) {
      return null;
    }
  }

  function releaseInitialCollectionDistanceSuppression() {
    try {
      window.__coveoSuppressInitialCollectionDistance = false;
    } catch (_) { }
  }

  async function syncCoveoEngineLocationContext(engine, mod) {
    if (!engine || !mod?.loadContextActions) return false;
    const Loc = window.CoveoLocationService;
    if (!Loc?.getContextForCoveo) return false;
    const isNearestSort =
      String(window.__coveoActiveSortValue?.() || "").trim() === "nearest";
    if (window.__coveoClientOnlyDistanceFilter !== false && !isNearestSort) {
      coveoLastSyncedLocationCtxKey = "cleared";
      return false;
    }
    try {
      const locCtx = isNearestSort
        ? getStoredCoveoLocationContextWithoutRadius({
            ignoreSuppression: true,
          })
        : getActiveCoveoLocationContext();
      const ctxKey = coveoLocationContextCacheKey(locCtx);
      if (ctxKey === coveoLastSyncedLocationCtxKey) {
        return !!locCtx;
      }

      const ctxActions = mod.loadContextActions(engine);
      if (!ctxActions) return false;

      if (locCtx?.location && typeof ctxActions.setLocation === "function") {
        await engine.dispatch(
          ctxActions.setLocation({
            latitude: locCtx.location.latitude,
            longitude: locCtx.location.longitude,
          }),
        );
      }
      if (typeof ctxActions.setCustom === "function") {
        if (locCtx) {
          await engine.dispatch(
            ctxActions.setCustom({
              location_type: locCtx.location_type,
              location_lat: locCtx.location_lat,
              location_lng: locCtx.location_lng,
              location_zip: locCtx.location_zip,
              location_timestamp: locCtx.location_timestamp,
              location_precision: locCtx.location_precision,
              location_radius_miles: locCtx.location_radius_miles,
            }),
          );
        } else {
          await engine.dispatch(ctxActions.setCustom(undefined));
        }
      }
      coveoLastSyncedLocationCtxKey = ctxKey;
      return !!locCtx;
    } catch (err) {
      console.warn("[Coveo] syncCoveoEngineLocationContext failed:", err);
      return false;
    }
  }

  function getActiveDistanceChipState() {
    try {
      const loc = getActiveCoveoStoredLocation();
      if (!loc) return null;
      const rawRadius =
        typeof window.__coveoSelectedRadiusMiles === "number"
          ? window.__coveoSelectedRadiusMiles
          : loc.radiusMiles;
      const radius = normalizeDistanceRadiusMiles(rawRadius);
      if (!radius) return null;

      const zip =
        loc.type === "zip"
          ? loc.zip
          : loc.approxZip || loc.zip || "";
      const city = String(loc.city || "").trim();
      const state = String(loc.state || "").trim();
      const label = String(loc.label || "").trim();
      const where = String(zip || label || [city, state].filter(Boolean).join(", ")).trim();
      if (!where) return null;

      return {
        radius,
        where,
        text: `Distance: ${radius}mi of ${where}`,
        ariaLabel: `Remove Distance filter ${radius} miles of ${where}`,
      };
    } catch (_) {
      return null;
    }
  }

  function getCoveoTotalCountFromControllerState(controller, subControllers) {
    const state = controller?.state || {};
    const response = state.response;
    const summaryState = subControllers?.summaryCtrl?.state ?? {};
    const pagState = subControllers?.paginationCtrl?.state ?? {};
    const responsePag = state.response?.pagination ?? state.pagination ?? {};
    const total =
      response?.totalCount ??
      response?.totalResults ??
      state.totalNumberOfResults ??
      state.totalNumberOfProducts ??
      state.totalCount ??
      state.totalResults ??
      summaryState.total ??
      summaryState.totalCount ??
      pagState.totalEntries ??
      pagState.totalCount ??
      pagState.totalResults ??
      responsePag.totalEntries ??
      responsePag.totalCount ??
      responsePag.totalResults ??
      null;
    return Number.isFinite(Number(total)) ? Number(total) : null;
  }

  function invalidateCoveoManagedRangeDomainState() {
    cancelCoveoManagedRangeDomainRefreshTask("invalidated");

    const cache = window.__coveoFacetServerValueCache;
    if (cache && typeof cache === "object") {
      Object.keys(cache).forEach(function (facetId) {
        if (facetIdsMatchManagedRange(facetId)) delete cache[facetId];
      });
    }

    const requests = getCoveoFacetServerValueRequests(false);
    if (requests && typeof requests === "object") {
      Object.keys(requests).forEach(function (requestKey) {
        const facetId = String(requestKey).split("\u001E")[0];
        if (!facetIdsMatchManagedRange(facetId)) return;
        abortCoveoFacetServerRequest(requests[requestKey]);
        delete requests[requestKey];
      });
    }

    const latestKeys = getCoveoFacetServerLatestRequestKeys(false);
    if (latestKeys && typeof latestKeys === "object") {
      Object.keys(latestKeys).forEach(function (facetId) {
        if (facetIdsMatchManagedRange(facetId)) delete latestKeys[facetId];
      });
    }
    const controllers = getCoveoFacetServerAbortControllers(false);
    if (controllers && typeof controllers === "object") {
      Object.keys(controllers).forEach(function (facetId) {
        if (!facetIdsMatchManagedRange(facetId)) return;
        try {
          controllers[facetId]?.abort?.();
        } catch (_) { }
        delete controllers[facetId];
      });
    }

    const rangeStore = window.__coveoRangeUiStateStore;
    if (rangeStore && typeof rangeStore === "object") {
      rangeStore.stableDomains = {};
      window.__coveoStableRangeDomains = rangeStore.stableDomains;
    }
  }

  function cancelCoveoManagedRangeDomainRefreshTask(status) {
    if (window.__coveoManagedRangeDomainRefreshTimer) {
      clearTimeout(window.__coveoManagedRangeDomainRefreshTimer);
      window.__coveoManagedRangeDomainRefreshTimer = null;
    }
    const task = window.__coveoManagedRangeDomainRefreshTask;
    if (task && typeof task.settle === "function") {
      task.settle(status || "cancelled");
      return;
    }
    window.__coveoManagedRangeDomainRefreshPending = null;
    window.__coveoManagedRangeDomainRefreshInvalidatingRevision = null;
    window.__coveoManagedRangeDomainRefreshPromise = null;
    window.__coveoManagedRangeDomainRefreshTask = null;
  }

  function requestCoveoManagedRangeDomainRefresh(options) {
    const opts = options || {};
    if (opts.invalidate !== false) {
      invalidateCoveoManagedRangeDomainState();
    } else {
      cancelCoveoManagedRangeDomainRefreshTask("controller-domain");
    }
    const revision =
      Number(window.__coveoManagedRangeDomainRefreshRevision || 0) + 1;
    window.__coveoManagedRangeDomainRefreshRevision = revision;
    /*
     * NumericFacet.state.domain is part of the primary Commerce response.
     * Keep this function awaitable for the existing UI mutation pipeline, but
     * do not spend additional QPM fetching Length, Price, or Year baselines.
     */
    return Promise.resolve({
      revision,
      status: "controller-domain",
    });
  }

  function clearCoveoDistanceFilterState(options) {
    const opts = options || {};
    const preserveStoredLocation = !!opts.preserveStoredLocation;
    try {
      if (preserveStoredLocation) {
        window.CoveoLocationService?.clearStoredRadiusMiles?.();
        /*
         * Remember All immediately for this document as well as in the shared
         * location service. The page flag protects against a slower duplicate
         * initializer; the persisted marker protects later page loads.
         */
        window.__coveoDistanceExplicitlyClearedThisPage = true;
      } else if (window.CoveoLocationService?.clearStoredLocation) {
        window.CoveoLocationService.clearStoredLocation();
      }
    } catch (_) { }
    window.__coveoSelectedRadiusMiles = null;
    window.__coveoHasPendingDistanceUi = false;
    window.__coveoDomDistanceVisibleCount = null;
    window.__coveoDomDistanceFilterPending = false;
    coveoLastSyncedLocationCtxKey = null;
    /*
     * Clearing Distance and starting a search are separate operations. Kill
     * the radius-bound cache and any scheduled refresh synchronously, but do
     * not fetch a replacement from the previous request snapshot. Every UI
     * path requests and awaits the new domain after its radius-free search.
     */
    invalidateCoveoManagedRangeDomainState();
    try {
      window.dispatchEvent(
        new CustomEvent(
          preserveStoredLocation
            ? "coveo:distance-radius-cleared"
            : "coveo:distance-location-cleared",
        ),
      );
    } catch (_) { }
  }

  function getStoredCoveoLocationContextWithoutRadius(options) {
    try {
      const opts = options || {};
      const loc = opts.ignoreSuppression
        ? getRawCoveoStoredLocation(true)
        : getActiveCoveoStoredLocation(true);
      const lat = Number(loc?.lat);
      const lng = Number(loc?.lng);
      if (!loc || !Number.isFinite(lat) || !Number.isFinite(lng)) return null;
      return {
        location: {
          latitude: lat,
          longitude: lng,
        },
        location_type: loc.type,
        location_lat: lat,
        location_lng: lng,
        location_zip: String(loc.zip || loc.approxZip || "").trim(),
        location_timestamp: loc.timestamp || "",
        location_precision: loc.precision,
        location_radius_miles: null,
      };
    } catch (_) {
      return null;
    }
  }

  function hasReusableStoredLocationForNearestSort() {
    try {
      const loc = getRawCoveoStoredLocation(true);
      const lat = Number(loc?.lat);
      const lng = Number(loc?.lng);
      return !!(
        loc &&
        Number.isFinite(lat) &&
        Number.isFinite(lng) &&
        (String(loc.zip || loc.approxZip || "").trim() || loc.type === "geo")
      );
    } catch (_) {
      return false;
    }
  }

  function applyStoredLocationContextWithoutRadiusToRequestBody(body, options) {
    if (!body || typeof body !== "object") return false;
    const locCtx = getStoredCoveoLocationContextWithoutRadius(options);
    if (!locCtx) return false;
    const context =
      body.context && typeof body.context === "object" ? body.context : {};
    body.context = Object.assign({}, context, locCtx, {
      location: Object.assign({}, context.location || {}, locCtx.location),
      custom: Object.assign({}, context.custom || {}, {
        location_type: locCtx.location_type,
        location_lat: locCtx.location_lat,
        location_lng: locCtx.location_lng,
        location_zip: locCtx.location_zip,
        location_timestamp: locCtx.location_timestamp,
        location_precision: locCtx.location_precision,
        location_radius_miles: locCtx.location_radius_miles,
      }),
    });
    return true;
  }

  function stripInactiveCoveoDistanceRadiusFromRequestBody(body) {
    if (!body || typeof body !== "object") return false;
    if (getActiveCoveoLocationContext()) return false;
    let changed = false;
    if (
      body.context &&
      typeof body.context === "object" &&
      Object.prototype.hasOwnProperty.call(
        body.context,
        "location_radius_miles",
      )
    ) {
      delete body.context.location_radius_miles;
      changed = true;
    }
    const custom = body.context?.custom;
    if (
      custom &&
      typeof custom === "object" &&
      Object.prototype.hasOwnProperty.call(custom, "location_radius_miles")
    ) {
      delete custom.location_radius_miles;
      changed = true;
    }
    if (Object.prototype.hasOwnProperty.call(body, "location_radius_miles")) {
      delete body.location_radius_miles;
      changed = true;
    }
    return changed;
  }

  async function dispatchCoveoCommerceQuery(engine, mod, options) {
    const opts = options || {};
    const isCurrent =
      typeof opts.isCurrent === "function" ? opts.isCurrent : () => true;
    if (!isCurrent()) return false;
    const syncLocation = opts.syncLocation !== false;
    const executeSearch = opts.executeSearch !== false;
    const controller = opts.controller || null;
    const controllerType = String(
      controller?.__coveoControllerType || "",
    ).toLowerCase();
    const preferProductListing =
      controllerType === "productlisting" ||
      controllerType === "product_listing";

    if (syncLocation) {
      await syncCoveoEngineLocationContext(engine, mod);
      if (!isCurrent()) return false;
    }
    if (!executeSearch) return false;

    if (preferProductListing) {
      if (mod?.loadProductListingActions && engine) {
        try {
          const pla = mod.loadProductListingActions(engine);
          if (pla?.fetchProductListing) {
            if (!isCurrent()) return false;
            await engine.dispatch(pla.fetchProductListing());
            return true;
          }
        } catch (err) {
          console.warn("[Coveo] fetchProductListing failed:", err);
        }
      }
      return false;
    }

    if (mod?.loadSearchActions && engine) {
      try {
        const searchActions = mod.loadSearchActions(engine);
        if (searchActions?.executeSearch) {
          if (!isCurrent()) return false;
          await engine.dispatch(searchActions.executeSearch());
          return true;
        }
      } catch (err) {
        console.warn("[Coveo] executeSearch failed:", err);
      }
    }
    return false;
  }

  async function resolveCoveoDispatchController(search, options) {
    const opts = options || {};
    const isCurrent =
      typeof opts.isCurrent === "function" ? opts.isCurrent : () => true;
    if (!isCurrent()) return null;
    const container = document.getElementById("coveo-headless-collection");
    if (!container || typeof container._coveoResolveDispatchController !== "function") {
      return search;
    }
    try {
      const resolvedController = await container._coveoResolveDispatchController(
        search,
        opts,
      );
      if (!isCurrent()) return null;
      return resolvedController || null;
    } catch (err) {
      console.warn("[Coveo Collection] resolve dispatch controller failed:", err);
      return null;
    }
  }

  async function dispatchCoveoSearch(search, engine, mod, options) {
    const suppliedOptions = options || {};
    const isCurrent =
      typeof suppliedOptions.isCurrent === "function"
        ? suppliedOptions.isCurrent
        : () => true;
    if (!isCurrent()) return false;
    search = await resolveCoveoDispatchController(search, suppliedOptions);
    if (!isCurrent() || !search) return false;
    const opts = Object.assign({}, suppliedOptions, {
      controller: search,
      isCurrent,
    });
    const ok = await dispatchCoveoCommerceQuery(engine, mod, opts);
    if (!isCurrent()) return false;
    if (ok) return true;
    if (opts.executeSearch === false) return false;
    if (search.executeFirstSearch) {
      await Promise.resolve(search.executeFirstSearch());
      return true;
    }
    if (search.executeFirstRequest) {
      await Promise.resolve(search.executeFirstRequest());
      return true;
    }
    if (search.refresh) {
      await Promise.resolve(search.refresh());
      return true;
    }
    return false;
  }

  async function coveoFacetShowAllValues(facetId, facet) {
    if (!facetId) return;
    if (facet && typeof facet.showMoreValues === "function") {
      window.__coveoFacetValuesRefreshInFlight = true;
      try {
        facet.showMoreValues();
      } finally {
        queueMicrotask(() => {
          window.__coveoFacetValuesRefreshInFlight = false;
        });
      }
    }
  }

  /**
   * Continuously load more facet values for a facet (no page cap).
   * Do not call from Make/Model/Boat Type search input handlers — it triggers
   * full drawer re-renders and can freeze or crash the browser while typing.
   * Prefer expandFacetValuesProgressively (capped) + scroll sentinels instead.
   */
  function loadAllFacetValues(facet) {
    if (!facet || typeof facet.showMoreValues !== "function") return;
    if (facet.__coveoLoadAllInFlight) return;
    if (facet.__coveoLoadAllComplete) return;
    facet.__coveoLoadAllInFlight = true;
    function step() {
      try {
        const state = facet.state || {};
        if (!state.canShowMoreValues) {
          facet.__coveoLoadAllInFlight = false;
          facet.__coveoLoadAllComplete = true;
          return;
        }
        window.__coveoFacetValuesRefreshInFlight = true;
        facet.showMoreValues();
      } catch (err) {
        facet.__coveoLoadAllInFlight = false;
        window.__coveoFacetValuesRefreshInFlight = false;
        console.warn("[Coveo Filters] load-all facet values:", err);
        return;
      }
      window.setTimeout(function () {
        window.__coveoFacetValuesRefreshInFlight = false;
        const s = facet.state || {};
        if (!s.canShowMoreValues) {
          facet.__coveoLoadAllInFlight = false;
          facet.__coveoLoadAllComplete = true;
          return;
        }
        step();
      }, 140);
    }
    step();
  }

  const COVEO_AUTO_EXPAND_FACET_VALUE_MAX_PAGES = 8;

  /**
   * Make/Model: load additional facet value pages once (not on every facet
   * re-render). Chaining showMoreValues here avoids a render → expand loop that
   * re-triggers thousands of product-card section fetches.
   */
  function expandFacetValuesProgressively(facetId, facet, pageCount) {
    if (!facetId || !facet || typeof facet.showMoreValues !== "function") return;
    if (facet.__coveoAutoExpandComplete) return;
    const pages = pageCount != null ? pageCount : 0;
    if (pages >= COVEO_AUTO_EXPAND_FACET_VALUE_MAX_PAGES) {
      facet.__coveoAutoExpandComplete = true;
      return;
    }
    const state = facet.state || {};
    if (!state.canShowMoreValues) {
      facet.__coveoAutoExpandComplete = true;
      return;
    }
    window.__coveoFacetValuesRefreshInFlight = true;
    try {
      facet.showMoreValues();
    } catch (err) {
      window.__coveoFacetValuesRefreshInFlight = false;
      facet.__coveoAutoExpandComplete = true;
      console.warn("[Coveo Filters] auto-expand facet values:", err);
      return;
    }
    window.setTimeout(function () {
      window.__coveoFacetValuesRefreshInFlight = false;
      if (!(facet.state || {}).canShowMoreValues) {
        facet.__coveoAutoExpandComplete = true;
        return;
      }
      expandFacetValuesProgressively(facetId, facet, pages + 1);
    }, 120);
  }

  function scheduleMakeModelFacetAutoExpand(facetGen, drawerContent) {
    return;
  }

  function flattenFacetControllers(facetGen) {
    const facetsObj = facetGen?.facets;
    if (!facetsObj) return [];
    if (Array.isArray(facetsObj)) return facetsObj;
    if (typeof Map !== "undefined" && facetsObj instanceof Map) {
      return Array.from(facetsObj.values());
    }
    if (typeof Set !== "undefined" && facetsObj instanceof Set) {
      return Array.from(facetsObj);
    }
    if (facetsObj && typeof facetsObj === "object") {
      return Object.values(facetsObj);
    }
    return [];
  }

  function findFacetController(facetGen, facetId) {
    return flattenFacetControllers(facetGen).find(
      (f) => (f.facetId || f.state?.facetId) === facetId,
    );
  }

  function getConditionValuesFromUrlState(state) {
    if (!(state?.facetValues instanceof Map)) return [];
    const lookupKeys = getCoveoUrlStateLookupKeys(COVEO_CONDITION_FACET_ID);
    for (let i = 0; i < lookupKeys.length; i++) {
      const values = state.facetValues.get(lookupKeys[i]);
      if (Array.isArray(values) && values.length) return values;
    }
    return [];
  }

  function reconcileConditionSelectionShadow(facetGen) {
    const pendingConditionValues = getConditionValuesFromUrlState(
      getPendingInitialCoveoUrlState(),
    );
    if (pendingConditionValues.length) {
      coveoConditionSelectionShadow.replace(pendingConditionValues);
    }
    return coveoConditionSelectionShadow.getValues();
  }

  function getConditionAwareFacets(facetGen) {
    return ensureConditionFacetPresence(
      flattenFacetControllers(facetGen),
      reconcileConditionSelectionShadow(facetGen),
    );
  }

  function applyAuthoritativeConditionSelectionToFacetRequests(body) {
    if (!body || typeof body !== "object") return false;
    const plan = planCoveoAuthoritativeConditionFacet({
      facets: Array.isArray(body.facets) ? body.facets : [],
      facetId: COVEO_CONDITION_FACET_ID,
      selectedValues: coveoConditionSelectionShadow.getValues(),
    });
    if (!plan?.changed) return false;
    body.facets = plan.facets;
    return true;
  }

  function deleteConditionSelectionSnapshotEntries(snapshot) {
    if (!(snapshot instanceof Map)) return snapshot;
    Array.from(snapshot.keys()).forEach(function (key) {
      const separatorIndex = key.indexOf("\u001E");
      if (separatorIndex === -1) return;
      if (facetIdsMatchCondition(key.slice(0, separatorIndex))) {
        snapshot.delete(key);
      }
    });
    return snapshot;
  }

  function getFacetSearchController(facet) {
    if (!facet || typeof facet !== "object") return null;
    const candidates = [
      facet.facetSearch,
      facet.facetSearchController,
      facet.search,
    ];
    return (
      candidates.find(function (candidate) {
        return candidate && typeof candidate === "object";
      }) || null
    );
  }

  function getFacetSearchState(facet) {
    const ctrl = getFacetSearchController(facet);
    const state =
      ctrl?.state ||
      facet?.state?.facetSearch ||
      facet?.state?.search ||
      null;
    return state && typeof state === "object" ? state : null;
  }

  function getFacetSearchValues(facet) {
    return normalizeFacetStateValues(getFacetSearchState(facet) || {});
  }

  async function setFacetSelectionByRawValue(
    facet,
    rawValue,
    desiredChecked,
    options,
  ) {
    const isCurrent =
      typeof options?.isCurrent === "function"
        ? options.isCurrent
        : () => true;
    if (!isCurrent()) return false;
    if (!facet) return false;
    const targetRaw = String(rawValue == null ? "" : rawValue);
    if (!targetRaw) return false;

    const liveValues = normalizeFacetStateValues(facet.state || {});
    const liveObj = liveValues.find(function (value) {
      return String(facetItemRawValue(value)) === targetRaw;
    });

    if (liveObj && typeof facet.toggleSelect === "function") {
      const currentlySelected = liveObj.state === "selected";
      if (currentlySelected === !!desiredChecked) return false;
      try {
        await Promise.resolve(facet.toggleSelect(liveObj));
        return isCurrent();
      } catch (_) {
        return false;
      }
    }

    if (!desiredChecked) return false;

    const searchCtrl = getFacetSearchController(facet);
    const searchObj = getFacetSearchValues(facet).find(function (value) {
      return String(facetItemRawValue(value)) === targetRaw;
    });
    if (!searchCtrl || !searchObj) return false;

    for (const methodName of ["select", "singleSelect"]) {
      const method = searchCtrl[methodName];
      if (typeof method !== "function") continue;
      try {
        await Promise.resolve(method.call(searchCtrl, searchObj));
        return true;
      } catch (_) {
        if (!isCurrent()) return false;
        try {
          await Promise.resolve(method.call(searchCtrl, targetRaw));
          return true;
        } catch (_) { }
      }
    }

    return false;
  }

  async function removeFacetSelectionByRawValue(
    engine,
    mod,
    facetGen,
    facetId,
    rawValue,
    options,
  ) {
    const createRemovalResult = function (
      applied,
      synced,
      primarySearch,
      source,
    ) {
      return {
        applied: !!applied,
        synced: !!synced,
        primarySearch,
        source,
      };
    };
    const waitForDesiredSnapshot = async function (attempts) {
      try {
        return await waitForFacetSelectionSnapshotSync(
          facetGen,
          desiredSnapshot,
          attempts,
        );
      } catch (_) {
        return false;
      }
    };
    const isCurrent =
      typeof options?.isCurrent === "function"
        ? options.isCurrent
        : () => true;
    const cancelledResult = function () {
      return createRemovalResult(false, false, "cancelled", "cancelled");
    };
    if (!isCurrent()) return cancelledResult();
    const targetFacetId = String(facetId || "");
    const targetRaw = String(rawValue == null ? "" : rawValue);
    if (!targetFacetId || !targetRaw) {
      return createRemovalResult(false, false, "explicit-required", "no-op");
    }

    const targetKey = `${targetFacetId}\u001E${targetRaw}`;
    const currentSnapshot = buildFacetSelectionSnapshot(facetGen);
    if (!currentSnapshot.get(targetKey)) {
      return createRemovalResult(false, false, "explicit-required", "no-op");
    }

    const desiredSnapshot = new Map(currentSnapshot);
    desiredSnapshot.set(targetKey, false);

    /*
     * Use the controller that produced the visible chip first. Its
     * toggleSelect API is the authoritative path for one value and avoids a
     * Commerce core-action/controller timing split. The batch action remains
     * a fallback for controllers that do not expose the selected value.
     */
    const directFacet = findFacetController(facetGen, targetFacetId);
    let directlyApplied = false;
    try {
      directlyApplied = await setFacetSelectionByRawValue(
        directFacet,
        targetRaw,
        false,
        { isCurrent },
      );
    } catch (_) { }
    if (!isCurrent()) return cancelledResult();
    if (directlyApplied) {
      const didSync = await waitForDesiredSnapshot(8);
      if (!isCurrent()) return cancelledResult();
      return createRemovalResult(
        true,
        didSync,
        "controller-owned",
        "toggle-select",
      );
    }

    let batchResult = null;
    if (!isCurrent()) return cancelledResult();
    try {
      batchResult = await applyFacetSelectionSnapshotBatch(
        engine,
        mod,
        desiredSnapshot,
        currentSnapshot,
        { isCurrent },
      );
    } catch (_) { }
    if (!isCurrent()) return cancelledResult();
    if (batchResult?.supported) {
      const didSync = await waitForDesiredSnapshot();
      if (!isCurrent()) return cancelledResult();
      /*
       * A Commerce action dispatch can complete before facetGen publishes its
       * next state. Treat an accepted deselect batch as applied even when that
       * short observation window expires; returning false here makes the chip
       * handler run a fallback toggle against stale "selected" state and turns
       * the value straight back on.
       */
      const applied = didSync || Number(batchResult.appliedCount || 0) > 0;
      return createRemovalResult(
        applied,
        didSync,
        "explicit-required",
        applied ? "state-only-batch" : "no-op",
      );
    }

    const facet = findFacetController(facetGen, targetFacetId);
    if (!facet) {
      return createRemovalResult(false, false, "explicit-required", "no-op");
    }
    let applied = false;
    try {
      applied = await setFacetSelectionByRawValue(
        facet,
        targetRaw,
        false,
        { isCurrent },
      );
    } catch (_) { }
    if (!isCurrent()) return cancelledResult();
    if (!applied) {
      return createRemovalResult(false, false, "explicit-required", "no-op");
    }
    const didSync = await waitForDesiredSnapshot(8);
    if (!isCurrent()) return cancelledResult();
    return createRemovalResult(
      true,
      didSync,
      "controller-owned",
      "toggle-select",
    );
  }

  function sortFacetValuesSelectedFirst(values) {
    if (!Array.isArray(values) || values.length === 0) return values || [];
    return [...values].sort((a, b) => {
      const sa = a?.state === "selected" ? 0 : 1;
      const sb = b?.state === "selected" ? 0 : 1;
      return sa - sb;
    });
  }

  function tryExtractQueryFromController(controller) {
    if (!controller) return "";
    const s = controller.state || {};
    const asTrim = (v) => {
      if (v == null) return "";
      const t = String(v).trim();
      return t;
    };
    let q = asTrim(s.query);
    if (q) return q;
    q = asTrim(s.q);
    if (q) return q;
    if (s.question != null) {
      q =
        typeof s.question === "object" && s.question !== null
          ? asTrim(s.question.value)
          : asTrim(s.question);
      if (q) return q;
    }
    return "";
  }

  function getActiveKeywordQuery(controller, container) {
    const submittedQueryKey = "_coveoLastSubmittedKeywordQuery";
    if (
      container &&
      Object.prototype.hasOwnProperty.call(container, submittedQueryKey)
    ) {
      return String(container[submittedQueryKey] ?? "").trim();
    }
    if (
      controller &&
      Object.prototype.hasOwnProperty.call(controller, submittedQueryKey)
    ) {
      return String(controller[submittedQueryKey] ?? "").trim();
    }
    let q = tryExtractQueryFromController(controller);
    if (q) return q;
    try {
      const u = new URL(window.location.href);
      const uq = (u.searchParams.get("q") || "").trim();
      if (uq) return uq;
    } catch (_) { }
    return "";
  }

  function setLastSubmittedKeywordQuery(controller, container, query) {
    const normalized = String(query == null ? "" : query).trim();
    if (container) {
      container._coveoLastSubmittedKeywordQuery = normalized;
    }
    if (controller && typeof controller === "object") {
      controller._coveoLastSubmittedKeywordQuery = normalized;
    }
  }

  async function clearKeywordQuery(
    controller,
    engine,
    mod,
    container,
    options,
  ) {
    const isCurrent =
      typeof options?.isCurrent === "function"
        ? options.isCurrent
        : () => true;
    if (!isCurrent()) return;
    setLastSubmittedKeywordQuery(controller, container, "");
    let didQueryUpdate = false;
    if (mod?.loadQueryActions && engine) {
      try {
        const queryActions = mod.loadQueryActions(engine);
        if (queryActions?.updateQuery) {
          const patch = { query: "" };
          const s = controller?.state || {};
          if (s.cq != null && String(s.cq).trim()) {
            patch.cq = s.cq;
          }
          engine.dispatch(queryActions.updateQuery(patch));
          didQueryUpdate = true;
        }
      } catch (_) { }
    }
    if (!didQueryUpdate && mod?.loadSearchActions && engine) {
      try {
        const searchActions = mod.loadSearchActions(engine);
        if (searchActions?.prepareForSearchWithQuery) {
          await engine.dispatch(
            searchActions.prepareForSearchWithQuery({ query: "" }),
          );
        }
      } catch (_) { }
      if (!isCurrent()) return;
    }
    const inputs = [
      container?.querySelector("#coveo-collection-search-input"),
      container?.querySelector("#coveo-search-page-input"),
      document.querySelector("#coveo-search-wrapper input[name='q']"),
    ].filter(Boolean);
    inputs.forEach((inp) => {
      inp.value = "";
    });
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete("q");
      replaceCoveoHistoryUrl(url.toString());
    } catch (_) { }
    try {
      if (window.CoveoSearchBoxController?.updateText) {
        window.CoveoSearchBoxController.updateText("");
      }
    } catch (_) { }
  }

  function getCoveoDefaultSortValue() {
    return (
      document.getElementById("coveo-sort")?.dataset?.defaultSort ||
      "relevance"
    );
  }

  function getCoveoCurrentDisplayPage(paginationCtrl) {
    const rawPage = paginationCtrl?.state?.page;
    const totalPages = paginationCtrl?.state?.totalPages || 1;
    if (!Number.isFinite(rawPage)) return 1;
    const isZeroBased = rawPage === 0 || (rawPage < totalPages && totalPages > 1);
    return isZeroBased ? rawPage + 1 : rawPage;
  }

  function collectCoveoUrlFacetSelections(facetGen) {
    const facets = getConditionAwareFacets(facetGen);
    const facetValues = new Map();
    const facetRanges = new Map();

    facets.forEach(function (facet) {
      const facetId = String(facet?.facetId || facet?.state?.facetId || "").trim();
      const normalizedFacetId = normalizeCoveoUrlFacetId(facetId);
      if (
        !normalizedFacetId ||
        isInternalCoveoUrlFacet(normalizedFacetId)
      ) {
        return;
      }

      const rangeKind = resolveCoveoRangeKindForFacet(facetId, facet);
      if (rangeKind) {
        const bounds =
          rangeKind === "numeric"
            ? resolveRangeBoundsFromFacetState(facet, "numeric")
            : resolveRangeChipBounds(facet, facetId, rangeKind);
        if (bounds && Number.isFinite(bounds.lo) && Number.isFinite(bounds.hi)) {
          facetRanges.set(normalizedFacetId, {
            lo: bounds.lo,
            hi: bounds.hi,
          });
        }
        return;
      }

      const values = normalizeFacetStateValues(facet.state || {})
        .filter(function (value) {
          if (value?.state !== "selected") return false;
          const raw = String(facetItemRawValue(value) || "").trim();
          if (!raw) return false;
          return !shouldSuppressFacetValue(
            facetId,
            getFacetDisplayLabel(
              facetId,
              String(
                facet.state?.displayName || facet.state?.label || facetId,
              ).trim(),
            ),
            raw,
          );
        })
        .map(function (value) {
          return String(facetItemRawValue(value)).trim();
        });

      if (!values.length) return;
      const uniqueValues = Array.from(new Set(values)).sort();
      facetValues.set(normalizedFacetId, uniqueValues);
    });

    if (!facetControllersIncludeYear(facets)) {
      const yearSel = getCoveoYearFacetSelection();
      if (yearSel && !yearSel.fullRange) {
        facetRanges.set(normalizeCoveoUrlFacetId(COVEO_YEAR_FACET_ID), {
          lo: yearSel.lo,
          hi: yearSel.hi,
        });
      }
    }

    return { facetValues, facetRanges };
  }

  function recordCoveoRangeHydrationDebug(event, details) {
    let debugEnabled = false;
    try {
      debugEnabled =
        new URL(window.location.href).searchParams.get(
          "coveo-debug-requests",
        ) === "1";
    } catch (_) { }
    const root = document.documentElement;
    if (!debugEnabled || !root) return;
    let records = [];
    try {
      records = JSON.parse(root.dataset.coveoRangeHydrationEvents || "[]");
    } catch (_) { }
    if (!Array.isArray(records)) records = [];
    records.push(
      Object.assign(
        { event: String(event || "") },
        details && typeof details === "object" ? details : {},
      ),
    );
    root.dataset.coveoRangeHydrationEvents = JSON.stringify(
      records.slice(-20),
    );
  }

  function buildPendingInitialCoveoNumericFacetValues(facet, nextRange) {
    const selectedStart = Number(nextRange?.start);
    const selectedEnd = Number(nextRange?.end);
    if (!Number.isFinite(selectedStart) || !Number.isFinite(selectedEnd)) {
      return null;
    }

    const values = [];
    const seenRanges = new Set();
    let selectedRangeIncluded = false;
    normalizeFacetStateValues(facet?.state || {}).forEach(function (value) {
      const start = Number(value?.start ?? value?.value?.start);
      const end = Number(value?.end ?? value?.value?.end);
      if (!Number.isFinite(start) || !Number.isFinite(end)) return;
      const endInclusive =
        (value?.endInclusive ?? value?.value?.endInclusive) !== false;
      const rangeKey = `${start}\u001E${end}`;
      if (seenRanges.has(rangeKey)) return;
      seenRanges.add(rangeKey);

      const isSelectedRange =
        Math.abs(start - selectedStart) < 1e-6 &&
        Math.abs(end - selectedEnd) < 1e-6;
      values.push(
        Object.assign({}, value, {
          start,
          end,
          endInclusive: isSelectedRange
            ? nextRange?.endInclusive !== false
            : endInclusive,
          state: isSelectedRange ? "selected" : "idle",
        }),
      );
      if (isSelectedRange) selectedRangeIncluded = true;
    });

    if (!selectedRangeIncluded) {
      values.push({
        start: selectedStart,
        end: selectedEnd,
        endInclusive: nextRange?.endInclusive !== false,
        state: "selected",
      });
    }
    return values;
  }

  async function applyPendingInitialCoveoRangeStateOnly(
    facet,
    facetId,
    nextRange,
    engine,
    mod,
    options,
  ) {
    const isCurrent =
      typeof options?.isCurrent === "function"
        ? options.isCurrent
        : () => true;
    const kind = String(options?.kind || "numeric");
    const expectedRange = options?.expectedRange || nextRange;
    const result = {
      applied: false,
      supported: false,
      synchronized: false,
    };
    if (!isCurrent()) return Object.assign(result, { cancelled: true });
    if (
      !facet ||
      !facetId ||
      !isNumericalRangeFacet(facet) ||
      !engine ||
      typeof engine.dispatch !== "function" ||
      typeof mod?.loadNumericFacetActions !== "function"
    ) {
      return result;
    }

    if (
      areCoveoFacetRangesEqual(
        resolveRangeBoundsFromFacetState(facet, kind),
        expectedRange,
      )
    ) {
      return Object.assign(result, {
        supported: true,
        synchronized: true,
      });
    }

    let numericActions;
    try {
      numericActions = mod.loadNumericFacetActions(engine);
    } catch (_) {
      return result;
    }
    if (typeof numericActions?.updateNumericFacetValues !== "function") {
      return result;
    }
    result.supported = true;

    const values = buildPendingInitialCoveoNumericFacetValues(
      facet,
      nextRange,
    );
    if (!values || !isCurrent()) {
      return Object.assign(result, { cancelled: !isCurrent() });
    }

    let action;
    try {
      action = numericActions.updateNumericFacetValues({ facetId, values });
    } catch (_) {
      return result;
    }
    if (!action || action.error) return result;

    let dispatchedAction;
    try {
      dispatchedAction = await Promise.resolve(engine.dispatch(action));
    } catch (_) {
      return result;
    }
    if (!isCurrent()) {
      return Object.assign(result, { cancelled: true });
    }
    if (dispatchedAction?.error) return result;

    /*
     * Commerce NumericFacet controller values are derived from the latest
     * response, while this public action intentionally updates the request
     * slice only. A valid action on a proven numericalRange controller is the
     * synchronization contract; waiting for response values would require the
     * duplicate fetch this path exists to avoid.
     */
    result.applied = true;
    result.synchronized = true;
    return result;
  }

  async function hydratePendingInitialCoveoUrlState(
    search,
    subControllers,
    engine,
    mod,
    hydrationLease,
  ) {
    const lease = hydrationLease || beginPendingInitialCoveoUrlHydration();
    const pendingState = lease?.pendingState || null;
    if (!pendingState) return "empty";
    function hydrationWasRetired() {
      return !lease.isCurrent();
    }

    const facets = flattenFacetControllers(subControllers?.facetGen)
      .slice()
      .sort(function (a, b) {
        return (
          getCoveoPendingUrlHydrationFacetPriority(
            a?.facetId || a?.state?.facetId || "",
          ) -
          getCoveoPendingUrlHydrationFacetPriority(
            b?.facetId || b?.state?.facetId || "",
          )
        );
      });
    let didMutate = false;
    let sawMismatch = false;
    let hasUnresolvedMismatch = false;
    let requiresExplicitSearch = false;

    const pendingConditionValues = resolvePendingInitialCoveoFacetValues(
      COVEO_CONDITION_FACET_ID,
    );
    if (pendingConditionValues.length) {
      coveoConditionSelectionShadow.replace(pendingConditionValues);
    }

    if (!facets.length) {
      const hasOtherPendingFacetState =
        getPendingInitialCoveoRegularFacetEntries(pendingState).some(function (
          entry,
        ) {
          return !facetIdsMatchCondition(entry?.facetId || "");
        }) ||
        (pendingState.facetRanges instanceof Map &&
          pendingState.facetRanges.size > 0);
      if (pendingConditionValues.length && !hasOtherPendingFacetState) {
        return "matched";
      }
      return "waiting";
    }

    for (let i = 0; i < facets.length; i++) {
      if (hydrationWasRetired()) return "cancelled";
      const facet = facets[i];
      const facetId = String(facet?.facetId || facet?.state?.facetId || "").trim();
      if (!facetId) continue;
      // Condition is governed by the authoritative shadow and request
      // pipeline, including responses where Coveo omits its controller.
      if (facetIdsMatchCondition(facetId)) continue;

      const pendingValues = resolvePendingInitialCoveoFacetValues(facetId);
      if (pendingValues.length) {
        const currentValues = normalizeFacetStateValues(facet.state || {})
          .filter(function (value) {
            return value?.state === "selected";
          })
          .map(function (value) {
            return String(facetItemRawValue(value) || "").trim();
          })
          .filter(Boolean);

        if (!areCoveoFacetValueSetsEqual(currentValues, pendingValues)) {
          sawMismatch = true;
          let appliedAsStateOnlyBatch = false;
          const currentSnapshot = buildFacetSelectionSnapshot(
            subControllers?.facetGen,
          );
          const desiredSnapshot =
            buildDesiredPendingInitialCoveoFacetSelectionSnapshot(
              currentSnapshot,
              facetId,
              pendingValues,
            );
          if (
            !appliedAsStateOnlyBatch &&
            werePendingUrlFiltersAppliedToPrimaryRequest()
          ) {
            const batchResult = await applyFacetSelectionSnapshotBatch(
              engine,
              mod,
              desiredSnapshot,
              currentSnapshot,
              { isCurrent: () => !hydrationWasRetired() },
            );
            if (hydrationWasRetired()) return "cancelled";
            if (batchResult?.supported) {
              appliedAsStateOnlyBatch = true;
              if (Number(batchResult.appliedCount || 0) > 0) {
                didMutate = true;
              }
            }
          }
          if (!appliedAsStateOnlyBatch) {
            for (let j = 0; j < pendingValues.length; j++) {
              if (hydrationWasRetired()) return "cancelled";
              const applied = await setFacetSelectionByRawValue(
                facet,
                pendingValues[j],
                true,
                { isCurrent: () => !hydrationWasRetired() },
              );
              if (hydrationWasRetired()) return "cancelled";
              if (applied) {
                didMutate = true;
              }
            }
          }
          if (appliedAsStateOnlyBatch) {
            const regularSelectionSynchronized =
              await waitForFacetSelectionSnapshotSync(
                subControllers?.facetGen,
                desiredSnapshot,
              );
            if (hydrationWasRetired()) return "cancelled";
            if (!regularSelectionSynchronized) {
              hasUnresolvedMismatch = true;
            }
          } else {
            hasUnresolvedMismatch = true;
          }
        }
      }

      const pendingRange = resolvePendingInitialCoveoFacetRange(facetId);
      if (pendingRange) {
        const rangeKind = resolveCoveoRangeKindForFacet(facetId, facet);
        const isYearRange = facetIdsMatchYear(facetId);
        const currentRange = isYearRange
          ? resolveRangeChipBounds(facet, facetId, rangeKind)
          : resolveRangeBoundsFromFacetState(facet, rangeKind);
        if (!areCoveoFacetRangesEqual(currentRange, pendingRange)) {
          sawMismatch = true;
          if (isYearRange) {
            hasUnresolvedMismatch = true;
            setCoveoYearFacetSelection({
              lo: Math.round(pendingRange.lo),
              hi: Math.round(pendingRange.hi),
              fullRange: false,
            });
            didMutate = true;
            requiresExplicitSearch = true;
          } else {
            const nextRange = buildPendingInitialCoveoRangeValue(
              facetId,
              facet,
              pendingRange,
            );
            let stateOnlySynchronized = false;
            const wasAppliedToPrimaryRequest = !!(
              nextRange &&
              wasPendingInitialCoveoFacetAppliedToPrimaryRequest(facetId)
            );
            recordCoveoRangeHydrationDebug("mismatch", {
              facetId,
              facetType: String(facet?.state?.type || facet?.type || ""),
              hasNumericActionLoader:
                typeof mod?.loadNumericFacetActions === "function",
              isNumericController: isNumericalRangeFacet(facet),
              pendingRange,
              requestPatched: wasAppliedToPrimaryRequest,
            });
            if (
              nextRange &&
              wasAppliedToPrimaryRequest
            ) {
              const stateOnlyResult =
                await applyPendingInitialCoveoRangeStateOnly(
                  facet,
                  facetId,
                  nextRange,
                  engine,
                  mod,
                  {
                    expectedRange: pendingRange,
                    isCurrent: () => !hydrationWasRetired(),
                    kind: rangeKind,
                  },
                );
              recordCoveoRangeHydrationDebug("state-only", {
                facetId,
                result: stateOnlyResult,
              });
              if (stateOnlyResult?.cancelled || hydrationWasRetired()) {
                return "cancelled";
              }
              if (stateOnlyResult?.synchronized) {
                stateOnlySynchronized = true;
                if (stateOnlyResult.applied) didMutate = true;
              }
            }
            if (stateOnlySynchronized) continue;

            hasUnresolvedMismatch = true;
            recordCoveoRangeHydrationDebug("fallback", { facetId });
            if (nextRange && typeof facet.setRanges === "function") {
              try {
                await Promise.resolve(facet.setRanges([nextRange]));
                if (hydrationWasRetired()) return "cancelled";
                didMutate = true;
              } catch (_) { }
            }
          }
        }
      }
    }

    if (hydrationWasRetired()) return "cancelled";
    const pendingYearRange = resolvePendingInitialCoveoFacetRange(COVEO_YEAR_FACET_ID);
    if (pendingYearRange) {
      const currentYearRange = getCoveoYearFacetSelection();
      if (
        !currentYearRange ||
        currentYearRange.fullRange ||
        !areCoveoFacetRangesEqual(currentYearRange, pendingYearRange)
      ) {
        sawMismatch = true;
        hasUnresolvedMismatch = true;
        setCoveoYearFacetSelection({
          lo: Math.round(pendingYearRange.lo),
          hi: Math.round(pendingYearRange.hi),
          fullRange: false,
        });
        didMutate = true;
        requiresExplicitSearch = true;
      }
    }

    if (!sawMismatch) return "matched";
    if (!hasUnresolvedMismatch) return "matched";
    if (!didMutate) return "stalled";

    if (requiresExplicitSearch) {
      if (hydrationWasRetired()) return "cancelled";
      await dispatchCoveoSearch(search, engine, mod);
    }
    return "applied";
  }

  function schedulePendingInitialCoveoUrlHydration(
    search,
    subControllers,
    engine,
    mod,
  ) {
    return schedulePendingInitialCoveoUrlHydrationLease(function (lease) {
      return hydratePendingInitialCoveoUrlState(
          search,
          subControllers,
          engine,
          mod,
          lease,
        );
    });
  }

  function syncCoveoStateToUrl(controller, subControllers, container) {
    const pendingInitialState = getPendingInitialCoveoUrlState();
    if (pendingInitialState) {
      syncCoveoUrlStateSnapshot({ pendingInitialState });
      return;
    }

    const current = collectCoveoUrlFacetSelections(subControllers?.facetGen);
    const query = String(getActiveKeywordQuery(controller, container) || "").trim();
    const currentSort = String(window.__coveoActiveSortValue?.() || "").trim();
    const defaultSort = String(getCoveoDefaultSortValue() || "relevance").trim();
    const currentPage = getCoveoCurrentDisplayPage(subControllers?.paginationCtrl);
    syncCoveoUrlStateSnapshot({
      conditionAllSelected: coveoConditionSelectionShadow.isAllSelected(),
      defaultSort,
      facetRanges: current.facetRanges,
      facetValues: current.facetValues,
      page: currentPage,
      pendingInitialState: null,
      preserveEmptyCondition: true,
      query,
      sort: currentSort,
    });
  }

  const COVEO_ACTIVE_FILTER_CHIP_CLOSE_ICON =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M11.3333 4.66675L4.66663 11.3334M4.66663 4.66675L11.3333 11.3334" stroke="#4D5761" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const coveoCollectionConditionChipAvailability = new WeakMap();

  function getCollectionConditionChipAvailability(facet, controller, container) {
    if (container?.id !== "coveo-headless-collection") return null;
    const state = controller?.state || {};
    const handle = String(container.dataset?.collectionHandle || "");
    const previous = coveoCollectionConditionChipAvailability.get(container);
    const previousAvailability =
      previous?.controller === controller && previous.handle === handle
        ? previous.availability
        : null;
    // Keep the last response's visibility while a filter/page request is loading.
    if (state.isLoading || state.isLoadingMore || state.error) {
      return previousAvailability;
    }
    if (!(state.response || state.responseId || state.searchResponse)) return null;
    if (facet.__coveoSyntheticConditionFacet) return null;

    const values = normalizeFacetStateValues(facet.state || {}).filter(
      (value) => !value.__coveoSyntheticConditionOption,
    );
    const counts = new Map();
    let hasKnownCount = false;
    values.forEach(function (value) {
      const label = getCanonicalConditionOptionLabel(facetItemRawValue(value));
      if (!label) return;
      const rawCount = value.numberOfResults ?? value.count;
      const count =
        (typeof rawCount === "number" ||
          (typeof rawCount === "string" && rawCount.trim() !== ""))
          ? Number(rawCount)
          : NaN;
      const knownCount = Number.isFinite(count) && count >= 0;
      counts.set(label, knownCount ? count : null);
      if (knownCount) hasKnownCount = true;
    });
    const complete =
      (facet.state?.canShowMoreValues ?? facet.state?.moreValuesAvailable) === false &&
      (hasKnownCount || values.length === 0);
    const availability = { counts, complete };
    coveoCollectionConditionChipAvailability.set(container, {
      controller, handle, availability,
    });
    return availability;
  }

  function isConditionChipAvailable(rawValue, availability) {
    if (!availability) return true;
    const label = getCanonicalConditionOptionLabel(rawValue);
    // Unknown/partial counts are not evidence that a selection has no matches.
    if (availability.counts.has(label)) {
      return availability.counts.get(label) !== 0;
    }
    return !availability.complete;
  }

  function removeConditionChipSelection(value, facetGen, controller, container) {
    const facet = getConditionAwareFacets(facetGen).find((item) =>
      facetIdsMatchCondition(item.facetId || item.state?.facetId || ""),
    );
    const availability = facet
      ? getCollectionConditionChipAvailability(facet, controller, container)
      : null;
    const visibleValues = coveoConditionSelectionShadow.getDisplayValues().filter(
      (selectedValue) => isConditionChipAvailable(selectedValue, availability),
    );
    if (
      availability &&
      visibleValues.length === 1 &&
      visibleValues[0] === getCanonicalConditionOptionLabel(value)
    ) {
      // Removing the last visible chip must not leave hidden zero-result filters.
      coveoConditionSelectionShadow.clear();
    } else {
      coveoConditionSelectionShadow.remove(value);
    }
  }

  function collectAppliedFacetChipListItems(facetGen, controller, container) {
    const facets = getConditionAwareFacets(facetGen);
    const items = [];
    let yearChipRendered = false;
    const activeDistance = getActiveDistanceChipState();

    if (activeDistance) {
      items.push(
        `<li class="coveo-active-filters__item" role="listitem"><button type="button" class="coveo-active-filters__chip" data-coveo-chip-remove="1" data-chip-mode="distance" data-facet-id="distance" aria-label="${escapeAttr(activeDistance.ariaLabel)}"><span class="coveo-active-filters__chip-text">${escapeHtml(activeDistance.text)}</span><span class="coveo-active-filters__chip-x" aria-hidden="true">${COVEO_ACTIVE_FILTER_CHIP_CLOSE_ICON}</span></button></li>`,
      );
    }

    facets.forEach((facet) => {
      const facetId = facet.facetId || facet.state?.facetId || "";
      if (!facetId) return;
      if (shouldHideCollectionBrandFacetFromUi(facetId)) return;
      const values = normalizeFacetStateValues(facet.state || {});
      // ALL has no request restriction, but exposes each Condition as a
      // removable chip. The drawer continues to show only its ALL tile.
      const chipValues = facetIdsMatchCondition(facetId)
        ? sortConditionFacetValues(
            ensureCanonicalConditionFacetValues(
              values,
              coveoConditionSelectionShadow.getDisplayValues(),
            ),
          )
        : values;
      const conditionAvailability = facetIdsMatchCondition(facetId)
        ? getCollectionConditionChipAvailability(facet, controller, container)
        : null;
      const selected = chipValues.filter((value) => {
        if (value.state !== "selected") return false;
        return isConditionChipAvailable(facetItemRawValue(value), conditionAvailability);
      });
      const isSyntheticYear =
        facet._isSyntheticYearFacet && facetIdsMatchYear(facetId);

      const facetLabel = getFacetDisplayLabel(
        facetId,
        String(facet.state?.displayName || facet.state?.label || facetId).trim(),
      );
      const idAttr = escapeAttr(facetId);

      if (facetIdsMatchLength(facetId)) {
        const bounds = resolveRangeChipBounds(facet, facetId, "length");
        if (bounds) {
          const lo = bounds.lo;
          const hi = bounds.hi;
          const spanText = `${facetLabel}: ${formatLengthFeetWhole(lo)}\u2013${formatLengthFeetWhole(hi)} ft`;
          const label = `Remove ${facetLabel} filter`;
          items.push(
            `<li class="coveo-active-filters__item" role="listitem"><button type="button" class="coveo-active-filters__chip" data-coveo-chip-remove="1" data-chip-mode="range" data-facet-id="${idAttr}" aria-label="${escapeAttr(label)}"><span class="coveo-active-filters__chip-text">${escapeHtml(spanText)}</span><span class="coveo-active-filters__chip-x" aria-hidden="true">${COVEO_ACTIVE_FILTER_CHIP_CLOSE_ICON}</span></button></li>`,
          );
        }
        return;
      }

      if (facetIdsMatchYear(facetId)) {
        if (yearChipRendered) return;
        const bounds = resolveRangeChipBounds(facet, facetId, "year");
        if (bounds) {
          const loI = Math.round(bounds.lo);
          const hiI = Math.round(bounds.hi);
          const spanText = `${facetLabel}: ${loI}\u2013${hiI}`;
          const label = `Remove ${facetLabel} filter`;
          const idAttr = escapeAttr(COVEO_YEAR_FACET_ID);
          items.push(
            `<li class="coveo-active-filters__item" role="listitem"><button type="button" class="coveo-active-filters__chip" data-coveo-chip-remove="1" data-chip-mode="range" data-facet-id="${idAttr}" aria-label="${escapeAttr(label)}"><span class="coveo-active-filters__chip-text">${escapeHtml(spanText)}</span><span class="coveo-active-filters__chip-x" aria-hidden="true">${COVEO_ACTIVE_FILTER_CHIP_CLOSE_ICON}</span></button></li>`,
          );
          yearChipRendered = true;
        }
        return;
      }

      if (!selected.length) return;

      if (facetIdsMatchPrice(facetId)) {
        const bounds = resolveRangeChipBounds(facet, facetId, "price");
        if (bounds) {
          let lo = Number(bounds.lo);
          let hi = Number(bounds.hi);
          lo = roundPriceToStep(lo, "floor");
          hi = roundPriceToStep(hi, "ceil");
          const spanText =
            lo === hi
              ? `${facetLabel}: ${formatPrice(lo)}`
              : `${facetLabel}: ${formatPrice(lo)}\u2013${formatPrice(hi)}`;
          const label = `Remove ${facetLabel} filter`;
          items.push(
            `<li class="coveo-active-filters__item" role="listitem"><button type="button" class="coveo-active-filters__chip" data-coveo-chip-remove="1" data-chip-mode="range" data-facet-id="${idAttr}" aria-label="${escapeAttr(label)}"><span class="coveo-active-filters__chip-text">${escapeHtml(spanText)}</span><span class="coveo-active-filters__chip-x" aria-hidden="true">${COVEO_ACTIVE_FILTER_CHIP_CLOSE_ICON}</span></button></li>`,
          );
        } else {
          const parsed = [
            ...new Set(
              selected
                .map((v) => {
                  const b = facetItemNumericBounds(v);
                  if (b) {
                    return roundPriceToStep(
                      normalizeCoveoFacetPriceDollars(b.lo),
                      "round",
                    );
                  }
                  return parsePrice(facetItemRawValue(v));
                })
                .filter((n) => n != null && Number.isFinite(n)),
            ),
          ];
          if (parsed.length === 1) {
            const spanText = `${facetLabel}: ${formatPrice(parsed[0])}`;
            const label = `Remove ${facetLabel} filter`;
            items.push(
              `<li class="coveo-active-filters__item" role="listitem"><button type="button" class="coveo-active-filters__chip" data-coveo-chip-remove="1" data-chip-mode="range" data-facet-id="${idAttr}" aria-label="${escapeAttr(label)}"><span class="coveo-active-filters__chip-text">${escapeHtml(spanText)}</span><span class="coveo-active-filters__chip-x" aria-hidden="true">${COVEO_ACTIVE_FILTER_CHIP_CLOSE_ICON}</span></button></li>`,
            );
          } else if (parsed.length >= 2) {
            const lo = roundPriceToStep(Math.min(...parsed), "floor");
            const hi = roundPriceToStep(Math.max(...parsed), "ceil");
            const spanText = `${facetLabel}: ${formatPrice(lo)}\u2013${formatPrice(hi)}`;
            const label = `Remove ${facetLabel} filter`;
            items.push(
              `<li class="coveo-active-filters__item" role="listitem"><button type="button" class="coveo-active-filters__chip" data-coveo-chip-remove="1" data-chip-mode="range" data-facet-id="${idAttr}" aria-label="${escapeAttr(label)}"><span class="coveo-active-filters__chip-text">${escapeHtml(spanText)}</span><span class="coveo-active-filters__chip-x" aria-hidden="true">${COVEO_ACTIVE_FILTER_CHIP_CLOSE_ICON}</span></button></li>`,
            );
          }
        }
        return;
      }

      if (isNumericalRangeFacet(facet)) {
        const bounds = selected
          .map(facetItemNumericBounds)
          .filter(Boolean);
        if (bounds.length) {
          const lo = Math.min(...bounds.map((b) => b.lo));
          const hi = Math.max(...bounds.map((b) => b.hi));
          const loR = Number(Number(lo).toPrecision(12));
          const hiR = Number(Number(hi).toPrecision(12));
          const spanText = `${facetLabel}: ${loR}\u2013${hiR}`;
          const rmLabel = `Remove ${facetLabel} filter`;
          items.push(
            `<li class="coveo-active-filters__item" role="listitem"><button type="button" class="coveo-active-filters__chip" data-coveo-chip-remove="1" data-chip-mode="range" data-facet-id="${idAttr}" aria-label="${escapeAttr(rmLabel)}"><span class="coveo-active-filters__chip-text">${escapeHtml(spanText)}</span><span class="coveo-active-filters__chip-x" aria-hidden="true">${COVEO_ACTIVE_FILTER_CHIP_CLOSE_ICON}</span></button></li>`,
          );
        }
        return;
      }

      selected.forEach((v) => {
        const raw = facetItemRawValue(v);
        const valueStr = String(raw);
        if (isAutoAppliedCollectionBrandFacetValue(facetId, valueStr)) return;
        if (shouldSuppressFacetValue(facetId, facetLabel, valueStr)) return;
        const display = valueStr;
        const spanText = `${facetLabel}: ${display}`;
        const label = `Remove ${facetLabel}: ${display}`;
        items.push(
          `<li class="coveo-active-filters__item" role="listitem"><button type="button" class="coveo-active-filters__chip" data-coveo-chip-remove="1" data-chip-mode="value" data-facet-id="${idAttr}" data-value="${escapeAttr(valueStr)}" aria-label="${escapeAttr(label)}"><span class="coveo-active-filters__chip-text">${escapeHtml(spanText)}</span><span class="coveo-active-filters__chip-x" aria-hidden="true">${COVEO_ACTIVE_FILTER_CHIP_CLOSE_ICON}</span></button></li>`,
        );
      });
    });

    const yearSel = getCoveoYearFacetSelection();
    if (yearSel && !yearSel.fullRange && !yearChipRendered &&
        !hasCoveoManagedRangeClearTombstone(COVEO_YEAR_FACET_ID)) {
      const idAttr = escapeAttr(COVEO_YEAR_FACET_ID);
      const spanText = `Year: ${yearSel.lo}\u2013${yearSel.hi}`;
      const label = "Remove Year filter";
      items.push(
        `<li class="coveo-active-filters__item" role="listitem"><button type="button" class="coveo-active-filters__chip" data-coveo-chip-remove="1" data-chip-mode="range" data-facet-id="${idAttr}" aria-label="${escapeAttr(label)}"><span class="coveo-active-filters__chip-text">${escapeHtml(spanText)}</span><span class="coveo-active-filters__chip-x" aria-hidden="true">${COVEO_ACTIVE_FILTER_CHIP_CLOSE_ICON}</span></button></li>`,
      );
    }

    return items;
  }

  function countAppliedFacetFilters(facetGen, controller, container) {
    return collectAppliedFacetChipListItems(facetGen, controller, container).length;
  }

  function isCoveoFilterPresentationPending(controller, container) {
    if (!controller || (container?.id !== "coveo-headless-collection" &&
      container?.id !== "coveo-headless-search")) return false;
    const state = controller.state || {};
    return !state.error && !!(
      state.isLoading || state.isLoadingMore ||
      !(state.response || state.responseId || state.searchResponse)
    );
  }

  function updateAppliedFiltersCount(facetGen, controller, container) {
    if (isCoveoFilterPresentationPending(controller, container)) return;
    const activeCount = countAppliedFacetFilters(
      facetGen,
      controller,
      container,
    );
    const countEls = Array.from(
      document.querySelectorAll(".coveo-filters-count"),
    );
    if (!countEls.length) return;
    countEls.forEach(function (countEl) {
      if (activeCount > 0) {
        countEl.textContent = String(activeCount);
        countEl.classList.remove("hidden");
        countEl.setAttribute("aria-hidden", "false");
      } else {
        countEl.textContent = "";
        countEl.classList.add("hidden");
        countEl.setAttribute("aria-hidden", "true");
      }
    });
  }

  function renderActiveFacetChips(facetGen, controller, container) {
    const strip = document.getElementById("coveo-active-filters");
    const drawerApplied = document.getElementById("coveo-filters-drawer-applied");
    if ((container?.id === "coveo-headless-collection" ||
      container?.id === "coveo-headless-search") && controller) {
      // Collection buckets decide which selected Conditions have matching boats.
      // Keep the reserved strip until the first response, and retain ready chips
      // while subsequent requests are loading.
      if (isCoveoFilterPresentationPending(controller, container)) return;
      if (strip) {
        strip.classList.remove("coveo-active-filters--pending");
        strip.setAttribute("aria-busy", "false");
      }
    }
    const facetItems = collectAppliedFacetChipListItems(facetGen, controller, container);
    const items = [];
    items.push(...facetItems);

    // Even when every selected Condition is unavailable, keep Clear all usable.
    const hasHiddenSelections = !items.length && countAppliedFacetFilters(facetGen) > 0;
    if (!items.length && !hasHiddenSelections) {
      const drawerContent =
        (container &&
          container.nodeType === 1 &&
          container.querySelector("#CoveoFiltersDrawerContent")) ||
        document.getElementById("CoveoFiltersDrawerContent");
      if (
        strip &&
        drawerContent &&
        drawerContent._coveoApplyingFilters &&
        strip.dataset.coveoLastRenderedInnerHtml
      ) {
        updateAppliedFiltersCount(facetGen, controller, container);
        return;
      }
      if (strip) {
        strip.innerHTML = "";
        strip.classList.add("hidden");
        strip.setAttribute("aria-hidden", "true");
        delete strip.dataset.coveoLastRenderedInnerHtml;
      }
      if (drawerApplied) {
        drawerApplied.innerHTML = "";
        drawerApplied.classList.add("hidden");
        drawerApplied.setAttribute("aria-hidden", "true");
      }
      updateAppliedFiltersCount(facetGen, controller, container);
      return;
    }

    const listInner = items.join("");
    const nextHtml = `
      <div class="coveo-active-filters__inner">
        <span class="coveo-active-filters__heading" id="coveo-active-filters-label">Applied filters</span>
        <ul class="coveo-active-filters__list" role="list" aria-labelledby="coveo-active-filters-label">
          ${listInner}
        </ul>
        <button type="button" class="coveo-active-filters__clear-all btn btn--link" data-coveo-clear-all-filters="1">Clear all</button>
      </div>
    `.trim();
    if (strip) {
      strip.classList.remove("hidden");
      strip.setAttribute("aria-hidden", "false");
      if (strip.dataset.coveoLastRenderedInnerHtml !== nextHtml) {
        strip.innerHTML = nextHtml;
        strip.dataset.coveoLastRenderedInnerHtml = nextHtml;
      }
    }
    if (drawerApplied) {
      drawerApplied.innerHTML = "";
      drawerApplied.classList.add("hidden");
      drawerApplied.setAttribute("aria-hidden", "true");
    }
    updateAppliedFiltersCount(facetGen, controller, container);
  }

  function waitForNextAnimationFrame() {
    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        resolve();
      });
    });
  }

  function isCoveoRealtimeFilterApplyEnabled() {
    return true;
  }

  function hasCoveoDrawerApplyButton() {
    try {
      return !!document.getElementById("coveo-apply-filters");
    } catch (_) {
      return false;
    }
  }

  function collapseCoveoDrawerFacetAccordions(container, content, options) {
    const opts = options || {};
    const drawer =
      (container &&
        container.nodeType === 1 &&
        container.querySelector("#CoveoFiltersDrawer")) ||
      document.getElementById("CoveoFiltersDrawer");
    const drawerContent =
      content ||
      (container &&
        container.nodeType === 1 &&
        container.querySelector("#CoveoFiltersDrawerContent")) ||
      document.getElementById("CoveoFiltersDrawerContent");
    if (drawerContent && opts.armNextRender !== false) {
      drawerContent._coveoCollapseFacetsOnNextRender = true;
    }
    return collapseFacetAccordions(drawer || drawerContent);
  }

  function prepareCoveoDrawerUiForGlobalClear(container) {
    const content =
      (container &&
        container.nodeType === 1 &&
        container.querySelector("#CoveoFiltersDrawerContent")) ||
      document.getElementById("CoveoFiltersDrawerContent");
    if (!content) return null;
    collapseCoveoDrawerFacetAccordions(container, content);
    content._coveoPendingCheckboxState = new Map();
    delete content._coveoPendingConditionAll;
    content._mmPendingFilterDl = [];
    content._coveoApplyingFilters = false;
    content._coveoFilterSessionBaseline = new Map();
    content
      .querySelectorAll(
        'input[type="checkbox"][data-facet-id][data-value]:not(.coveo-mobile-range-hidden-checkbox)',
      )
      .forEach(function (checkbox) {
        checkbox.checked = false;
        syncFacetCheckboxLabelSelectedClass(checkbox);
      });
    content
      .querySelectorAll('input[type="checkbox"][data-condition-all]')
      .forEach(function (checkbox) {
        checkbox.checked = true;
        syncFacetCheckboxLabelSelectedClass(checkbox);
      });
    try {
      if (typeof content._coveoDiscardPendingLengthRangeCommits === "function") {
        content._coveoDiscardPendingLengthRangeCommits();
      }
    } catch (_) { }
    return content;
  }

  async function clearAllCoveoFacetSelections(
    search,
    engine,
    mod,
    container,
    facetGen,
    options,
  ) {
    const opts = options || {};
    const isMutationCurrent =
      typeof opts.isCurrent === "function" ? opts.isCurrent : () => true;
    if (!isMutationCurrent()) return;
    const preserveDistanceLocation = !!opts.preserveDistanceLocation;
    coveoConditionSelectionShadow.clear();
    const drawerContent = prepareCoveoDrawerUiForGlobalClear(container);
    if (drawerContent) {
      drawerContent._coveoSuppressFacetRerenderUntil = Date.now() + 950;
    }
    if (opts.clearKeyword) {
      await clearKeywordQuery(search, engine, mod, container, {
        isCurrent: isMutationCurrent,
      });
      if (!isMutationCurrent()) return;
    }
    clearCoveoYearFacetSelection();
    clearAllCoveoFacetRangeSelections();
    clearAllCoveoPendingRangeUiSnapshots();
    const facets = flattenFacetControllers(facetGen);
    const facetIds = Array.from(
      new Set(
        facets
          .map((facet) => String(facet?.facetId || facet?.state?.facetId || "").trim())
          .filter(Boolean),
      ),
    );
    facetIds.forEach(function (facetId) {
      setCoveoManagedRangeClearTombstone(facetId, true);
    });
    setCoveoManagedRangeClearTombstone(COVEO_YEAR_FACET_ID, true);
    const didClearDistance = opts.clearDistance !== false;
    const shouldFinalizeDistance =
      didClearDistance || opts.distanceAlreadyCleared === true;
    if (shouldFinalizeDistance) {
      let resetDistanceState = false;
      if (
        preserveDistanceLocation &&
        typeof window.__coveoResetDistanceToAllInventory === "function"
      ) {
        try {
          await window.__coveoResetDistanceToAllInventory({
            force: true,
            runSearch: false,
            isCurrent: isMutationCurrent,
          });
          resetDistanceState = true;
        } catch (_) { }
        if (!isMutationCurrent()) return;
      }
      if (!resetDistanceState && didClearDistance) {
        try {
          clearCoveoDistanceFilterState({
            preserveStoredLocation: preserveDistanceLocation,
          });
        } catch (_) { }
      }
    }

    const currentSnapshot = buildFacetSelectionSnapshot(facetGen);
    const desiredSnapshot = new Map(currentSnapshot);
    desiredSnapshot.forEach(function (_selected, key) {
      desiredSnapshot.set(key, false);
    });
    deleteConditionSelectionSnapshotEntries(currentSnapshot);
    deleteConditionSelectionSnapshotEntries(desiredSnapshot);
    let batchResult = null;
    try {
      batchResult = await applyFacetSelectionSnapshotBatch(
        engine,
        mod,
        desiredSnapshot,
        currentSnapshot,
        { isCurrent: isMutationCurrent },
      );
    } catch (_) { }
    if (!isMutationCurrent()) return;

    let controllerOwnedSearch = false;
    if (batchResult?.supported) {
      try {
        await waitForFacetSelectionSnapshotSync(
          facetGen,
          desiredSnapshot,
        );
      } catch (_) { }
      if (!isMutationCurrent()) return;
    } else {
      for (const facet of facets) {
        if (!isMutationCurrent()) return;
        if (
          facetIdsMatchCondition(
            facet?.facetId || facet?.state?.facetId || "",
          )
        ) {
          continue;
        }
        const didRunControllerSearch =
          await clearCoveoFacetControllerSelectionForUiClear(
            facet,
            facet?.facetId || facet?.state?.facetId,
            { isCurrent: isMutationCurrent },
          );
        if (!isMutationCurrent()) return;
        controllerOwnedSearch =
          controllerOwnedSearch || didRunControllerSearch;
      }
    }
    if (!isMutationCurrent()) return;
    facetIds.forEach(function (facetId) {
      rememberBoatSearchQuery(facetId, "");
    });
    if (!controllerOwnedSearch) {
      await dispatchCoveoSearch(search, engine, mod, {
        isCurrent: isMutationCurrent,
      });
      if (!isMutationCurrent()) return;
    }
    if (shouldFinalizeDistance) {
      await requestCoveoManagedRangeDomainRefresh();
    }
    collapseCoveoDrawerFacetAccordions(container, drawerContent, {
      armNextRender: false,
    });
  }

  function wireActiveFiltersStrip(container, lifecycle) {
    if (!container || container.dataset.coveoActiveFiltersStripWired) return;
    container.dataset.coveoActiveFiltersStripWired = "true";
    const onActiveFilterClick = (e) => {
      const target = e.target;
      if (!target || typeof target.closest !== "function") return;
      const keywordBtn = target.closest("[data-coveo-clear-keyword]");
      const clearBtn = target.closest("[data-coveo-clear-all-filters]");
      const chipBtn = target.closest("[data-coveo-chip-remove]");
      if (!keywordBtn && !clearBtn && !chipBtn) return;
      e.preventDefault();
      const retiredInitialHydration = retirePendingInitialCoveoUrlHydration();
      const action = keywordBtn
        ? { type: "keyword" }
        : clearBtn
          ? { type: "clear-all" }
          : {
              type: "chip",
              facetId: chipBtn.getAttribute("data-facet-id") || "",
              mode: chipBtn.getAttribute("data-chip-mode") || "",
              value: chipBtn.getAttribute("data-value"),
            };

      enqueueCoveoUiMutation(container, async function (lease) {
        const isMutationCurrent = function () {
          const leaseIsCurrent =
            !lease ||
            typeof lease.isCurrent !== "function" ||
            lease.isCurrent();
          const lifecycleIsCurrent =
            !lifecycle ||
            (lifecycle.active &&
              lifecycle.isCurrent() &&
              container.isConnected !== false);
          return leaseIsCurrent && lifecycleIsCurrent;
        };
        if (!isMutationCurrent()) return;
        /*
         * A shared-link facet toggle can already be awaiting its own Coveo
         * request when the user clicks the freshly rendered chip. Let that
         * retired request settle before applying the user's inverse action;
         * otherwise the late URL hydration can win and put Make back.
         */
        await waitForRetiredInitialCoveoUrlHydration(
          retiredInitialHydration,
          3000,
        );
        if (!isMutationCurrent()) return;
        const endMutation = beginCoveoUiMutation(
          container,
          action.type === "clear-all" ? 900 : 700,
        );
        const search = container._coveoSearch;
        const engine = container._coveoEngine;
        const mod = container._coveoMod;
        const subControllers = container._coveoSubControllers || {};
        if (!search || !engine) {
          endMutation();
          return;
        }

        const facetGen = subControllers.facetGen;

        try {
          if (action.type === "keyword") {
            await clearKeywordQuery(search, engine, mod, container, {
              isCurrent: isMutationCurrent,
            });
            if (!isMutationCurrent()) return;
            await dispatchCoveoSearch(search, engine, mod, {
              isCurrent: isMutationCurrent,
            });
            return;
          }

          if (action.type === "clear-all") {
            await clearAllCoveoFacetSelections(
              search,
              engine,
              mod,
              container,
              facetGen,
              {
                clearKeyword: true,
                clearDistance: true,
                preserveDistanceLocation: true,
                isCurrent: isMutationCurrent,
              },
            );
            return;
          }

          const facetId = action.facetId;
          const mode = action.mode;
          if (mode === "distance") {
            if (typeof window.__coveoSelectAllDistanceInventory === "function") {
              await window.__coveoSelectAllDistanceInventory({
                isCurrent: isMutationCurrent,
                signal: lease?.signal,
              });
              return;
            }
            if (typeof window.__coveoResetDistanceToAllInventory === "function") {
              await window.__coveoResetDistanceToAllInventory({
                force: true,
                isCurrent: isMutationCurrent,
                signal: lease?.signal,
              });
              return;
            }
            clearCoveoDistanceFilterState({
              preserveStoredLocation: true,
            });
            await dispatchCoveoSearch(search, engine, mod, {
              isCurrent: isMutationCurrent,
            });
            if (!isMutationCurrent()) return;
            await requestCoveoManagedRangeDomainRefresh();
            return;
          }
          if (mode === "range" && facetIdsMatchYear(facetId)) {
            const controllerOwnedSearch = await clearCoveoYearFacetControllers(
              facetGen, { isCurrent: isMutationCurrent },
            );
            if (!isMutationCurrent()) return;
            await Promise.resolve();
            if (!isMutationCurrent()) return;
            await waitForNextAnimationFrame();
            if (!isMutationCurrent()) return;
            if (!controllerOwnedSearch) {
              await dispatchCoveoSearch(search, engine, mod, {
                isCurrent: isMutationCurrent,
              });
            }
            return;
          }
          const facet = findFacetController(facetGen, facetId);
          if (mode === "value" && facetIdsMatchCondition(facetId)) {
            removeConditionChipSelection(action.value, facetGen, search, container);
            if (!isMutationCurrent()) return;
            await dispatchCoveoSearch(search, engine, mod, {
              isCurrent: isMutationCurrent,
            });
            return;
          }
          if (!facet) {
            if (facetId) {
              clearCoveoFacetRangeSelection(facetId);
              clearCoveoPendingRangeUiSnapshot(facetId);
              await dispatchCoveoSearch(search, engine, mod, {
                isCurrent: isMutationCurrent,
              });
            }
            return;
          }

          if (mode === "range") {
            setCoveoManagedRangeClearTombstone(facetId, true);
            clearCoveoFacetRangeSelection(facetId);
            clearCoveoPendingRangeUiSnapshot(facetId);
            const controllerOwnedSearch =
              await clearCoveoFacetControllerSelectionForUiClear(
                facet,
                facetId,
                { isCurrent: isMutationCurrent },
              );
            if (!isMutationCurrent()) return;
            await Promise.resolve();
            if (!isMutationCurrent()) return;
            await waitForNextAnimationFrame();
            if (!isMutationCurrent()) return;
            if (!controllerOwnedSearch) {
              await dispatchCoveoSearch(search, engine, mod, {
                isCurrent: isMutationCurrent,
              });
            }
            return;
          }

          const value = action.value;
          if (value == null) return;
          let removalResult = null;
          try {
            removalResult = await removeFacetSelectionByRawValue(
              engine,
              mod,
              facetGen,
              facetId,
              value,
              { isCurrent: isMutationCurrent },
            );
          } catch (_) { }
          if (!isMutationCurrent()) return;
          await Promise.resolve();
          if (!isMutationCurrent()) return;
          await waitForNextAnimationFrame();
          if (!isMutationCurrent()) return;
          if (removalResult?.primarySearch !== "controller-owned") {
            await dispatchCoveoSearch(search, engine, mod, {
              isCurrent: isMutationCurrent,
            });
          }
        } finally {
          endMutation();
        }
      }, 5000);
    };
    if (lifecycle) {
      lifecycle.listen(container, "click", onActiveFilterClick);
    } else {
      container.addEventListener("click", onActiveFilterClick);
    }
  }

  function wireFiltersDrawer(
    search,
    subControllers,
    engine,
    mod,
    rootEl,
    lifecycle,
  ) {
    const root = rootEl && rootEl.nodeType === 1 ? rootEl : document;
    const shouldResetKeywordQuery =
      root?.id === "coveo-headless-search" ||
      !!root?.querySelector?.("#coveo-search-page-form");
    const toggle =
      root.querySelector("#coveo-filters-toggle") ||
      document.getElementById("coveo-filters-toggle");
    const drawer =
      root.querySelector("#CoveoFiltersDrawer") ||
      document.getElementById("CoveoFiltersDrawer");
    const content =
      root.querySelector("#CoveoFiltersDrawerContent") ||
      document.getElementById("CoveoFiltersDrawerContent");
    const applyBtn =
      root.querySelector("#coveo-apply-filters") ||
      document.getElementById("coveo-apply-filters");
    const listen = function (target, type, listener, options) {
      if (lifecycle) return lifecycle.listen(target, type, listener, options);
      target?.addEventListener?.(type, listener, options);
      return listener;
    };
    const claimGlobal = function (key, value) {
      if (lifecycle) return lifecycle.claim(window, key, value);
      window[key] = value;
      return value;
    };
    const isLifecycleActive = function () {
      return (
        !lifecycle ||
        (lifecycle.active &&
          lifecycle.isCurrent() &&
          root?.isConnected !== false)
      );
    };

    if (!toggle || !drawer) return;

    document.documentElement.classList.add(
      "coveo-scrollbar-gutter-stable",
    );
    setFiltersDrawerMode();
    const deferDrawerApply = !isCoveoRealtimeFilterApplyEnabled() && !!applyBtn;
    const visualViewport = window.visualViewport || null;
    const resolveLiveSearch = () => root?._coveoSearch || search;
    const resolveLiveSubControllers = () => root?._coveoSubControllers || subControllers || {};
    const resolveLiveEngine = () => root?._coveoEngine || engine;
    const resolveLiveMod = () => root?._coveoMod || mod;
    const resolveLiveFilterContext = () => {
      return {
        search: resolveLiveSearch(),
        subControllers: resolveLiveSubControllers(),
        engine: resolveLiveEngine(),
        mod: resolveLiveMod(),
      };
    };
    const syncApplyButtonAvailability = () => {
      if (!applyBtn) return;
      const blocked =
        typeof window.__coveoIsDistanceApplyBlocked === "function" &&
        window.__coveoIsDistanceApplyBlocked();
      const busy = !!content?._coveoApplyInFlight;
      applyBtn.disabled = !!busy || !!blocked;
      applyBtn.setAttribute(
        "aria-disabled",
        applyBtn.disabled ? "true" : "false",
      );
      if (blocked) {
        applyBtn.setAttribute(
          "title",
          "Enter a ZIP code or use your location to apply distance.",
        );
      } else {
        applyBtn.removeAttribute("title");
      }
    };

    const syncDrawerViewportHeight = () => {
      const isOpen = drawer.hasAttribute("open");
      const isMobile = window.matchMedia("(max-width: 767.98px)").matches;
      if (!isOpen || !isMobile) {
        drawer.style.removeProperty("--modal-height");
        return;
      }
      if (drawer.classList.contains("coveo-filters-drawer--bottom")) {
        drawer.style.removeProperty("--modal-height");
        return;
      }
      const viewportHeight = Math.max(
        320,
        Math.round(
          Number(visualViewport?.height || window.innerHeight || 0),
        ),
      );
      drawer.style.setProperty("--modal-height", `${viewportHeight}px`);
    };

    const syncDrawerLayout = () => {
      syncDrawerViewportHeight();
      if (lifecycle) {
        lifecycle.requestAnimationFrame(syncDrawerViewportHeight);
      } else {
        window.requestAnimationFrame(syncDrawerViewportHeight);
      }
    };

    if (root.dataset.coveoFiltersDrawerWired === "true") return;
    root.dataset.coveoFiltersDrawerWired = "true";

    if (!drawer.dataset.coveoViewportSyncWired) {
      drawer.dataset.coveoViewportSyncWired = "true";
      listen(window, "resize", syncDrawerViewportHeight);
      listen(
        window,
        "coveo:distance-apply-availability-changed",
        syncApplyButtonAvailability,
      );
      listen(window, "coveo:filters-layout-changed", syncDrawerLayout);
      if (visualViewport) {
        listen(visualViewport, "resize", syncDrawerViewportHeight);
        listen(visualViewport, "scroll", syncDrawerViewportHeight);
      }
    }

    if (!toggle.dataset.coveoFilterToggleWired) {
      toggle.dataset.coveoFilterToggleWired = "true";
      listen(toggle, "click", (e) => {
        e.preventDefault();
        if (drawer.open) {
          drawer.hide();
        } else {
          drawer.show(toggle);
        }
      });
      toggle.setAttribute(
        "aria-expanded",
        drawer.hasAttribute("open") ? "true" : "false",
      );
      listen(drawer, "toggle", () => {
        const isOpen = drawer.hasAttribute("open");
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
        const lockScroll =
          isOpen && window.matchMedia("(max-width: 767.98px)").matches;
        document.documentElement.classList.toggle(
          "coveo-filters-scroll-lock",
          lockScroll,
        );
        document.body.classList.toggle("coveo-filters-scroll-lock", lockScroll);
        if (!isOpen) {
          drawer.classList.remove("coveo-filters-keyboard-open");
        }
        syncDrawerLayout();
        syncApplyButtonAvailability();
        if (isOpen && content && !content._coveoApplyingFilters) {
          const liveSubControllers = resolveLiveSubControllers();
          resetPendingFilterSessionState(content, liveSubControllers.facetGen);
        }
        // When the drawer closes while pending filter changes still exist
        // (i.e. user dismissed via Cancel or the X without clicking Apply),
        // discard the pending changes and revert the drawer DOM to match
        // the engine state on next open.
        if (!isOpen && content && deferDrawerApply) {
          if (window.__coveoNearestSortPromptActive) {
            window.__coveoNearestSortPromptActive = false;
            window.__coveoPendingSortSelection = null;
          }
          if (content._coveoApplyingFilters) {
            return;
          }
          const hadPendingCb =
            content._coveoPendingCheckboxState &&
            content._coveoPendingCheckboxState.size > 0;
          const hadPendingDl =
            content._mmPendingFilterDl &&
            content._mmPendingFilterDl.length > 0;
          const hadPendingRange =
            hasCoveoPendingRangeUiSnapshots() ||
            !!content._coveoHasPendingLengthRangeCommits?.();
          const hadPendingDistance = !!window.__coveoHasPendingDistanceUi;
          const hadPendingConditionAll =
            typeof content._coveoPendingConditionAll === "boolean";
          if (hadPendingCb || hadPendingDl || hadPendingRange || hadPendingDistance || hadPendingConditionAll) {
            if (content._coveoPendingCheckboxState) {
              content._coveoPendingCheckboxState.clear();
            }
            delete content._coveoPendingConditionAll;
            content._mmPendingFilterDl = [];
            try {
              if (typeof content._coveoDiscardPendingLengthRangeCommits === "function") {
                content._coveoDiscardPendingLengthRangeCommits();
              }
            } catch (_) { }
            try {
              if (
                window.__coveoHasPendingDistanceUi &&
                typeof window.__coveoResetPendingDistanceUi === "function"
              ) {
                window.__coveoResetPendingDistanceUi();
              }
            } catch (_) { }
            try {
              const liveCtx = resolveLiveFilterContext();
              renderFacets(liveCtx.subControllers.facetGen, {
                controller: liveCtx.search,
                container: root,
                engine: liveCtx.engine,
                mod: liveCtx.mod,
              });
            } catch (_) { }
          }
        }
      });
    }

    const closeDrawer = () => {
      if (drawer.hide) {
        drawer.hide();
      } else if (drawer.removeAttribute) {
        drawer.removeAttribute("open");
        drawer.hidden = true;
        document.body.classList.remove("showing");
      }
    };
    claimGlobal("__coveoOpenFiltersDrawer", () => {
      if (drawer.show) {
        drawer.show(toggle);
      } else if (drawer.setAttribute) {
        drawer.setAttribute("open", "");
        drawer.hidden = false;
      }
    });
    claimGlobal("__coveoCloseFiltersDrawer", closeDrawer);
    lifecycle?.addCleanup(function () {
      closeDrawer();
      delete root.dataset.coveoFiltersDrawerWired;
      delete drawer.dataset.coveoViewportSyncWired;
      delete toggle.dataset.coveoFilterToggleWired;
      drawer.style.removeProperty("--modal-height");
      drawer.classList.remove("coveo-filters-keyboard-open");
      document.documentElement.classList.remove("coveo-filters-scroll-lock");
      document.body.classList.remove(
        "coveo-filters-scroll-lock",
        "modal-showing",
        "modal-show",
      );
    });

    const resetAllFilters = async ({
      closeAfter = false,
      isCurrent,
    } = {}) => {
      const isMutationCurrent = function () {
        return (
          isLifecycleActive() &&
          (typeof isCurrent !== "function" || isCurrent())
        );
      };
      if (!isMutationCurrent()) return;
      const resetContent = prepareCoveoDrawerUiForGlobalClear(root) || content;
      if (resetContent) {
        resetContent._coveoSuppressFacetRerenderUntil = Date.now() + 950;
      }
      if (closeAfter) {
        closeDrawer();
      }
      clearCoveoDistanceFilterState({
        preserveStoredLocation: true,
      });
      const liveSearch = await resolveCoveoDispatchController(
        resolveLiveSearch(),
        { isCurrent: isMutationCurrent },
      );
      if (!isMutationCurrent() || !liveSearch) return;
      const liveCtx = resolveLiveFilterContext();
      await clearAllCoveoFacetSelections(
        liveSearch,
        liveCtx.engine,
        liveCtx.mod,
        root,
        liveCtx.subControllers.facetGen,
        {
          clearKeyword: shouldResetKeywordQuery,
          clearDistance: false,
          distanceAlreadyCleared: true,
          preserveDistanceLocation: true,
          isCurrent: isMutationCurrent,
        },
      );
    };

    const queueResetAllFilters = ({
      closeAfter = false,
      retiredInitialHydration = null,
    } = {}) => {
      if (!isLifecycleActive()) return;
      if (closeAfter) closeDrawer();
      const existingQueueOwner = content?._coveoResetQueued;
      if (existingQueueOwner) {
        existingQueueOwner.closeAfter =
          existingQueueOwner.closeAfter || closeAfter;
        return existingQueueOwner.promise;
      }
      const queueOwner = {
        closeAfter: !!closeAfter,
        promise: null,
      };
      if (content) content._coveoResetQueued = queueOwner;

      const queuedMutation = enqueueCoveoUiMutation(
        root,
        async function (lease) {
          const isMutationCurrent = function () {
            const leaseIsCurrent =
              !lease ||
              typeof lease.isCurrent !== "function" ||
              lease.isCurrent();
            return leaseIsCurrent && isLifecycleActive();
          };
          if (!isMutationCurrent()) return;
          await waitForRetiredInitialCoveoUrlHydration(
            retiredInitialHydration,
            3000,
          );
          if (!isMutationCurrent()) return;

          const resetOwner = {};
          if (content) content._coveoResetInFlight = resetOwner;
          const endMutation = beginCoveoUiMutation(root, 950);
          try {
            await resetAllFilters({
              closeAfter: queueOwner.closeAfter,
              isCurrent: isMutationCurrent,
            });
          } finally {
            endMutation();
            if (content?._coveoResetInFlight === resetOwner) {
              content._coveoResetInFlight = false;
            }
          }
        },
        5000,
      );
      queueOwner.promise = queuedMutation;

      const releaseQueueOwner = function () {
        if (content?._coveoResetQueued === queueOwner) {
          delete content._coveoResetQueued;
        }
      };
      Promise.resolve(queuedMutation).then(
        releaseQueueOwner,
        releaseQueueOwner,
      );
      return queuedMutation;
    };

    const enqueueRealtimeFilterMutation = (
      retiredInitialHydration,
      task,
    ) => {
      return enqueueCoveoUiMutation(
        root,
        async function (lease) {
          const isMutationCurrent = function () {
            const leaseIsCurrent =
              !lease ||
              typeof lease.isCurrent !== "function" ||
              lease.isCurrent();
            return leaseIsCurrent && isLifecycleActive();
          };
          if (!isMutationCurrent()) return;
          await waitForRetiredInitialCoveoUrlHydration(
            retiredInitialHydration,
            3000,
          );
          if (!isMutationCurrent()) return;

          const endMutation = beginCoveoUiMutation(root, 900);
          try {
            await task(isMutationCurrent);
          } finally {
            endMutation();
          }
        },
        5000,
      );
    };

    if (applyBtn) {
      listen(applyBtn, "click", async (e) => {
        e.preventDefault();
        retirePendingInitialCoveoUrlHydration();
        if (
          !deferDrawerApply &&
          !window.__coveoHasPendingDistanceUi
        ) {
          closeDrawer();
          return;
        }
        if (
          typeof window.__coveoIsDistanceApplyBlocked === "function" &&
          window.__coveoIsDistanceApplyBlocked()
        ) {
          if (typeof window.__coveoPromptForDistanceLocation === "function") {
            window.__coveoPromptForDistanceLocation();
          }
          syncApplyButtonAvailability();
          return;
        }
        if (content?._coveoApplyInFlight) return;
        if (content) {
          content._coveoApplyInFlight = true;
          content._coveoApplyingFilters = true;
        }
        if (applyBtn) {
          applyBtn.disabled = true;
          applyBtn.setAttribute("aria-busy", "true");
        }
        try {
          await Promise.resolve();
          await waitForNextAnimationFrame();
          if (!isLifecycleActive()) return;

          const hadPendingDistance = !!window.__coveoHasPendingDistanceUi;
          const hadAllInventoryDistance = !!(
            window.__coveoSelectedRadiusMiles == null &&
            document.querySelector(
              '.coveo-distance-radius-btn[data-radius="all"].is-active',
            )
          );
          const shouldApplyDistanceChange =
            hadPendingDistance || hadAllInventoryDistance;
          if (content) {
            content._coveoRangeFacetCommitApplied = false;
          }
          try {
            if (
              typeof content?._coveoFlushPendingLengthRangeCommits === "function"
            ) {
              content._coveoFlushPendingLengthRangeCommits();
            } else if (typeof content?._coveoFlushAllLengthRangeCommits === "function") {
              content._coveoFlushAllLengthRangeCommits();
            }
          } catch (_) { }
          try {
            if (typeof window.__coveoFlushPendingDistanceLocation === "function") {
              await window.__coveoFlushPendingDistanceLocation();
            }
          } catch (err) {
            if (!err || !err._distanceValidation) {
              console.warn("[Coveo Filters] distance flush failed:", err);
            }
            return;
          }
          if (!isLifecycleActive()) return;
          const hadPendingRangeCommit = !!content?._coveoRangeFacetCommitApplied;
          if (content) {
            content._coveoRangeFacetCommitApplied = false;
          }
          const resolvedSearch = await resolveCoveoDispatchController(
            resolveLiveSearch(),
            { isCurrent: isLifecycleActive },
          );
          if (!isLifecycleActive() || !resolvedSearch) return;
          const liveCtx = resolveLiveFilterContext();

          let didChangeConditionSelection = false;
          let facetReplayCount = 0;
          let facetReplayAdded = [];
          try {
            const desiredSnapshotWithCondition =
              buildDrawerDesiredSelectionSnapshot(
                content,
                liveCtx.subControllers.facetGen,
              );
            const currentSnapshotWithCondition = buildFacetSelectionSnapshot(
              liveCtx.subControllers.facetGen,
            );
            const conditionDrawer = content?.querySelector?.(
              "[data-condition-facet]",
            );
            const desiredConditionSelection = readSelectedDrawerFacetValues(
              conditionDrawer,
              {
                matchesFacet: facetIdsMatchCondition,
                canonicalizeValue: getCanonicalConditionOptionLabel,
              },
            );
            const canonicalDesiredConditionValues =
              desiredConditionSelection.hasMatchingInputs
                ? desiredConditionSelection.values
                : coveoConditionSelectionShadow.getValues();
            const currentConditionValues =
              coveoConditionSelectionShadow.getValues();
            const desiredConditionAllSelected =
              canonicalDesiredConditionValues.length === 0 &&
              (typeof content?._coveoPendingConditionAll === "boolean"
                ? content._coveoPendingConditionAll
                : coveoConditionSelectionShadow.isAllSelected());
            const hasPendingConditionChange = Array.from(
              content?._coveoPendingCheckboxState?.keys?.() || [],
            ).some(function (key) {
              const separatorIndex = String(key).indexOf("\u001E");
              return (
                separatorIndex !== -1 &&
                facetIdsMatchCondition(String(key).slice(0, separatorIndex))
              );
            });
            if (
              hasPendingConditionChange ||
              desiredConditionAllSelected !== coveoConditionSelectionShadow.isAllSelected() ||
              !areCoveoFacetValueSetsEqual(
                canonicalDesiredConditionValues,
                currentConditionValues,
              )
            ) {
              if (desiredConditionAllSelected) {
                coveoConditionSelectionShadow.selectAll();
              } else {
                coveoConditionSelectionShadow.replace(
                  canonicalDesiredConditionValues,
                );
              }
              didChangeConditionSelection = true;
              facetReplayCount += 1;
              const previouslySelectedConditions = new Set(
                currentConditionValues,
              );
              canonicalDesiredConditionValues.forEach(function (
                desiredConditionValue,
              ) {
                if (previouslySelectedConditions.has(desiredConditionValue)) {
                  return;
                }
                facetReplayAdded.push({
                  facetId: COVEO_CONDITION_FACET_ID,
                  value: desiredConditionValue,
                });
              });
            }

            const desiredSnapshot = deleteConditionSelectionSnapshotEntries(
              new Map(desiredSnapshotWithCondition),
            );
            const currentSnapshot = deleteConditionSelectionSnapshotEntries(
              new Map(currentSnapshotWithCondition),
            );
            const batchResult = await applyFacetSelectionSnapshotBatch(
              liveCtx.engine,
              liveCtx.mod,
              desiredSnapshot,
              currentSnapshot,
            );
            if (batchResult?.supported) {
              const batchAppliedCount = batchResult.appliedCount || 0;
              facetReplayCount += batchAppliedCount;
              if (Array.isArray(batchResult.added)) {
                facetReplayAdded.push(...batchResult.added);
              }
              if (batchAppliedCount > 0) {
                await waitForFacetSelectionSnapshotSync(
                  liveCtx.subControllers.facetGen,
                  desiredSnapshot,
                );
              }
            } else {
              for (const [key, desiredChecked] of desiredSnapshot.entries()) {
                const currentChecked = !!currentSnapshot.get(key);
                if (currentChecked === !!desiredChecked) continue;
                const sepIdx = key.indexOf("\u001E");
                if (sepIdx === -1) continue;
                const facetId = key.slice(0, sepIdx);
                const value = key.slice(sepIdx + 1);
                const facet = findFacetController(
                  liveCtx.subControllers.facetGen,
                  facetId,
                );
                if (!facet) continue;
                try {
                  const applied = await setFacetSelectionByRawValue(
                    facet,
                    value,
                    desiredChecked,
                  );
                  if (applied) {
                    facetReplayCount += 1;
                    if (!currentSnapshot.get(key) && desiredChecked) {
                      facetReplayAdded.push({ facetId, value });
                    }
                  }
                } catch (_) { }
              }
              if (facetReplayCount > 0) {
                await waitForFacetSelectionSnapshotSync(
                  liveCtx.subControllers.facetGen,
                  desiredSnapshot,
                );
              }
            }
            if (content) {
              content._coveoPendingCheckboxState = new Map();
              delete content._coveoPendingConditionAll;
              content._coveoFilterSessionBaseline =
                desiredSnapshotWithCondition;
              content._mmPendingFilterDl = facetReplayAdded.slice();
            }
          } catch (_) { }

          await Promise.resolve();
          if (!isLifecycleActive()) return;
          closeDrawer();

          if (shouldApplyDistanceChange) {
            if (facetReplayCount === 0 || didChangeConditionSelection) {
              coveoLastSyncedLocationCtxKey = null;
              await dispatchCoveoSearch(
                resolveLiveSearch(),
                resolveLiveEngine(),
                resolveLiveMod(),
              );
            } else {
              coveoLastSyncedLocationCtxKey = null;
              await dispatchCoveoCommerceQuery(resolveLiveEngine(), resolveLiveMod(), {
                executeSearch: false,
              });
            }
          } else if (hadPendingRangeCommit && facetReplayCount === 0) {
            await dispatchCoveoSearch(
              resolveLiveSearch(),
              resolveLiveEngine(),
              resolveLiveMod(),
            );
          } else if (facetReplayCount > 0) {
            await dispatchCoveoSearch(
              resolveLiveSearch(),
              resolveLiveEngine(),
              resolveLiveMod(),
            );
          } else {
            await waitForNextAnimationFrame();
          }
          if (shouldApplyDistanceChange) {
            await requestCoveoManagedRangeDomainRefresh();
          }
          const pend = (content && content._mmPendingFilterDl) || [];
          if (content) content._mmPendingFilterDl = [];
          pend.forEach((p) => {
            mmPushFilterAppliedForFacet(
              p.facetId,
              p.value,
              resolveLiveSearch(),
            );
          });
        } finally {
          if (content) {
            content._coveoApplyInFlight = false;
          }
          if (applyBtn) {
            applyBtn.removeAttribute("aria-busy");
          }
          syncApplyButtonAvailability();
        }
      });
      syncApplyButtonAvailability();
    }
    listen(drawer, "click", (e) => {
      const resetControl = e.target?.closest?.(
        "#coveo-reset-filters, #coveo-clear-filters",
      );
      if (!resetControl || !drawer.contains(resetControl)) return;
      e.preventDefault();
      const retiredInitialHydration = retirePendingInitialCoveoUrlHydration();
      queueResetAllFilters({
        closeAfter: resetControl.id === "coveo-clear-filters",
        retiredInitialHydration,
      });
    });

    listen(content, "change", (e) => {
      const retiredInitialHydration = retirePendingInitialCoveoUrlHydration();
      const conditionAllCb = e.target.closest?.(
        'input[type="checkbox"][data-condition-all][data-facet-id]',
      );
      if (conditionAllCb) {
        const facetId = conditionAllCb.dataset.facetId;
        conditionAllCb.checked = true;
        syncFacetCheckboxLabelSelectedClass(conditionAllCb);
        const conditionCheckboxes = Array.from(
          content.querySelectorAll(
            'input[type="checkbox"][data-facet-id][data-value]',
          ),
        ).filter(function (checkbox) {
          return checkbox.dataset.facetId === facetId;
        });
        conditionCheckboxes.forEach(function (checkbox) {
          checkbox.checked = false;
          syncFacetCheckboxLabelSelectedClass(checkbox);
        });
        if (deferDrawerApply) {
          content._coveoPendingConditionAll = true;
          const liveSubControllers = resolveLiveSubControllers();
          if (!(content._coveoPendingCheckboxState instanceof Map)) {
            content._coveoPendingCheckboxState = new Map();
          }
          if (!(content._coveoFilterSessionBaseline instanceof Map)) {
            content._coveoFilterSessionBaseline = buildFacetSelectionSnapshot(
              liveSubControllers.facetGen,
            );
          }
          content._mmPendingFilterDl = content._mmPendingFilterDl || [];
          const selectedConditionValues = new Set(
            coveoConditionSelectionShadow.getValues(),
          );
          conditionCheckboxes.forEach(function (checkbox) {
            const value = String(checkbox.dataset.value || "");
            if (!value) return;
            const pendingKey = `${facetId}\u001E${value}`;
            const baselineChecked = selectedConditionValues.has(
              getCanonicalConditionOptionLabel(value),
            );
            if (baselineChecked) {
              content._coveoPendingCheckboxState.set(pendingKey, false);
            } else {
              content._coveoPendingCheckboxState.delete(pendingKey);
            }
          });
          content._mmPendingFilterDl = content._mmPendingFilterDl.filter(
            function (item) {
              return item?.facetId !== facetId;
            },
          );
          conditionAllCb.checked = true;
          syncFacetCheckboxLabelSelectedClass(conditionAllCb);
          return;
        }

        enqueueRealtimeFilterMutation(
          retiredInitialHydration,
          async function (isMutationCurrent) {
            if (!isMutationCurrent()) return;
            const liveCtx = resolveLiveFilterContext();
            coveoConditionSelectionShadow.selectAll();
            await dispatchCoveoSearch(
              liveCtx.search,
              liveCtx.engine,
              liveCtx.mod,
              { isCurrent: isMutationCurrent },
            );
          },
        );
        return;
      }

      const cb = e.target.closest?.(
        'input[type="checkbox"][data-facet-id][data-value]',
      );
      if (!cb) return;
      if (cb.classList?.contains("coveo-mobile-range-hidden-checkbox")) return;
      const facetId = cb.dataset.facetId;
      const value = cb.dataset.value;
      const desiredChecked = !!cb.checked;
      let conditionCheckboxesForChange = null;
      if (facetIdsMatchCondition(facetId)) {
        if (deferDrawerApply) content._coveoPendingConditionAll = false;
        const conditionGrid = cb.closest("[data-condition-facet]");
        const allCheckbox = conditionGrid?.querySelector(
          'input[type="checkbox"][data-condition-all]',
        );
        conditionCheckboxesForChange = Array.from(
          conditionGrid?.querySelectorAll(
            'input[type="checkbox"][data-value]',
          ) || [],
        );
        const hasSelectedCondition = conditionCheckboxesForChange.some(
          function (checkbox) {
            return checkbox.checked;
          },
        );

        if (allCheckbox) {
          allCheckbox.checked = !hasSelectedCondition;
          syncFacetCheckboxLabelSelectedClass(allCheckbox);
        }
      }
      const dependency = getFacetDependencyConfig(facetId);
      const isParentFacet = COVEO_FACET_DEPENDENCIES.some(function (entry) {
        return typeof entry?.parentMatcher === "function" &&
          entry.parentMatcher(facetId);
      });

      // Some facets visually hide the underlying checkbox and represent the
      // selected state via an `is-selected` class on the wrapping label
      // (Condition tiles, Make/Boat-type options, etc). Keep that class in
      // sync with the live checkbox state so each click gives instant
      // visual feedback regardless of whether Apply Filter is deferred.
      syncFacetCheckboxLabelSelectedClass(cb);

      // When Apply Filter button is present, stage the user's intent before
      // doing any facet-controller work so the checkbox click feels instant.
      // The actual Coveo state change is deferred to the Apply Filter click.
      if (deferDrawerApply) {
        const liveSubControllers = resolveLiveSubControllers();
        if (!content._coveoPendingCheckboxState) {
          content._coveoPendingCheckboxState = new Map();
        }
        if (!(content._coveoFilterSessionBaseline instanceof Map)) {
          content._coveoFilterSessionBaseline = buildFacetSelectionSnapshot(
            liveSubControllers.facetGen,
          );
        }
        const pendingKey = `${facetId}\u001E${value}`;
        const baselineChecked = conditionCheckboxesForChange
          ? coveoConditionSelectionShadow
              .getValues()
              .includes(getCanonicalConditionOptionLabel(value))
          : !!content._coveoFilterSessionBaseline.get(pendingKey);

        if (desiredChecked === baselineChecked) {
          content._coveoPendingCheckboxState.delete(pendingKey);
        } else {
          content._coveoPendingCheckboxState.set(pendingKey, desiredChecked);
        }

        content._mmPendingFilterDl = content._mmPendingFilterDl || [];
        if (desiredChecked && desiredChecked !== baselineChecked) {
          const already = content._mmPendingFilterDl.some(
            (p) =>
              p.facetId === facetId && String(p.value) === String(value || ""),
          );
          if (!already) {
            content._mmPendingFilterDl.push({
              facetId,
              value: String(value || ""),
            });
          }
        } else {
          content._mmPendingFilterDl = content._mmPendingFilterDl.filter(
            (p) =>
              !(
                p.facetId === facetId &&
                String(p.value) === String(value || "")
              ),
          );
        }

        if (isParentFacet) {
          clearDependentFacetSelectionsForParent(
            content,
            liveSubControllers.facetGen,
            facetId,
            false,
          );
          rerenderFacetDrawerContent(content);
          return;
        }

        if (dependency) {
          const desiredSnapshot = buildDrawerDesiredSelectionSnapshot(
            content,
            liveSubControllers.facetGen,
          );
          if (isFacetDependencyBlocked(desiredSnapshot, facetId)) {
            cb.checked = false;
            syncFacetCheckboxLabelSelectedClass(cb);
            clearDrawerFacetSelectionsByMatcher(
              content,
              liveSubControllers.facetGen,
              dependency.childMatcher,
            );
            rerenderFacetDrawerContent(content);
          }
        }
        return;
      }

      if (conditionCheckboxesForChange) {
        enqueueRealtimeFilterMutation(
          retiredInitialHydration,
          async function (isMutationCurrent) {
            if (!isMutationCurrent()) return;
            const liveCtx = resolveLiveFilterContext();
            const desiredConditionValue = getCanonicalConditionOptionLabel(value);
            if (!desiredConditionValue) return;
            // Apply this click to current state: a queued chip removal may
            // already have changed selections since these checkboxes rendered.
            const desiredConditionValues = new Set(
              coveoConditionSelectionShadow.getValues(),
            );
            if (desiredChecked) {
              desiredConditionValues.add(desiredConditionValue);
            } else {
              desiredConditionValues.delete(desiredConditionValue);
            }
            coveoConditionSelectionShadow.replace(
              Array.from(desiredConditionValues),
            );
            if (!isMutationCurrent()) return;
            await dispatchCoveoSearch(
              liveCtx.search,
              liveCtx.engine,
              liveCtx.mod,
              { isCurrent: isMutationCurrent },
            );
            if (desiredChecked && isMutationCurrent()) {
              mmPushFilterAppliedForFacet(
                facetId,
                value,
                liveCtx.search,
              );
            }
          },
        );
        return;
      }

      enqueueRealtimeFilterMutation(
        retiredInitialHydration,
        async function (isMutationCurrent) {
          if (!isMutationCurrent()) return;
          const liveCtx = resolveLiveFilterContext();
          const facet = findFacetController(
            liveCtx.subControllers.facetGen,
            facetId,
          );
          if (!facet) return;
          if (dependency && desiredChecked) {
            const currentSnapshot = buildFacetSelectionSnapshot(
              liveCtx.subControllers.facetGen,
            );
            if (isFacetDependencyBlocked(currentSnapshot, facetId)) {
              if (!!cb.checked === desiredChecked) {
                cb.checked = false;
                syncFacetCheckboxLabelSelectedClass(cb);
                rerenderFacetDrawerContent(content);
              }
              return;
            }
          }
          try {
            if (isParentFacet) {
              const parentBatchResult =
                await applyParentFacetSelectionSnapshotBatch(
                  liveCtx.search,
                  liveCtx.engine,
                  liveCtx.mod,
                  liveCtx.subControllers.facetGen,
                  facetId,
                  value,
                  desiredChecked,
                  { isCurrent: isMutationCurrent },
                );
              if (!isMutationCurrent()) return;
              if (parentBatchResult?.supported) {
                if (
                  desiredChecked &&
                  Number(parentBatchResult.appliedCount || 0) > 0
                ) {
                  mmPushFilterAppliedForFacet(
                    facetId,
                    value,
                    liveCtx.search,
                  );
                }
                rerenderFacetDrawerContent(content);
                return;
              }
            }

            await setFacetSelectionByRawValue(
              facet,
              value,
              desiredChecked,
              { isCurrent: isMutationCurrent },
            );
            if (!isMutationCurrent()) return;
            if (isParentFacet) {
              if (desiredChecked) {
                mmPushFilterAppliedForFacet(facetId, value, liveCtx.search);
              }
              await clearDependentFacetSelectionsForParent(
                content,
                liveCtx.subControllers.facetGen,
                facetId,
                true,
                { isCurrent: isMutationCurrent },
              );
              if (!isMutationCurrent()) return;
              rerenderFacetDrawerContent(content);
              return;
            }
          } catch (_) { }
          if (!isMutationCurrent()) return;
          if (dependency) {
            const liveSnapshot = buildFacetSelectionSnapshot(
              liveCtx.subControllers.facetGen,
            );
            if (isFacetDependencyBlocked(liveSnapshot, facetId)) {
              try {
                await setFacetSelectionByRawValue(
                  facet,
                  value,
                  false,
                  { isCurrent: isMutationCurrent },
                );
              } catch (_) { }
              if (!isMutationCurrent()) return;
              if (!!cb.checked === desiredChecked) {
                cb.checked = false;
                syncFacetCheckboxLabelSelectedClass(cb);
                rerenderFacetDrawerContent(content);
              }
              return;
            }
          }
          if (!isMutationCurrent()) return;
          const valuesAfter = normalizeFacetStateValues(facet.state || {});
          const selectedEntry = valuesAfter.find(
            (entry) => String(facetItemRawValue(entry)) === String(value),
          );
          const isNowSelected =
            selectedEntry && selectedEntry.state === "selected";
          if (isNowSelected) {
            mmPushFilterAppliedForFacet(facetId, value, liveCtx.search);
          }
          // toggleSelect already executes the search query.
        },
      );
    });

    listen(content, "click", (e) => {
      const moreBtn = e.target.closest?.("[data-coveo-facet-show-more]");
      const lessBtn = e.target.closest?.("[data-coveo-facet-show-less]");
      if (!moreBtn && !lessBtn) return;
      e.preventDefault();
      e.stopPropagation();
      const facetId =
        moreBtn?.getAttribute("data-coveo-facet-show-more") ||
        lessBtn?.getAttribute("data-coveo-facet-show-less");
      if (!facetId) return;

      const liveSubControllers = resolveLiveSubControllers();
      const facet = findFacetController(liveSubControllers.facetGen, facetId);
      if (!facet) return;
      (async () => {
        try {
          if (moreBtn) {
            await coveoFacetShowAllValues(facetId, facet, engine, mod);
          } else if (lessBtn && typeof facet.showLessValues === "function") {
            facet.showLessValues();
          }
        } catch (err) {
          console.warn("[Coveo Filters] facet show more/less:", err);
        }
      })();
    });
  }

  function setFiltersDrawerMode() {
    var drawer = document.getElementById("CoveoFiltersDrawer");
    if (!drawer || !drawer.classList) return;

    var rawMode = drawer.getAttribute("data-coveo-filter-display");
    var mode =
      (rawMode && String(rawMode).trim().toLowerCase().replace(/-/g, "_")) ||
      "modal";
    if (mode === "right_drawer") {
      mode = "drawer_right";
    }
    var isMobile = window.matchMedia("(max-width: 767.98px)").matches;

    drawer.classList.remove(
      "modal",
      "drawer--bottom",
      "drawer--right",
      "coveo-filters-drawer--bottom",
      "coveo-filters-drawer--right",
    );

    if (isMobile) {
      drawer.classList.add("drawer--bottom", "coveo-filters-drawer--bottom");
      return;
    }

    if (mode === "drawer_right") {
      drawer.classList.add("drawer--right", "coveo-filters-drawer--right");
      return;
    }

    drawer.classList.add("modal", "coveo-filters-drawer--bottom");
  }

  /**
   * Load more facet values when the drawer body scroll brings the facet end into view.
   * Facet lists intentionally do not scroll on their own (see headless.css) to avoid nested scrollbars.
   */
  function wireCoveoFacetDefaultWrapScrollLoad(
    content,
    facetGen,
    engine,
    mod,
    lifecycle,
  ) {
    if (!content || !facetGen) return;
    const schedule = function (callback, delay) {
      return lifecycle
        ? lifecycle.setTimeout(callback, delay)
        : window.setTimeout(callback, delay);
    };
    const scheduleFrame = function (callback) {
      return lifecycle
        ? lifecycle.requestAnimationFrame(callback)
        : window.requestAnimationFrame(callback);
    };
    if (content._coveoFacetLoadMoreDisposers) {
      content._coveoFacetLoadMoreDisposers.forEach(function (d) {
        try {
          d();
        } catch (_) { }
      });
    }
    const disposers = [];
    const scrollRoot = content.closest(".drawer__body");
    if (!scrollRoot || typeof IntersectionObserver === "undefined") {
      content._coveoFacetLoadMoreDisposers = disposers;
      return;
    }

    function observeSentinel(sentinel, facetId, rootEl) {
      if (!sentinel || !facetId) return;
      let loadingMore = false;
      const io = new IntersectionObserver(
        function (entries) {
          if (!entries.some(function (e) {
            return e.isIntersecting;
          }) || loadingMore) {
            return;
          }
          const facet = findFacetController(facetGen, facetId);
          if (!facet) return;
          if (!(facet.state || {}).canShowMoreValues) return;
          loadingMore = true;
          coveoFacetShowAllValues(facetId, facet, engine, mod)
            .catch(function () { })
            .finally(function () {
              schedule(function () {
                loadingMore = false;
              }, 450);
            });
        },
        {
          root: rootEl || scrollRoot,
          rootMargin: "0px 0px 120px 0px",
          threshold: 0,
        },
      );
      lifecycle?.trackObserver(io);
      io.observe(sentinel);
      disposers.push(function () {
        io.disconnect();
      });
    }

    content.querySelectorAll(".coveo-facet-default-wrap").forEach(function (wrap) {
      const details = wrap.closest("details[data-facet-id]");
      const facetId = details?.getAttribute("data-facet-id");
      if (!facetId) return;
      const s = document.createElement("div");
      s.className = "coveo-facet-load-more-sentinel";
      s.setAttribute("data-facet-sentinel", facetId);
      s.setAttribute("aria-hidden", "true");
      const moreLess = wrap.querySelector(".coveo-facet-moreless");
      if (moreLess) wrap.insertBefore(s, moreLess);
      else wrap.appendChild(s);
      observeSentinel(s, facetId);
    });

    content
      .querySelectorAll(".coveo-mobile-boat-options[data-boat-options-for]")
      .forEach(function (opts) {
        const facetId = opts.getAttribute("data-boat-options-for");
        if (!facetId) return;
        const inner = opts.closest(".coveo-mobile-boat-facet-inner");
        const moreLess = inner?.querySelector(".coveo-facet-moreless");
        if (moreLess) {
          moreLess.hidden = true;
        }
        let loadingMore = false;
        const maybeLoadMore = function () {
          if (loadingMore) return;
          const now = Date.now();
          if (Number(opts._coveoIgnoreScrollUntil || 0) > now) return;
          const currentTop = Math.max(0, Number(opts.scrollTop) || 0);
          const minNextTop = Math.max(
            0,
            Number(opts._coveoNextLoadMinScrollTop || 0),
          );
          const hasRecentDownwardWheel =
            Number(opts._coveoLastWheelDownAt || 0) > now - 220;
          if (currentTop < minNextTop && !hasRecentDownwardWheel) return;
          const remaining =
            opts.scrollHeight - (opts.scrollTop + opts.clientHeight);
          if (remaining > 48) return;
          const facet = findFacetController(facetGen, facetId);
          if (!facet) return;
          if (!(facet.state || {}).canShowMoreValues) return;
          if (facetUsesPagedBoatOptionsUi(facetId)) {
            setBoatFacetLoadingState(content, facetId, true);
            setPendingBoatFacetAppend(content, facetId);
            const snapshot = captureBoatFacetScrollSnapshot(opts);
            if (snapshot) {
              snapshot.preserveBottomAnchor = false;
            }
            setPendingBoatFacetScrollRestore(content, snapshot);
          }
          loadingMore = true;
          opts._coveoNextLoadMinScrollTop =
            currentTop + getBoatFacetLoadMoreMinAdvance(opts);
          coveoFacetShowAllValues(facetId, facet, engine, mod)
            .catch(function () { })
            .finally(function () {
              schedule(function () {
                loadingMore = false;
                opts._coveoIgnoreScrollUntil = Date.now() + 250;
                if (facetUsesPagedBoatOptionsUi(facetId)) {
                  setBoatFacetLoadingState(content, facetId, false);
                }
                if (!(facet.state || {}).canShowMoreValues) {
                  clearPendingBoatFacetAppend(content, facetId);
                }
              }, 450);
            });
        };
        let loadObserver = null;
        const maybeObserveBoatOptionsGap = function () {
          if (loadObserver) {
            loadObserver.disconnect();
            loadObserver = null;
          }
          if (typeof IntersectionObserver === "undefined") return;
          const gap = opts.querySelector(".coveo-mobile-boat-options__load-gap");
          if (!gap) return;
          loadObserver = new IntersectionObserver(
            function (entries) {
              if (!entries.some(function (entry) {
                return entry.isIntersecting;
              })) {
                return;
              }
              maybeLoadMore();
            },
            {
              root: opts,
              rootMargin: "0px 0px 96px 0px",
              threshold: 0,
            },
          );
          lifecycle?.trackObserver(loadObserver);
          loadObserver.observe(gap);
        };
        const maybeLoadMoreFromWheel = function (event) {
          if (Number(event?.deltaY || 0) <= 0) return;
          opts._coveoLastWheelDownAt = Date.now();
          scheduleFrame(function () {
            maybeLoadMore();
          });
        };
        opts.addEventListener("scroll", maybeLoadMore, { passive: true });
        opts.addEventListener("wheel", maybeLoadMoreFromWheel, {
          passive: true,
        });
        maybeObserveBoatOptionsGap();
        disposers.push(function () {
          opts.removeEventListener("scroll", maybeLoadMore);
          opts.removeEventListener("wheel", maybeLoadMoreFromWheel);
          if (loadObserver) {
            loadObserver.disconnect();
            loadObserver = null;
          }
        });
      });

    content._coveoFacetLoadMoreDisposers = disposers;
  }

  const COVEO_DISTANCE_RADIUS_OPTIONS = [50, 100, 250, 500];
  const DEFAULT_RADIUS_MILES = 50;
  const COVEO_LOCATION_PROMPT_STORAGE_KEYS = {
    shared: "coveo_location_prompt_shared",
    suppressUntil: "coveo_location_prompt_suppress_until",
    dismissCount: "coveo_location_prompt_dismiss_count",
    permanent: "coveo_location_prompt_permanent",
  };
  const COVEO_LOCATION_PROMPT_SESSION_SHOWN_KEY =
    "coveo_location_prompt_shown_session";
  const COVEO_DISTANCE_RADIUS_INITIALIZED_STORAGE_KEY =
    "coveo_distance_radius_initialized_50_v1";
  /*
   * Sentinel for the "All inventory" radius option. When this is the active
   * selection, no distance filter is applied — the storefront returns the
   * full catalog. Per Brennan's spec (5/22/26 Slack), All inventory is the
   * default selected state, but it is NOT shown in the collapsed Distance
   * summary badge — only real radii (50/100/250) populate that chip.
   */
  const COVEO_DISTANCE_ALL_INVENTORY = "all";

  function normalizeDistanceRadiusMiles(radius) {
    const r = Number(radius);
    if (COVEO_DISTANCE_RADIUS_OPTIONS.includes(r)) return r;
    return null;
  }

  function getExplicitDistanceRadiusMiles(loc) {
    const selectedRadius = normalizeDistanceRadiusMiles(
      window.__coveoSelectedRadiusMiles,
    );
    if (selectedRadius != null) return selectedRadius;
    const storedRadius = normalizeDistanceRadiusMiles(loc?.radiusMiles);
    if (storedRadius != null) return storedRadius;
    return null;
  }

  function isAllInventoryRadius(radius) {
    return (
      radius === COVEO_DISTANCE_ALL_INVENTORY ||
      String(radius).toLowerCase() === COVEO_DISTANCE_ALL_INVENTORY
    );
  }

  function readCoveoPromptLocalValue(key) {
    try {
      return window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (_) {
      return null;
    }
  }

  function writeCoveoPromptLocalValue(key, value) {
    try {
      if (!window.localStorage) return;
      if (value == null || String(value).trim() === "") {
        window.localStorage.removeItem(key);
      } else {
        window.localStorage.setItem(key, String(value));
      }
    } catch (_) { }
  }

  function markCoveoDistanceRadiusInitialized() {
    writeCoveoPromptLocalValue(
      COVEO_DISTANCE_RADIUS_INITIALIZED_STORAGE_KEY,
      "1",
    );
  }

  function initializeStoredLocationDistanceRadius() {
    const Loc = window.CoveoLocationService;
    if (!Loc?.getStoredLocation) {
      window.__coveoSelectedRadiusMiles = null;
      return null;
    }
    try {
      const storedLocation = Loc.getStoredLocation(true);
      const radius = resolveStoredDistanceActivationRadius(
        storedLocation,
        normalizeDistanceRadiusMiles,
      );
      window.__coveoSelectedRadiusMiles = radius;
      if (radius != null) markCoveoDistanceRadiusInitialized();
      return radius;
    } catch (_) {
      window.__coveoSelectedRadiusMiles = null;
      return null;
    }
  }

  function readCoveoPromptSessionValue(key) {
    try {
      return window.sessionStorage ? window.sessionStorage.getItem(key) : null;
    } catch (_) {
      return null;
    }
  }

  function writeCoveoPromptSessionValue(key, value) {
    try {
      if (!window.sessionStorage) return;
      if (value == null || String(value).trim() === "") {
        window.sessionStorage.removeItem(key);
      } else {
        window.sessionStorage.setItem(key, String(value));
      }
    } catch (_) { }
  }

  function getCoveoLocationPromptDismissCount() {
    const raw = readCoveoPromptLocalValue(
      COVEO_LOCATION_PROMPT_STORAGE_KEYS.dismissCount,
    );
    const count = parseInt(raw || "0", 10);
    return Number.isNaN(count) ? 0 : Math.max(0, count);
  }

  function hasShownCoveoLocationPromptThisSession() {
    return (
      readCoveoPromptSessionValue(COVEO_LOCATION_PROMPT_SESSION_SHOWN_KEY) ===
      "1"
    );
  }

  function markCoveoLocationPromptShownThisSession() {
    writeCoveoPromptSessionValue(COVEO_LOCATION_PROMPT_SESSION_SHOWN_KEY, "1");
  }

  function markCoveoLocationPromptShared() {
    writeCoveoPromptLocalValue(COVEO_LOCATION_PROMPT_STORAGE_KEYS.shared, "1");
    writeCoveoPromptLocalValue(
      COVEO_LOCATION_PROMPT_STORAGE_KEYS.permanent,
      "1",
    );
  }

  function isCoveoLocationPromptPermanentlySuppressed() {
    return (
      readCoveoPromptLocalValue(COVEO_LOCATION_PROMPT_STORAGE_KEYS.permanent) ===
      "1"
    );
  }

  function resetCoveoLocationPromptDismissState() {
    writeCoveoPromptLocalValue(
      COVEO_LOCATION_PROMPT_STORAGE_KEYS.dismissCount,
      null,
    );
    writeCoveoPromptLocalValue(
      COVEO_LOCATION_PROMPT_STORAGE_KEYS.suppressUntil,
      null,
    );
  }

  function hasActiveCoveoLocationPromptSuppression() {
    const rawUntil = readCoveoPromptLocalValue(
      COVEO_LOCATION_PROMPT_STORAGE_KEYS.suppressUntil,
    );
    const until = rawUntil ? parseInt(rawUntil, 10) : NaN;
    if (!Number.isFinite(until) || until <= 0) return false;
    if (until > Date.now()) return true;
    resetCoveoLocationPromptDismissState();
    return false;
  }

  function getCoveoLocationPromptSuppressUntilEndOfDay() {
    const until = new Date();
    until.setHours(23, 59, 59, 999);
    return until.getTime();
  }

  function recordCoveoLocationPromptDismissal() {
    const nextCount = getCoveoLocationPromptDismissCount() + 1;
    writeCoveoPromptLocalValue(
      COVEO_LOCATION_PROMPT_STORAGE_KEYS.dismissCount,
      String(nextCount),
    );
    markCoveoLocationPromptShownThisSession();
    writeCoveoPromptLocalValue(
      COVEO_LOCATION_PROMPT_STORAGE_KEYS.suppressUntil,
      String(getCoveoLocationPromptSuppressUntilEndOfDay()),
    );
  }

  function hasCoveoSearchOrFilterInteraction(search, subControllers) {
    try {
      const query = String(getActiveKeywordQuery(search, null) || "").trim();
      if (query) return true;
    } catch (_) { }
    try {
      const facets = flattenFacetControllers(subControllers?.facetGen);
      return facets.some((facet) => {
        const values = normalizeFacetStateValues(facet.state || {});
        return values.some((value) => value.state === "selected");
      });
    } catch (_) {
      return false;
    }
  }

  function formatDistanceRadiusBadge(radius) {
    if (isAllInventoryRadius(radius)) return "All";
    const r = normalizeDistanceRadiusMiles(radius);
    return r != null ? String(r) + "mi" : "";
  }

  /** Keep Distance pinned at the top of the filters drawer, before Coveo facets. */
  function mountDistanceFilterInDrawer(drawerContent) {
    const block = document.getElementById("coveo-distance-filter-block");
    if (!block || !drawerContent) return;
    if (
      block.parentElement !== drawerContent.parentElement ||
      block.nextElementSibling !== drawerContent
    ) {
      drawerContent.insertAdjacentElement("beforebegin", block);
    }
  }

  function wireDistanceFilter(search, engine, mod, lifecycle) {
    const Loc = window.CoveoLocationService;
    if (!Loc) {
      return;
    }

    const NATIONWIDE_RADIUS_MILES =
      Loc.NATIONWIDE_RADIUS_MILES != null
        ? Loc.NATIONWIDE_RADIUS_MILES
        : 10000;
    const pageRoot = lifecycle?.root || null;
    const findPageElementById = function (id) {
      return (
        pageRoot?.querySelector?.(`[id="${id}"]`) ||
        document.getElementById(id)
      );
    };

    const block = findPageElementById("coveo-distance-filter-block");
    if (!block) {
      return;
    }
    if (block.dataset.coveoDistanceWired === "true") return;
    block.dataset.coveoDistanceWired = "true";

    /*
     * DOM references for the Distance 2.0 layout. See
     * `snippets/coveo-distance-filter-block.liquid`.
     */
    const summaryBadge = block.querySelector("[data-distance-summary-badge]");
    const locationPanel = block.querySelector("[data-distance-location-panel]");
    const radiusOptions = block.querySelector("[data-distance-radius-options]");
    const savedLocationHint = block.querySelector("[data-distance-saved-location]");
    const emptyState = block.querySelector("[data-distance-location-empty]");
    const filledState = block.querySelector("[data-distance-location-filled]");
    const filledLabel = block.querySelector("[data-distance-location-label]");
    const changeBtn = block.querySelector("[data-distance-change]");
    const clearLocationBtn = block.querySelector("[data-distance-clear]");
    const useCurrentBtn = findPageElementById("coveo-use-current-location");
    const applyLocationBtn = findPageElementById("coveo-apply-location");
    const zipInput = findPageElementById("coveo-zip-input");
    const zipClearBtn = block.querySelector("[data-distance-zip-clear]");
    const zipError = findPageElementById("coveo-zip-error");
    const locationError = findPageElementById("coveo-location-error");
    const permissionModal = findPageElementById(
      "coveo-distance-permission-modal",
    );
    const locationModal = findPageElementById(
      "coveo-distance-location-modal",
    );
    const locationModalInput = findPageElementById(
      "coveo-location-modal-zip-input",
    );
    const locationModalApplyBtn = findPageElementById(
      "coveo-location-modal-apply",
    );
    const locationModalUseCurrentBtn = findPageElementById(
      "coveo-location-modal-use-current",
    );
    const locationModalStatus = findPageElementById(
      "coveo-distance-location-modal-status",
    );
    const locationModalError = findPageElementById(
      "coveo-distance-location-modal-error",
    );
    const locationModalDismissBtns = locationModal
      ? locationModal.querySelectorAll(
        "[data-location-modal-back], [data-location-modal-close], [data-location-modal-dismiss]",
      )
      : [];
    const locationPromptEl = block.querySelector("[data-distance-location-prompt]");
    const filledHintEl = block.querySelector(
      "[data-distance-location-filled-hint]",
    );

    let selectedRadiusMiles = null;
    let locationModalMode = null;
    let locationModalReturnToFilters = false;
    let locationModalCloseTimer = null;
    let permissionModalCloseTimer = null;
    let settlePermissionModal = null;
    const listen = function (target, type, listener, options) {
      if (lifecycle) return lifecycle.listen(target, type, listener, options);
      target?.addEventListener?.(type, listener, options);
      return listener;
    };
    const schedule = function (callback, delay) {
      return lifecycle
        ? lifecycle.setTimeout(callback, delay)
        : window.setTimeout(callback, delay);
    };
    const clearScheduled = function (timerId) {
      if (timerId == null) return;
      if (lifecycle) lifecycle.clearTimeout(timerId);
      else window.clearTimeout(timerId);
    };
    const scheduleFrame = function (callback) {
      return lifecycle
        ? lifecycle.requestAnimationFrame(callback)
        : window.requestAnimationFrame(callback);
    };
    const claimGlobal = function (key, value) {
      if (lifecycle) return lifecycle.claim(window, key, value);
      window[key] = value;
      return value;
    };
    const distanceLifecycleToken = Object.freeze({ block });
    claimGlobal("__coveoDistanceUiOwner", distanceLifecycleToken);
    const isDistanceLifecycleActive = function () {
      return (
        !lifecycle ||
        (lifecycle.active &&
          lifecycle.isCurrent() &&
          block.isConnected !== false &&
          window.__coveoDistanceUiOwner === distanceLifecycleToken)
      );
    };
    lifecycle?.addCleanup(function () {
      delete block.dataset.coveoDistanceWired;
      if (window.__coveoDistanceUiOwner !== distanceLifecycleToken) return;
      delete window.__coveoDistanceResetFanout;
      delete window.__coveoDistanceResetOptions;
      delete window.__coveoDomDistanceFilterPending;
      delete window.__coveoDomDistanceVisibleCount;
      delete window.__coveoHasPendingDistanceUi;
      delete window.__coveoNearestSortPromptActive;
      delete window.__coveoPendingSortSelection;
    });

    function enableCollectionDistanceAfterUserAction() {
      releaseInitialCollectionDistanceSuppression();
    }

    function hoistModalToBody(modalEl) {
      if (!modalEl || !document.body) return modalEl;
      try {
        if (modalEl.parentElement !== document.body) {
          document.body.appendChild(modalEl);
        }
      } catch (_) { }
      return modalEl;
    }

    const modalPortals = [permissionModal, locationModal]
      .filter(Boolean)
      .map(function (modal) {
        return {
          modal,
          nextSibling: modal.nextSibling,
          parent: modal.parentNode,
        };
      });
    hoistModalToBody(permissionModal);
    hoistModalToBody(locationModal);
    lifecycle?.addCleanup(function () {
      settlePermissionModal?.();
      clearScheduled(permissionModalCloseTimer);
      clearScheduled(locationModalCloseTimer);
      [permissionModal, locationModal].forEach(function (modal) {
        if (!modal) return;
        modal.classList.remove("is-visible", "is-closing");
        modal.setAttribute("aria-hidden", "true");
        modal.setAttribute("hidden", "");
      });
      modalPortals
        .slice()
        .reverse()
        .forEach(function (portal) {
          const { modal, nextSibling, parent } = portal;
          if (parent?.isConnected) {
            const reference =
              nextSibling?.parentNode === parent ? nextSibling : null;
            parent.insertBefore(modal, reference);
          } else {
            modal.remove();
          }
        });
    });

    function setHidden(el, hidden) {
      if (!el) return;
      if (hidden) el.setAttribute("hidden", "");
      else el.removeAttribute("hidden");
    }

    function setKeyboardFocusMode(active, inputEl) {
      const isMobile = window.matchMedia("(max-width: 767.98px)").matches;
      if (!isMobile) return;
      const filtersDrawer = document.getElementById("CoveoFiltersDrawer");
      if (filtersDrawer?.hasAttribute("open")) {
        filtersDrawer.classList.toggle("coveo-filters-keyboard-open", !!active);
      }
      /*
       * Real iOS Safari already adjusts the visual viewport when the keyboard
       * opens. Forcing a follow-up `scrollIntoView({ block: "center" })` makes
       * the bottom sheet appear to zoom/jump downward, especially in the
       * distance ZIP flow. Let the browser keep its native position instead.
       */
    }

    function showAnimatedStandaloneModal(modalEl, kind) {
      if (!modalEl) return;
      const closeTimerKey =
        kind === "permission" ? "permissionModalCloseTimer" : "locationModalCloseTimer";
      if (closeTimerKey === "permissionModalCloseTimer" && permissionModalCloseTimer) {
        clearScheduled(permissionModalCloseTimer);
        permissionModalCloseTimer = null;
      }
      if (closeTimerKey === "locationModalCloseTimer" && locationModalCloseTimer) {
        clearScheduled(locationModalCloseTimer);
        locationModalCloseTimer = null;
      }
      modalEl.classList.remove("is-closing");
      setHidden(modalEl, false);
      scheduleFrame(function () {
        modalEl.classList.add("is-visible");
      });
    }

    function hideAnimatedStandaloneModal(modalEl, kind, done) {
      if (!modalEl) {
        if (typeof done === "function") done();
        return;
      }
      const closeTimerKey =
        kind === "permission" ? "permissionModalCloseTimer" : "locationModalCloseTimer";
      if (closeTimerKey === "permissionModalCloseTimer" && permissionModalCloseTimer) {
        clearScheduled(permissionModalCloseTimer);
        permissionModalCloseTimer = null;
      }
      if (closeTimerKey === "locationModalCloseTimer" && locationModalCloseTimer) {
        clearScheduled(locationModalCloseTimer);
        locationModalCloseTimer = null;
      }
      modalEl.classList.remove("is-visible");
      modalEl.classList.add("is-closing");
      const timer = schedule(function () {
        modalEl.classList.remove("is-closing");
        setHidden(modalEl, true);
        if (typeof done === "function") done();
      }, 280);
      if (closeTimerKey === "permissionModalCloseTimer") {
        permissionModalCloseTimer = timer;
      } else {
        locationModalCloseTimer = timer;
      }
    }

    function clearError(el) {
      if (!el) return;
      el.textContent = "";
      setHidden(el, true);
    }

    function showError(el, message) {
      if (!el) return;
      el.textContent = message || "";
      setHidden(el, false);
    }

    function clearAllErrors() {
      clearError(zipError);
      clearError(locationError);
    }

    function clearLocationModalError() {
      clearError(locationModalError);
    }

    function showLocationModalError(message) {
      showError(locationModalError, message);
    }

    function updateZipClearButton() {
      if (!zipClearBtn || !zipInput) return;
      setHidden(zipClearBtn, !String(zipInput.value || "").trim());
    }

    if (zipInput) {
      listen(zipInput, "focus", function () {
        setKeyboardFocusMode(true, zipInput);
      });
      listen(zipInput, "blur", function () {
        schedule(function () {
          setKeyboardFocusMode(false, zipInput);
        }, 120);
      });
    }

    if (locationModalInput) {
      listen(locationModalInput, "focus", function () {
        setKeyboardFocusMode(true, locationModalInput);
      });
      listen(locationModalInput, "blur", function () {
        schedule(function () {
          setKeyboardFocusMode(false, locationModalInput);
        }, 120);
      });
    }

    function radiusForNewLocation() {
      return (
        normalizeDistanceRadiusMiles(selectedRadiusMiles) || DEFAULT_RADIUS_MILES
      );
    }

    function persistSelectedRadius(radius, deferUntilApply) {
      const normalized = normalizeDistanceRadiusMiles(radius);
      selectedRadiusMiles = normalized;
      if (typeof window !== "undefined" && !deferUntilApply) {
        window.__coveoSelectedRadiusMiles = normalized;
      }
      return normalized;
    }

    function markDistancePending(deferUntilApply) {
      if (deferUntilApply) {
        window.__coveoHasPendingDistanceUi = true;
      }
    }

    function isDistanceApplyBlocked() {
      if (!hasCoveoDrawerApplyButton()) return false;
      const normalizedRadius = normalizeDistanceRadiusMiles(selectedRadiusMiles);
      if (normalizedRadius == null) return false;
      const typedZip = String(zipInput?.value || "").trim();
      if (typedZip) return false;
      return !getActiveCoveoStoredLocation();
    }

    function syncDistanceApplyButtonUi() {
      if (!hasCoveoDrawerApplyButton()) return;
      const applyBtn = document.getElementById("coveo-apply-filters");
      if (!applyBtn) return;
      if (applyBtn.getAttribute("aria-busy") === "true") return;
      const blocked = isDistanceApplyBlocked();
      applyBtn.disabled = blocked;
      applyBtn.setAttribute("aria-disabled", blocked ? "true" : "false");
      applyBtn.classList.toggle("is-disabled", blocked);
      if (blocked) {
        applyBtn.setAttribute(
          "title",
          "Enter a ZIP code or use your location to apply distance.",
        );
      } else {
        applyBtn.removeAttribute("title");
      }
    }

    function notifyDistanceApplyAvailabilityChanged() {
      syncDistanceApplyButtonUi();
      try {
        window.dispatchEvent(
          new CustomEvent("coveo:distance-apply-availability-changed", {
            detail: { blocked: isDistanceApplyBlocked() },
          }),
        );
      } catch (_) { }
    }

    claimGlobal("__coveoIsDistanceApplyBlocked", isDistanceApplyBlocked);
    claimGlobal("__coveoPromptForDistanceLocation", function () {
      clearAllErrors();
      showError(
        locationError,
        "Enter a ZIP code or use your location to apply distance.",
      );
      closeFiltersDrawerForModalFlow();
      openLocationEntryModal({ mode: "distance", returnToFilters: true });
    });

    function buildLocationLabel(loc) {
      if (!loc) return "";
      const zip = loc.type === "zip" ? loc.zip : loc.approxZip;
      const parts = [];
      const cityState = [loc.city, loc.state]
        .map((s) => (s ? String(s).trim() : ""))
        .filter(Boolean);
      if (cityState.length === 2) {
        parts.push(cityState[0] + ", " + cityState[1]);
      } else if (cityState.length === 1) {
        parts.push(cityState[0]);
      }
      if (zip) parts.push(String(zip).trim());
      if (parts.length) return parts.join(" ");
      if (loc.type === "geo") return "Using current location";
      return loc.type === "zip" ? "ZIP code " + (loc.zip || "") : "Current location";
    }

    function updateLocationModalStatus(loc) {
      if (!locationModalStatus) return;
      const label = buildLocationLabel(loc);
      if (!label) {
        locationModalStatus.textContent = "";
        setHidden(locationModalStatus, true);
        return;
      }
      locationModalStatus.textContent = label;
      setHidden(locationModalStatus, false);
    }

    function syncLocationModalInputFromState(options) {
      if (!locationModalInput) return;
      const opts = options || {};
    const loc = getActiveCoveoStoredLocation();
      const value = opts.force
        ? String(zipInput?.value || "").trim() ||
          String(loc?.zip || loc?.approxZip || "").trim()
        : String(locationModalInput.value || "").trim() ||
          String(zipInput?.value || "").trim() ||
          String(loc?.zip || loc?.approxZip || "").trim();
      locationModalInput.value = value;
      updateLocationModalStatus(loc);
    }

    function openLocationEntryModal(options) {
      if (!locationModal) return;
      const opts = options || {};
      locationModalMode =
        opts.mode === "nearest"
          ? "nearest"
          : opts.mode === "prompt"
            ? "prompt"
            : "distance";
      locationModalReturnToFilters = !!opts.returnToFilters;
      clearAllErrors();
      clearLocationModalError();
      syncLocationModalInputFromState({ force: true });
      showAnimatedStandaloneModal(locationModal, "location");
      locationModal.setAttribute("aria-hidden", "false");
      schedule(function () {
        try {
          locationModalInput?.focus();
          locationModalInput?.select?.();
        } catch (_) { }
      }, 30);
    }

    function reopenFiltersDrawerWithDistanceOpen() {
      try {
        if (typeof window.__coveoOpenFiltersDrawer === "function") {
          window.__coveoOpenFiltersDrawer();
        }
        block.querySelector("details")?.setAttribute("open", "");
      } catch (_) { }
    }

    function closeFiltersDrawerForModalFlow() {
      try {
        if (typeof window.__coveoCloseFiltersDrawer === "function") {
          window.__coveoCloseFiltersDrawer();
        }
      } catch (_) { }
    }

    function closeLocationEntryModal(options) {
      if (!locationModal) return;
      const opts = options || {};
      const closingMode = locationModalMode;
      const reopenFilters =
        opts.reopenFilters != null ? !!opts.reopenFilters : locationModalReturnToFilters;
      locationModal.setAttribute("aria-hidden", "true");
      hideAnimatedStandaloneModal(locationModal, "location", function () {
        locationModalMode = null;
        locationModalReturnToFilters = false;
        if (
          (closingMode === "nearest" || closingMode === "prompt") &&
          !opts.preservePendingSort
        ) {
          window.__coveoNearestSortPromptActive = false;
          window.__coveoPendingSortSelection = null;
        }
        clearLocationModalError();
        if (reopenFilters) {
          try {
            if (typeof window.__coveoOpenFiltersDrawer === "function") {
              window.__coveoOpenFiltersDrawer();
            }
            block.querySelector("details")?.setAttribute("open", "");
          } catch (_) { }
        }
      });
    }

    function scrollToPageTopAfterLocationApply() {
      // Wait for the standalone modal close animation to release page scroll.
      schedule(function () {
        scheduleFrame(function () {
          try {
            window.scrollTo({ top: 0, behavior: "smooth" });
          } catch (_) {
            window.scrollTo(0, 0);
          }
        });
      }, 320);
    }

    function updateSummaryBadge(radius) {
      if (!summaryBadge) return;
      const badge = formatDistanceRadiusBadge(radius);
      if (!badge) {
        summaryBadge.textContent = "";
        setHidden(summaryBadge, true);
      } else {
        summaryBadge.textContent = badge;
        setHidden(summaryBadge, false);
      }
    }

    function updateSavedLocationHint(radius, loc) {
      if (!savedLocationHint) return;
      const hasRealRadius = normalizeDistanceRadiusMiles(radius) != null;
      if (!loc || hasRealRadius) {
        savedLocationHint.textContent = "";
        setHidden(savedLocationHint, true);
        return;
      }
      savedLocationHint.textContent =
        "Location saved for Nearest: " + buildLocationLabel(loc);
      setHidden(savedLocationHint, false);
    }

    function markActiveRadiusButton(radius) {
      if (!block) return;
      const isAll = isAllInventoryRadius(radius);
      const normalized = normalizeDistanceRadiusMiles(radius);
      block.querySelectorAll(".coveo-distance-radius-btn").forEach((btn) => {
        const raw = (btn.dataset.radius || "").trim();
        let active = false;
        if (raw === COVEO_DISTANCE_ALL_INVENTORY) {
          /*
           * "All inventory" is the default — highlight it whenever no real
           * radius is active (including the initial "no radius" state).
           */
          active = isAll || normalized == null;
        } else {
          const r = normalizeDistanceRadiusMiles(parseInt(raw, 10));
          active = normalized != null && r === normalized;
        }
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-checked", active ? "true" : "false");
      });
    }

    function renderLocationPanel(radius, loc) {
      if (!locationPanel) return;

      /*
       * The location panel (ZIP + "Use my location") only applies to real
       * radii. "All inventory" and the initial empty state both hide it.
       */
      const isAll = isAllInventoryRadius(radius);
      const normalizedRadius = normalizeDistanceRadiusMiles(radius);
      const hasRealRadius = normalizedRadius != null;
      setHidden(locationPanel, !hasRealRadius);

      if (!hasRealRadius) {
        block.setAttribute(
          "data-distance-state",
          isAll ? "all-inventory" : "no-radius",
        );
        updateSavedLocationHint(radius, loc);
        notifyDistanceApplyAvailabilityChanged();
        return;
      }

      updateSavedLocationHint(radius, null);

      if (!loc) {
        block.setAttribute("data-distance-state", "no-location");
        if (locationPromptEl) {
          locationPromptEl.textContent = "Now confirm your location";
        }
        setHidden(filledHintEl, true);
        setHidden(filledState, true);
        setHidden(emptyState, false);
        updateZipClearButton();
        notifyDistanceApplyAvailabilityChanged();
        return;
      }

      block.setAttribute("data-distance-state", "radius");
      setHidden(locationPromptEl, true);
      if (filledLabel) filledLabel.textContent = buildLocationLabel(loc);
      setHidden(filledHintEl, false);
      setHidden(filledState, false);
      setHidden(emptyState, true);
      notifyDistanceApplyAvailabilityChanged();
    }

    function syncRadiusFromStorage(loc) {
      if (loc && loc.radiusMiles != null && !Number.isNaN(Number(loc.radiusMiles))) {
        const r = normalizeDistanceRadiusMiles(loc.radiusMiles);
        if (r == null) {
          try {
            Loc.clearStoredRadiusMiles?.();
          } catch (_) { }
        }
        selectedRadiusMiles = r != null ? r : COVEO_DISTANCE_ALL_INVENTORY;
      } else {
        /*
         * No stored location → default to "All inventory" (the unfiltered
         * state). The previous behavior was `null` (no radius selected),
         * which left the radius row visually unhighlighted on first load.
         */
        selectedRadiusMiles = COVEO_DISTANCE_ALL_INVENTORY;
      }
      if (typeof window !== "undefined") {
        window.__coveoSelectedRadiusMiles = isAllInventoryRadius(
          selectedRadiusMiles,
        )
          ? null
          : selectedRadiusMiles;
      }
    }

    function updateLocationSourceUI() {
      const loc = getActiveCoveoStoredLocation();
      if (loc) {
        markCoveoLocationPromptShared();
      }
      clearAllErrors();
      syncRadiusFromStorage(loc);
      window.__coveoHasPendingDistanceUi = false;

      if (zipInput) {
        if (!loc) {
          zipInput.value = "";
        } else if (loc.type === "zip" && loc.zip) {
          zipInput.value = loc.zip;
        } else if (loc.type === "geo") {
          zipInput.value = loc.approxZip || "";
        }
        updateZipClearButton();
      }

      markActiveRadiusButton(selectedRadiusMiles);
      updateSummaryBadge(selectedRadiusMiles);
      renderLocationPanel(selectedRadiusMiles, loc);
      updateLocationModalStatus(loc);
      syncCoveoToolbarLocationHint();
    }

    claimGlobal("__coveoResetPendingDistanceUi", updateLocationSourceUI);

    function hasApplyFilterButton() {
      try {
        return (
          !isCoveoRealtimeFilterApplyEnabled() &&
          !!document.getElementById("coveo-apply-filters")
        );
      } catch (_) {
        return false;
      }
    }

    async function runSearch(options) {
      if (!isDistanceLifecycleActive()) return;
      const opts = options || {};
      const isCurrent =
        typeof opts.isCurrent === "function" ? opts.isCurrent : () => true;
      if (!isCurrent()) return;
      if (hasApplyFilterButton() && opts.force !== true) {
        return;
      }

      const collectionRoot = document.getElementById(
        "coveo-headless-collection",
      );
      const usesCollectionDistanceProductPool = !!(
        collectionRoot &&
        typeof collectionRoot._coveoEnsureDistanceProductPool === "function" &&
        window.__coveoClientOnlyDistanceFilter !== false &&
        collectionRoot._coveoWillUseServerDistanceFiltering?.() !== true &&
        getActiveCoveoLocationContext()
      );
      if (usesCollectionDistanceProductPool) {
        window.__coveoCollectionDistancePoolLoading = true;
      }

      const willUseServerDistanceFiltering = !!(
        collectionRoot?._coveoWillUseServerDistanceFiltering?.() &&
        getActiveCoveoLocationContext()
      );
      if (
        (window.__coveoClientOnlyDistanceFilter === false ||
          willUseServerDistanceFiltering) &&
        getActiveCoveoLocationContext()
      ) {
        window.__coveoDomDistanceFilterPending = true;
        window.__coveoDomDistanceVisibleCount = null;
        window.__coveoDistanceFilterNoIndexedGeo = false;
        window.__coveoDistanceFilterGracefulFallback = false;
        const productsEl = document.getElementById("coveo-products");
        if (productsEl) {
          syncCoveoDistanceProductsGridVisibility(productsEl);
        }
        refreshCoveoDistanceSummaryAndPagination();
      }

      try {
        await dispatchCoveoSearch(search, engine, mod, { isCurrent });
        if (!isDistanceLifecycleActive() || !isCurrent()) return;
        if (
          typeof collectionRoot?._coveoEnsureDistanceProductPool === "function"
        ) {
          await collectionRoot._coveoEnsureDistanceProductPool();
          if (!isCurrent()) return;
        }
      } catch (err) {
        if (!isDistanceLifecycleActive()) return;
        if (usesCollectionDistanceProductPool) {
          window.__coveoCollectionDistancePoolLoading = false;
        }
        console.error("[Coveo Distance Filter] Error executing search:", err);
      }

      if (!search) {
        console.warn(
          "[Coveo Distance Filter] No valid search method available",
          { search, engine, mod },
        );
      }
    }

    function refreshVisibleNoResultsRecommendations() {
      const noResultsEl = document.getElementById("coveo-no-results");
      if (!noResultsEl || noResultsEl.classList.contains("hidden")) return;
      const activeContainer =
        document.getElementById("coveo-headless-search") ||
        document.getElementById("coveo-headless-collection");
      if (!activeContainer) return;
      maybeInitNoResultsRecommendations(activeContainer, true);
    }

    claimGlobal("__coveoDistanceFilterRunSearch", runSearch);

    const radiusButtons = block.querySelectorAll(".coveo-distance-radius-btn");
    if (radiusButtons.length === 0) {
      return;
    }

    /* -----------------------------------------------------------------
       Permission pre-prompt modal. We show our own dialog before calling
       `navigator.geolocation` so the user sees branded copy first.
       ----------------------------------------------------------------- */
    function openPermissionModal() {
      if (!permissionModal) return Promise.resolve(false);
      return new Promise((resolve) => {
        const allowBtn = permissionModal.querySelector(
          "[data-permission-allow]",
        );
        const cancelBtns = permissionModal.querySelectorAll(
          "[data-permission-cancel]",
        );
        let finished = false;

        function finish(result) {
          if (finished) return;
          finished = true;
          settlePermissionModal = null;
          resolve(result);
        }

        function removePermissionListeners() {
          document.removeEventListener("keydown", onKey);
          permissionModal.removeEventListener("click", onContainerClick);
          if (allowBtn) allowBtn.removeEventListener("click", onAllow);
          cancelBtns.forEach((b) => b.removeEventListener("click", onCancel));
        }

        function cleanup(result) {
          permissionModal.setAttribute("aria-hidden", "true");
          removePermissionListeners();
          hideAnimatedStandaloneModal(permissionModal, "permission", function () {
            finish(result);
          });
        }
        function onAllow() {
          cleanup(true);
        }
        function onCancel() {
          cleanup(false);
        }
        function onKey(e) {
          if (e.key === "Escape") cleanup(false);
        }
        function onContainerClick(e) {
          if (e.target === permissionModal) cleanup(false);
        }

        settlePermissionModal = function () {
          removePermissionListeners();
          clearScheduled(permissionModalCloseTimer);
          permissionModalCloseTimer = null;
          permissionModal.classList.remove("is-visible", "is-closing");
          permissionModal.setAttribute("aria-hidden", "true");
          permissionModal.setAttribute("hidden", "");
          finish(false);
        };

        showAnimatedStandaloneModal(permissionModal, "permission");
        permissionModal.setAttribute("aria-hidden", "false");
        permissionModal.addEventListener("click", onContainerClick);
        if (allowBtn) {
          allowBtn.addEventListener("click", onAllow);
          // Defer focus so the click that opened the modal doesn't immediately re-trigger.
          schedule(() => {
            try {
              allowBtn.focus();
            } catch (_) { }
          }, 30);
        }
        cancelBtns.forEach((b) => b.addEventListener("click", onCancel));
        document.addEventListener("keydown", onKey);
      });
    }

    function showZipFallbackAfterLocationFailure(err) {
      const code = err && err._geolocationCode;
      const denied =
        (err && err.message === "Permission denied") || code === 1;
      const unsupported =
        err && err.message === "Geolocation is not supported";
      const msg = denied
        ? "Location denied. Enter a ZIP code below."
        : unsupported
          ? "Location is not available in this browser. Enter a ZIP code below."
          : "Location unavailable. Enter a ZIP code below.";
      showError(locationError, msg);
    }

    function requestCurrentLocationFlow() {
      const radius = radiusForNewLocation();
      return Loc.requestLocation(radius, 15000).catch((err) => {
        const code = err && err._geolocationCode;
        if (code === 2 || code === 3) {
          return Loc.requestLocation(radius, 60000);
        }
        throw err;
      });
    }

    function completeNearestSortPrompt(options) {
      const opts = options || {};
      const hasPendingNearestSelection = !!window.__coveoPendingSortSelection?.value;
      const completedAutomaticLocationPrompt = locationModalMode === "prompt";
      if (completedAutomaticLocationPrompt) {
        try {
          const promptLocation = Loc.getStoredLocation?.(true);
          if (promptLocation) {
            Loc.setStoredLocation(
              Object.assign({}, promptLocation, {
                radiusMiles: DEFAULT_RADIUS_MILES,
              }),
            );
          }
          Loc.setStoredRadiusMiles?.(DEFAULT_RADIUS_MILES);
          persistSelectedRadius(DEFAULT_RADIUS_MILES, false);
          coveoLastSyncedLocationCtxKey = null;
        } catch (_) { }
      }
      window.__coveoNearestSortPromptActive = false;
      markCoveoLocationPromptShared();
      window.__coveoHasPendingDistanceUi = false;
      updateLocationSourceUI();
      syncLocationModalInputFromState();
      coveoLastSyncedLocationCtxKey = null;
      if (opts.closeModal !== false) {
        closeLocationEntryModal({
          reopenFilters: false,
          preservePendingSort: hasPendingNearestSelection,
        });
      }
      if (opts.closeDrawer !== false && typeof window.__coveoCloseFiltersDrawer === "function") {
        window.__coveoCloseFiltersDrawer();
      }
      if (
        hasPendingNearestSelection &&
        typeof window.__coveoApplyPendingSortSelection === "function"
      ) {
        return window.__coveoApplyPendingSortSelection();
      }
      window.__coveoPendingSortSelection = null;
      return Promise.resolve();
    }

    function requestCurrentLocationFlowForNearestSort(options) {
      const opts = options || {};
      const requestedRadius = normalizeDistanceRadiusMiles(opts.radiusMiles);
      return Loc.getBrowserLocation(15000)
        .then(function (coords) {
          if (!isDistanceLifecycleActive()) return null;
          return Loc.reverseGeocodeAddress(coords.lat, coords.lng).then(
            function (info) {
              if (!isDistanceLifecycleActive()) return null;
              const data = {
                lat: coords.lat,
                lng: coords.lng,
                type: "geo",
                zip: undefined,
                approxZip: info.zip || undefined,
                city: info.city || undefined,
                state: info.state || undefined,
                timestamp: new Date().toISOString(),
                precision: "device",
              };
              if (requestedRadius != null) {
                data.radiusMiles = requestedRadius;
              }
              Loc.setStoredLocation(data);
              if (requestedRadius != null) {
                Loc.setStoredRadiusMiles?.(requestedRadius);
                persistSelectedRadius(requestedRadius, false);
              }
              if (zipInput) zipInput.value = data.approxZip || "";
              if (locationModalInput) {
                locationModalInput.value = data.approxZip || "";
              }
              coveoLastSyncedLocationCtxKey = null;
              return completeNearestSortPrompt();
            },
          );
        })
        .catch(function (err) {
          if (!isDistanceLifecycleActive()) return null;
          showZipFallbackAfterLocationFailure(err);
          throw err;
        });
    }

    function promptLocationForNearestSort() {
      if (hasReusableStoredLocationForNearestSort()) {
        window.__coveoNearestSortPromptActive = false;
        clearAllErrors();
        clearLocationModalError();
        syncLocationModalInputFromState();
        return completeNearestSortPrompt({
          closeModal: false,
          closeDrawer: false,
        });
      }
      window.__coveoNearestSortPromptActive = true;
      clearAllErrors();
      closeFiltersDrawerForModalFlow();
      openLocationEntryModal({ mode: "nearest", returnToFilters: false });
    }

    function openSearchLocationPrompt() {
      clearSearchLocationPromptInventoryWait();
      window.__coveoNearestSortPromptActive = true;
      clearAllErrors();
      clearLocationModalError();
      window.__coveoPendingSortSelection = null;
      markCoveoLocationPromptShownThisSession();
      openLocationEntryModal({ mode: "prompt", returnToFilters: false });
    }

    function dismissSearchLocationPrompt() {
      recordCoveoLocationPromptDismissal();
      closeLocationEntryModal({
        reopenFilters: false,
        preservePendingSort: false,
      });
    }

    let scheduledSearchLocationPromptTimer = null;
    let searchLocationPromptInventoryObserver = null;
    let searchLocationPromptInventoryDelayTimer = null;
    let searchLocationPromptScrollHandler = null;

    function clearSearchLocationPromptInventoryWait() {
      if (searchLocationPromptInventoryObserver) {
        try {
          searchLocationPromptInventoryObserver.disconnect();
        } catch (_) { }
        searchLocationPromptInventoryObserver = null;
      }
      if (searchLocationPromptInventoryDelayTimer) {
        clearScheduled(searchLocationPromptInventoryDelayTimer);
        searchLocationPromptInventoryDelayTimer = null;
      }
      if (searchLocationPromptScrollHandler) {
        try {
          window.removeEventListener("scroll", searchLocationPromptScrollHandler, {
            passive: true,
          });
        } catch (_) {
          try {
            window.removeEventListener("scroll", searchLocationPromptScrollHandler);
          } catch (_) { }
        }
        searchLocationPromptScrollHandler = null;
      }
    }

    lifecycle?.addCleanup(function () {
      clearScheduled(scheduledSearchLocationPromptTimer);
      scheduledSearchLocationPromptTimer = null;
      clearSearchLocationPromptInventoryWait();
    });

    function isCoveoInventoryVisible(productsEl) {
      if (!productsEl || typeof productsEl.getBoundingClientRect !== "function") {
        return false;
      }
      const rect = productsEl.getBoundingClientRect();
      const viewportHeight =
        window.innerHeight || document.documentElement?.clientHeight || 0;
      if (viewportHeight <= 0) return false;
      return rect.top <= viewportHeight * 0.92 && rect.bottom >= viewportHeight * 0.18;
    }

    function scheduleInventoryVisiblePromptOpen(context) {
      clearSearchLocationPromptInventoryWait();
      const productsEl = document.getElementById("coveo-products");
      if (!productsEl) return false;

      const openPromptAfterScrollStart = function () {
        clearSearchLocationPromptInventoryWait();
        if (scheduledSearchLocationPromptTimer) return;
        scheduledSearchLocationPromptTimer = schedule(function () {
          scheduledSearchLocationPromptTimer = null;
          try {
            window.__coveoMaybeOpenSearchLocationPrompt?.(
              Object.assign({}, context || {}, { inventorySeen: true }),
            );
          } catch (_) { }
        }, 2000);
      };

      const waitForScrollStart = function () {
        if (searchLocationPromptScrollHandler) return;
        searchLocationPromptScrollHandler = function () {
          openPromptAfterScrollStart();
        };
        searchLocationPromptScrollHandler = listen(
          window,
          "scroll",
          searchLocationPromptScrollHandler,
          { passive: true },
        );

        if ((window.scrollY || window.pageYOffset || 0) > 0) {
          openPromptAfterScrollStart();
        }
      };

      if (isCoveoInventoryVisible(productsEl)) {
        waitForScrollStart();
        return true;
      }

      if ("IntersectionObserver" in window) {
        searchLocationPromptInventoryObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              if (entry.intersectionRatio < 0.2) return;
              waitForScrollStart();
            });
          },
          {
            threshold: [0.2, 0.4],
            rootMargin: "0px 0px -10% 0px",
          },
        );
        lifecycle?.trackObserver(searchLocationPromptInventoryObserver);
        searchLocationPromptInventoryObserver.observe(productsEl);
      }

      searchLocationPromptInventoryDelayTimer = schedule(function () {
        if (isCoveoInventoryVisible(productsEl)) {
          waitForScrollStart();
          return;
        }
        clearSearchLocationPromptInventoryWait();
      }, 4000);

      return true;
    }

    function scheduleSearchLocationPrompt(context) {
      if (scheduledSearchLocationPromptTimer) return false;
      const ctx = context || {};
      if (ctx.requireInventoryVisible && ctx.hasResults) {
        return scheduleInventoryVisiblePromptOpen(ctx);
      }
      scheduledSearchLocationPromptTimer = schedule(function () {
        scheduledSearchLocationPromptTimer = null;
        scheduleFrame(function () {
          scheduleFrame(function () {
            try {
              window.__coveoMaybeOpenSearchLocationPrompt?.(ctx);
            } catch (_) { }
          });
        });
      }, 0);
      return true;
    }

    claimGlobal("__coveoScheduleSearchLocationPrompt", scheduleSearchLocationPrompt);

    claimGlobal("__coveoMaybeOpenSearchLocationPrompt", function (context) {
      const ctx = context || {};
      if (locationModalMode || window.__coveoNearestSortPromptActive) return false;
      if (!ctx.isSearchOrPlp) return false;
      if (!ctx.hasInteraction) return false;
      if (ctx.requireInventoryVisible && !ctx.inventorySeen) return false;
      if (ctx.hasResults === false) return false;
      const loc = Loc.getStoredLocation?.(true);
      if (loc) {
        markCoveoLocationPromptShared();
        return false;
      }
      if (
        readCoveoPromptLocalValue(COVEO_LOCATION_PROMPT_STORAGE_KEYS.shared) ===
        "1"
      ) {
        return false;
      }
      if (isCoveoLocationPromptPermanentlySuppressed()) return false;
      if (hasActiveCoveoLocationPromptSuppression()) return false;
      if (hasShownCoveoLocationPromptThisSession()) return false;
      openSearchLocationPrompt();
      return true;
    });

    function commitNearestSortLocationFromZip(options) {
      const opts = options || {};
      const requestedRadius =
        normalizeDistanceRadiusMiles(opts.radiusMiles) ||
        (locationModalMode === "prompt" ? DEFAULT_RADIUS_MILES : null);
      const zip = (zipInput?.value || "").trim();
      if (!zip) {
        showError(zipError, "Please enter a ZIP code.");
        return Promise.resolve();
      }
      return Loc.geocodeZip(zip)
        .then(function (coords) {
          if (!isDistanceLifecycleActive()) return null;
          const nextLocation = {
            lat: coords.lat,
            lng: coords.lng,
            type: "zip",
            zip: zip,
            city: coords.city || undefined,
            state: coords.state || undefined,
            timestamp: new Date().toISOString(),
            precision: "approx",
          };
          if (requestedRadius != null) {
            nextLocation.radiusMiles = requestedRadius;
          }
          Loc.setStoredLocation(nextLocation);
          if (requestedRadius != null) {
            Loc.setStoredRadiusMiles?.(requestedRadius);
            persistSelectedRadius(requestedRadius, false);
          }
          coveoLastSyncedLocationCtxKey = null;
          zipInput.value = zip;
          return completeNearestSortPrompt();
        })
        .catch(function (err) {
          if (!isDistanceLifecycleActive()) return null;
          showError(
            zipError,
            err && err.message ? err.message : "ZIP code not found.",
          );
          throw err;
        });
    }

    claimGlobal(
      "__coveoPromptLocationForNearestSort",
      promptLocationForNearestSort,
    );

    function triggerUseCurrentLocation() {
      enableCollectionDistanceAfterUserAction();
      clearAllErrors();
      if (!normalizeDistanceRadiusMiles(selectedRadiusMiles)) {
        showError(
          locationError,
          "Select a radius to find nearby inventory first.",
        );
        return;
      }
      requestCurrentLocationFlow()
        .then(function (data) {
          if (!isDistanceLifecycleActive()) return;
          if (zipInput) {
            zipInput.value = data && data.approxZip ? data.approxZip : "";
          }
          updateLocationSourceUI();
          if (hasApplyFilterButton()) {
            window.__coveoHasPendingDistanceUi = true;
            coveoLastSyncedLocationCtxKey = null;
          }
          refreshVisibleNoResultsRecommendations();
          return runSearch();
        })
        .catch(function (err) {
          if (!isDistanceLifecycleActive()) return;
          showZipFallbackAfterLocationFailure(err);
        });
    }

    if (useCurrentBtn) {
      listen(useCurrentBtn, "click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearAllErrors();
        if (!normalizeDistanceRadiusMiles(selectedRadiusMiles)) {
          showError(
            locationError,
            "Select a radius to find nearby inventory first.",
          );
          return;
        }
        openPermissionModal().then((allowed) => {
          if (!isDistanceLifecycleActive()) return;
          if (!allowed) {
            showError(
              locationError,
              "Enter a ZIP code to search nearby inventory.",
            );
            return;
          }
          triggerUseCurrentLocation();
        });
      });
    }

    /*
     * Reset the distance filter to its default "All inventory" state while
     * preserving any saved ZIP / geolocation. This lets the user remove the
     * radius without losing the location they already shared.
     */
    function resetToAllInventory(options) {
      const opts = options || {};
      const isCurrent =
        typeof opts.isCurrent === "function" ? opts.isCurrent : () => true;
      if (!isCurrent()) return Promise.resolve({ status: "cancelled" });
      retirePendingInitialCoveoUrlHydration();
      clearAllErrors();
      const deferUntilApply =
        hasApplyFilterButton() && opts.force !== true;
      clearCoveoDistanceFilterState({
        preserveStoredLocation: true,
      });
      /*
       * Keep the distance block's closure state in sync immediately. Waiting
       * for a later drawer render to reread storage allowed the previous
       * radius to become active again when the drawer closed.
       */
      selectedRadiusMiles = COVEO_DISTANCE_ALL_INVENTORY;
      window.__coveoSelectedRadiusMiles = null;
      markActiveRadiusButton(selectedRadiusMiles);
      updateSummaryBadge(selectedRadiusMiles);
      renderLocationPanel(selectedRadiusMiles, Loc.getStoredLocation?.() || null);
      if (deferUntilApply) {
        markDistancePending(true);
        notifyDistanceApplyAvailabilityChanged();
        return Promise.resolve();
      }
      if (opts.runSearch !== false) {
        return Promise.resolve(
          runSearch({
            force: opts.force === true,
            isCurrent,
          }),
        ).then(function () {
          if (!isCurrent()) return { status: "cancelled" };
          return requestCoveoManagedRangeDomainRefresh();
        });
      }
      return Promise.resolve({ status: "search-deferred" });
    }

    claimGlobal("__coveoResetDistanceToAllInventory", function (options) {
      return resetToAllInventory(
        Object.assign({ force: true }, options || {}),
      );
    });
    claimGlobal("__coveoSelectAllDistanceInventory", function (options) {
      const resetOptions = options || {};
      const allButton = document.querySelector(
        '.coveo-distance-radius-btn[data-radius="all"]',
      );
      if (!allButton) {
        return window.__coveoResetDistanceToAllInventory(
          Object.assign({ force: true }, resetOptions),
        );
      }
      const fanout = [];
      window.__coveoDistanceResetFanout = fanout;
      window.__coveoDistanceResetOptions = resetOptions;
      try {
        allButton.click();
      } finally {
        if (window.__coveoDistanceResetFanout === fanout) {
          window.__coveoDistanceResetFanout = null;
        }
        if (window.__coveoDistanceResetOptions === resetOptions) {
          window.__coveoDistanceResetOptions = null;
        }
      }
      return Promise.all(
        fanout.map(function (promise) {
          return Promise.resolve(promise).catch(function () { });
        }),
      );
    });

    radiusButtons.forEach((btn) => {
      listen(btn, "click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        retirePendingInitialCoveoUrlHydration();

        const raw = String(btn.dataset.radius || "").trim();

        /*
         * "All inventory": short-circuit — no radius, no location, no
         * permission prompt. Just reset back to the unfiltered view.
         */
        if (raw === COVEO_DISTANCE_ALL_INVENTORY) {
          window.__coveoDistanceExplicitlyClearedThisPage = true;
          const resetPromise = resetToAllInventory(
            Object.assign(
              {},
              window.__coveoDistanceResetOptions || {},
              {
                force: Array.isArray(window.__coveoDistanceResetFanout),
              },
            ),
          );
          if (Array.isArray(window.__coveoDistanceResetFanout)) {
            window.__coveoDistanceResetFanout.push(resetPromise);
          }
          return;
        }

        enableCollectionDistanceAfterUserAction();
        const radius = normalizeDistanceRadiusMiles(parseInt(raw, 10));
        if (radius == null) return;
        markCoveoDistanceRadiusInitialized();

        const loc = Loc.getStoredLocation();
        const deferPersistenceUntilApply = hasApplyFilterButton();

        /*
         * Clicking the already-active radius toggles back to the default
         * "All inventory" state. This gives the user a quick path out
         * without scrolling to find the All-inventory pill.
         */
        const currentRadius = normalizeDistanceRadiusMiles(selectedRadiusMiles);
        if (currentRadius != null && currentRadius === radius) {
          window.__coveoDistanceExplicitlyClearedThisPage = true;
          const resetPromise = resetToAllInventory({
            force: Array.isArray(window.__coveoDistanceResetFanout),
          });
          if (Array.isArray(window.__coveoDistanceResetFanout)) {
            window.__coveoDistanceResetFanout.push(resetPromise);
          }
          return;
        }

        clearAllErrors();
        persistSelectedRadius(radius, deferPersistenceUntilApply);
        markActiveRadiusButton(radius);
        updateSummaryBadge(radius);
        markDistancePending(deferPersistenceUntilApply);
        renderLocationPanel(radius, loc);

        if (loc && !deferPersistenceUntilApply) {
          Loc.setStoredLocation(Object.assign({}, loc, { radiusMiles: radius }));
          coveoLastSyncedLocationCtxKey = null;
          runSearch();
        } else if (zipInput) {
          /*
           * Default path is manual ZIP entry. Browser geolocation is only
           * requested from the explicit "Use my location" action.
           */
          try {
            zipInput.focus();
          } catch (_) { }
        }
      });
    });

    if (clearLocationBtn) {
      listen(clearLocationBtn, "click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        retirePendingInitialCoveoUrlHydration();
        clearAllErrors();
        clearCoveoDistanceFilterState();
        return Promise.resolve(runSearch()).then(function () {
          return requestCoveoManagedRangeDomainRefresh();
        });
      });
    }

    if (changeBtn) {
      listen(changeBtn, "click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearAllErrors();
        setHidden(filledState, true);
        setHidden(emptyState, false);
        if (zipInput) {
          try {
            zipInput.focus();
          } catch (_) { }
        }
      });
    }

    function commitPendingDistanceLocation() {
      clearAllErrors();
      updateZipClearButton();

      if (isAllInventoryRadius(selectedRadiusMiles)) {
        /*
         * The closure state is authoritative here. A response from the old
         * radius request can briefly leave the 50mi button with `is-active`
         * in the DOM; consulting that stale class during Apply used to write
         * 50 back into storage immediately after the user selected All.
         */
        const storedLoc = Loc.getStoredLocation();
        if (storedLoc) {
          Loc.clearStoredRadiusMiles?.();
        }
        window.__coveoSelectedRadiusMiles = null;
        window.__coveoHasPendingDistanceUi = false;
        coveoLastSyncedLocationCtxKey = null;
        markActiveRadiusButton(COVEO_DISTANCE_ALL_INVENTORY);
        updateSummaryBadge(COVEO_DISTANCE_ALL_INVENTORY);
        renderLocationPanel(
          COVEO_DISTANCE_ALL_INVENTORY,
          Loc.getStoredLocation?.() || storedLoc || null,
        );
        return Promise.resolve();
      }

      let radiusFromUi = selectedRadiusMiles;
      const activeRadiusBtn = block.querySelector(
        ".coveo-distance-radius-btn.is-active",
      );
      if (activeRadiusBtn) {
        const parsed = parseInt(activeRadiusBtn.dataset.radius, 10);
        if (!Number.isNaN(parsed)) radiusFromUi = parsed;
      }

      const zip = (zipInput?.value || "").trim();
      const stored = Loc.getStoredLocation();

      const radiusForCommit =
        normalizeDistanceRadiusMiles(radiusFromUi) || DEFAULT_RADIUS_MILES;

      if (!zip) {
        if (stored) {
          persistSelectedRadius(radiusForCommit, false);
          window.__coveoHasPendingDistanceUi = false;
          Loc.setStoredLocation(
            Object.assign({}, stored, { radiusMiles: radiusForCommit }),
          );
          coveoLastSyncedLocationCtxKey = null;
          markActiveRadiusButton(radiusForCommit);
          updateSummaryBadge(radiusForCommit);
          renderLocationPanel(radiusForCommit, stored);
        } else if (normalizeDistanceRadiusMiles(radiusFromUi)) {
          showError(
            locationError,
            "Enter a ZIP code or use your location to apply distance.",
          );
          const err = new Error("Distance location is required");
          err._distanceValidation = true;
          throw err;
        }
        return Promise.resolve();
      }

      const radiusForZip = radiusForCommit;

      const storedZip =
        stored && stored.zip ? String(stored.zip).trim() : "";
      const storedZipPrefix = normalizeUsZipPrefix(storedZip);
      const enteredZipPrefix = normalizeUsZipPrefix(zip);
      const canReuseStoredZipLocation =
        stored &&
        stored.type === "zip" &&
        storedZip &&
        (storedZip === zip ||
          (storedZipPrefix &&
            enteredZipPrefix &&
            storedZipPrefix === enteredZipPrefix));
      if (canReuseStoredZipLocation) {
        persistSelectedRadius(radiusForZip, false);
        window.__coveoHasPendingDistanceUi = false;
        Loc.setStoredLocation(
          Object.assign({}, stored, { radiusMiles: radiusForZip }),
        );
        coveoLastSyncedLocationCtxKey = null;
        markActiveRadiusButton(radiusForZip);
        updateSummaryBadge(radiusForZip);
        renderLocationPanel(radiusForZip, Loc.getStoredLocation() || stored);
        return Promise.resolve();
      }

      return Loc.setLocationFromZip(zip, { radiusMiles: radiusForZip })
        .then(function () {
          if (!isDistanceLifecycleActive()) return;
          persistSelectedRadius(radiusForZip, false);
          window.__coveoHasPendingDistanceUi = false;
          coveoLastSyncedLocationCtxKey = null;
          zipInput.value = zip;
          updateLocationSourceUI();
        })
        .catch(function (err) {
          if (!isDistanceLifecycleActive()) return;
          showError(
            zipError,
            err && err.message ? err.message : "ZIP code not found.",
          );
          throw err;
        });
    }

    claimGlobal(
      "__coveoFlushPendingDistanceLocation",
      commitPendingDistanceLocation,
    );

    if (zipInput) {
      let suppressNextZipChangeSubmit = false;

      function submitZipFromInput() {
        enableCollectionDistanceAfterUserAction();
        if (window.__coveoNearestSortPromptActive) {
          return commitNearestSortLocationFromZip();
        }
        if (!normalizeDistanceRadiusMiles(selectedRadiusMiles)) {
          showError(
            locationError,
            "Select a radius to find nearby inventory first.",
          );
          return Promise.resolve();
        }
        const zip = (zipInput.value || "").trim();
        if (!zip) {
          showError(zipError, "Please enter a ZIP code.");
          return Promise.resolve();
        }
        return commitPendingDistanceLocation().then(function () {
          if (hasApplyFilterButton()) {
            window.__coveoHasPendingDistanceUi = true;
            coveoLastSyncedLocationCtxKey = null;
          }
          refreshVisibleNoResultsRecommendations();
          return runSearch();
        });
      }
      listen(zipInput, "keydown", function (e) {
        if (e.key !== "Enter" && e.keyCode !== 13) return;
        e.preventDefault();
        submitZipFromInput();
      });
      listen(zipInput, "input", function () {
        clearError(zipError);
        updateZipClearButton();
        if (normalizeDistanceRadiusMiles(selectedRadiusMiles) != null) {
          window.__coveoHasPendingDistanceUi = true;
        }
        notifyDistanceApplyAvailabilityChanged();
      });
      listen(zipInput, "change", function () {
        if (suppressNextZipChangeSubmit) {
          suppressNextZipChangeSubmit = false;
          return;
        }
        if (!String(zipInput.value || "").trim()) {
          updateZipClearButton();
          return;
        }
        submitZipFromInput();
      });

      if (applyLocationBtn) {
        listen(applyLocationBtn, "pointerdown", function () {
          suppressNextZipChangeSubmit = true;
        });
        listen(applyLocationBtn, "click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          suppressNextZipChangeSubmit = true;
          try {
            zipInput.blur();
          } catch (_) { }
          finally {
            suppressNextZipChangeSubmit = false;
          }
          submitZipFromInput();
        });
      }
    }

    function submitZipFromLocationModal() {
      enableCollectionDistanceAfterUserAction();
      clearLocationModalError();
      const zip = String(locationModalInput?.value || "").trim();
      if (!zip) {
        showLocationModalError("Please enter a ZIP code.");
        return Promise.resolve();
      }
      if (zipInput) {
        zipInput.value = zip;
        updateZipClearButton();
      }
      if (locationModalMode === "nearest" || locationModalMode === "prompt") {
        const shouldApplyPromptRadius = locationModalMode === "prompt";
        return commitNearestSortLocationFromZip({
          radiusMiles: shouldApplyPromptRadius ? DEFAULT_RADIUS_MILES : null,
        })
          .then(function () {
            if (!isDistanceLifecycleActive()) return;
            if (!shouldApplyPromptRadius) return;
            coveoLastSyncedLocationCtxKey = null;
            return runSearch({ force: true });
          })
          .then(function (result) {
            if (!isDistanceLifecycleActive()) return result;
            scrollToPageTopAfterLocationApply();
            return result;
          })
          .catch(function (err) {
            if (!isDistanceLifecycleActive()) return;
            showLocationModalError(
              err && err.message ? err.message : "ZIP code not found.",
            );
            throw err;
          });
      }
      if (!normalizeDistanceRadiusMiles(selectedRadiusMiles)) {
        showLocationModalError("Select a radius to find nearby inventory first.");
        return Promise.resolve();
      }
      return commitPendingDistanceLocation()
        .then(function () {
          if (!isDistanceLifecycleActive()) return;
          return runSearch();
        })
        .then(function () {
          if (!isDistanceLifecycleActive()) return;
          updateLocationSourceUI();
          syncLocationModalInputFromState();
          closeLocationEntryModal({ reopenFilters: false });
          scrollToPageTopAfterLocationApply();
        })
        .catch(function (err) {
          if (!isDistanceLifecycleActive()) return;
          showLocationModalError(
            err && err.message ? err.message : "ZIP code not found.",
          );
          throw err;
        });
    }

    function submitCurrentLocationFromModal() {
      enableCollectionDistanceAfterUserAction();
      clearLocationModalError();
      const currentModalMode =
        locationModalMode === "nearest" || locationModalMode === "prompt"
          ? locationModalMode
          : "distance";
      closeLocationEntryModal({
        reopenFilters: false,
        preservePendingSort: true,
      });
      openPermissionModal().then((allowed) => {
        if (!isDistanceLifecycleActive()) return;
        if (!allowed) {
          openLocationEntryModal({
            mode: currentModalMode,
            returnToFilters: false,
          });
          showLocationModalError(
            currentModalMode === "nearest"
              ? "Enter a ZIP code to sort by nearest."
              : "Enter a ZIP code to search nearby inventory.",
          );
          return;
        }
        if (currentModalMode === "nearest" || currentModalMode === "prompt") {
          requestCurrentLocationFlowForNearestSort({
            radiusMiles:
              currentModalMode === "prompt" ? DEFAULT_RADIUS_MILES : null,
          })
            .then(function () {
              if (!isDistanceLifecycleActive()) return;
              if (currentModalMode !== "prompt") return;
              coveoLastSyncedLocationCtxKey = null;
              return runSearch({ force: true });
            })
            .catch(function (err) {
              if (!isDistanceLifecycleActive()) return;
              showZipFallbackAfterLocationFailure(err);
              openLocationEntryModal({
                mode: currentModalMode,
                returnToFilters: false,
              });
              showLocationModalError("Location unavailable. Enter a ZIP code below.");
            });
          return;
        }
        requestCurrentLocationFlow()
          .then(function (data) {
            if (!isDistanceLifecycleActive()) return;
            if (zipInput) {
              zipInput.value = data && data.approxZip ? data.approxZip : "";
            }
            updateLocationSourceUI();
            if (hasApplyFilterButton()) {
              window.__coveoHasPendingDistanceUi = true;
              coveoLastSyncedLocationCtxKey = null;
            }
            return runSearch();
          })
          .catch(function (err) {
            if (!isDistanceLifecycleActive()) return;
            showZipFallbackAfterLocationFailure(err);
            showLocationModalError("Location unavailable. Enter a ZIP code below.");
          });
      });
    }

    if (locationModalInput) {
      listen(locationModalInput, "input", function () {
        clearLocationModalError();
      });
      listen(locationModalInput, "keydown", function (e) {
        if (e.key !== "Enter" && e.keyCode !== 13) return;
        e.preventDefault();
        submitZipFromLocationModal();
      });
    }

    if (locationModalApplyBtn) {
      listen(locationModalApplyBtn, "click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        try {
          locationModalInput.blur();
        } catch (_) { }
        submitZipFromLocationModal();
      });
    }

    if (locationModalUseCurrentBtn) {
      listen(locationModalUseCurrentBtn, "click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        submitCurrentLocationFromModal();
      });
    }

    locationModalDismissBtns.forEach(function (btn) {
      listen(btn, "click", function (e) {
        e.preventDefault();
        if (locationModalMode === "prompt") {
          dismissSearchLocationPrompt();
          return;
        }
        closeLocationEntryModal({ reopenFilters: locationModalReturnToFilters });
      });
    });

    if (locationModal) {
      listen(locationModal, "click", function (e) {
        if (e.target !== locationModal) return;
        closeLocationEntryModal({ reopenFilters: locationModalReturnToFilters });
      });
    }

    if (zipClearBtn) {
      listen(zipClearBtn, "click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        retirePendingInitialCoveoUrlHydration();
        clearCoveoDistanceFilterState();
        return Promise.resolve(runSearch()).then(function () {
          return requestCoveoManagedRangeDomainRefresh();
        });
      });
    }

    listen(window, "coveo:distance-location-cleared", function () {
      if (zipInput) zipInput.value = "";
      clearAllErrors();
      coveoLastSyncedLocationCtxKey = null;
      selectedRadiusMiles = null;
      window.__coveoSelectedRadiusMiles = null;
      window.__coveoHasPendingDistanceUi = false;
      window.__coveoDomDistanceVisibleCount = null;
      window.__coveoDomDistanceFilterPending = false;
      const productsEl = document.getElementById("coveo-products");
      if (productsEl) {
        resetDomDistanceFilteredColumns(productsEl);
        syncCoveoDistanceProductsGridVisibility(productsEl);
      }
      markActiveRadiusButton(null);
      updateSummaryBadge(null);
      renderLocationPanel(null, null);
      updateZipClearButton();
      notifyDistanceApplyAvailabilityChanged();
    });

    listen(window, "coveo:distance-radius-cleared", function () {
      clearAllErrors();
      coveoLastSyncedLocationCtxKey = null;
      selectedRadiusMiles = COVEO_DISTANCE_ALL_INVENTORY;
      window.__coveoSelectedRadiusMiles = null;
      window.__coveoHasPendingDistanceUi = false;
      window.__coveoDomDistanceVisibleCount = null;
      window.__coveoDomDistanceFilterPending = false;
      const productsEl = document.getElementById("coveo-products");
      if (productsEl) {
        resetDomDistanceFilteredColumns(productsEl);
        syncCoveoDistanceProductsGridVisibility(productsEl);
      }
      markActiveRadiusButton(COVEO_DISTANCE_ALL_INVENTORY);
      updateSummaryBadge(COVEO_DISTANCE_ALL_INVENTORY);
      renderLocationPanel(
        COVEO_DISTANCE_ALL_INVENTORY,
        Loc.getStoredLocation?.() || null,
      );
      updateLocationSourceUI();
      notifyDistanceApplyAvailabilityChanged();
    });

    const drawerContent = document.getElementById("CoveoFiltersDrawerContent");
    if (drawerContent) mountDistanceFilterInDrawer(drawerContent);
    updateLocationSourceUI();
    notifyDistanceApplyAvailabilityChanged();
  }

  const coveoCardsModule = window.CoveoCardsModule?.create?.({
    resolveBoatPromoBadge,
    getProductField,
    getProductGeoCoordinates,
    isEmptyField,
    parseGeoCoordinate,
    parsePrice,
    resolveProductCardCondition: getProductCardCondition,
    resolveProductCardLength: getProductCardLength,
    searchPageResultsPerPage: SEARCH_PAGE_RESULTS_PER_PAGE,
  });
  if (!coveoCardsModule) {
    throw new Error("[Coveo Cards] Missing headless-search-page-cards.js");
  }
  const {
    COVEO_LIQUID_PRODUCT_CARD_FETCH_STATUS,
    COVEO_LIQUID_PRODUCT_PROGRESSIVE_FLUSH_DELAY_MS,
    COVEO_LIQUID_PRODUCT_SECTION_FETCH_CONCURRENCY_PROGRESSIVE,
    attachCoveoProductKeyToCardHtml,
    cacheProductGeoFromCardHtml,
    fetchLiquidProductCardResult,
    getCoveoStableProductKey,
    getProductCardCondition: resolveCoveoCardCondition,
    getProductCardLength: resolveCoveoCardLength,
    renderSkeletonCard,
    shouldSkipLiquidCardHydrationForResult,
  } = coveoCardsModule;
  const coveoDistanceModule = window.CoveoDistanceModule?.create?.({
    coveoLocationContextCacheKey,
    getActiveCoveoLocationContext,
    getActiveCoveoStoredLocation,
    getActiveKeywordQuery,
    getCoveoQuerySummaryElements,
    isCoveoProductNavigationPendingActive,
    normalizeUsZipPrefix,
    parseGeoCoordinate,
    setCoveoDomDistanceAppliedCtxKey,
  });
  if (!coveoDistanceModule) {
    throw new Error("[Coveo Distance] Missing headless-search-page-distance.js");
  }
  const {
    applyDomDistanceFilterToProductGrid,
    getCoveoDistanceGridItems,
    refreshCoveoDistanceSummaryAndPagination,
    resetDomDistanceFilteredColumns,
    setCoveoSourceIndex,
    syncCoveoDistanceProductsGridVisibility,
  } = coveoDistanceModule;

  function findCoveoProductByStableKey(search, key) {
    if (!search || !key) return null;
    const state = search.state || {};
    const productsRaw =
      state.products ||
      state.results ||
      (state.searchResponse && state.searchResponse.results) ||
      (state.response && state.response.results) ||
      [];
    const arr = Array.isArray(productsRaw) ? productsRaw : [];
    return arr.find((p) => getCoveoStableProductKey(p) === key) || null;
  }

  const COVEO_SELECTED_PRODUCT_CONTEXT_STORAGE_KEY =
    "marinemax:coveo-selected-product-context";

  function persistCoveoPermanentIdForPdp(productOrPermanentId, href) {
    if (!productOrPermanentId || !href) return;
    try {
      const additionalFields =
        typeof productOrPermanentId === "object"
          ? productOrPermanentId.additionalFields || {}
          : {};
      const permanentId = String(
        typeof productOrPermanentId === "string"
          ? productOrPermanentId
          : productOrPermanentId.permanentid ||
              additionalFields.permanentid ||
              "",
      ).trim();
      if (!permanentId) return;

      const productUrl = new URL(href, window.location.origin);
      if (
        productUrl.origin !== window.location.origin ||
        !/(?:^|\/)products\//i.test(productUrl.pathname)
      ) {
        return;
      }

      window.sessionStorage.setItem(
        COVEO_SELECTED_PRODUCT_CONTEXT_STORAGE_KEY,
        JSON.stringify({
          permanentId,
          productPath: productUrl.pathname.replace(/\/+$/, "") || "/",
          savedAt: Date.now(),
        }),
      );
      console.log(
        `[Coveo Recs] Saved PLP permanentid=${permanentId} productPath=${productUrl.pathname}`,
      );
    } catch (_) { }
  }

  function dispatchCoveoInteractiveProductSelect(search, product) {
    if (!search || !product) return;
    try {
      const build =
        typeof search.interactiveProduct === "function"
          ? search.interactiveProduct.bind(search)
          : typeof search.InteractiveProduct === "function"
            ? search.InteractiveProduct.bind(search)
            : null;
      if (!build) return;
      let ctrl = null;
      try {
        ctrl = build({ options: { product } });
      } catch (_) {
        ctrl = build({ product });
      }
      if (ctrl && typeof ctrl.select === "function") {
        ctrl.select();
      }
    } catch (err) {
      console.warn("[Coveo Analytics] interactiveProduct.select failed:", err);
    }
  }

  function wireCoveoHeadlessProductClickAnalytics(lifecycle) {
    const productsEl =
      lifecycle?.root?.querySelector?.("#coveo-products") ||
      document.getElementById("coveo-products");
    if (!productsEl || productsEl.dataset.coveoHeadlessProductAnalytics === "1") {
      return;
    }
    wireCoveoProductNavigationPendingReset();
    productsEl.dataset.coveoHeadlessProductAnalytics = "1";
    const onProductClick = function (e) {
      const anchor = e.target.closest(
        "a.coveo-boat-card__link, a.coveo-search-card__link",
      );
      if (!anchor || !anchor.getAttribute("href") || anchor.getAttribute("href") === "#") {
        return;
      }
      const shouldPreserveSearchHistory =
        shouldTrackCoveoProductNavigationPending(e, anchor);
      if (shouldPreserveSearchHistory) {
        setCoveoProductNavigationPending(anchor.getAttribute("href") || "");
      } else {
        clearCoveoProductNavigationPending();
      }
      const cardRoot =
        anchor.closest("[data-coveo-product-key]") ||
        anchor.closest(".coveo-search-card-wrapper") ||
        anchor.closest(".coveo-boat-card") ||
        anchor.closest(".coveo-search-card");
      const key =
        (cardRoot &&
          cardRoot.getAttribute &&
          cardRoot.getAttribute("data-coveo-product-key")) ||
        "";
      const host =
        productsEl.closest("#coveo-headless-search") ||
        productsEl.closest("#coveo-headless-collection");
      const search = host && host._coveoSearch;
      if (!key) return;
      persistCoveoPermanentIdForPdp(
        key,
        anchor.getAttribute("href") || "",
      );
      if (!search) return;
      const product = findCoveoProductByStableKey(search, key);
      if (!product) return;
      if (
        shouldPreserveSearchHistory &&
        host?.id === "coveo-headless-search" &&
        typeof window.MarineMaxCoveoSearchHistory?.capture === "function"
      ) {
        window.MarineMaxCoveoSearchHistory.capture({
          engine: host._coveoEngine,
          href: anchor.getAttribute("href") || "",
        });
      }
      dispatchCoveoInteractiveProductSelect(search, product);
      try {
        const it = mmCoveoProductToDatalayerItem(product);
        if (it && window.dataLayer) {
          const coll = document.getElementById("coveo-headless-collection");
          const searchRoot = document.getElementById("coveo-headless-search");
          let listName = "inventory_search";
          if (coll && coll.dataset.collectionTitle) {
            listName = coll.dataset.collectionTitle;
          } else if (searchRoot) {
            listName = "search";
          }
          window.dataLayer.push({
            event: "select_item",
            item_list_name: listName,
            ecommerce: { currency: "USD", items: [it] },
          });
        }
      } catch (_) { }
    };
    if (lifecycle) {
      lifecycle.listen(productsEl, "click", onProductClick, true);
      lifecycle.addCleanup(function () {
        delete productsEl.dataset.coveoHeadlessProductAnalytics;
      });
    } else {
      productsEl.addEventListener("click", onProductClick, true);
    }
  }

  const COVEO_NO_RESULTS_HEADING_PLACEHOLDER = "__COVEO_QUERY_PLACEHOLDER__";

  /** Decode entities from Liquid `| escape` (or &amp; in attributes) so textContent shows real apostrophes/quotes. */
  function decodeHtmlEntities(str) {
    if (str == null || str === "") return "";
    const ta = document.createElement("textarea");
    ta.innerHTML = String(str);
    return ta.value;
  }

  function syncCoveoNoResultsHeading(noResultsEl, search, container) {
    if (!noResultsEl) return;
    const rawTpl = noResultsEl.getAttribute(
      "data-coveo-no-results-heading-template",
    );
    const headingEl = document.getElementById("coveo-no-results-heading");
    if (!headingEl || typeof rawTpl !== "string" || !rawTpl.trim()) return;
    const tpl = decodeHtmlEntities(rawTpl);
    const q = (getActiveKeywordQuery(search, container) || "").trim();

    if (q) {
      if (tpl.indexOf(COVEO_NO_RESULTS_HEADING_PLACEHOLDER) !== -1) {
        headingEl.textContent = tpl
          .split(COVEO_NO_RESULTS_HEADING_PLACEHOLDER)
          .join(q);
      }
      return;
    }
    const fallbackParts = describeAppliedSearchContext(search, container);
    if (fallbackParts) {
      headingEl.textContent = `We're sorry, we could not find any matches for ${fallbackParts}.`;
    } else {
      headingEl.textContent = "We're sorry, we could not find any matches.";
    }
  }

  function formatNoResultsSelectedFacetLabel(facet, value) {
    const raw = facetItemRawValue(value);
    if (raw == null || !String(raw).trim()) return "";
    const rawStr = String(raw).trim();
    const facetId = getCoveoFacetRequestFieldId(facet);
    const isPriceFacet =
      coveoFacetRequestLooksLikePrice(facet) ||
      facetId === "price" ||
      facetId.includes("price");
    if (!isPriceFacet) return rawStr;

    const bounds = normalizeRangeBoundsForUiKind(
      facetItemNumericBounds(value),
      "price",
    );
    if (
      bounds &&
      Number.isFinite(bounds.lo) &&
      Number.isFinite(bounds.hi)
    ) {
      return `${formatPriceDisplay(bounds.lo)}–${formatPriceDisplay(bounds.hi)}`;
    }

    const parts = rawStr.split(/[–-]/);
    if (parts.length === 2) {
      const lo = normalizeCoveoFacetPriceDollars(parseFloat(parts[0]));
      const hi = normalizeCoveoFacetPriceDollars(parseFloat(parts[1]));
      if (Number.isFinite(lo) && Number.isFinite(hi)) {
        return `${formatPriceDisplay(lo)}–${formatPriceDisplay(hi)}`;
      }
    }

    const single = normalizeCoveoFacetPriceDollars(parseFloat(rawStr));
    if (Number.isFinite(single)) {
      return formatPriceDisplay(single);
    }

    return rawStr;
  }

  /**
   * Build a short human-readable description of the active filters/location
   * shown in the no-results heading when the user hasn't typed a keyword.
   */
  function describeAppliedSearchContext(search, container) {
    const parts = [];
    try {
      const root =
        (container && container.nodeType === 1 ? container : null) ||
        document.getElementById("coveo-headless-search") ||
        document.getElementById("coveo-headless-collection") ||
        document;
      const chipLabels = Array.from(
        root.querySelectorAll?.(
          ".coveo-active-filters__chip-text, [data-coveo-chip-remove] .coveo-active-filters__chip-text",
        ) || [],
      )
        .map((el) => String(el.textContent || "").trim())
        .map((text) => text.replace(/^[^:]+:\s*/, "").trim())
        .filter((text) => !/^\d+\s*mi\s+of\b/i.test(text))
        .filter(Boolean);
      if (chipLabels.length) {
        const head = chipLabels.slice(0, 3).join(", ");
        if (chipLabels.length > 3) {
          parts.push(`${head} +${chipLabels.length - 3} more`);
        } else {
          parts.push(head);
        }
      }
      if (!parts.length) {
      const subCtrls =
        (root && root._coveoSubControllers) ||
        (document.getElementById("coveo-headless-search")
          ?._coveoSubControllers) ||
        (document.getElementById("coveo-headless-collection")
          ?._coveoSubControllers) ||
        {};
      const facets = flattenFacetControllers(subCtrls.facetGen);
      const selectedLabels = [];
      facets.forEach((f) => {
        const hiddenFacetId = f.facetId || f.state?.facetId || "";
        if (shouldHideCollectionBrandFacetFromUi(hiddenFacetId)) return;
        const vs = normalizeFacetStateValues(f.state || {});
        vs.forEach((v) => {
          if (v.state === "selected") {
            if (
              isAutoAppliedCollectionBrandFacetValue(
                hiddenFacetId,
                facetItemRawValue(v),
              )
            ) {
              return;
            }
            const formatted = formatNoResultsSelectedFacetLabel(f, v);
            if (formatted) {
              selectedLabels.push(formatted);
            }
          }
        });
      });
      if (selectedLabels.length) {
        const head = selectedLabels.slice(0, 3).join(", ");
        if (selectedLabels.length > 3) {
          parts.push(`${head} +${selectedLabels.length - 3} more`);
        } else {
          parts.push(head);
        }
      }
      }
    } catch (_) { }

    try {
      const Loc = window.CoveoLocationService;
      const loc = getActiveCoveoStoredLocation();
      if (loc && (loc.zip || loc.approxZip || loc.label)) {
        const where = (loc.label || loc.zip || loc.approxZip || "").trim();
        if (where) {
          const radius =
            typeof window.__coveoSelectedRadiusMiles === "number"
              ? window.__coveoSelectedRadiusMiles
              : Number(loc.radiusMiles) || null;
          const normalized = normalizeDistanceRadiusMiles(radius);
          if (normalized) {
            parts.push(`within ${normalized} mi of ${where}`);
          } else {
            parts.push(`near ${where}`);
          }
        }
      }
    } catch (_) { }

    if (!parts.length) return "";
    return `"${parts.join(", ")}"`;
  }

  /**
   * Loads Coveo recommendations into the no-results carousel.
   * Reuses the search engine when possible, but falls back to a standalone
   * recommendations engine when we need saved geo context without mutating the
   * main search engine's request state.
   */
  function resetNoResultsRecommendationsInit(noResultsEl) {
    delete noResultsEl.dataset.coveoRecsInit;
    noResultsEl._coveoRecsLocationKey = null;
  }

  function scheduleNoResultsRecommendationsRetry(container, noResultsEl) {
    const lifecycle = container?._coveoPageLifecycleOwner || null;
    const retryCount =
      parseInt(noResultsEl.dataset.coveoRecsRetryCount || "0", 10) || 0;
    if (
      retryCount >= 2 ||
      noResultsEl.dataset.coveoRecsRetryScheduled === "1"
    ) {
      return;
    }

    noResultsEl.dataset.coveoRecsRetryCount = String(retryCount + 1);
    noResultsEl.dataset.coveoRecsRetryScheduled = "1";
    const schedule = lifecycle
      ? lifecycle.setTimeout
      : setTimeout;
    schedule(function () {
      delete noResultsEl.dataset.coveoRecsRetryScheduled;
      maybeInitNoResultsRecommendations(container, true);
    }, 240 * (retryCount + 1));
  }

  function maybeInitNoResultsRecommendations(container, shouldShowNoResults) {
    if (!shouldShowNoResults || !container) return;
    const lifecycle = container._coveoPageLifecycleOwner || null;
    if (lifecycle && !lifecycle.active) return;
    const engine = container._coveoEngine;
    const noResultsEl =
      container.querySelector?.("#coveo-no-results") ||
      document.getElementById("coveo-no-results");
    if (!noResultsEl) return;
    const slotId = (noResultsEl.dataset.coveoRecSlotId || "").trim();
    if (!slotId) return;
    const grid = noResultsEl.querySelector("[id^=\"coveo-recommendations-grid-\"]");
    if (!grid || !grid.id) return;
    const storedLocation =
      window.CoveoLocationService?.getStoredLocation?.(true) || null;
    const activeLocationContext =
      window.CoveoLocationService?.getContextForCoveo?.() || null;
    const locationContextKey = JSON.stringify({
      lat: activeLocationContext?.location?.latitude ?? storedLocation?.lat ?? null,
      lng: activeLocationContext?.location?.longitude ?? storedLocation?.lng ?? null,
      zip:
        activeLocationContext?.location_zip ??
        storedLocation?.zip ??
        storedLocation?.approxZip ??
        "",
      radius:
        activeLocationContext?.location_radius_miles ??
        storedLocation?.radiusMiles ??
        null,
    });
    if (noResultsEl.dataset.coveoRecsInit === "1") {
      const recommendationRuntime =
        window.MarineMaxHeadlessRecommendationsRuntime;
      const hasActiveRecommendationInstance =
        recommendationRuntime &&
        typeof recommendationRuntime.has === "function"
          ? recommendationRuntime.has(grid.id)
          : null;

      // A failed initialization resolves to `false` and disposes its runtime
      // instance. Do not let the DOM guard permanently block a later render
      // from recovering the no-results carousel.
      if (hasActiveRecommendationInstance === false) {
        resetNoResultsRecommendationsInit(noResultsEl);
      } else {
        if (
          noResultsEl._coveoRecsLocationKey !== locationContextKey &&
          typeof window.refreshCoveoHeadlessRecommendationsLocation ===
            "function"
        ) {
          noResultsEl._coveoRecsLocationKey = locationContextKey;
          window
            .refreshCoveoHeadlessRecommendationsLocation(grid.id, {
              useStoredLocationWithoutRadius: !!storedLocation,
            })
            .catch(function (err) {
              console.warn(
                "[Coveo Search] No-results recommendations location refresh failed:",
                err,
              );
            });
        }
        return;
      }
    }
    if (typeof window.initCoveoHeadlessRecommendations !== "function") {
      if (!noResultsEl.dataset.coveoRecsRetryScheduled) {
        noResultsEl.dataset.coveoRecsRetryScheduled = "1";
        const schedule = lifecycle
          ? lifecycle.setTimeout
          : setTimeout;
        schedule(function () {
          delete noResultsEl.dataset.coveoRecsRetryScheduled;
          maybeInitNoResultsRecommendations(container, true);
        }, 120);
      }
      return;
    }

    noResultsEl.dataset.coveoRecsInit = "1";
    noResultsEl._coveoRecsLocationKey = locationContextKey;
    const limit = parseInt(noResultsEl.dataset.coveoRecLimit || "8", 10) || 8;
    const sectionId = (noResultsEl.dataset.coveoRecSectionId || "").trim();
    const marketRaw = noResultsEl.dataset.coveoRecMarketId || "";
    const marketId =
      marketRaw !== "" && !Number.isNaN(Number(marketRaw))
        ? Number(marketRaw)
        : undefined;
    const configUrl = buildCoveoAppProxyUrl(
      marketId != null ? String(marketId) : "",
    );
    const hasStoredLocation = !!storedLocation;
    const hasActiveLocationContext = !!activeLocationContext;
    const shouldUseStandaloneLocationAwareEngine =
      hasStoredLocation && !hasActiveLocationContext;

    let initialization;
    try {
      initialization = window.initCoveoHeadlessRecommendations({
        containerId: grid.id,
        slotId,
        productId: null,
        limit,
        enableSlider: true,
        sectionId,
        configUrl,
        marketId,
        engine:
          shouldUseStandaloneLocationAwareEngine || !engine ? undefined : engine,
        useStoredLocationWithoutRadius: shouldUseStandaloneLocationAwareEngine,
        syncLocationContext: true,
      });
    } catch (err) {
      console.warn("[Coveo Search] No-results recommendations init failed:", err);
      resetNoResultsRecommendationsInit(noResultsEl);
      scheduleNoResultsRecommendationsRetry(container, noResultsEl);
      return;
    }

    Promise.resolve(initialization)
      .then(function (initialized) {
        if (lifecycle && !lifecycle.active) return;
        if (initialized === true) {
          delete noResultsEl.dataset.coveoRecsRetryCount;
          return;
        }
        resetNoResultsRecommendationsInit(noResultsEl);
        scheduleNoResultsRecommendationsRetry(container, noResultsEl);
      })
      .catch(function (err) {
        if (lifecycle && !lifecycle.active) return;
        console.warn("[Coveo Search] No-results recommendations init failed:", err);
        resetNoResultsRecommendationsInit(noResultsEl);
        scheduleNoResultsRecommendationsRetry(container, noResultsEl);
      });
  }

  function syncCoveoCollectionBelowContentVisibility(shouldShowNoResults) {
    const belowContent = document.getElementById("coveo-collection-below-content");
    if (!belowContent) return;
    belowContent.classList.toggle("hidden", !!shouldShowNoResults);
    belowContent.setAttribute(
      "aria-hidden",
      shouldShowNoResults ? "true" : "false",
    );
  }

  function render(search, container, mod, subControllers = {}) {
    const lifecycle = container?._coveoPageLifecycleOwner || null;
    const isRenderLifecycleActive = function () {
      return (
        (!lifecycle || (lifecycle.active && lifecycle.isCurrent())) &&
        container?.isConnected !== false
      );
    };
    if (!isRenderLifecycleActive()) return;
    if (container && typeof container === "object") {
      container._coveoSearch = search;
      container._coveoMod = mod;
      container._coveoSubControllers = subControllers;
    }
    const state = search.state || {};
    const productsRaw =
      state.products ||
      state.results ||
      (state.searchResponse &&
        (state.searchResponse.products || state.searchResponse.results)) ||
      (state.response &&
        (state.response.products || state.response.results)) ||
      (state.data &&
        (state.data.products ||
          state.data.results ||
          (state.data.response &&
            (state.data.response.products || state.data.response.results)))) ||
      [];
    let products = Array.isArray(productsRaw) ? [...productsRaw] : [];
    products = products.filter((p) => !isCoveoPlaceholderSoldGhostProduct(p));
    const collectionHandle = String(
      container?.dataset?.collectionHandle || "",
    ).trim();
    const normalizedCollectionHandle =
      normalizeCoveoCollectionHandleValue(collectionHandle);
    const isScopedCollectionSearchMode =
      !!normalizedCollectionHandle &&
      normalizedCollectionHandle !== "all" &&
      container?.id === "coveo-headless-collection" &&
      container?._coveoCollectionMode === "search";
    if (isScopedCollectionSearchMode) {
      products = filterCoveoProductsByCollectionHandle(
        products,
        collectionHandle,
      );
      products = filterCoveoProductsByCollectionMembership(
        products,
        container?._coveoCollectionScopeMembership || null,
      );
    }
    const distanceContextActive = !!getActiveCoveoLocationContext();
    const activeSortValue = String(
      window.__coveoActiveSortValue?.() || "",
    ).trim();
    const isNearestProductListing = !!(
      activeSortValue === "nearest" &&
      container?._coveoCollectionMode === "productListing"
    );
    if (isNearestProductListing && products.length > 1) {
      const userLocation = getStoredCoveoLocationContextWithoutRadius({
        ignoreSuppression: true,
      });
      const userLat = Number(userLocation?.location?.latitude);
      const userLng = Number(userLocation?.location?.longitude);
      const haversine =
        window.CoveoLocationService?.haversineDistanceMiles;
      if (
        Number.isFinite(userLat) &&
        Number.isFinite(userLng) &&
        typeof haversine === "function"
      ) {
        products = products
          .map(function (product, index) {
            const coordinates = getProductGeoCoordinates(product);
            const miles = coordinates
              ? haversine(
                  userLat,
                  userLng,
                  coordinates.lat,
                  coordinates.lng,
                )
              : NaN;
            return {
              product: product,
              index: index,
              miles: Number.isFinite(miles) ? miles : Infinity,
            };
          })
          .sort(function (a, b) {
            return a.miles - b.miles || a.index - b.index;
          })
          .map(function (entry) {
            return entry.product;
          });
      }
    }
    const keywordQuery = (getActiveKeywordQuery(search, container) || "").toLowerCase();
    if (
      keywordQuery &&
      products.length > 1 &&
      !distanceContextActive &&
      activeSortValue !== "nearest"
    ) {
      const getSearchableTitle = (p) =>
        String(
          getProductField(p, ["ec_name", "ec_product_name", "name", "title"]) || "",
        ).toLowerCase();
      products.sort((a, b) => {
        const aTitle = getSearchableTitle(a);
        const bTitle = getSearchableTitle(b);
        const aExact = aTitle === keywordQuery;
        const bExact = bTitle === keywordQuery;
        if (aExact !== bExact) return aExact ? -1 : 1;
        const aStarts = aTitle.startsWith(keywordQuery);
        const bStarts = bTitle.startsWith(keywordQuery);
        if (aStarts !== bStarts) return aStarts ? -1 : 1;
        const aContains = aTitle.includes(keywordQuery);
        const bContains = bTitle.includes(keywordQuery);
        if (aContains !== bContains) return aContains ? -1 : 1;
        return 0;
      });
    }
    const error = state.error;
    const isLoading = state.isLoading;
    if (!isLoading) {
      logCoveoServerNearestPage(products, state, subControllers);
    }

    const productsEl =
      container?.querySelector?.("#coveo-products") ||
      document.getElementById("coveo-products");
    const loadingEl =
      container?.querySelector?.("#coveo-loading") ||
      document.getElementById("coveo-loading");
    const errorEl =
      container?.querySelector?.("#coveo-error") ||
      document.getElementById("coveo-error");
    const noResultsEl =
      container?.querySelector?.("#coveo-no-results") ||
      document.getElementById("coveo-no-results");
    const paginationEl =
      container?.querySelector?.("#coveo-pagination") ||
      document.getElementById("coveo-pagination");
    const summaryEls = getCoveoQuerySummaryElements();
    const summaryEl = summaryEls[0] || null;
    syncCoveoToolbarLocationHint();

    const hasReceivedResponse = !!(
      state.response ||
      state.responseId ||
      state.searchResponse
    );
    const inferredTotalResults =
      state.response?.totalCount ??
      state.response?.totalResults ??
      state.totalNumberOfResults ??
      state.totalNumberOfProducts ??
      state.totalCount ??
      state.totalResults ??
      subControllers.summaryCtrl?.state?.total ??
      subControllers.summaryCtrl?.state?.totalCount ??
      subControllers.paginationCtrl?.state?.totalEntries ??
      subControllers.paginationCtrl?.state?.totalCount ??
      subControllers.paginationCtrl?.state?.totalResults ??
      0;
    const response = state.response;
    const explicitTotalFromResponse =
      response &&
        typeof response === "object" &&
        (typeof response.totalCount === "number" ||
          typeof response.totalResults === "number")
        ? Number(response.totalCount ?? response.totalResults ?? 0)
        : null;
    const effectiveTotalForHasResults =
      explicitTotalFromResponse != null &&
        !Number.isNaN(explicitTotalFromResponse)
        ? explicitTotalFromResponse
        : inferredTotalResults;
    const domDistanceVisible =
      typeof window.__coveoDomDistanceVisibleCount === "number"
        ? window.__coveoDomDistanceVisibleCount
        : null;
    const usesServerSideDistanceFiltering =
      distanceContextActive && window.__coveoClientOnlyDistanceFilter === false;
    const activeDistanceCtxKey = distanceContextActive
      ? coveoLocationContextCacheKey(
        getActiveCoveoLocationContext() || null,
      )
      : "";
    const lastAppliedDistanceCtxKey = String(
      window.__coveoDomDistanceAppliedCtxKey || "",
    );

    if (
      distanceContextActive &&
      !usesServerSideDistanceFiltering &&
      !window.__coveoDomDistanceFilterPending &&
      activeDistanceCtxKey &&
      lastAppliedDistanceCtxKey &&
      lastAppliedDistanceCtxKey !== activeDistanceCtxKey
    ) {
      window.__coveoDomDistanceFilterPending = true;
      window.__coveoDomDistanceVisibleCount = null;
      window.__coveoDistanceFilterNoIndexedGeo = false;
      window.__coveoDistanceFilterGracefulFallback = false;
    }

    /*
     * When Coveo is already filtering distance server-side, a stale DOM-side
     * visible count from the previous render must never hide fresh `products`
     * returned by Commerce. Treat the incoming product payload as the source
     * of truth and reset the local distance bookkeeping around it.
     */
    if (usesServerSideDistanceFiltering && !isLoading && hasReceivedResponse) {
      window.__coveoDomDistanceFilterPending = false;
      window.__coveoDistanceFilterNoIndexedGeo = false;
      window.__coveoDistanceFilterGracefulFallback = false;
      window.__coveoClientDistanceFilterActive = false;
      window.__coveoDomDistanceVisibleCount = products.length;
    }
    const hasAnyResults = distanceContextActive
      ? window.__coveoDomDistanceFilterPending
        ? true
        : usesServerSideDistanceFiltering
          ? products.length > 0
          : domDistanceVisible != null
          ? domDistanceVisible > 0
          : products.length > 0
      : products.length > 0 || effectiveTotalForHasResults > 0;
    const isFacetValuesRefresh = !!window.__coveoFacetValuesRefreshInFlight;
    const showLoading =
      !isFacetValuesRefresh &&
      (isLoading || (products.length === 0 && !error && !hasReceivedResponse));
    const shouldShowNoResults =
      !error &&
      !showLoading &&
      hasReceivedResponse &&
      !hasAnyResults;
    const suppressProductRenderUntil = Number(
      container?._coveoSuppressProductRenderUntil || 0,
    );
    const suppressProductRender =
      suppressProductRenderUntil > Date.now() &&
      !!productsEl &&
      !!String(productsEl.innerHTML || "").trim();
    if (suppressProductRender) {
      const remaining = Math.max(
        48,
        suppressProductRenderUntil - Date.now() + 24,
      );
      if (container?._coveoDeferredProductRenderTimer) {
        if (lifecycle) {
          lifecycle.clearTimeout(container._coveoDeferredProductRenderTimer);
        } else {
          window.clearTimeout(container._coveoDeferredProductRenderTimer);
        }
      }
      if (container) {
      const schedule = lifecycle
        ? lifecycle.setTimeout
        : setTimeout;
        container._coveoDeferredProductRenderTimer = schedule(function () {
          container._coveoDeferredProductRenderTimer = null;
          render(search, container, mod, subControllers);
        }, remaining);
      }
    }

    if (loadingEl) loadingEl.classList.toggle("hidden", !showLoading);
    if (errorEl) errorEl.classList.add("hidden");
    if (noResultsEl) noResultsEl.classList.toggle("hidden", !shouldShowNoResults);
    if (!showLoading && typeof window.__coveoStabilizeSearchPageUi === "function") {
      const scheduleFrame = lifecycle
        ? lifecycle.requestAnimationFrame
        : window.requestAnimationFrame.bind(window);
      scheduleFrame(function () {
        window.__coveoStabilizeSearchPageUi({ delay: 0 });
      });
    }
    syncCoveoCollectionBelowContentVisibility(shouldShowNoResults);

    if (error) {
      if (errorEl) {
        errorEl.textContent = error.message || "Search error";
        errorEl.classList.remove("hidden");
      }
      if (productsEl) {
        productsEl.innerHTML = "";
        productsEl.dataset.currentProducts = "";
        productsEl.dataset.currentRenderKey = "";
      }
      if (noResultsEl) noResultsEl.classList.add("hidden");
      syncCoveoCollectionBelowContentVisibility(false);
      renderActiveFacetChips(null, search, container);
      syncCoveoToolbarPresentation(search, container);
      return;
    }

    if (suppressProductRender) {
      renderPagination(subControllers.paginationCtrl, paginationEl);
      renderFacets(subControllers.facetGen, {
        controller: search,
        container,
        engine: container && container._coveoEngine,
        mod,
      });
      renderActiveFacetChips(subControllers.facetGen, search, container);
      syncCoveoToolbarPresentation(search, container);
      return;
    }

    if (!isLoading) {
      if (shouldShowNoResults) {
        if (noResultsEl) noResultsEl.classList.remove("hidden");
        if (productsEl) {
          productsEl.innerHTML = "";
          productsEl.dataset.currentProducts = "";
          productsEl.dataset.currentRenderKey = "";
        }
      } else {
        if (isCoveoProductNavigationPendingActive()) {
          return;
        }
        if (noResultsEl) noResultsEl.classList.add("hidden");
        if (productsEl && products.length === 0 && hasReceivedResponse) {
          productsEl.innerHTML = "";
          productsEl.dataset.currentProducts = "";
          productsEl.dataset.currentRenderKey = "";
        }
        if (productsEl && products.length > 0) {
          const locCtxForKey = getActiveCoveoLocationContext() || null;
          const distanceKey = locCtxForKey
            ? `${locCtxForKey.location_lat},${locCtxForKey.location_lng},${locCtxForKey.location_radius_miles}`
            : "all";
          const productIds = `${products
            .map((p) => p.permanentid || p.clickUri || "")
            .join(",")}::dist=${distanceKey}`;
          const renderKey = `${productIds}::${state.responseId || "no-response-id"}`;
          const hasHydratedCards = !!productsEl.querySelector(
            ".coveo-search-card:not(.coveo-search-card--skeleton), .coveo-boat-card",
          );
          const hydrationInProgress =
            productsEl.dataset.coveoHydrating === "1" &&
            productsEl.dataset.currentProducts === productIds;
          const sameProducts =
            productsEl.dataset.currentProducts === productIds &&
            (hasHydratedCards || hydrationInProgress);
          if (!sameProducts) {
            productsEl.innerHTML = products
              .map((product) =>
                attachCoveoProductKeyToCardHtml(
                  renderSkeletonCard(),
                  getCoveoStableProductKey(product),
                ),
              )
              .join("");
            getCoveoDistanceGridItems(productsEl).forEach((item, index) => {
              setCoveoSourceIndex(item, index);
            });
            productsEl.dataset.currentRenderKey = renderKey;
            productsEl.dataset.coveoHydrating = "1";
          }
          if (!sameProducts) (async () => {
            const idsAtStart = productIds;
            const renderKeyAtStart = renderKey;
            let flushHydratedSlotsTimer = 0;
            try {
              if (locCtxForKey && !usesServerSideDistanceFiltering) {
                window.__coveoDomDistanceFilterPending = true;
                window.__coveoDomDistanceVisibleCount = null;
              }
              let fetchedCardCount = 0;
              let fallbackCardCount = 0;
              let confirmedOffMarketCardCount = 0;
              let transientFallbackCardCount = 0;
              const hydrationReasonCounts = Object.create(null);
              const n = products.length;
              const hydrationConcurrency =
                COVEO_LIQUID_PRODUCT_SECTION_FETCH_CONCURRENCY_PROGRESSIVE;
              const workers = Math.min(
                hydrationConcurrency,
                Math.max(1, n),
              );
              let nextIndex = 0;
              const hydratedHtmlByIndex = new Array(n);
              const pendingHydratedIndices = new Set();
              const progressiveFlushBatchSize = Math.max(
                2,
                Math.min(3, workers),
              );

              function buildResolvedProductCardHtml(index) {
                const html = hydratedHtmlByIndex[index];
                if (html && String(html).trim()) return String(html);
                const product = products[index];
                const stableKey = getCoveoStableProductKey(product);
                return attachCoveoProductKeyToCardHtml(
                  renderBoatCard(product),
                  stableKey,
                  product,
                );
              }

              function recordHydrationReason(reason) {
                const key = String(reason || "unknown");
                hydrationReasonCounts[key] =
                  Number(hydrationReasonCounts[key] || 0) + 1;
              }

              function flushHydratedSlots() {
                if (
                  !isRenderLifecycleActive() ||
                  productsEl.dataset.currentRenderKey !== renderKeyAtStart
                ) {
                  pendingHydratedIndices.clear();
                  return;
                }
                if (pendingHydratedIndices.size === 0) return;
                // Nearest sorting needs all dealer coordinates before revealing
                // cards, so the final order is ready on their first paint.
                if (activeSortValue === "nearest") {
                  for (let slot = 0; slot < n; slot++) {
                    if (!hydratedHtmlByIndex[slot]) return;
                  }
                }
                // Each resolved slot is revealed once; the final flush must not
                // replace cards (and loaded images) already inserted earlier.
                const columnTracks = window.getComputedStyle(productsEl)
                  .gridTemplateColumns.trim().split(/\s+/);
                const columns = Math.max(1, columnTracks.length);
                const indices = Array.from(pendingHydratedIndices).filter(function (index) {
                  // Reveal a complete row so a later, taller badge cannot resize
                  // neighbouring cards that are already visible.
                  const rowStart = Math.floor(index / columns) * columns;
                  const rowEnd = Math.min(n, rowStart + columns);
                  for (let slot = rowStart; slot < rowEnd; slot++) {
                    if (!hydratedHtmlByIndex[slot]) return false;
                  }
                  return true;
                }).sort(function (a, b) {
                  return a - b;
                });
                indices.forEach(function (index) {
                  pendingHydratedIndices.delete(index);
                  const currentSlot = productsEl.children[index];
                  if (!currentSlot) return;
                  const tmp = document.createElement("div");
                  tmp.innerHTML = buildResolvedProductCardHtml(index);
                  const nextEl = tmp.firstElementChild;
                  if (!nextEl) return;
                  currentSlot.replaceWith(nextEl);
                });
                getCoveoDistanceGridItems(productsEl).forEach(function (item, index) {
                  setCoveoSourceIndex(item, index);
                });
              }

              function scheduleHydratedSlotsFlush() {
                if (productsEl.dataset.currentRenderKey !== renderKeyAtStart) {
                  pendingHydratedIndices.clear();
                  return;
                }
                if (pendingHydratedIndices.size >= progressiveFlushBatchSize) {
                  if (flushHydratedSlotsTimer) {
                    if (lifecycle) lifecycle.clearTimeout(flushHydratedSlotsTimer);
                    else window.clearTimeout(flushHydratedSlotsTimer);
                    flushHydratedSlotsTimer = 0;
                  }
                  flushHydratedSlots();
                  return;
                }
                if (flushHydratedSlotsTimer) return;
                const schedule = lifecycle
                  ? lifecycle.setTimeout
                  : setTimeout;
                flushHydratedSlotsTimer = schedule(function () {
                  flushHydratedSlotsTimer = 0;
                  flushHydratedSlots();
                }, COVEO_LIQUID_PRODUCT_PROGRESSIVE_FLUSH_DELAY_MS);
              }

              async function hydrateOneSlot(i) {
                if (
                  !isRenderLifecycleActive() ||
                  productsEl.dataset.currentRenderKey !== renderKeyAtStart
                ) {
                  return;
                }
                const p = products[i];
                if (shouldSkipLiquidCardHydrationForResult(container, i)) {
                  const fallbackHtml = attachCoveoProductKeyToCardHtml(
                    renderBoatCard(p),
                    getCoveoStableProductKey(p),
                    p,
                  );
                  hydratedHtmlByIndex[i] = fallbackHtml;
                  fallbackCardCount += 1;
                  transientFallbackCardCount += 1;
                  recordHydrationReason("hydration-skipped");
                  pendingHydratedIndices.add(i);
                  scheduleHydratedSlotsFlush();
                  return;
                }
                let cardResult;
                try {
                  cardResult = await fetchLiquidProductCardResult(
                    p.clickUri,
                    p,
                    {
                      shouldContinue: function () {
                        return (
                          isRenderLifecycleActive() &&
                          productsEl.dataset.currentRenderKey === renderKeyAtStart
                        );
                      },
                    },
                  );
                } catch (_) {
                  cardResult = {
                    status:
                      COVEO_LIQUID_PRODUCT_CARD_FETCH_STATUS.TRANSIENT_FAILURE,
                    html: "",
                    reason: "unexpected-hydration-error",
                  };
                }
                if (
                  !isRenderLifecycleActive() ||
                  productsEl.dataset.currentRenderKey !== renderKeyAtStart
                ) {
                  return;
                }
                const stableKey = getCoveoStableProductKey(p);
                const hasLiquidCard =
                  cardResult?.status ===
                    COVEO_LIQUID_PRODUCT_CARD_FETCH_STATUS.OK &&
                  !!String(cardResult?.html || "").trim();
                const isConfirmedUnavailable =
                  cardResult?.status ===
                  COVEO_LIQUID_PRODUCT_CARD_FETCH_STATUS.CONFIRMED_UNAVAILABLE;
                const rawCardHtml = hasLiquidCard
                  ? String(cardResult.html).trim()
                  : isConfirmedUnavailable
                    ? renderOffMarketCard(p)
                    : renderBoatCard(p);
                const html = attachCoveoProductKeyToCardHtml(
                  rawCardHtml,
                  stableKey,
                  p,
                );
                cacheProductGeoFromCardHtml(stableKey, html);
                recordHydrationReason(cardResult?.reason);
                if (hasLiquidCard) {
                  fetchedCardCount += 1;
                } else {
                  fallbackCardCount += 1;
                  if (isConfirmedUnavailable) {
                    confirmedOffMarketCardCount += 1;
                  } else {
                    transientFallbackCardCount += 1;
                  }
                }
                hydratedHtmlByIndex[i] = html;
                pendingHydratedIndices.add(i);
                scheduleHydratedSlotsFlush();
              }

              async function worker() {
                while (isRenderLifecycleActive()) {
                  const i = nextIndex++;
                  if (i >= n) break;
                  await hydrateOneSlot(i);
                }
              }

              await Promise.all(
                Array.from({ length: workers }, () => worker()),
              );

              if (!isRenderLifecycleActive()) return;

              if (productsEl.dataset.currentRenderKey === renderKeyAtStart) {
                if (flushHydratedSlotsTimer) {
                  if (lifecycle) lifecycle.clearTimeout(flushHydratedSlotsTimer);
                  else window.clearTimeout(flushHydratedSlotsTimer);
                  flushHydratedSlotsTimer = 0;
                }
                for (let index = 0; index < n; index++) {
                  if (hydratedHtmlByIndex[index] && String(hydratedHtmlByIndex[index]).trim()) {
                    continue;
                  }
                  hydratedHtmlByIndex[index] = buildResolvedProductCardHtml(index);
                  pendingHydratedIndices.add(index);
                }
                flushHydratedSlots();
                if (isNearestProductListing) {
                  applyNearestSortToProductGrid(productsEl);
                }
                logCoveoCollectionNearestDomOrder(
                  productsEl,
                  container,
                  subControllers,
                );
                if (noResultsEl && productsEl.querySelector(".coveo-search-card, .coveo-boat-card")) {
                  const distCtx = getActiveCoveoLocationContext();
                  const distVisible = window.__coveoDomDistanceVisibleCount;
                  const distPending = window.__coveoDomDistanceFilterPending;
                  const keepNoResultsForDistance =
                    distCtx &&
                    (distPending ||
                      (typeof distVisible === "number" && distVisible === 0));
                  if (!keepNoResultsForDistance) {
                    noResultsEl.classList.add("hidden");
                  }
                }
              }

              if (productsEl.dataset.currentRenderKey === renderKeyAtStart) {
                void applyDomDistanceFilterToProductGrid(
                  productsEl,
                  summaryEl,
                ).then(() => {
                  if (
                    isRenderLifecycleActive() &&
                    productsEl.dataset.currentRenderKey === renderKeyAtStart
                  ) {
                    refreshCoveoDistanceSummaryAndPagination();
                  }
                });
              }

              if (
                productsEl &&
                productsEl.dataset.currentProducts === idsAtStart &&
                productsEl.dataset.currentRenderKey === renderKeyAtStart
              ) {
                try {
                  const hydrationSummary = {
                    totalProducts: n,
                    renderedCards: n,
                    fetchedCardCount,
                    fallbackCardCount,
                    confirmedOffMarketCardCount,
                    transientFallbackCardCount,
                    hydrationReasonCounts: { ...hydrationReasonCounts },
                    concurrency: workers,
                    page: subControllers.paginationCtrl?.state?.page ?? null,
                    progressiveHydration: true,
                    batchedHydration: true,
                  };
                  window.__coveoSearchCardsHydrationLast = hydrationSummary;
                  console.debug("[Coveo Search Cards]", hydrationSummary);
                } catch (_) { }
              }
            } finally {
              if (flushHydratedSlotsTimer) {
                if (lifecycle) lifecycle.clearTimeout(flushHydratedSlotsTimer);
                else window.clearTimeout(flushHydratedSlotsTimer);
              }
              if (
                isRenderLifecycleActive() &&
                productsEl.dataset.currentRenderKey === renderKeyAtStart
              ) {
                productsEl.dataset.coveoHydrating = "";
              }
            }
          })();
          productsEl.dataset.currentProducts = productIds;
          mmScheduleViewItemListPush(container, products, state);
          if (sameProducts && isNearestProductListing && !hydrationInProgress) {
            applyNearestSortToProductGrid(productsEl);
          }
          if (sameProducts && locCtxForKey &&
            (!hydrationInProgress || usesServerSideDistanceFiltering)) {
            void applyDomDistanceFilterToProductGrid(
              productsEl,
              summaryEl,
            ).then(() => {
              if (isRenderLifecycleActive()) {
                refreshCoveoDistanceSummaryAndPagination();
              }
            });
          }
        }
      }
    }

    if (summaryEl && !isCoveoFilterPresentationPending(search, container)) {
      const summaryState = subControllers.summaryCtrl?.state ?? {};
      const pagState = subControllers.paginationCtrl?.state ?? {};
      const responsePag = state.response?.pagination ?? state.pagination ?? {};
      const rawPage =
        pagState.page ?? responsePag.page ?? responsePag.pageIndex ?? 0;
      const page = rawPage + 1;
      const totalPages = Math.max(
        pagState.totalPages ?? responsePag.totalPages ?? 1,
        1,
      );
      const perPage =
        pagState.pageSize ??
        responsePag.pageSize ??
        responsePag.perPage ??
        products.length;
      let total =
        pagState.totalEntries ??
        responsePag.totalEntries ??
        responsePag.totalResults ??
        responsePag.totalCount ??
        summaryState.total ??
        summaryState.totalCount ??
        pagState.totalCount ??
        pagState.totalResults ??
        responsePag.totalCount ??
        state.response?.totalCount ??
        state.response?.totalResults ??
        state.totalNumberOfResults ??
        state.totalNumberOfProducts ??
        state.totalCount ??
        state.totalResults ??
        0;
      if (total === 0 && totalPages > 1 && perPage > 0) {
        total =
          page >= totalPages
            ? (page - 1) * perPage + products.length
            : totalPages * perPage;
      }
      if (total === 0 && products.length > 0 && totalPages <= 1) {
        total = products.length;
      }
      let first =
        summaryState.firstResult ??
        responsePag.firstResult ??
        responsePag.first ??
        0;
      let last =
        summaryState.lastResult ??
        responsePag.lastResult ??
        responsePag.last ??
        0;
      if ((first <= 0 || last <= 0) && products.length > 0) {
        if (total > 0 && page >= totalPages) {
          first = total - products.length + 1;
          last = total;
        } else {
          first = (page - 1) * perPage + 1;
          last = first + products.length - 1;
        }
      }
      if (first <= 0 && products.length > 0) {
        first = 1;
      }
      if (last <= 0 && products.length > 0) {
        last = first + products.length - 1;
      }
      if (last > total && total > 0) total = last;
      if (total === 0 && last > 0) total = last;
      last = total > 0 ? Math.min(last, total) : last;
      if (distanceContextActive) {
        window.__coveoDistanceServerSummary = { first, last, total };
      } else {
        window.__coveoDistanceServerSummary = null;
      }
      const itemsLabel = summaryEl.dataset.itemsLabel || "Boats";
      const foundLabel = summaryEl.dataset.foundLabel || "Found";
      const activeQueryText = String(
        getActiveKeywordQuery(search, container) || "",
      ).trim();
      const formatShortResultsText = (value, queryText) => {
        const safeValue = Math.max(0, Number(value) || 0);
        if (safeValue <= 0) return "";
        const baseText = `${safeValue.toLocaleString()} Results`;
        return queryText ? `${baseText} for "${queryText}"` : baseText;
      };
      const mobileResolvedTotal =
        distanceContextActive &&
        typeof window.__coveoDomDistanceVisibleCount === "number"
          ? window.__coveoDomDistanceVisibleCount
          : total > 0
            ? total
            : products.length;
      let text = "";
      if (distanceContextActive) {
        if (window.__coveoDomDistanceFilterPending) {
          text = activeQueryText
            ? `Finding results for "${activeQueryText}"…`
            : "Finding results…";
        } else if (
          typeof window.__coveoDomDistanceVisibleCount === "number"
        ) {
          const v = window.__coveoDomDistanceVisibleCount;
          if (window.__coveoDistanceFilterGracefulFallback) {
            text = formatShortResultsText(
              total > 0 ? total : products.length,
              activeQueryText,
            );
          } else if (v > 0) {
            text = formatShortResultsText(
              usesServerSideDistanceFiltering && total > 0 && first > 0
                ? total
                : v,
              activeQueryText,
            );
          } else if (window.__coveoDistanceFilterNoIndexedGeo) {
            text = activeQueryText
              ? `0 Results for "${activeQueryText}"`
              : "0 Results";
          } else {
            text = activeQueryText
              ? `0 Results for "${activeQueryText}"`
              : "0 Results";
          }
        } else {
          text = activeQueryText
            ? `Finding results for "${activeQueryText}"…`
            : "Finding results…";
        }
      } else if ((total > 0 || products.length > 0) && first > 0) {
        const resolvedTotal = total > 0 ? total : products.length;
        text = formatShortResultsText(resolvedTotal, activeQueryText);
      } else if (activeQueryText) {
        text = `0 Results for "${activeQueryText}"`;
      }
      summaryEls.forEach((el) => {
        if (el.classList.contains("coveo-query-summary--mobile")) {
          const shortTotal = Math.max(0, mobileResolvedTotal || 0);
          el.textContent =
            shortTotal > 0
              ? formatShortResultsText(shortTotal, activeQueryText)
              : activeQueryText
                ? `0 Results for "${activeQueryText}"`
                : "";
          el.setAttribute("title", el.textContent);
          return;
        }
        el.textContent = text;
        el.setAttribute("title", text);
      });

      if (productsEl && distanceContextActive) {
        syncCoveoDistanceProductsGridVisibility(productsEl);
        if (
          !window.__coveoDomDistanceFilterPending &&
          !window.__coveoDistanceFilterGracefulFallback &&
          typeof window.__coveoDomDistanceVisibleCount === "number" &&
          window.__coveoDomDistanceVisibleCount === 0
        ) {
          if (noResultsEl) {
            noResultsEl.classList.remove("hidden");
            const heading = noResultsEl.querySelector(
              "#coveo-no-results-heading, .coveo-no-results__heading, h2, h3, h4",
            );
            if (heading) {
              const distanceLoc = getActiveCoveoStoredLocation() || null;
              const distanceRadius =
                typeof window.__coveoSelectedRadiusMiles === "number"
                  ? window.__coveoSelectedRadiusMiles
                  : Number(distanceLoc?.radiusMiles) || null;
              const normalizedDistanceRadius =
                normalizeDistanceRadiusMiles(distanceRadius);
              heading.textContent = window.__coveoDistanceFilterNoIndexedGeo
                ? "No boats with location data for distance filtering. Try removing the distance filter."
                : normalizedDistanceRadius
                  ? `No boats within ${normalizedDistanceRadius} mi on this page. Try a larger radius or remove the distance filter.`
                  : "No boats within the selected distance on this page. Try a larger radius or remove the distance filter.";
            }
          }
        }
      }

      if (
        distanceContextActive &&
        paginationEl &&
        !usesServerSideDistanceFiltering &&
        !window.__coveoDomDistanceFilterPending
      ) {
        const visible = window.__coveoDomDistanceVisibleCount;
        if (typeof visible === "number") {
          paginationEl.innerHTML = "";
        }
      }

      const filtersModalTotal = document.getElementById(
        "coveo-filters-modal-total",
      );
      const filtersApplyLabel = document.querySelector(
        "#coveo-apply-filters .btn__text",
      );
      const resolvedTotal = total > 0 ? total : products.length;
      if (filtersModalTotal) {
        filtersModalTotal.textContent =
          resolvedTotal > 0 ? `${resolvedTotal} ${itemsLabel}` : "";
      }
      if (filtersApplyLabel) {
        filtersApplyLabel.textContent = "View Results";
      }
    }

    renderPagination(subControllers.paginationCtrl, paginationEl);
    renderFacets(subControllers.facetGen, {
      controller: search,
      container,
      engine: container && container._coveoEngine,
      mod,
    });
    renderActiveFacetChips(subControllers.facetGen, search, container);
    if (hasReceivedResponse && getPendingInitialCoveoUrlState() && !isLoading) {
      schedulePendingInitialCoveoUrlHydration(
        search,
        subControllers,
        container && container._coveoEngine,
        mod,
      );
    }
    syncCoveoStateToUrl(search, subControllers, container);
    syncCoveoToolbarPresentation(search, container);

    if (
      !error &&
      !showLoading &&
      hasReceivedResponse &&
      typeof window.__coveoScheduleSearchLocationPrompt === "function"
    ) {
      window.__coveoScheduleSearchLocationPrompt({
        isSearchOrPlp: true,
        hasInteraction: hasCoveoSearchOrFilterInteraction(
          search,
          subControllers,
        ),
        hasResults: hasAnyResults,
        requireInventoryVisible: true,
      });
    }

    if (!error && shouldShowNoResults) {
      syncCoveoNoResultsHeading(noResultsEl, search, container);
      maybeInitNoResultsRecommendations(container, true);
    }
  }

  function renderPagination(paginationCtrl, paginationEl) {
    if (!paginationEl || !paginationCtrl?.state) {
      if (paginationEl) paginationEl.innerHTML = "";
      return;
    }
    const p = paginationCtrl.state;
    const totalPages = p.totalPages || 1;
    if (totalPages <= 1) {
      paginationEl.innerHTML = "";
      return;
    }

    const rawPage = p.page ?? 0;
    const isZeroBased =
      rawPage === 0 || (rawPage < totalPages && totalPages > 1);
    const currentPage = isZeroBased ? rawPage + 1 : rawPage;

    const showPages = [];
    const windowSize = 3;
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) showPages.push(i);
    } else {
      showPages.push(1);
      const rangeStart = Math.max(2, currentPage - windowSize);
      const rangeEnd = Math.min(totalPages - 1, currentPage + windowSize);
      if (rangeStart > 2) showPages.push(0);
      for (let i = rangeStart; i <= rangeEnd; i++) showPages.push(i);
      if (rangeEnd < totalPages - 1) showPages.push(0);
      if (totalPages > 1) showPages.push(totalPages);
    }

    let pagesHtml = "";
    if (currentPage > 1) {
      pagesHtml += `<button type="button" class="coveo-pagination__btn coveo-pagination__btn--prev" data-action="prev" aria-label="Previous page"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M8 2L4 6l4 4"/></svg> Previous</button>`;
    }
    showPages.forEach((i) => {
      if (i === 0) {
        pagesHtml += `<span class="coveo-pagination__ellipsis" aria-hidden="true">...</span>`;
      } else {
        const active = i === currentPage;
        pagesHtml += `<button type="button" class="coveo-pagination__btn ${active ? "coveo-pagination__btn--current" : ""}" data-page="${i}" aria-label="${active ? `Current page, Page ${i}` : `Page ${i}`}"${active ? ' aria-current="page"' : ""}>${i}</button>`;
      }
    });
    if (currentPage < totalPages) {
      pagesHtml += `<button type="button" class="coveo-pagination__btn coveo-pagination__btn--next" data-action="next" aria-label="Next page">Next <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 2l4 4-4 4"/></svg></button>`;
    }

    paginationEl.innerHTML = `<nav class="coveo-pagination__nav" aria-label="Pagination"><div class="coveo-pagination__inner">${pagesHtml}</div></nav>`;

    const toApiPage = (displayPage) =>
      isZeroBased ? displayPage - 1 : displayPage;

    paginationEl.querySelectorAll("[data-action=prev]").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (window.__coveoCollectionScopePrefetchLoading === true) return;
        paginationCtrl.previousPage?.();
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    });
    paginationEl.querySelectorAll("[data-action=next]").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (window.__coveoCollectionScopePrefetchLoading === true) return;
        paginationCtrl.nextPage?.();
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    });
    paginationEl.querySelectorAll("[data-page]").forEach((btn) => {
      const displayPage = parseInt(btn.dataset.page, 10);
      btn.addEventListener("click", () => {
        if (window.__coveoCollectionScopePrefetchLoading === true) return;
        paginationCtrl.selectPage?.(toApiPage(displayPage));
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    });
  }

  /** When "Apply Filter" is present, range UI updates locally until Apply (avoids re-rendering the drawer on each drag). */
  function shouldDeferRangeFacetCommitUntilApply() {
    try {
      return (
        !isCoveoRealtimeFilterApplyEnabled() &&
        !!document.getElementById("coveo-apply-filters")
      );
    } catch (_) {
      return false;
    }
  }

  /**
   * Several facets (Condition tiles, Make/Boat-type rows) hide the native
   * checkbox and rely on an `is-selected` class on the wrapping label to
   * paint the selected state. Native checkbox toggling alone gives no
   * visible feedback for those facets, so we mirror the live `checked`
   * value onto the closest label that opts into class-based styling.
   */
  function syncFacetCheckboxLabelSelectedClass(cb) {
    if (!cb) return;
    const label = cb.closest(
      "label.coveo-mobile-condition-tile, label.coveo-mobile-boat-option, label.coveo-facet-value",
    );
    if (!label) return;
    if (cb.checked) {
      label.classList.add("is-selected");
    } else {
      label.classList.remove("is-selected");
    }
  }

  function syncConditionAllCheckboxState(root) {
    if (!root) return;
    root.querySelectorAll("[data-condition-facet]").forEach(function (grid) {
      const allCheckbox = grid.querySelector(
        'input[type="checkbox"][data-condition-all]',
      );
      if (!allCheckbox) return;
      const hasSelectedCondition = Array.from(
        grid.querySelectorAll('input[type="checkbox"][data-value]'),
      ).some(function (checkbox) {
        return checkbox.checked;
      });
      allCheckbox.checked = !hasSelectedCondition;
      syncFacetCheckboxLabelSelectedClass(allCheckbox);
    });
  }

  /**
   * When the facets re-render (because of an external search refresh), the
   * freshly generated checkbox/show-all DOM reflects the engine state and
   * loses any pending changes the user staged in the drawer. Re-apply those
   * pending changes so the user's drawer choices stay visible until they
   * click Apply Filter.
   */
  function captureBoatSearchFocus(content) {
    if (!content) return null;
    const active = document.activeElement;
    if (
      !active ||
      !content.contains(active) ||
      !active.classList?.contains("coveo-mobile-boat-search__input")
    ) {
      return null;
    }
    const facetId = active
      .closest?.(".coveo-mobile-boat-search")
      ?.getAttribute("data-boat-search-for");
    if (!facetId) return null;
    let selStart = null;
    let selEnd = null;
    try {
      selStart = active.selectionStart;
      selEnd = active.selectionEnd;
    } catch (_) { }
    return { facetId, selStart, selEnd };
  }

  function restoreBoatSearchFocus(content, snapshot) {
    if (!content || !snapshot || !snapshot.facetId) return;
    const input = content.querySelector(
      '.coveo-mobile-boat-search[data-boat-search-for="' +
        escapeAttr(snapshot.facetId) +
        '"] .coveo-mobile-boat-search__input',
    );
    if (!input) return;
    try {
      input.focus({ preventScroll: true });
      if (snapshot.selStart != null && snapshot.selEnd != null) {
        input.setSelectionRange(snapshot.selStart, snapshot.selEnd);
      }
    } catch (_) { }
  }

  function captureBoatFacetScrollSnapshot(menu) {
    if (!menu) return null;
    const facetId = menu.getAttribute("data-boat-options-for");
    if (!facetId) return null;
    const top = Math.max(0, Number(menu.scrollTop) || 0);
    const clientHeight = Math.max(0, Number(menu.clientHeight) || 0);
    const scrollHeight = Math.max(0, Number(menu.scrollHeight) || 0);
    return {
      facetId,
      top,
      clientHeight,
      distanceToBottom: Math.max(0, scrollHeight - (top + clientHeight)),
      preserveBottomAnchor: true,
    };
  }

  function captureFacetsDrawerScrollSnapshot(content) {
    const scrollRoot = content?.closest?.(".drawer__body");
    if (!scrollRoot) return null;
    return {
      top: Math.max(0, Number(scrollRoot.scrollTop) || 0),
    };
  }

  function restoreFacetsDrawerScrollPosition(content, snapshot) {
    const scrollRoot = content?.closest?.(".drawer__body");
    if (!scrollRoot || !snapshot) return;
    try {
      scrollRoot.scrollTop = Math.max(0, Number(snapshot.top) || 0);
    } catch (_) { }
  }

  function setPendingBoatFacetScrollRestore(content, snapshot) {
    if (!content) return;
    content._coveoPendingBoatFacetScrollRestore =
      snapshot && snapshot.facetId ? snapshot : null;
  }

  function restorePendingBoatFacetScrollPosition(content) {
    const snapshot = content?._coveoPendingBoatFacetScrollRestore;
    if (!content || !snapshot?.facetId) return;
    const menu = content.querySelector(
      '.coveo-mobile-boat-options[data-boat-options-for="' +
        escapeAttr(snapshot.facetId) +
        '"]',
    );
    if (!menu) return;
    let nextTop = Math.max(0, Number(snapshot.top) || 0);
    if (
      snapshot.preserveBottomAnchor !== false &&
      Number(snapshot.distanceToBottom) <= 64
    ) {
      nextTop = Math.max(
        0,
        Number(menu.scrollHeight || 0) -
          Number(menu.clientHeight || 0) -
          Math.max(0, Number(snapshot.distanceToBottom) || 0),
      );
    }
    try {
      menu.scrollTop = nextTop;
    } catch (_) { }
  }

  function setBoatFacetLoadingState(content, facetId, isLoading) {
    if (!content || !facetId) return;
    const menu = content.querySelector(
      '.coveo-mobile-boat-options[data-boat-options-for="' +
        escapeAttr(facetId) +
        '"]',
    );
    const inner = menu?.closest(".coveo-mobile-boat-facet-inner");
    if (menu) {
      menu.classList.toggle("is-loading", !!isLoading);
      menu.setAttribute("aria-busy", isLoading ? "true" : "false");
    }
    if (inner) {
      inner.classList.toggle("is-loading", !!isLoading);
      if (isLoading) {
        inner.setAttribute("data-loading-label", "Loading more...");
      } else {
        inner.removeAttribute("data-loading-label");
      }
    }
  }

  function getBoatFacetLoadMoreMinAdvance(menu) {
    const clientHeight = Math.max(0, Number(menu?.clientHeight) || 0);
    const isDesktopViewport =
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia("(min-width: 768px)").matches;
    if (isDesktopViewport) {
      return Math.max(8, Math.round(clientHeight * 0.04));
    }
    return Math.max(32, Math.round(clientHeight * 0.18));
  }

  function setPendingBoatFacetAppend(content, facetId) {
    if (!content || !facetId) return;
    content._coveoPendingBoatFacetAppend = {
      facetId: String(facetId).trim(),
    };
  }

  function clearPendingBoatFacetAppend(content, facetId) {
    if (!content) return;
    const pending = content._coveoPendingBoatFacetAppend;
    if (!pending) return;
    if (facetId && String(pending.facetId || "") !== String(facetId || "")) {
      return;
    }
    content._coveoPendingBoatFacetAppend = null;
  }

  function markBoatFacetAppendApplied(content, facetId, durationMs = 1200) {
    if (!content || !facetId) return;
    content._coveoBoatFacetAppendApplied = {
      facetId: String(facetId).trim(),
      until: Date.now() + Math.max(0, Number(durationMs) || 0),
    };
  }

  function hasRecentBoatFacetAppendApplied(content) {
    const state = content?._coveoBoatFacetAppendApplied;
    if (!state?.facetId) return false;
    if (Number(state.until || 0) <= Date.now()) {
      content._coveoBoatFacetAppendApplied = null;
      return false;
    }
    return true;
  }

  function renderSearchableFacetOptionMarkup(
    facetId,
    label,
    value,
    options = {},
  ) {
    const valueStr = String(facetItemRawValue(value));
    if (shouldSuppressFacetValue(facetId, label, valueStr)) return "";
    const checked =
      value.state === "selected" &&
      !isAutoAppliedCollectionBrandFacetValue(facetId, valueStr);
    const safeId = escapeAttr(valueStr);
    const cnt = value.count ?? value.numberOfResults ?? 0;
    const isDisabled = !!options.disabled;
    return `<label class="coveo-mobile-boat-option ${checked ? "is-selected" : ""}">
              <input
                type="checkbox"
                class="coveo-mobile-boat-checkbox"
                ${checked ? "checked" : ""}
                ${isDisabled ? "disabled" : ""}
                data-facet-id="${escapeAttr(facetId)}"
                data-value="${escapeAttr(valueStr)}"
                data-boat-option-id="${safeId}"
              />
              <span class="coveo-mobile-boat-option__check" aria-hidden="true">${COVEO_FILTER_CHECK_SVG}</span>
              <span class="coveo-mobile-boat-option__text">${escapeHtml(
                valueStr,
              )} (${cnt})</span>
            </label>`;
  }

  function ensureBoatFacetLoadMoreGap(menu, canShowMore) {
    if (!menu) return null;
    let gap = menu.querySelector(".coveo-mobile-boat-options__load-gap");
    if (canShowMore) {
      if (!gap) {
        gap = document.createElement("div");
        gap.className = "coveo-mobile-boat-options__load-gap";
        gap.setAttribute("aria-hidden", "true");
      }
      menu.appendChild(gap);
      return gap;
    }
    if (gap) {
      gap.remove();
    }
    return null;
  }

  function appendPendingBoatFacetValuesInPlace(content, facetGen) {
    const pending = content?._coveoPendingBoatFacetAppend;
    const facetId = String(pending?.facetId || "").trim();
    if (!content || !facetGen || !facetId) return false;
    const facet = findFacetController(facetGen, facetId);
    if (!facet) return false;
    const menu = content.querySelector(
      '.coveo-mobile-boat-options[data-boat-options-for="' +
        escapeAttr(facetId) +
        '"]',
    );
    if (!menu) return false;

    const label = getFacetDisplayLabel(
      facetId,
      String(
        facet.state?.displayName || facet.state?.label || facetId || "Filter",
      ).trim(),
    );
    const values = sortFacetValuesSelectedFirst(
      normalizeFacetStateValues(facet.state || {}),
    );
    const searchableValues = getRenderedSearchableFacetValues(
      facet,
      facetId,
      values,
    );
    const canShowMore = !!(facet.state || {}).canShowMoreValues;
    if (facet.state?.isLoading || content._coveoController?.state?.isLoading) {
      return false;
    }

    const renderedById = new Map();
    menu.querySelectorAll("[data-boat-option-id]").forEach(function (input) {
      const raw = String(input.getAttribute("data-boat-option-id") || "");
      if (!raw) return;
      const option = input.closest(".coveo-mobile-boat-option");
      if (option) renderedById.set(raw, option);
    });

    // Controller updates can render the previous page before the response arrives.
    // Keep the append pending until new options arrive or the list is complete.
    const hasNewValues = searchableValues.some(function (value) {
      const raw = String(facetItemRawValue(value));
      return raw && !renderedById.has(raw) &&
        !shouldSuppressFacetValue(facetId, label, raw);
    });
    if (!hasNewValues && canShowMore) return false;

    searchableValues.forEach(function (value) {
      const raw = String(facetItemRawValue(value));
      if (!raw || shouldSuppressFacetValue(facetId, label, raw)) return;
      const existing = renderedById.get(raw);
      const checked =
        value.state === "selected" &&
        !isAutoAppliedCollectionBrandFacetValue(facetId, raw);
      const cnt = value.count ?? value.numberOfResults ?? 0;
      if (existing) {
        const input = existing.querySelector(
          '.coveo-mobile-boat-checkbox[data-boat-option-id="' +
            escapeAttr(raw) +
            '"]',
        );
        const text = existing.querySelector(".coveo-mobile-boat-option__text");
        if (input) {
          input.checked = !!checked;
        }
        if (text) {
          text.textContent = raw + " (" + cnt + ")";
        }
        existing.classList.toggle("is-selected", !!checked);
        return;
      }
      const markup = renderSearchableFacetOptionMarkup(facetId, label, value);
      if (!markup) return;
      const temp = document.createElement("div");
      temp.innerHTML = markup;
      const nextOption = temp.firstElementChild;
      if (!nextOption) return;
      const gap = ensureBoatFacetLoadMoreGap(menu, canShowMore);
      if (gap) {
        menu.insertBefore(nextOption, gap);
      } else {
        menu.appendChild(nextOption);
      }
    });
    ensureBoatFacetLoadMoreGap(menu, canShowMore);

    const rememberedQuery = getRememberedBoatSearchQuery(facetId);
    if (rememberedQuery) {
      applyBoatSearchFilter(content, facetId, rememberedQuery);
    }
    restorePendingBoatFacetScrollPosition(content);
    try {
      menu._coveoIgnoreScrollUntil = Date.now() + 400;
    } catch (_) { }
    markBoatFacetAppendApplied(content, facetId);
    clearPendingBoatFacetAppend(content, facetId);
    setBoatFacetLoadingState(content, facetId, false);
    return true;
  }

  function normalizeBoatFacetSearchText(input) {
    return String(input || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
      .replace(/\s+/g, " ");
  }

  function rememberBoatSearchQuery(facetId, value) {
    if (!facetId) return;
    if (!window.__coveoBoatSearchQueries) {
      window.__coveoBoatSearchQueries = {};
    }
    const v = String(value == null ? "" : value);
    if (v) window.__coveoBoatSearchQueries[facetId] = v;
    else delete window.__coveoBoatSearchQueries[facetId];
  }

  function getRememberedBoatSearchQuery(facetId) {
    if (!facetId) return "";
    return (window.__coveoBoatSearchQueries || {})[facetId] || "";
  }

  let coveoMakeModelFacetRequestSequence = 0;

  function getMakeModelFacetSearchState(content, createIfMissing) {
    if (!content) return null;
    if (
      (!content._coveoMakeModelFacetSearchState ||
        content._coveoMakeModelFacetSearchState.destroyed) &&
      createIfMissing
    ) {
      content._coveoMakeModelFacetSearchState = {
        activeQueryByFacetId: {},
        inFlightByFacetId: {},
        latestQueryByFacetId: {},
        replayQueuedByFacetId: {},
        requestSeqByFacetId: {},
        timersByFacetId: {},
      };
    }
    return content._coveoMakeModelFacetSearchState || null;
  }

  function isLatestMakeModelFacetSearchRequest(
    content,
    facetId,
    query,
    requestSeq,
  ) {
    const state = getMakeModelFacetSearchState(content, false);
    if (!state || state.destroyed || !facetId) return false;
    return (
      String(state.latestQueryByFacetId[facetId] || "") ===
      String(query == null ? "" : query)
    ) &&
      Number(state.requestSeqByFacetId[facetId] || 0) === Number(requestSeq || 0);
  }

  async function flushMakeModelFacetSearch(content, facetId) {
    const normalizedFacetId = String(facetId || "").trim();
    if (!content || !normalizedFacetId) return false;
    const state = getMakeModelFacetSearchState(content, true);
    if (state.inFlightByFacetId[normalizedFacetId]) {
      state.replayQueuedByFacetId[normalizedFacetId] = true;
      return false;
    }

    const activeQuery = String(
      state.latestQueryByFacetId[normalizedFacetId] || "",
    );
    const requestSeq = ++coveoMakeModelFacetRequestSequence;
    state.requestSeqByFacetId[normalizedFacetId] = requestSeq;
    state.activeQueryByFacetId[normalizedFacetId] = activeQuery;
    state.inFlightByFacetId[normalizedFacetId] = true;

    try {
      return await runMakeModelFacetSearchNow(
        content,
        normalizedFacetId,
        activeQuery,
        requestSeq,
      );
    } finally {
      state.inFlightByFacetId[normalizedFacetId] = false;
      const latestQuery = String(
        state.latestQueryByFacetId[normalizedFacetId] || "",
      );
      const shouldReplay =
        !!state.replayQueuedByFacetId[normalizedFacetId] ||
        latestQuery !== activeQuery;
      state.replayQueuedByFacetId[normalizedFacetId] = false;
      if (shouldReplay) {
        const pendingTimer = state.timersByFacetId[normalizedFacetId];
        if (pendingTimer) {
          clearTimeout(pendingTimer);
          delete state.timersByFacetId[normalizedFacetId];
        }
        window.setTimeout(function () {
          void flushMakeModelFacetSearch(content, normalizedFacetId);
        }, 0);
      }
    }
  }

  function runMakeModelFacetSearch(content, facetId, query) {
    const normalizedFacetId = String(facetId || "").trim();
    if (!content || !normalizedFacetId) return false;
    const state = getMakeModelFacetSearchState(content, true);
    state.latestQueryByFacetId[normalizedFacetId] = String(
      query == null ? "" : query,
    );
    const pendingTimer = state.timersByFacetId[normalizedFacetId];
    if (pendingTimer) {
      clearTimeout(pendingTimer);
    }
    const delay = String(query || "").trim() ? 160 : 0;
    state.timersByFacetId[normalizedFacetId] = window.setTimeout(function () {
      delete state.timersByFacetId[normalizedFacetId];
      void flushMakeModelFacetSearch(content, normalizedFacetId);
    }, delay);
    return true;
  }

  function rerenderFacetDrawerContent(content) {
    if (!content?._coveoFacetGen) return;
    content._coveoForceBoatSearchRender = true;
    try {
      renderFacets(content._coveoFacetGen, {
        container:
          content.closest?.("#CoveoFiltersDrawer") ||
          content.parentElement ||
          content,
        engine: content._coveoEngine,
        mod: content._coveoMod,
      });
    } finally {
      content._coveoForceBoatSearchRender = false;
    }
  }

  function rerenderFacetDrawerFacetGroupInPlace(content, facetId) {
    const normalizedFacetId = String(facetId || "").trim();
    if (!content || !content._coveoFacetGen || !normalizedFacetId) return false;
    if (
      facetIdsMatchManagedRange(normalizedFacetId) &&
      hasActiveCoveoRangeUiInteraction()
    ) {
      return false;
    }
    const facetGen = content._coveoFacetGen;
    const facet =
      findFacetController(facetGen, normalizedFacetId) ||
      (facetIdsMatchManagedRange(normalizedFacetId)
        ? flattenFacetControllers(facetGen).find(function (candidate) {
          return requestFacetIdsMatchManagedRange(
            candidate?.facetId || candidate?.state?.facetId,
            normalizedFacetId,
          );
        })
        : null);
    if (!facet) return false;
    const renderedFacetId = String(
      facet.facetId || facet.state?.facetId || normalizedFacetId,
    );
    const details = content.querySelector(
      'details[data-facet-id="' + escapeAttr(renderedFacetId) + '"]',
    );
    if (!details) return false;

    const desiredDrawerSnapshot = buildDrawerDesiredSelectionSnapshot(
      content,
      facetGen,
    );
    const openFacetIds = new Set();
    content.querySelectorAll("details[open][data-facet-id]").forEach((el) => {
      const id = el.getAttribute("data-facet-id");
      if (id) openFacetIds.add(id);
    });
    if (
      normalizeFacetStateValues(facet.state || {}).some(function (value) {
        return value.state === "selected";
      })
    ) {
      openFacetIds.add(renderedFacetId);
    }

    const currentMenu = details.querySelector(".coveo-mobile-boat-options");
    const boatScrollSnapshot = captureBoatFacetScrollSnapshot(currentMenu);
    if (boatScrollSnapshot) {
      setPendingBoatFacetScrollRestore(content, boatScrollSnapshot);
    }
    const focusSnapshot = captureBoatSearchFocus(content);
    const drawerScrollSnapshot = captureFacetsDrawerScrollSnapshot(content);
    const temp = document.createElement("div");
    temp.innerHTML = renderFacetGroup(facet, openFacetIds, {
      conditionSelectedValues:
        reconcileConditionSelectionShadow(facetGen),
      desiredDrawerSnapshot,
    });
    const nextDetails = temp.firstElementChild;
    if (!nextDetails) return false;

    details.replaceWith(nextDetails);
    restoreBoatSearchFocus(content, focusSnapshot);
    restoreFacetsDrawerScrollPosition(content, drawerScrollSnapshot);
    pruneSyncedPendingFilterState(content, facetGen);
    reapplyPendingFilterStateAfterFacetRender(content);
    reapplyBoatSearchFilterAfterFacetRender(content);
    wireCoveoFacetDefaultWrapScrollLoad(
      content,
      facetGen,
      content._coveoEngine,
      content._coveoMod,
    );
    restorePendingBoatFacetScrollPosition(content);
    return true;
  }

  function ensureFacetAllValuesLoadedForSearch(content, facetId, facet) {
    if (!content || !facetId || !facet || typeof facet.showMoreValues !== "function") {
      return Promise.resolve(false);
    }
    if (facet.__coveoLoadAllComplete || !(facet.state || {}).canShowMoreValues) {
      facet.__coveoLoadAllComplete = true;
      if (!rerenderFacetDrawerFacetGroupInPlace(content, facetId)) {
        rerenderFacetDrawerContent(content);
      }
      return Promise.resolve(true);
    }
    if (facet.__coveoPredictiveLoadPromise) {
      return facet.__coveoPredictiveLoadPromise;
    }
    facet.__coveoPredictiveLoadPromise = new Promise(function (resolve) {
      loadAllFacetValues(facet);
      const poll = function () {
        const state = facet.state || {};
        if (facet.__coveoLoadAllComplete || !state.canShowMoreValues) {
          facet.__coveoLoadAllComplete = true;
          facet.__coveoPredictiveLoadPromise = null;
          if (!rerenderFacetDrawerFacetGroupInPlace(content, facetId)) {
            rerenderFacetDrawerContent(content);
          }
          resolve(true);
          return;
        }
        window.setTimeout(poll, 160);
      };
      window.setTimeout(poll, 160);
    });
    return facet.__coveoPredictiveLoadPromise;
  }

  function mergeRenderableFacetValues(sourceValues, liveValues, options) {
    const normalizedSource = Array.isArray(sourceValues) ? sourceValues : [];
    const normalizedLive = Array.isArray(liveValues) ? liveValues : [];
    const appendUnmatchedLive = options?.appendUnmatchedLive !== false;
    const liveByRaw = new Map();
    normalizedLive.forEach(function (value) {
      const raw = String(facetItemRawValue(value));
      if (!raw) return;
      liveByRaw.set(raw, value);
    });
    const merged = [];
    const seen = new Set();
    normalizedSource.forEach(function (value) {
      const raw = String(facetItemRawValue(value));
      if (!raw || seen.has(raw)) return;
      const live = liveByRaw.get(raw);
      const next = Object.assign({}, value);
      if (live) {
        next.state = live.state;
        if (live.count != null) next.count = live.count;
        if (live.numberOfResults != null) {
          next.numberOfResults = live.numberOfResults;
        }
      }
      merged.push(next);
      seen.add(raw);
    });
    if (appendUnmatchedLive) {
      normalizedLive.forEach(function (value) {
        const raw = String(facetItemRawValue(value));
        if (!raw || seen.has(raw)) return;
        merged.push(value);
        seen.add(raw);
      });
    }
    return sortFacetValuesSelectedFirst(merged);
  }

  function buildPredictiveFacetSearchQueries(rawQuery) {
    const trimmed = String(rawQuery || "").trim();
    if (!trimmed) return [];
    const queries = [trimmed];
    const parts = trimmed.split(/\s+/).filter(Boolean);
    if (!parts.length) return queries;
    const last = parts[parts.length - 1];
    if (!last.endsWith("*")) {
      const predictive = [...parts.slice(0, -1), `${last}*`].join(" ");
      if (predictive && !queries.includes(predictive)) {
        queries.push(predictive);
      }
    }
    return queries;
  }

  function getCoveoFacetServerValueLimit(facetId) {
    if (facetIdUsesRangeServerDomainRefresh(facetId)) return 100;
    if (facetIdsMatchMake(facetId)) return 1000;
    if (facetIdsMatchModel(facetId)) return 5000;
    return 1000;
  }

  function facetIdSupportsServerFacetRefresh(facetId) {
    return (
      facetIdsMatchMake(facetId) ||
      facetIdsMatchModel(facetId) ||
      facetIdsMatchLength(facetId) ||
      facetIdsMatchPrice(facetId) ||
      facetIdsMatchYear(facetId)
    );
  }

  function facetIdUsesRangeServerDomainRefresh(facetId) {
    return (
      facetIdsMatchLength(facetId) ||
      facetIdsMatchPrice(facetId) ||
      facetIdsMatchYear(facetId)
    );
  }

  function requestFacetMatchesFacetId(requestFacet, facetId) {
    const requestId = String(
      requestFacet?.facetId ||
      requestFacet?.field ||
      requestFacet?.facetField ||
      "",
    );
    if (!requestId || !facetId) return false;
    if (requestId === facetId) return true;
    if (facetIdsMatchMake(facetId) && facetIdsMatchMake(requestId)) return true;
    if (facetIdsMatchModel(facetId) && facetIdsMatchModel(requestId)) return true;
    if (facetIdsMatchLength(facetId) && facetIdsMatchLength(requestId)) return true;
    if (facetIdsMatchPrice(facetId) && facetIdsMatchPrice(requestId)) return true;
    if (facetIdsMatchYear(facetId) && facetIdsMatchYear(requestId)) return true;
    return false;
  }

  function getRenderedSearchableFacetValues(facet, facetId, values) {
    const liveValues = Array.isArray(values) ? values : [];
    const rememberedBoatQ = String(getRememberedBoatSearchQuery(facetId) || "").trim();
    if (
      (facetIdsMatchMake(facetId) || facetIdsMatchModel(facetId)) &&
      rememberedBoatQ.length >= 1
    ) {
      const searchValues = getFacetSearchValues(facet);
      if (searchValues.length) {
        return mergeRenderableFacetValues(searchValues, liveValues);
      }
    }

    const cached = getCoveoFacetServerCache(facetId);
    if (!Array.isArray(cached) || !cached.length) return liveValues;
    return mergeRenderableFacetValues(cached, liveValues);
  }

  async function runMakeModelFacetSearchNow(
    content,
    facetId,
    query,
    requestSeq,
  ) {
    if (!content || !facetId) return false;
    if (!facetIdsMatchMake(facetId) && !facetIdsMatchModel(facetId)) return false;

    const facet = findFacetController(content._coveoFacetGen, facetId);
    const searchCtrl = getFacetSearchController(facet);
    if (!searchCtrl || typeof searchCtrl.updateText !== "function") return false;

    const rawQuery = String(query || "");
    const trimmed = rawQuery.trim();
    const hadActiveFacetSearch = !!content?._coveoFacetSearchActiveById?.[facetId];

    try {
      searchCtrl.updateText(trimmed);
    } catch (_) {
      return false;
    }

    if (trimmed.length < 1) {
      if (typeof searchCtrl.clear === "function") {
        try {
          await Promise.resolve(searchCtrl.clear());
        } catch (_) { }
      }
      if (
        !isLatestMakeModelFacetSearchRequest(content, facetId, rawQuery, requestSeq)
      ) {
        return false;
      }
      if (content?._coveoFacetSearchActiveById) {
        delete content._coveoFacetSearchActiveById[facetId];
      }
      if (hadActiveFacetSearch) {
        if (!rerenderFacetDrawerFacetGroupInPlace(content, facetId)) {
          rerenderFacetDrawerContent(content);
        }
      }
      return true;
    }

    const searchQueries = buildPredictiveFacetSearchQueries(trimmed);
    let searchCompleted = false;

    if (typeof searchCtrl.search === "function") {
      for (const searchQuery of searchQueries) {
        try {
          searchCtrl.updateText(searchQuery);
          await Promise.resolve(searchCtrl.search());
          searchCompleted = true;
        } catch (_) {
          return false;
        }
        if (
          !isLatestMakeModelFacetSearchRequest(content, facetId, rawQuery, requestSeq)
        ) {
          return false;
        }
        if (getFacetSearchValues(facet).length > 0) {
          break;
        }
      }
    } else {
      return false;
    }

    if (!searchCompleted) {
      return false;
    }

    if (!isLatestMakeModelFacetSearchRequest(content, facetId, rawQuery, requestSeq)) {
      return false;
    }

    if (
      trimmed.length <= 3 &&
      getFacetSearchValues(facet).length === 0
    ) {
      void ensureFacetAllValuesLoadedForSearch(content, facetId, facet);
    }

    if (!content._coveoFacetSearchActiveById) {
      content._coveoFacetSearchActiveById = {};
    }
    content._coveoFacetSearchActiveById[facetId] = true;
    if (!rerenderFacetDrawerFacetGroupInPlace(content, facetId)) {
      rerenderFacetDrawerContent(content);
    }
    return true;
  }

  async function legacyFetchCoveoFacetServerValues(content, facetId, query) {
    if (!content || !facetId) return null;
    if (!facetIdSupportsServerFacetRefresh(facetId)) return null;
    const qRaw = String(query || "").trim();
    const cached = qRaw ? null : getCoveoFacetServerCache(facetId);
    if (cached) return cached;
    const snapshot = window.__coveoLastCommerceRequest;
    if (!snapshot?.url || !snapshot?.body) {
      const facet = findFacetController(content._coveoFacetGen, facetId);
      if (facet && typeof facet.showMoreValues === "function") {
        expandFacetValuesProgressively(facetId, facet, 0);
      }
      return null;
    }
    const requests = getCoveoFacetServerValueRequests(true);
    const latestRequestKeys = getCoveoFacetServerLatestRequestKeys(true);
    const abortControllers = getCoveoFacetServerAbortControllers(true);
    const facetKey = getCoveoFacetServerStateKey(facetId);
    const contextKey = buildCoveoFacetValueCacheContextKey(snapshot.body);
    const requestKey = `${facetKey}\u001E${qRaw.toLowerCase()}\u001E${contextKey}`;
    const existing = requests[requestKey];
    if (existing) {
      latestRequestKeys[facetKey] = requestKey;
      return existing;
    }
    const prevRequestKey = String(latestRequestKeys[facetKey] || "");
    const prevAbortController = abortControllers[facetKey];
    latestRequestKeys[facetKey] = requestKey;
    if (
      prevRequestKey &&
      prevRequestKey !== requestKey &&
      prevAbortController &&
      typeof prevAbortController.abort === "function"
    ) {
      try {
        prevAbortController.abort();
      } catch (_) { }
    }
    const abortController =
      typeof AbortController === "function" ? new AbortController() : null;
    if (abortController) {
      abortControllers[facetKey] = abortController;
    }

    const promise = (async function () {
      try {
        const body = JSON.parse(JSON.stringify(snapshot.body));
        const targetFacet = (Array.isArray(body.facets) ? body.facets : []).find(
          function (facet) {
            return requestFacetMatchesFacetId(facet, facetId);
          },
        );
        if (!targetFacet) return null;
        const limit = getCoveoFacetServerValueLimit(facetId);
        body._mmFacetValuesOnly = true;
        const facetRequest = Object.assign({}, targetFacet, {
          numberOfValues: limit,
          initialNumberOfValues: limit,
          freezeCurrentValues: false,
          preventAutoSelect: false,
        });
        if (qRaw) {
          facetRequest.query = qRaw;
        }
        if (facetIdUsesRangeServerDomainRefresh(facetId)) {
          /*
           * For range sliders we want the domain constrained by the *other*
           * active filters (brand, condition, etc.), not by this facet's own
           * currently selected range. Clearing self-selection here lets Coveo
           * return the real available min/max under the surrounding context.
           */
          delete facetRequest.values;
          delete facetRequest.currentValues;
          delete facetRequest.domain;
        }
        body.facets = (Array.isArray(body.facets) ? body.facets : []).map(
          function (facet) {
            return requestFacetMatchesFacetId(facet, facetId)
              ? facetRequest
              : facet;
          },
        );
        const response = await fetch(
          snapshot.url,
          Object.assign({}, snapshot.init || {}, {
            body: JSON.stringify(body),
            signal: abortController?.signal,
          }),
        );
        if (!response.ok) return null;
        const data = await response.json().catch(function () {
          return null;
        });
        const responseFacet = Array.isArray(data?.facets)
          ? data.facets.find(function (facet) {
            return requestFacetMatchesFacetId(facet, facetId);
          }) || null
          : null;
        const values = Array.isArray(responseFacet?.values)
          ? responseFacet.values
          : [];
        if (!responseFacet) return null;
        if (latestRequestKeys[facetKey] !== requestKey) {
          return values;
        }
        if (!qRaw) {
          setCoveoFacetServerCache(facetId, snapshot.body, responseFacet);
        }
        if (!rerenderFacetDrawerFacetGroupInPlace(content, facetId)) {
          renderFacets(content._coveoFacetGen, {
            container:
              content.closest?.("#CoveoFiltersDrawer") ||
              content.parentElement ||
              content,
            engine: content._coveoEngine,
            mod: window.CoveoCommerceModule,
          });
        }
        return values;
      } catch (err) {
        if (err?.name === "AbortError") {
          return null;
        }
        console.warn("[Coveo Filters] facet server values fetch:", err);
        return null;
      } finally {
        delete requests[requestKey];
        if (abortControllers[facetKey] === abortController) {
          delete abortControllers[facetKey];
        }
      }
    })();

    requests[requestKey] = promise;
    return promise;
  }

  function parseCoveoLengthNumber(value) {
    const parsed = parseFloat(
      String(value == null ? "" : value).replace(/[^0-9.-]/g, ""),
    );
    return Number.isFinite(parsed) ? parsed : null;
  }

  function parseCoveoOverallLengthFromCardHtml(html) {
    const match = String(html || "").match(
      /\bdata-length-overall=["']([^"']*)["']/i,
    );
    return match ? parseCoveoLengthNumber(match[1]) : null;
  }

  async function extendCoveoLengthFacetDomainFromSortedProducts(
    facetState,
    data,
  ) {
    if (!facetState || typeof facetState !== "object") return facetState;
    const products = Array.isArray(data?.products)
      ? data.products
      : Array.isArray(data?.results)
        ? data.results
        : Array.isArray(data?.response?.products)
          ? data.response.products
          : Array.isArray(data?.response?.results)
            ? data.response.results
            : [];
    const longestProduct = products[0] || null;
    const rawLongest = longestProduct
      ? getProductField(longestProduct, [
          "ec_length",
          "ec_length_overall",
          "iiq_length_overall",
          "iiq.length_overall",
          "iiq_length",
          "iiq.length",
          "length_overall",
          "lengthoverall",
          "length",
        ])
      : null;
    let longest = parseCoveoLengthNumber(rawLongest);
    if (
      (!Number.isFinite(longest) || longest <= COVEO_LENGTH_SLIDER_MIN) &&
      longestProduct &&
      typeof fetchLiquidProductCardResult === "function"
    ) {
      try {
        const cardResult = await fetchLiquidProductCardResult(
          longestProduct.clickUri,
          longestProduct,
        );
        longest = parseCoveoOverallLengthFromCardHtml(cardResult?.html);
      } catch (_) { }
    }
    if (!Number.isFinite(longest) || longest <= COVEO_LENGTH_SLIDER_MIN) {
      return facetState;
    }

    const bucketBounds = (Array.isArray(facetState.values)
      ? facetState.values
      : []
    )
      .map(facetItemNumericBounds)
      .filter(Boolean);
    const bucketLo = bucketBounds.length
      ? Math.min.apply(null, bucketBounds.map(function (bound) { return bound.lo; }))
      : COVEO_LENGTH_SLIDER_MIN;
    const bucketHi = bucketBounds.length
      ? Math.max.apply(null, bucketBounds.map(function (bound) { return bound.hi; }))
      : COVEO_LENGTH_SLIDER_MIN;
    const lo = Math.max(COVEO_LENGTH_SLIDER_MIN, Math.floor(bucketLo));
    const hi = Math.min(
      COVEO_LENGTH_SLIDER_MAX,
      Math.ceil(Math.max(bucketHi, longest)),
    );
    if (!(hi > lo)) return facetState;
    return Object.assign({}, facetState, {
      domain: { min: lo, max: hi },
    });
  }

  async function fetchCoveoFacetServerValues(content, facetId, query) {
    if (!content || !facetId || !facetIdSupportsServerFacetRefresh(facetId)) {
      return null;
    }
    const qRaw = String(query || "").trim();
    /*
     * Baseline range responses are keyed by endpoint, query, collection,
     * peer filters, market, and location. Reuse a validated response while
     * that context is unchanged instead of spending another QPM after an
     * equivalent Search or Product Listing response. Forced refresh paths
     * invalidate these entries before arriving here.
     */
    const cached = qRaw ? null : getCoveoFacetServerCache(facetId);
    if (cached) return cached;
    const snapshot = window.__coveoLastCommerceRequest;
    if (!snapshot?.url || !snapshot?.body) return null;

    const body = JSON.parse(JSON.stringify(snapshot.body));
    let targetFacet = (Array.isArray(body.facets) ? body.facets : []).find(
      function (facet) {
        return requestFacetMatchesFacetId(facet, facetId);
      },
    );
    if (!targetFacet) {
      const template = getCoveoFacetRequestTemplate(facetId);
      if (template) {
        body.facets = Array.isArray(body.facets) ? body.facets : [];
        body.facets.push(template);
        targetFacet = template;
      }
    }
    if (!targetFacet) return null;

    const limit = getCoveoFacetServerValueLimit(facetId);
    Object.assign(targetFacet, {
      numberOfValues: limit,
      initialNumberOfValues: limit,
      freezeCurrentValues: false,
      preventAutoSelect: false,
    });
    if (qRaw) targetFacet.query = qRaw;
    body._mmFacetValuesOnly = true;
    body._mmFacetValuesOnlyTargetId = facetId;

    const requestInit = Object.assign({}, snapshot.init || {});
    requestInit.method = "POST";
    requestInit._mmFacetValuesOnly = true;
    requestInit._mmFacetValuesOnlyTargetId = facetId;
    if (!requestInit.headers || !Object.keys(requestInit.headers).length) {
      requestInit.headers = { "Content-Type": "application/json" };
    }
    function prepareFacetOnlyRequest(url, requestBody, init) {
      if (typeof window.__coveoPrepareFacetValuesOnlyRequestBody === "function") {
        window.__coveoPrepareFacetValuesOnlyRequestBody(url, requestBody, init);
      }
      return requestBody;
    }
    prepareFacetOnlyRequest(snapshot.url, body, requestInit);

    const excludeTargetFromContext = facetIdUsesRangeServerDomainRefresh(facetId);
    const contextKey = buildCoveoFacetValueCacheContextKey(body, {
      excludeFacetId: excludeTargetFromContext ? facetId : "",
      requestUrl: snapshot.url,
    });
    const facetKey = getCoveoFacetServerStateKey(facetId);
    const requestKey = `${facetKey}\u001E${qRaw.toLowerCase()}\u001E${contextKey}`;
    const requests = getCoveoFacetServerValueRequests(true);
    const latestRequestKeys = getCoveoFacetServerLatestRequestKeys(true);
    const abortControllers = getCoveoFacetServerAbortControllers(true);
    const existingRecord = requests[requestKey];
    if (isReusableCoveoFacetServerRequest(existingRecord)) {
      latestRequestKeys[facetKey] = requestKey;
      existingRecord.requestedFacetIds?.add?.(String(facetId));
      return getCoveoFacetServerRequestPromise(existingRecord);
    }
    if (existingRecord) delete requests[requestKey];

    const previousKey = String(latestRequestKeys[facetKey] || "");
    if (previousKey && previousKey !== requestKey) {
      const previousRecord = requests[previousKey];
      abortCoveoFacetServerRequest(previousRecord);
      if (requests[previousKey] === previousRecord) delete requests[previousKey];
    }
    const previousController = abortControllers[facetKey];
    if (previousController && typeof previousController.abort === "function") {
      try {
        previousController.abort();
      } catch (_) { }
    }

    const controller =
      typeof AbortController === "function" ? new AbortController() : null;
    const requestRecord = {
      aborted: false,
      controller,
      promise: null,
      requestedFacetIds: new Set([String(facetId)]),
    };
    latestRequestKeys[facetKey] = requestKey;
    if (controller) abortControllers[facetKey] = controller;
    requestInit.body = JSON.stringify(body);
    if (controller) requestInit.signal = controller.signal;

    requestRecord.promise = (async function () {
      try {
        const response = await fetch(snapshot.url, requestInit);
        if (!response?.ok) return null;
        const data = await response.json().catch(function () { return null; });
        let responseFacet = Array.isArray(data?.facets)
          ? data.facets.find(function (facet) {
            return requestFacetMatchesFacetId(facet, facetId);
          }) || null
          : null;
        if (responseFacet && facetIdsMatchLength(facetId)) {
          responseFacet = await extendCoveoLengthFacetDomainFromSortedProducts(
            responseFacet,
            data,
          );
        }
        const values = Array.isArray(responseFacet?.values)
          ? responseFacet.values
          : [];
        if (!responseFacet) return null;
        if (
          requestRecord.aborted ||
          controller?.signal?.aborted ||
          latestRequestKeys[facetKey] !== requestKey ||
          requests[requestKey] !== requestRecord
        ) {
          return null;
        }
        if (
          excludeTargetFromContext &&
          !deriveCoveoManagedRangeServerDomain(facetId, responseFacet, {
            requireExplicitDomain: true,
          })
        ) {
          console.warn("[Coveo Filters] facet baseline missing-domain:", facetId);
          return values;
        }
        if (!qRaw) {
          setCoveoFacetServerCache(facetId, body, responseFacet, contextKey);
        }
        let rerenderedFacet = false;
        requestRecord.requestedFacetIds.forEach(function (requestedFacetId) {
          if (rerenderFacetDrawerFacetGroupInPlace(content, requestedFacetId)) {
            rerenderedFacet = true;
          }
        });
        if (!rerenderedFacet) {
          renderFacets(content._coveoFacetGen, {
            container:
              content.closest?.("#CoveoFiltersDrawer") ||
              content.parentElement ||
              content,
            engine: content._coveoEngine,
            mod: window.CoveoCommerceModule,
          });
        }
        return values;
      } catch (err) {
        if (err?.name === "AbortError") return null;
        console.warn("[Coveo Filters] facet server values fetch:", err);
        return null;
      } finally {
        if (requests[requestKey] === requestRecord) {
          delete requests[requestKey];
        }
        if (abortControllers[facetKey] === controller) {
          delete abortControllers[facetKey];
        }
      }
    })();
    requests[requestKey] = requestRecord;
    return requestRecord.promise;
  }

  function applyBoatSearchFilter(content, facetId, value) {
    if (!content || !facetId) return;
    const menu = content.querySelector(
      '[data-boat-options-for="' + facetId + '"]',
    );
    if (!menu) return;
    const qRaw = String(value || "").trim().toLowerCase();
    const q = normalizeBoatFacetSearchText(qRaw);
    menu
      .querySelectorAll(".coveo-mobile-boat-option")
      .forEach(function (opt) {
        const textEl = opt.querySelector(".coveo-mobile-boat-option__text");
        const tRaw = (textEl?.textContent || "").trim().toLowerCase();
        const t = normalizeBoatFacetSearchText(tRaw);
        const matches =
          !qRaw || tRaw.includes(qRaw) || (q && t.includes(q));
        opt.style.display = matches ? "" : "none";
      });
  }

  /**
   * After a facet re-render wipes the drawer DOM, restore the per-facet boat
   * search input value and re-run the visible/hidden filter so values that
   * just loaded via showMoreValues are properly filtered.
   */
  function reapplyBoatSearchFilterAfterFacetRender(content) {
    if (!content) return;
    const stored = window.__coveoBoatSearchQueries || {};
    const facetIds = Object.keys(stored);
    if (!facetIds.length) return;
    facetIds.forEach(function (facetId) {
      const value = stored[facetId];
      if (!value) return;
      const input = content.querySelector(
        '.coveo-mobile-boat-search[data-boat-search-for="' +
          escapeAttr(facetId) +
          '"] .coveo-mobile-boat-search__input',
      );
      if (input && input.value !== value) {
        input.value = value;
      }
      applyBoatSearchFilter(content, facetId, value);
    });
  }

  /**
   * Rebuilding the entire filters drawer while the user types in Make/Model/Boat
   * Type search (especially during uncapped showMoreValues) freezes or crashes the
   * tab. Skip full innerHTML replacement when a boat-search field is focused or
   * has an active query during facet-value pagination.
   */
  function shouldSkipFacetsDrawerFullRender(content) {
    if (!content) return false;
    if (content._coveoForceBoatSearchRender) return false;
    if (content._coveoPendingBoatFacetAppend?.facetId) return true;
    if (hasRecentBoatFacetAppendApplied(content)) return true;
    if (captureBoatSearchFocus(content)) return true;
    if (!window.__coveoFacetValuesRefreshInFlight) return false;
    const stored = window.__coveoBoatSearchQueries || {};
    return Object.keys(stored).some(function (facetId) {
      return String(stored[facetId] || "").trim().length > 0;
    });
  }

  function reapplyPendingFilterStateAfterFacetRender(content) {
    if (!content) return;
    try {
      const pendingCb = content._coveoPendingCheckboxState;
      if (pendingCb && pendingCb.size > 0) {
        for (const [key, desiredChecked] of pendingCb.entries()) {
          const sepIdx = key.indexOf("\u001E");
          if (sepIdx === -1) continue;
          const facetId = key.slice(0, sepIdx);
          const value = key.slice(sepIdx + 1);
          const cb = content.querySelector(
            `input[type="checkbox"][data-facet-id="${escapeAttr(
              facetId,
            )}"][data-value="${escapeAttr(value)}"]`,
          );
          if (cb) {
            cb.checked = !!desiredChecked;
            syncFacetCheckboxLabelSelectedClass(cb);
          }
        }
      }
      if (content._coveoPendingConditionAll === true) {
        content
          .querySelectorAll('input[type="checkbox"][data-facet-id][data-value]')
          .forEach(function (checkbox) {
            if (!facetIdsMatchCondition(checkbox.dataset.facetId)) return;
            checkbox.checked = false;
            syncFacetCheckboxLabelSelectedClass(checkbox);
          });
      }
      syncConditionAllCheckboxState(content);
    } catch (_) { }
  }

  function clearDrawerFacetSelectionsByMatcher(content, facetGen, matcher) {
    if (!content || typeof matcher !== "function") return;
    if (!(content._coveoPendingCheckboxState instanceof Map)) {
      content._coveoPendingCheckboxState = new Map();
    }
    const baseline =
      content._coveoFilterSessionBaseline instanceof Map
        ? content._coveoFilterSessionBaseline
        : buildFacetSelectionSnapshot(facetGen);
    const pending = content._coveoPendingCheckboxState;
    const desiredSnapshot = buildDrawerDesiredSelectionSnapshot(content, facetGen);
    const facetIds = new Set();

    function collectFacetIdsFromSnapshot(snapshot) {
      if (!(snapshot instanceof Map)) return;
      snapshot.forEach(function (_checked, key) {
        const sepIdx = key.indexOf("\u001E");
        if (sepIdx === -1) return;
        const facetId = key.slice(0, sepIdx);
        if (matcher(facetId)) facetIds.add(facetId);
      });
    }

    collectFacetIdsFromSnapshot(baseline);
    collectFacetIdsFromSnapshot(desiredSnapshot);
    collectFacetIdsFromSnapshot(pending);

    desiredSnapshot.forEach(function (checked, key) {
      const sepIdx = key.indexOf("\u001E");
      if (sepIdx === -1) return;
      const facetId = key.slice(0, sepIdx);
      if (!matcher(facetId) || !checked) return;
      const baselineChecked = !!baseline.get(key);
      if (baselineChecked) {
        pending.set(key, false);
      } else {
        pending.delete(key);
      }
    });

    Array.from(pending.keys()).forEach(function (key) {
      const sepIdx = key.indexOf("\u001E");
      if (sepIdx === -1) return;
      const facetId = key.slice(0, sepIdx);
      if (!matcher(facetId)) return;
      const desiredChecked = !!pending.get(key);
      if (!desiredChecked) return;
      const baselineChecked = !!baseline.get(key);
      if (baselineChecked) {
        pending.set(key, false);
      } else {
        pending.delete(key);
      }
    });

    content
      .querySelectorAll('input[type="checkbox"][data-facet-id][data-value]')
      .forEach(function (checkbox) {
        const facetId = checkbox.getAttribute("data-facet-id");
        if (!facetId || !matcher(facetId)) return;
        checkbox.checked = false;
        syncFacetCheckboxLabelSelectedClass(checkbox);
      });

    if (content._mmPendingFilterDl) {
      content._mmPendingFilterDl = content._mmPendingFilterDl.filter(function (item) {
        return !matcher(item?.facetId);
      });
    }

    facetIds.forEach(function (facetId) {
      rememberBoatSearchQuery(facetId, "");
    });
  }

  async function clearLiveFacetSelectionsByMatcher(
    facetGen,
    matcher,
    options,
  ) {
    const isCurrent =
      typeof options?.isCurrent === "function"
        ? options.isCurrent
        : () => true;
    if (!isCurrent()) return;
    if (!facetGen || typeof matcher !== "function") return;
    const facets = flattenFacetControllers(facetGen).filter(function (facet) {
      const facetId = facet?.facetId || facet?.state?.facetId || "";
      return facetId && matcher(facetId);
    });
    for (const facet of facets) {
      if (!isCurrent()) return;
      const facetId = facet?.facetId || facet?.state?.facetId || "";
      const facetState = facet?.state || {};
      const hasActiveSelection =
        facetState.hasActiveValues === true ||
        normalizeFacetStateValues(facetState).some(function (value) {
          return value?.state === "selected";
        });
      if (!hasActiveSelection) continue;
      await clearCoveoFacetControllerSelectionForUiClear(facet, facetId, {
        isCurrent,
      });
      if (!isCurrent()) return;
    }
  }

  function getCommerceFacetActionLoaders(engine, mod) {
    if (!engine || !mod) return null;
    const regularActions =
      typeof mod.loadRegularFacetActions === "function"
        ? mod.loadRegularFacetActions(engine)
        : null;
    const coreActions =
      typeof mod.loadCoreFacetActions === "function"
        ? mod.loadCoreFacetActions(engine)
        : null;
    if (typeof regularActions?.toggleSelectFacetValue !== "function") {
      return null;
    }
    const deselectAllFacetValuesAction =
      typeof coreActions?.deselectAllValuesInCoreFacet === "function"
        ? function (facetId) {
            return coreActions.deselectAllValuesInCoreFacet({ facetId });
          }
        : typeof coreActions?.deselectAllFacetValues === "function"
          ? function (facetId) {
              return coreActions.deselectAllFacetValues(facetId);
            }
          : null;
    return {
      regularActions,
      coreActions,
      deselectAllFacetValuesAction,
    };
  }

  async function applyFacetSelectionSnapshotBatch(
    engine,
    mod,
    desiredSnapshot,
    currentSnapshot,
    options,
  ) {
    const isCurrent =
      typeof options?.isCurrent === "function"
        ? options.isCurrent
        : () => true;
    if (!isCurrent()) {
      return { supported: false, appliedCount: 0, added: [] };
    }
    const actionLoaders = getCommerceFacetActionLoaders(engine, mod);
    if (!actionLoaders) return { supported: false, appliedCount: 0, added: [] };

    const { regularActions, deselectAllFacetValuesAction } = actionLoaders;
    const changedFacetIds = new Set();
    const changedSelections = [];
    const desiredSelectedValuesByFacet = new Map();
    desiredSnapshot.forEach(function (desiredChecked, key) {
      const currentChecked = !!currentSnapshot.get(key);
      if (currentChecked === !!desiredChecked) return;
      const sepIdx = key.indexOf("\u001E");
      if (sepIdx === -1) return;
      const facetId = key.slice(0, sepIdx);
      const value = key.slice(sepIdx + 1);
      changedFacetIds.add(facetId);
      changedSelections.push({
        currentChecked,
        desiredChecked: !!desiredChecked,
        facetId,
        value,
      });
    });

    /*
     * Changed facets are rebuilt from scratch below (deselect-all, followed by
     * toggling desired values back on). Include every desired selected value,
     * not only values whose boolean changed, or an existing selection such as
     * New would be lost while adding Used/Brokerage through the All control.
     */
    desiredSnapshot.forEach(function (desiredChecked, key) {
      if (!desiredChecked) return;
      const sepIdx = key.indexOf("\u001E");
      if (sepIdx === -1) return;
      const facetId = key.slice(0, sepIdx);
      if (!changedFacetIds.has(facetId)) return;
      const value = key.slice(sepIdx + 1);
      if (!desiredSelectedValuesByFacet.has(facetId)) {
        desiredSelectedValuesByFacet.set(facetId, []);
      }
      desiredSelectedValuesByFacet.get(facetId).push(value);
    });

    if (!changedFacetIds.size) {
      return { supported: true, appliedCount: 0, added: [] };
    }

    /*
     * Some Coveo builds expose the regular state-only toggle action without
     * the core deselect-all action. Toggle only the changed values in that
     * capability mode, then let the caller own the single primary search.
     */
    if (!deselectAllFacetValuesAction) {
      if (!isCurrent()) {
        return { supported: false, appliedCount: 0, added: [] };
      }
      const added = changedSelections
        .filter(function (selection) {
          return selection.desiredChecked && !selection.currentChecked;
        })
        .map(function (selection) {
          return {
            facetId: selection.facetId,
            value: selection.value,
          };
        });
      await Promise.all(
        changedSelections.map(function (selection) {
          return Promise.resolve(
            engine.dispatch(
              regularActions.toggleSelectFacetValue({
                facetId: selection.facetId,
                selection: {
                  value: selection.value,
                  state: selection.currentChecked ? "selected" : "idle",
                },
              }),
            ),
          );
        }),
      );
      if (!isCurrent()) {
        return { supported: false, appliedCount: 0, added: [] };
      }
      return {
        supported: true,
        appliedCount: changedSelections.length,
        added,
      };
    }

    if (!isCurrent()) {
      return { supported: false, appliedCount: 0, added: [] };
    }
    await Promise.all(
      Array.from(changedFacetIds).map(function (facetId) {
        return Promise.resolve(
          engine.dispatch(deselectAllFacetValuesAction(facetId)),
        );
      }),
    );
    if (!isCurrent()) {
      return { supported: false, appliedCount: 0, added: [] };
    }

    // Count a deselect-only change as an applied mutation so Apply Filter
    // still dispatches a search when the final value/chip is removed.
    let appliedCount = changedFacetIds.size;
    const added = [];
    if (!isCurrent()) {
      return { supported: false, appliedCount: 0, added: [] };
    }
    await Promise.all(
      Array.from(changedFacetIds).map(function (facetId) {
        const values = desiredSelectedValuesByFacet.get(facetId) || [];
        values.forEach(function (value) {
          if (!currentSnapshot.get(`${facetId}\u001E${value}`)) {
            added.push({ facetId, value });
          }
        });
        return Promise.all(
          values.map(function (value) {
            return Promise.resolve(
              engine.dispatch(
                regularActions.toggleSelectFacetValue({
                  facetId,
                  selection: {
                    value,
                    state: "idle",
                  },
                }),
              ),
            );
          }),
        );
      }),
    );
    if (!isCurrent()) {
      return { supported: false, appliedCount: 0, added: [] };
    }

    return { supported: true, appliedCount, added };
  }

  async function waitForFacetSelectionSnapshotSync(
    facetGen,
    desiredSnapshot,
    maxFrames = 12,
  ) {
    if (!(desiredSnapshot instanceof Map)) return false;
    for (let frame = 0; frame < maxFrames; frame++) {
      const actualSnapshot = buildFacetSelectionSnapshot(facetGen);
      if (facetSelectionSnapshotsMatch(desiredSnapshot, actualSnapshot)) {
        return true;
      }
      await waitForNextAnimationFrame();
    }
    return facetSelectionSnapshotsMatch(
      desiredSnapshot,
      buildFacetSelectionSnapshot(facetGen),
    );
  }

  function isCoveoSearchResponseLoading() {
    if (window.__coveoSearchResponseLoading === true) return true;
    const root =
      document.getElementById("coveo-headless-search") ||
      document.getElementById("coveo-headless-collection");
    const state =
      root?._coveoSearch?.state ||
      root?._coveoSubControllers?.search?.state;
    return !!(state?.isLoading || state?.isLoadingMore);
  }

  function replayDeferredRangeUiRender(deferred) {
    if (!deferred?.facetGen) return;
    renderFacets(deferred.facetGen, deferred.opts || {});
  }

  function renderFacets(facetGen, opts) {
    opts = opts || {};
    const container = opts.container;
    const lifecycle = container?._coveoPageLifecycleOwner || null;
    if (lifecycle && !lifecycle.active) return;
    const content =
      (container &&
        container.nodeType === 1 &&
        container.querySelector("#CoveoFiltersDrawerContent")) ||
      document.getElementById("CoveoFiltersDrawerContent");
    const countEl = document.getElementById("coveo-filters-count");
    const searchRoot =
      container?.closest?.("#coveo-headless-search, #coveo-headless-collection") ||
      document.getElementById("coveo-headless-search") ||
      document.getElementById("coveo-headless-collection");
    const controller =
      opts.controller || content?._coveoController || searchRoot?._coveoSearch || null;
    const renderEngine =
      opts.engine || content?._coveoEngine || searchRoot?._coveoEngine || null;
    const renderMod =
      opts.mod || content?._coveoMod || searchRoot?._coveoMod || null;
    if (content) {
      if (opts.controller) content._coveoController = opts.controller;
      if (opts.engine) content._coveoEngine = opts.engine;
      if (opts.mod) content._coveoMod = opts.mod;
    }
    const schedule = function (callback, delay) {
      return lifecycle
        ? lifecycle.setTimeout(callback, delay)
        : window.setTimeout(callback, delay);
    };
    const clearScheduled = function (timerId) {
      if (timerId == null) return;
      if (lifecycle) lifecycle.clearTimeout(timerId);
      else window.clearTimeout(timerId);
    };
    const scheduleFrame = function (callback) {
      return lifecycle
        ? lifecycle.requestAnimationFrame(callback)
        : window.requestAnimationFrame(callback);
    };
    const cancelFrame = function (frameId) {
      if (frameId == null) return;
      if (lifecycle) lifecycle.cancelAnimationFrame(frameId);
      else window.cancelAnimationFrame(frameId);
    };
    const listen = function (target, type, listener, options) {
      if (lifecycle) return lifecycle.listen(target, type, listener, options);
      target?.addEventListener?.(type, listener, options);
      return listener;
    };
    if (!content) {
      if (countEl) countEl.classList.add("hidden");
      return;
    }
    if (hasActiveCoveoRangeUiInteraction()) {
      deferCoveoRangeUiRender({ facetGen, opts });
      return;
    }
    const suppressUntil = Number(content._coveoSuppressFacetRerenderUntil || 0);
    if (suppressUntil > Date.now()) {
      const remaining = Math.max(16, suppressUntil - Date.now() + 10);
      if (content._coveoDeferredFacetRenderTimer) {
        clearScheduled(content._coveoDeferredFacetRenderTimer);
      }
      content._coveoDeferredFacetRenderTimer = schedule(function () {
        content._coveoDeferredFacetRenderTimer = null;
        renderFacets(facetGen, opts);
      }, remaining);
      return;
    }
    updateAppliedFiltersCount(facetGen, controller, container);
    const liveFacets = flattenFacetControllers(facetGen);
    const conditionSelectedValues = reconcileConditionSelectionShadow(facetGen);
    const facets = ensureConditionFacetPresence(
      liveFacets,
      conditionSelectedValues,
    );
    const desiredDrawerSnapshot = buildDrawerDesiredSelectionSnapshot(
      content,
      facetGen,
    );
    const collapseFacetsOnRender =
      content._coveoCollapseFacetsOnNextRender === true;
    const openFacetIds = new Set();
    if (!collapseFacetsOnRender) {
      content.querySelectorAll("details[open][data-facet-id]").forEach((el) => {
        const id = el.getAttribute("data-facet-id");
        if (id) openFacetIds.add(id);
      });
      facets.forEach((f) => {
        const vals = normalizeFacetStateValues(f.state || {});
        const fid = f.facetId || f.state?.facetId;
        if (
          fid &&
          vals.some(function (v) {
            return v.state === "selected";
          })
        ) {
          openFacetIds.add(fid);
        }
      });
    }
    const hasRenderedConditionFacet = !!content.querySelector(
      "[data-condition-facet]",
    );
    if (
      !collapseFacetsOnRender &&
      hasRenderedConditionFacet &&
      appendPendingBoatFacetValuesInPlace(content, facetGen)
    ) {
      return;
    }
    if (
      !collapseFacetsOnRender &&
      hasRenderedConditionFacet &&
      shouldSkipFacetsDrawerFullRender(content)
    ) {
      pruneSyncedPendingFilterState(content, facetGen);
      reapplyPendingFilterStateAfterFacetRender(content);
      reapplyBoatSearchFilterAfterFacetRender(content);
      return;
    }
    const facetHtmlParts = [];
    let syntheticYearInserted = false;
    facets.forEach((f) => {
      facetHtmlParts.push(
        renderFacetGroup(f, openFacetIds, {
          conditionSelectedValues,
          desiredDrawerSnapshot,
        }),
      );
      if (
        !syntheticYearInserted &&
        !facetControllersIncludeYear(facets) &&
        facetIdsMatchPrice(f.facetId || f.state?.facetId)
      ) {
        facetHtmlParts.push(
          renderFacetGroup(buildSyntheticYearFacetStub(), openFacetIds, {
            conditionSelectedValues,
            desiredDrawerSnapshot,
          }),
        );
        syntheticYearInserted = true;
      }
    });
    if (
      liveFacets.length > 0 &&
      !syntheticYearInserted &&
      !facetControllersIncludeYear(facets)
    ) {
      facetHtmlParts.push(
        renderFacetGroup(buildSyntheticYearFacetStub(), openFacetIds, {
          conditionSelectedValues,
          desiredDrawerSnapshot,
        }),
      );
    }
    const _distanceBlockEl = document.getElementById(
      "coveo-distance-filter-block",
    );
    if (
      _distanceBlockEl &&
      content.contains(_distanceBlockEl) &&
      content.parentElement
    ) {
      content.parentElement.insertBefore(_distanceBlockEl, content);
    }
    const focusSnapshot = captureBoatSearchFocus(content);
    const drawerScrollSnapshot = captureFacetsDrawerScrollSnapshot(content);
    content.innerHTML = facetHtmlParts.join("");
    if (collapseFacetsOnRender) {
      content._coveoCollapseFacetsOnNextRender = false;
    }
    content._coveoRangeUiRenderVersion =
      Number(content._coveoRangeUiRenderVersion || 0) + 1;
    const rangeUiRenderVersion = content._coveoRangeUiRenderVersion;
    content._coveoFacetGen = facetGen;
    restoreBoatSearchFocus(content, focusSnapshot);
    restoreFacetsDrawerScrollPosition(content, drawerScrollSnapshot);
    mountDistanceFilterInDrawer(content);
    if (!window.__coveoFacetValuesRefreshInFlight) {
      scheduleMakeModelFacetAutoExpand(facetGen, content);
    }
    wireCoveoFacetDefaultWrapScrollLoad(
      content,
      facetGen,
      opts && opts.engine,
      opts && opts.mod,
      lifecycle,
    );
    restorePendingBoatFacetScrollPosition(content);
    pruneSyncedPendingFilterState(content, facetGen);
    reapplyPendingFilterStateAfterFacetRender(content);
    reapplyBoatSearchFilterAfterFacetRender(content);
    scheduleFrame(function () {
      if (content._coveoRangeUiRenderVersion !== rangeUiRenderVersion) return;
      restoreFacetsDrawerScrollPosition(content, drawerScrollSnapshot);
      restorePendingBoatFacetScrollPosition(content);
      scheduleFrame(function () {
        if (content._coveoRangeUiRenderVersion !== rangeUiRenderVersion) return;
        restoreFacetsDrawerScrollPosition(content, drawerScrollSnapshot);
        restorePendingBoatFacetScrollPosition(content);
        content._coveoPendingBoatFacetScrollRestore = null;
      });
    });
    function syncLengthDualSliderUi(container, minVal, maxVal, kind) {
      var minInput = container.querySelector(
        ".coveo-mobile-range-input--min",
      );
      var maxInput = container.querySelector(
        ".coveo-mobile-range-input--max",
      );
      if (!minInput || !maxInput) return;
      var lo = parseFloat(String(minInput.min));
      var hi = parseFloat(String(minInput.max));
      var span = hi - lo || 1;
      var a = Math.min(minVal, maxVal);
      var b = Math.max(minVal, maxVal);
      var pctA = span ? ((a - lo) / span) * 100 : 0;
      var pctB = span ? ((b - lo) / span) * 100 : 0;
      minInput.value = String(a);
      maxInput.value = String(b);
      var dual = container.querySelector(".coveo-mobile-length-dual");
      if (dual) {
        dual.style.setProperty("--l-pct-a", pctA + "%");
        dual.style.setProperty("--l-pct-b", pctB + "%");
        var thumbSize = 22;
        var minTx = (thumbSize * (50 - pctA)) / 100;
        var maxTx = (thumbSize * (50 - pctB)) / 100;
        dual.style.setProperty("--l-bubble-min-tx", minTx + "px");
        dual.style.setProperty("--l-bubble-max-tx", maxTx + "px");
      }
      var minBubble = container.querySelector(
        ".coveo-mobile-length-dual__bubble--min",
      );
      var maxBubble = container.querySelector(
        ".coveo-mobile-length-dual__bubble--max",
      );
      if (minBubble) {
        minBubble.textContent =
          kind === "price"
            ? formatCompactPriceBubbleValue(a)
            : kind === "length"
              ? formatLengthBubbleDisplay(a)
              : kind === "year"
                ? String(Math.round(a))
                : formatGenericNumericDisplay(a);
      }
      if (maxBubble) {
        maxBubble.textContent =
          kind === "price"
            ? formatCompactPriceBubbleValue(b)
            : kind === "length"
              ? formatLengthBubbleDisplay(b)
              : kind === "year"
                ? String(Math.round(b))
                : formatGenericNumericDisplay(b);
      }
      var fill = container.querySelector(
        ".coveo-mobile-length-dual__track-fill",
      );
      if (fill) {
        fill.style.left = pctA + "%";
        fill.style.width = Math.max(0, pctB - pctA) + "%";
      }
    }
    scheduleFrame(function () {
      if (content._coveoRangeUiRenderVersion !== rangeUiRenderVersion) return;
      content
        .querySelectorAll(
          '.coveo-mobile-range[data-range-kind="length"], .coveo-mobile-range[data-range-kind="year"], .coveo-mobile-range[data-range-kind="numeric"], .coveo-mobile-range[data-range-kind="price"]',
        )
        .forEach(function (rangeEl) {
          if (content._coveoRangeUiRenderVersion !== rangeUiRenderVersion) return;
          var kind = rangeEl.getAttribute("data-range-kind") || "length";
          var minInput = rangeEl.querySelector(".coveo-mobile-range-input--min");
          var maxInput = rangeEl.querySelector(".coveo-mobile-range-input--max");
          if (!minInput || !maxInput) return;
          var v0 = parseFloat(String(minInput.value));
          var v1 = parseFloat(String(maxInput.value));
          if (Number.isNaN(v0) || Number.isNaN(v1)) return;
          syncLengthDualSliderUi(rangeEl, v0, v1, kind);
        });
    });

    if (!content.dataset.mobileFacetControlsWired) {
      content.dataset.mobileFacetControlsWired = "true";

      listen(
        content,
        "toggle",
        function (e) {
          var det = e.target;
          if (!det || String(det.tagName) !== "DETAILS" || !det.open) return;
          var range = det.querySelector(
            '.coveo-mobile-range[data-range-kind="length"], .coveo-mobile-range[data-range-kind="year"], .coveo-mobile-range[data-range-kind="numeric"], .coveo-mobile-range[data-range-kind="price"]',
          );
          if (!range) return;
          var rk = range.getAttribute("data-range-kind") || "length";
          var minIn = range.querySelector(".coveo-mobile-range-input--min");
          var maxIn = range.querySelector(".coveo-mobile-range-input--max");
          if (!minIn || !maxIn) return;
          var v0 = parseFloat(String(minIn.value));
          var v1 = parseFloat(String(maxIn.value));
          if (Number.isNaN(v0) || Number.isNaN(v1)) return;
          scheduleFrame(function () {
            scheduleFrame(function () {
              syncLengthDualSliderUi(range, v0, v1, rk);
            });
          });
        },
        true,
      );

      var boatSearchFilterRafByFacet = {};
      listen(content, "input", function (e) {
        const target = e.target;
        if (!target) return;
        var boatSearch = target.closest?.(".coveo-mobile-boat-search__input");
        if (!boatSearch) return;
        var facetId = boatSearch
          .closest?.(".coveo-mobile-boat-search")
          ?.getAttribute("data-boat-search-for");
        if (!facetId) return;
        rememberBoatSearchQuery(facetId, boatSearch.value);
        if (boatSearchFilterRafByFacet[facetId]) {
          cancelFrame(boatSearchFilterRafByFacet[facetId]);
        }
        boatSearchFilterRafByFacet[facetId] = scheduleFrame(function () {
          boatSearchFilterRafByFacet[facetId] = 0;
          applyBoatSearchFilter(content, facetId, boatSearch.value);
          if (facetIdsMatchMake(facetId) || facetIdsMatchModel(facetId)) {
            void runMakeModelFacetSearch(content, facetId, boatSearch.value);
          }
        });
      });

      listen(
        content,
        "focusin",
        function (e) {
          const target = e.target;
          if (!target || !target.classList?.contains("coveo-mobile-boat-search__input")) return;
          return;
        },
        true,
      );

      function getRangeContainerFromEl(el) {
        if (!el) return null;
        return el.closest?.(".coveo-mobile-range");
      }

      function usesResponsivePriceRangeDrag(kind) {
        return kind === "price";
      }

      function applyRangeUiFrozenState(container, frozen) {
        if (!container) return;
        container.classList.toggle("is-frozen", !!frozen);
        container.setAttribute("aria-disabled", frozen ? "true" : "false");
        container
          .querySelectorAll(
            ".coveo-mobile-range-input--min, .coveo-mobile-range-input--max, .coveo-mobile-length-input--min, .coveo-mobile-length-input--max",
          )
          .forEach(function (input) {
            input.disabled = !!frozen;
          });
      }

      var rangeUiUnlockTimerByFacet = {};
      function lockCoveoRangeUi(container, facetId, durationMs) {
        if (!container || !facetId) return;
        const unlockTimers =
          content._coveoRangeUiUnlockTimerByFacet ||
          (content._coveoRangeUiUnlockTimerByFacet = {});
        const managedCommit = facetIdsMatchManagedRange(facetId);
        const targetContainers = managedCommit && content
          ? Array.from(content.querySelectorAll(".coveo-mobile-range"))
          : [container];
        if (!targetContainers.length) targetContainers.push(container);
        targetContainers.forEach(function (targetContainer) {
          const targetFacetId = String(
            targetContainer.getAttribute("data-facet-id") || facetId,
          );
          const rangeFacetId = targetFacetId;
          if (managedCommit && !facetIdsMatchManagedRange(rangeFacetId)) return;
          setCoveoRangeUiFrozen(targetFacetId, durationMs);
          applyRangeUiFrozenState(targetContainer, true);
          if (unlockTimers[targetFacetId]) {
            clearScheduled(unlockTimers[targetFacetId]);
          }
          unlockTimers[targetFacetId] = schedule(function () {
            if (isCoveoRangeUiFrozen(targetFacetId)) return;
            unlockCoveoRangeUiForFacet(targetFacetId);
            applyRangeUiFrozenState(targetContainer, false);
            clearScheduled(unlockTimers[targetFacetId]);
            delete unlockTimers[targetFacetId];
          }, Math.max(0, Number(durationMs) || 0) + 20);
        });
      }

      function unlockCoveoRangeUiForFacet(facetId) {
        if (!facetId || !content) return;
        const selector =
          '.coveo-mobile-range[data-facet-id="' + escapeAttr(facetId) + '"]';
        content.querySelectorAll(selector).forEach(function (container) {
          applyRangeUiFrozenState(container, false);
        });
      }

      function clampToInputBounds(value, inputMin, inputMax) {
        var out = value;
        if (Number.isFinite(inputMin)) out = Math.max(inputMin, out);
        if (Number.isFinite(inputMax)) out = Math.min(inputMax, out);
        return out;
      }

      function getActiveLengthThumb(container) {
        if (!container) return null;
        var thumb = container.getAttribute("data-active-thumb");
        return thumb === "min" || thumb === "max" ? thumb : null;
      }

      function setActiveLengthThumb(container, thumb) {
        if (!container) return;
        if (thumb === "min" || thumb === "max") {
          container.setAttribute("data-active-thumb", thumb);
        } else {
          container.removeAttribute("data-active-thumb");
        }
      }

      function rememberCustomRangeDragSelection(container, kind, minVal, maxVal) {
        if (!container || !kind) return;
        const lo = Math.min(minVal, maxVal);
        const hi = Math.max(minVal, maxVal);
        if (!Number.isFinite(lo) || !Number.isFinite(hi)) return;
        container._coveoLastCustomDragSelection = {
          kind,
          lo,
          hi,
        };
      }

      function reapplyRememberedCustomRangeDragSelection(container, options) {
        if (!container) return false;
        const remembered = container._coveoLastCustomDragSelection;
        if (!remembered || typeof remembered !== "object") return false;
        const kind = container.getAttribute("data-range-kind") || "";
        if (!kind || remembered.kind !== kind) return false;
        const minInput = container.querySelector(".coveo-mobile-range-input--min");
        const maxInput = container.querySelector(".coveo-mobile-range-input--max");
        if (!minInput || !maxInput) return false;

        const loBound = parseFloat(String(minInput.getAttribute("min") || ""));
        const hiBound = parseFloat(String(maxInput.getAttribute("max") || ""));
        let nextMin = Number(remembered.lo);
        let nextMax = Number(remembered.hi);
        if (!Number.isFinite(nextMin) || !Number.isFinite(nextMax)) return false;
        nextMin = clampToInputBounds(nextMin, loBound, hiBound);
        nextMax = clampToInputBounds(nextMax, loBound, hiBound);
        if (nextMin > nextMax) {
          const tmp = nextMin;
          nextMin = nextMax;
          nextMax = tmp;
        }
        if (kind === "length" || kind === "year" || kind === "numeric") {
          nextMin = Math.round(nextMin);
          nextMax = Math.round(nextMax);
        } else if (kind === "price") {
          nextMin = roundPriceToStep(nextMin, "round");
          nextMax = roundPriceToStep(nextMax, "round");
        }

        minInput.value = String(nextMin);
        maxInput.value = String(nextMax);
        const lenMinField = container.querySelector(".coveo-mobile-length-input--min");
        const lenMaxField = container.querySelector(".coveo-mobile-length-input--max");
        if (kind === "price") {
          if (lenMinField) lenMinField.value = formatPriceDisplay(nextMin);
          if (lenMaxField) lenMaxField.value = formatPriceDisplay(nextMax);
        } else if (kind === "length") {
          if (lenMinField) lenMinField.value = formatLengthFeetWhole(nextMin);
          if (lenMaxField) lenMaxField.value = formatLengthFeetWhole(nextMax);
        } else {
          if (lenMinField) lenMinField.value = String(nextMin);
          if (lenMaxField) lenMaxField.value = String(nextMax);
        }
        syncLengthDualSliderUi(container, nextMin, nextMax, kind);
        if (!options?.preserveOnly) {
          snapshotPendingRangeUi(container);
          if (options?.commitImmediately) {
            flushLengthRangeFacetCommit(container);
          } else {
            markLengthRangeFacetCommitPending(container);
          }
        }
        return true;
      }

      function resolveActiveLengthThumbFromPointer(container, clientX) {
        if (!container) return null;
        var rail = container.querySelector(".coveo-mobile-length-dual__rail");
        var minInput = container.querySelector(".coveo-mobile-range-input--min");
        var maxInput = container.querySelector(".coveo-mobile-range-input--max");
        if (!rail || !minInput || !maxInput) return null;
        var rect = rail.getBoundingClientRect();
        if (!(rect && rect.width > 0)) return null;
        var lo = parseFloat(String(minInput.getAttribute("min") || ""));
        var hi = parseFloat(String(maxInput.getAttribute("max") || ""));
        if (!Number.isFinite(lo) || !Number.isFinite(hi) || hi <= lo) return null;
        var minVal = parseFloat(String(minInput.value));
        var maxVal = parseFloat(String(maxInput.value));
        if (!Number.isFinite(minVal)) minVal = lo;
        if (!Number.isFinite(maxVal)) maxVal = hi;
        var span = hi - lo;
        var minCx = rect.left + ((minVal - lo) / span) * rect.width;
        var maxCx = rect.left + ((maxVal - lo) / span) * rect.width;
        var x = Math.max(rect.left, Math.min(rect.right, clientX));
        return Math.abs(x - minCx) <= Math.abs(x - maxCx) ? "min" : "max";
      }

      function getLengthThumbHitFromPointer(container, clientX) {
        if (!container) return null;
        var rail = container.querySelector(".coveo-mobile-length-dual__rail");
        var minInput = container.querySelector(".coveo-mobile-range-input--min");
        var maxInput = container.querySelector(".coveo-mobile-range-input--max");
        if (!rail || !minInput || !maxInput) return null;
        var rect = rail.getBoundingClientRect();
        if (!(rect && rect.width > 0)) return null;
        var lo = parseFloat(String(minInput.getAttribute("min") || ""));
        var hi = parseFloat(String(maxInput.getAttribute("max") || ""));
        if (!Number.isFinite(lo) || !Number.isFinite(hi) || hi <= lo) return null;
        var minVal = parseFloat(String(minInput.value));
        var maxVal = parseFloat(String(maxInput.value));
        if (!Number.isFinite(minVal)) minVal = lo;
        if (!Number.isFinite(maxVal)) maxVal = hi;
        var span = hi - lo;
        var minCx = rect.left + ((minVal - lo) / span) * rect.width;
        var maxCx = rect.left + ((maxVal - lo) / span) * rect.width;
        var kind = container.getAttribute("data-range-kind") || "";
        var thumbSize =
          kind === "price" &&
            typeof window !== "undefined" &&
            window.matchMedia &&
            window.matchMedia("(max-width: 767.98px)").matches
            ? 10
            : 22;
        var threshold = thumbSize * 0.5 + 6;
        var x = Math.max(rect.left, Math.min(rect.right, clientX));
        if (Math.abs(x - minCx) <= threshold) return "min";
        if (Math.abs(x - maxCx) <= threshold) return "max";
        return null;
      }

      /*
       * When both thumbs overlap, the visible max handle normally sits on top.
       * At the right boundary that makes the range impossible to reopen: the
       * max thumb cannot move any farther right and it blocks the min thumb.
       * Choose the only thumb that can expand a boundary-collapsed range, and
       * use the pointer direction for a collapsed value in the middle.
       */
      function resolveCollapsedLengthThumb(container, clientX) {
        if (!container) return null;
        var rail = container.querySelector(".coveo-mobile-length-dual__rail");
        var minInput = container.querySelector(".coveo-mobile-range-input--min");
        var maxInput = container.querySelector(".coveo-mobile-range-input--max");
        if (!rail || !minInput || !maxInput) return null;
        var rect = rail.getBoundingClientRect();
        if (!(rect && rect.width > 0)) return null;
        var lo = parseFloat(String(minInput.getAttribute("min") || ""));
        var hi = parseFloat(String(maxInput.getAttribute("max") || ""));
        var minVal = parseFloat(String(minInput.value));
        var maxVal = parseFloat(String(maxInput.value));
        if (
          !Number.isFinite(lo) ||
          !Number.isFinite(hi) ||
          hi <= lo ||
          !Number.isFinite(minVal) ||
          !Number.isFinite(maxVal)
        ) {
          return null;
        }
        var valueEps = Math.max((hi - lo) * 0.000001, 0.000001);
        if (Math.abs(maxVal - minVal) > valueEps) return null;

        var value = (minVal + maxVal) / 2;
        var centerX = rect.left + ((value - lo) / (hi - lo)) * rect.width;
        var x = Math.max(rect.left, Math.min(rect.right, clientX));
        if (x < centerX - 1) return "min";
        if (x > centerX + 1) return "max";
        if (value >= hi - valueEps) return "min";
        if (value <= lo + valueEps) return "max";
        return null;
      }

      function setLengthValueFromRailPointer(container, clientX) {
        if (!container) return;
        var kind = container.getAttribute("data-range-kind") || "";
        if (
          kind !== "length" &&
          kind !== "year" &&
          kind !== "numeric" &&
          kind !== "price"
        )
          return;
        var rail = container.querySelector(".coveo-mobile-length-dual__rail");
        var minInput = container.querySelector(".coveo-mobile-range-input--min");
        var maxInput = container.querySelector(".coveo-mobile-range-input--max");
        if (!rail || !minInput || !maxInput) return;

        var rect = rail.getBoundingClientRect();
        if (!(rect && rect.width > 0)) return;
        var x = Math.max(rect.left, Math.min(rect.right, clientX));
        var ratio = (x - rect.left) / rect.width;

        var lo = parseFloat(String(minInput.getAttribute("min") || ""));
        var hi = parseFloat(String(maxInput.getAttribute("max") || ""));
        if (!Number.isFinite(lo) || !Number.isFinite(hi) || hi <= lo) return;

        var rawVal = lo + ratio * (hi - lo);
        var stepRaw = parseFloat(String(minInput.getAttribute("step") || ""));
        var step =
          Number.isFinite(stepRaw) && stepRaw > 0
            ? stepRaw
            : kind === "year"
              ? 1
              : kind === "price"
                ? 1000
                : kind === "numeric"
                  ? 1
                  : kind === "length"
                    ? 1
                    : 0.1;
        var snapped = Math.round(rawVal / step) * step;
        if (
          kind === "year" ||
          kind === "price" ||
          kind === "numeric" ||
          kind === "length"
        ) {
          snapped = Math.round(snapped);
        } else {
          snapped = Number(snapped.toFixed(6));
        }
        snapped = clampToInputBounds(snapped, lo, hi);

        var minVal = parseFloat(String(minInput.value));
        var maxVal = parseFloat(String(maxInput.value));
        if (!Number.isFinite(minVal)) minVal = lo;
        if (!Number.isFinite(maxVal)) maxVal = hi;

        var active =
          resolveCollapsedLengthThumb(container, clientX) ||
          getActiveLengthThumb(container);
        if (!active) {
          var distToMin = Math.abs(snapped - minVal);
          var distToMax = Math.abs(snapped - maxVal);
          active = distToMin <= distToMax ? "min" : "max";
        }

        if (active === "min") {
          minVal = Math.min(snapped, maxVal);
        } else {
          maxVal = Math.max(snapped, minVal);
        }

        setActiveLengthThumb(container, active);

        minVal = clampToInputBounds(minVal, lo, hi);
        maxVal = clampToInputBounds(maxVal, lo, hi);
        minInput.value = String(minVal);
        maxInput.value = String(maxVal);

        var lenMinField = container.querySelector(".coveo-mobile-length-input--min");
        var lenMaxField = container.querySelector(".coveo-mobile-length-input--max");
        if (kind === "price") {
          if (lenMinField) lenMinField.value = formatPriceDisplay(minVal);
          if (lenMaxField) lenMaxField.value = formatPriceDisplay(maxVal);
        } else if (kind === "length") {
          if (lenMinField) lenMinField.value = formatLengthFeetWhole(minVal);
          if (lenMaxField) lenMaxField.value = formatLengthFeetWhole(maxVal);
        } else {
          if (lenMinField) lenMinField.value = String(minVal);
          if (lenMaxField) lenMaxField.value = String(maxVal);
        }

        syncLengthDualSliderUi(container, minVal, maxVal, kind);
        rememberCustomRangeDragSelection(container, kind, minVal, maxVal);
        if (shouldDeferRangeFacetCommitUntilApply()) {
          markLengthRangeFacetCommitPending(container);
        } else if (shouldHoldRangeCommitUntilPointerRelease(container)) {
          markLengthRangeFacetCommitPending(container);
        } else {
          scheduleLengthRangeFacetCommit(container);
        }
      }

      function parsePoints(container) {
        try {
          var raw = container.getAttribute("data-points") || "";
          return raw
            .split(",")
            .map(function (s) {
              var n = parseFloat(s);
              return Number.isNaN(n) ? null : n;
            })
            .filter(function (x) {
              return x != null;
            })
            .sort(function (a, b) {
              return a - b;
            });
        } catch (_) {
          return [];
        }
      }

      function snapToNearest(num, points) {
        if (!points || !points.length) return num;
        var best = points[0];
        var bestDist = Math.abs(num - best);
        for (var i = 1; i < points.length; i++) {
          var d = Math.abs(num - points[i]);
          if (d < bestDist) {
            best = points[i];
            bestDist = d;
          }
        }
        return best;
      }

      function approxEqual(a, b) {
        return Math.abs(a - b) < 0.000001;
      }

      var lengthRangeCommitTimer = null;
      var pendingLengthRangeContainers = new Set();
      function markRangeFacetCommitApplied() {
        if (content) {
          content._coveoRangeFacetCommitApplied = true;
        }
      }
      function resolveRangeCommitEndpointValue(
        kind,
        visibleInput,
        rangeInput,
        fallbackBound,
      ) {
        var parseValue =
          kind === "price"
            ? parsePriceInputValue
            : function (raw) {
              return parseFloat(String(raw ?? ""));
            };
        var explicitValue = String(visibleInput?.value ?? "").trim();
        if (explicitValue !== "") {
          return parseValue(explicitValue);
        }
        var placeholderValue = String(
          visibleInput?.getAttribute?.("placeholder") || "",
        ).trim();
        if (placeholderValue !== "") {
          var parsedPlaceholder = parseValue(placeholderValue);
          if (Number.isFinite(parsedPlaceholder)) return parsedPlaceholder;
        }
        var parsedRangeValue = parseFloat(String(rangeInput?.value ?? ""));
        if (Number.isFinite(parsedRangeValue)) return parsedRangeValue;
        return Number.isFinite(fallbackBound) ? fallbackBound : NaN;
      }
      function snapshotPendingRangeUi(container) {
        if (!container) return;
        var facetIdSnap = container.getAttribute("data-facet-id");
        var kindSnap = container.getAttribute("data-range-kind") || "";
        if (
          !facetIdSnap ||
          (kindSnap !== "length" &&
            kindSnap !== "year" &&
            kindSnap !== "numeric" &&
            kindSnap !== "price")
        ) {
          return;
        }
        var minInputSnap = container.querySelector(
          ".coveo-mobile-range-input--min",
        );
        var maxInputSnap = container.querySelector(
          ".coveo-mobile-range-input--max",
        );
        if (!minInputSnap || !maxInputSnap) return;
        var lenMinSnap = container.querySelector(
          ".coveo-mobile-length-input--min",
        );
        var lenMaxSnap = container.querySelector(
          ".coveo-mobile-length-input--max",
        );
        var rangeLoSnap = parseFloat(
          String(container.getAttribute("data-range-lo") || ""),
        );
        var rangeHiSnap = parseFloat(
          String(container.getAttribute("data-range-hi") || ""),
        );
        if (!Number.isFinite(rangeLoSnap)) {
          rangeLoSnap = parseFloat(String(minInputSnap.getAttribute("min") || ""));
        }
        if (!Number.isFinite(rangeHiSnap)) {
          rangeHiSnap = parseFloat(String(maxInputSnap.getAttribute("max") || ""));
        }
        var loSnap = resolveRangeCommitEndpointValue(
          kindSnap,
          lenMinSnap,
          minInputSnap,
          rangeLoSnap,
        );
        var hiSnap = resolveRangeCommitEndpointValue(
          kindSnap,
          lenMaxSnap,
          maxInputSnap,
          rangeHiSnap,
        );
        if (!Number.isFinite(loSnap) || !Number.isFinite(hiSnap)) return;
        var hasRangeBoundsSnap =
          Number.isFinite(rangeLoSnap) && Number.isFinite(rangeHiSnap);
        setCoveoPendingRangeUiSnapshot(
          facetIdSnap,
          kindSnap,
          {
            lo: Math.min(loSnap, hiSnap),
            hi: Math.max(loSnap, hiSnap),
          },
          hasRangeBoundsSnap
            ? {
              lo: Math.min(rangeLoSnap, rangeHiSnap),
              hi: Math.max(rangeLoSnap, rangeHiSnap),
            }
            : null,
        );
        setCoveoLiveRangeUiSnapshot(facetIdSnap, kindSnap, {
          lo: Math.min(loSnap, hiSnap),
          hi: Math.max(loSnap, hiSnap),
        });
      }
      function markLengthRangeFacetCommitPending(container) {
        if (!container) return;
        pendingLengthRangeContainers.add(container);
        snapshotPendingRangeUi(container);
      }
      function shouldHoldRangeCommitUntilPointerRelease(container) {
        if (!container) return false;
        if (shouldDeferRangeFacetCommitUntilApply()) return false;
        return rangePointerDragContainer === container;
      }
      function scheduleLengthRangeFacetCommit(container) {
        if (!container) return;
        markLengthRangeFacetCommitPending(container);
        if (lengthRangeCommitTimer) clearScheduled(lengthRangeCommitTimer);
        lengthRangeCommitTimer = schedule(function () {
          lengthRangeCommitTimer = null;
          pendingLengthRangeContainers.forEach(function (pendingContainer) {
            flushLengthRangeFacetCommit(pendingContainer);
          });
          pendingLengthRangeContainers.clear();
        }, 50);
      }
      function flushLengthRangeFacetCommit(container, options) {
        var opts = options || {};
        var kind = container.getAttribute("data-range-kind") || "";
        if (
          kind !== "length" &&
          kind !== "year" &&
          kind !== "numeric" &&
          kind !== "price"
        )
          return;
        var minInput = container.querySelector(
          ".coveo-mobile-range-input--min",
        );
        var maxInput = container.querySelector(
          ".coveo-mobile-range-input--max",
        );
        if (!minInput || !maxInput) return;
        var lenMinField = container.querySelector(
          ".coveo-mobile-length-input--min",
        );
        var lenMaxField = container.querySelector(
          ".coveo-mobile-length-input--max",
        );
        var loBound;
        var hiBound;
        if (kind === "price") {
          loBound = parseFloat(
            String(container.getAttribute("data-range-lo") || ""),
          );
          hiBound = parseFloat(
            String(container.getAttribute("data-range-hi") || ""),
          );
        } else {
          loBound = parseFloat(String(minInput.getAttribute("min") || ""));
          hiBound = parseFloat(String(maxInput.getAttribute("max") || ""));
        }
        var minVal = resolveRangeCommitEndpointValue(
          kind,
          lenMinField,
          minInput,
          loBound,
        );
        var maxVal = resolveRangeCommitEndpointValue(
          kind,
          lenMaxField,
          maxInput,
          hiBound,
        );
        if (!Number.isFinite(minVal) || !Number.isFinite(maxVal)) return;
        if (Number.isFinite(loBound)) minVal = Math.max(loBound, minVal);
        if (Number.isFinite(hiBound)) minVal = Math.min(hiBound, minVal);
        if (Number.isFinite(loBound)) maxVal = Math.max(loBound, maxVal);
        if (Number.isFinite(hiBound)) maxVal = Math.min(hiBound, maxVal);
        var committedMin;
        var committedMax;
        if (kind === "year") {
          committedMin = Math.round(minVal);
          committedMax = Math.round(maxVal);
        } else if (kind === "price") {
          committedMin = roundPriceToStep(minVal, "round");
          committedMax = roundPriceToStep(maxVal, "round");
        } else if (kind === "numeric") {
          committedMin = Math.round(minVal);
          committedMax = Math.round(maxVal);
        } else {
          committedMin = Math.round(minVal);
          committedMax = Math.round(maxVal);
        }
        if (committedMin > committedMax) {
          var tmp = committedMin;
          committedMin = committedMax;
          committedMax = tmp;
        }
        minInput.value = String(committedMin);
        maxInput.value = String(committedMax);
        if (kind === "price") {
          if (lenMinField) lenMinField.value = formatPriceDisplay(committedMin);
          if (lenMaxField) lenMaxField.value = formatPriceDisplay(committedMax);
        } else if (kind === "length") {
          if (lenMinField) lenMinField.value = formatLengthFeetWhole(committedMin);
          if (lenMaxField) lenMaxField.value = formatLengthFeetWhole(committedMax);
        } else {
          if (lenMinField) lenMinField.value = String(committedMin);
          if (lenMaxField) lenMaxField.value = String(committedMax);
        }
        syncLengthDualSliderUi(container, committedMin, committedMax, kind);

        var rangeLo = parseFloat(
          String(container.getAttribute("data-range-lo") || ""),
        );
        var rangeHi = parseFloat(
          String(container.getAttribute("data-range-hi") || ""),
        );
        if (!Number.isFinite(rangeLo)) {
          rangeLo = parseFloat(String(minInput.getAttribute("min") || ""));
        }
        if (!Number.isFinite(rangeHi)) {
          rangeHi = parseFloat(String(maxInput.getAttribute("max") || ""));
        }
        var loR = Math.min(committedMin, committedMax);
        var hiR = Math.max(committedMin, committedMax);
        var span =
          Number.isFinite(rangeHi) && Number.isFinite(rangeLo)
            ? Math.max(rangeHi - rangeLo, 0)
            : 0;
        var eps = span > 1e-9 ? span * 1e-6 : 1e-4;
        var fullRange =
          Number.isFinite(rangeLo) &&
          Number.isFinite(rangeHi) &&
          loR <= rangeLo + eps &&
          hiR >= rangeHi - eps;

        var facetId = container.getAttribute("data-facet-id");
        if (!facetId) return;
        var deferCommitUntilApply =
          shouldDeferRangeFacetCommitUntilApply() && !opts.forceApply;
        lockCoveoRangeUi(container, facetId, COVEO_RANGE_COMMIT_LOCK_MS);
        if (content) {
          content._coveoSuppressFacetRerenderUntil =
            Date.now() + COVEO_RANGE_COMMIT_LOCK_MS;
        }
        var priceApiScale =
          kind === "price"
            ? parseFloat(
              String(container.getAttribute("data-price-api-scale") || "1"),
            ) || 1
            : 1;
        var searchContainer =
          document.getElementById("coveo-headless-search") ||
          document.getElementById("coveo-headless-collection");
        var subCtrl =
          (searchContainer && searchContainer._coveoSubControllers) || {};
        var facet = findFacetController(subCtrl.facetGen, facetId);
        if (kind === "year") {
          setCoveoLiveRangeUiSnapshot(
            facetId,
            kind,
            fullRange
              ? { fullRange: true }
              : { lo: loR, hi: hiR, fullRange: false },
          );
          setCoveoStickyRangeUiSnapshot(
            facetId,
            kind,
            fullRange
              ? { fullRange: true }
              : { lo: loR, hi: hiR, fullRange: false },
            2600,
          );
          if (deferCommitUntilApply) {
            syncCoveoPendingRangeUiSelectionToDomain(facetId, kind, {
              lo: rangeLo,
              hi: rangeHi,
            });
            return;
          }
          pendingLengthRangeContainers.delete(container);
          setCoveoYearFacetSelection(
            fullRange
              ? { fullRange: true }
              : { lo: loR, hi: hiR, fullRange: false },
          );
          clearCoveoPendingRangeUiSnapshot(facetId, {
            preserveSticky: true,
            preserveFrozen: true,
          });
          markRangeFacetCommitApplied();
          if (!shouldDeferRangeFacetCommitUntilApply()) {
            void dispatchCoveoSearch(
              controller,
              renderEngine,
              renderMod,
            ).catch(function (error) {
              console.warn("[Coveo Filters] Year search failed:", error);
            });
          }
          return;
        }
        if (!facet) return;

        var currentRanges = (facet.state && facet.state.values) || [];
        var currentlyFullRange =
          !currentRanges.length ||
          currentRanges.every(function (r) {
            return r.state !== "selected";
          });
        setCoveoLiveRangeUiSnapshot(
          facetId,
          kind,
          fullRange ? { fullRange: true } : { lo: loR, hi: hiR },
        );
        setCoveoStickyRangeUiSnapshot(
          facetId,
          kind,
          fullRange ? { fullRange: true } : { lo: loR, hi: hiR },
          2600,
        );
        if (deferCommitUntilApply) {
          syncCoveoPendingRangeUiSelectionToDomain(facetId, kind, {
            lo: rangeLo,
            hi: rangeHi,
          });
          return;
        }
        if (kind === "year") {
          setCoveoYearFacetSelection(
            fullRange
              ? { fullRange: true }
              : { lo: loR, hi: hiR, fullRange: false },
          );
        } else if (kind === "length" || kind === "price") {
          setCoveoFacetRangeSelection(
            facetId,
            fullRange ? { fullRange: true } : { lo: loR, hi: hiR },
          );
        }
        clearCoveoPendingRangeUiSnapshot(
          facetId,
          {
            preserveLive: usesResponsivePriceRangeDrag(kind),
            preserveSticky: true,
            preserveFrozen: true,
          },
        );
        if (!fullRange && currentRanges.length === 1) {
          var existing = currentRanges[0];
          var existingBounds = normalizeRangeBoundsForUiKind(
            {
              lo: existing?.start ?? existing?.lo ?? 0,
              hi: existing?.end ?? existing?.hi ?? 0,
            },
            kind,
          );
          if (
            existing &&
            existing.state === "selected" &&
            existingBounds &&
            Math.abs(existingBounds.lo - loR) < 1e-6 &&
            Math.abs(existingBounds.hi - hiR) < 1e-6
          ) {
            return;
          }
        }

        if (typeof facet.setRanges === "function") {
          try {
            if (fullRange) {
              facet.setRanges([]);
            } else {
              facet.setRanges([
                {
                  start:
                    kind === "price"
                      ? toCoveoPriceFacetApiValue(loR, priceApiScale)
                      : loR,
                  end:
                    kind === "price"
                      ? toCoveoPriceFacetApiValue(hiR, priceApiScale)
                      : hiR,
                  endInclusive: true,
                  state: "selected",
                },
              ]);
            }
            markRangeFacetCommitApplied();
            return;
          } catch (_) { }
        }

        var snapshotValues = normalizeFacetStateValues(
          facet.state || {},
        ).slice();
        var targetRawValues = [];
        if (!fullRange) {
          snapshotValues.forEach(function (v) {
            var bounds = normalizeRangeBoundsForUiKind(
              facetItemNumericBounds(v),
              kind,
            );
            if (!bounds) return;
            var overlapsRange =
              bounds.hi > loR + 1e-6 && bounds.lo < hiR - 1e-6;
            var degenerate =
              Math.abs(bounds.hi - bounds.lo) < 1e-9 &&
              bounds.lo >= loR - 1e-6 &&
              bounds.lo <= hiR + 1e-6;
            if (overlapsRange || degenerate) {
              var raw = facetItemRawValue(v);
              if (raw !== "" && raw != null) {
                targetRawValues.push(String(raw));
              }
            }
          });
        }

        if (typeof facet.deselectAll === "function") {
          try {
            facet.deselectAll();
          } catch (_) { }
        }

        if (typeof facet.toggleSelect === "function") {
          targetRawValues.forEach(function (rawStr) {
            var currentValues = normalizeFacetStateValues(facet.state || {});
            var target = currentValues.find(function (cv) {
              return String(facetItemRawValue(cv)) === rawStr;
            });
            if (target) {
              try {
                facet.toggleSelect(target);
              } catch (_) { }
            }
          });
        }
      }

      listen(content, "input", function (e) {
        var target = e.target;
        if (!target) return;
        var isRangeMin = target.classList?.contains?.(
          "coveo-mobile-range-input--min",
        );
        var isRangeMax = target.classList?.contains?.(
          "coveo-mobile-range-input--max",
        );
        var isLenMin = target.classList?.contains?.(
          "coveo-mobile-length-input--min",
        );
        var isLenMax = target.classList?.contains?.(
          "coveo-mobile-length-input--max",
        );
        if (!isRangeMin && !isRangeMax && !isLenMin && !isLenMax) return;
        var container = getRangeContainerFromEl(target);
        if (!container) return;
        if (container.classList?.contains("is-frozen")) return;
        if (shouldIgnoreNativeRangeEvent(container, target)) return;
        var kind = container.getAttribute("data-range-kind") || "";
        if (
          kind !== "length" &&
          kind !== "year" &&
          kind !== "numeric" &&
          kind !== "price"
        )
          return;
        retirePendingInitialCoveoUrlHydration();

        var minInput = container.querySelector(
          ".coveo-mobile-range-input--min",
        );
        var maxInput = container.querySelector(
          ".coveo-mobile-range-input--max",
        );
        if (!minInput || !maxInput) return;

        var loAttr = parseFloat(String(minInput.getAttribute("min") || ""));
        var hiAttr = parseFloat(String(maxInput.getAttribute("max") || ""));
        function clamp(n) {
          if (!Number.isFinite(n)) return n;
          if (Number.isFinite(loAttr)) n = Math.max(loAttr, n);
          if (Number.isFinite(hiAttr)) n = Math.min(hiAttr, n);
          return n;
        }

        var minVal;
        var maxVal;
        /*
         * For the price kind the visible Min/Max inputs are formatted
         * currency strings, so we read with `parsePriceInputValue` and
         * write back with `formatPriceDisplay`. For other kinds we keep
         * the existing raw-number behavior.
         */
        var parseField =
          kind === "price"
            ? function (v) {
              return parsePriceInputValue(v);
            }
            : function (v) {
              var n = parseFloat(String(v));
              if (kind === "length" && Number.isFinite(n)) n = Math.round(n);
              return n;
            };
        var formatField =
          kind === "price"
            ? function (n) {
              return formatPriceDisplay(n);
            }
            : kind === "length"
              ? function (n) {
                return formatLengthFeetWhole(n);
              }
              : function (n) {
                return String(n);
              };

        if (isLenMin || isLenMax) {
          if (isLenMin) setActiveLengthThumb(container, "min");
          else if (isLenMax) setActiveLengthThumb(container, "max");
          var lenMinField = container.querySelector(
            ".coveo-mobile-length-input--min",
          );
          var lenMaxField = container.querySelector(
            ".coveo-mobile-length-input--max",
          );
          if (!lenMinField || !lenMaxField) return;
          minVal = parseField(lenMinField.value);
          maxVal = parseField(lenMaxField.value);
          /*
           * Keep partial manual entry intact while the user is typing the
           * second bound for year/price/length-style filters. If we clamp
           * and reconcile on every keystroke, a transient partial value in
           * the second field can snap into the domain and overwrite the
           * already-entered first field. We only live-sync the slider once
           * both typed values form a coherent range; blur/change still
           * performs the final normalized commit.
           */
          if (Number.isNaN(minVal) || Number.isNaN(maxVal)) return;
          minVal = clamp(minVal);
          maxVal = clamp(maxVal);
          if (minVal > maxVal) return;
          minInput.value = String(minVal);
          maxInput.value = String(maxVal);
        } else {
          minVal = parseFloat(String(minInput.value));
          maxVal = parseFloat(String(maxInput.value));
          if (Number.isNaN(minVal) || Number.isNaN(maxVal)) return;

          if (minVal > maxVal) {
            if (target.classList.contains("coveo-mobile-range-input--min")) {
              maxInput.value = String(minVal);
              maxVal = minVal;
            } else {
              minInput.value = String(maxVal);
              minVal = maxVal;
            }
          }
          var lfMin = container.querySelector(
            ".coveo-mobile-length-input--min",
          );
          var lfMax = container.querySelector(
            ".coveo-mobile-length-input--max",
          );
          if (lfMin) lfMin.value = formatField(minVal);
          if (lfMax) lfMax.value = formatField(maxVal);
        }

        syncLengthDualSliderUi(container, minVal, maxVal, kind);
        snapshotPendingRangeUi(container);
        if (shouldDeferRangeFacetCommitUntilApply()) {
          markLengthRangeFacetCommitPending(container);
        }
      });

      var rangePointerDragContainer = null;
      var rangePointerDragPointerId = null;
      var rangePointerCaptureTarget = null;
      var rangePointerLatestClientX = null;
      var rangePointerMoveRaf = null;
      var rangePointerFinalizing = false;
      var rangePointerEventTarget =
        (content && content.ownerDocument) || document;

      function applyQueuedRangePointerMove() {
        rangePointerMoveRaf = null;
        if (!rangePointerDragContainer) {
          rangePointerLatestClientX = null;
          return;
        }
        var clientX = rangePointerLatestClientX;
        rangePointerLatestClientX = null;
        if (!Number.isFinite(clientX)) return;
        setLengthValueFromRailPointer(rangePointerDragContainer, clientX);
      }

      function queueRangePointerMove(clientX) {
        if (!Number.isFinite(clientX)) return;
        rangePointerLatestClientX = clientX;
        if (rangePointerMoveRaf != null) return;
        rangePointerMoveRaf = scheduleFrame(applyQueuedRangePointerMove);
      }

      function flushQueuedRangePointerMove() {
        if (rangePointerMoveRaf != null) {
          cancelFrame(rangePointerMoveRaf);
          rangePointerMoveRaf = null;
        }
        applyQueuedRangePointerMove();
      }

      function isNativeRangeThumbTarget(target) {
        if (!target || !target.classList) return false;
        return (
          target.classList.contains("coveo-mobile-range-input--min") ||
          target.classList.contains("coveo-mobile-range-input--max")
        );
      }

      function markCustomRangeDragState(container, isActive) {
        if (!container) return;
        if (isActive) {
          container._coveoCustomRangeDragActive = true;
          container._coveoIgnoreNativeRangeEventsUntil = 0;
        } else {
          container._coveoCustomRangeDragActive = false;
          container._coveoIgnoreNativeRangeEventsUntil = Date.now() + 220;
        }
      }

      function shouldIgnoreNativeRangeEvent(container, target) {
        if (!container || !isNativeRangeThumbTarget(target)) return false;
        if (container._coveoCustomRangeDragActive) return true;
        var until = Number(container._coveoIgnoreNativeRangeEventsUntil || 0);
        return until > Date.now();
      }

      listen(content, "focusin", function (e) {
        var target = e.target;
        if (!target) return;
        var rangeContainer = getRangeContainerFromEl(target);
        if (!rangeContainer) return;
        if (
          target.classList?.contains("coveo-mobile-length-input--min") ||
          target.classList?.contains("coveo-mobile-range-input--min")
        ) {
          setActiveLengthThumb(rangeContainer, "min");
        } else if (
          target.classList?.contains("coveo-mobile-length-input--max") ||
          target.classList?.contains("coveo-mobile-range-input--max")
        ) {
          setActiveLengthThumb(rangeContainer, "max");
        }
      });

      function beginCustomRangePointerDrag(e) {
        var target = e.target;
        if (!target) return;
        var rangeContainer = getRangeContainerFromEl(target);
        if (!rangeContainer) return;
        if (rangeContainer.classList?.contains("is-frozen")) return;
        var onMin = target.classList?.contains("coveo-mobile-range-input--min");
        var onMax = target.classList?.contains("coveo-mobile-range-input--max");
        var onHandleMin = target.classList?.contains(
          "coveo-mobile-length-dual__handle--min",
        );
        var onHandleMax = target.classList?.contains(
          "coveo-mobile-length-dual__handle--max",
        );
        var rail = target.closest?.(".coveo-mobile-length-dual__rail");
        var intendedThumb = resolveActiveLengthThumbFromPointer(
          rangeContainer,
          e.clientX,
        );
        var hitThumb = getLengthThumbHitFromPointer(
          rangeContainer,
          e.clientX,
        );
        var collapsedThumb = resolveCollapsedLengthThumb(
          rangeContainer,
          e.clientX,
        );
        var targetThumb = collapsedThumb || (onHandleMin
          ? "min"
          : onHandleMax
            ? "max"
            : hitThumb || intendedThumb || (onMin ? "min" : onMax ? "max" : null));

        if (targetThumb) {
          setActiveLengthThumb(rangeContainer, targetThumb);
        }

        if (!(onMin || onMax || onHandleMin || onHandleMax || rail)) return;
        retirePendingInitialCoveoUrlHydration();
        try {
          e.preventDefault();
          e.stopPropagation();
        } catch (_) { }
        rangePointerDragContainer = rangeContainer;
        rangePointerDragPointerId = e.pointerId;
        beginCoveoRangeUiInteraction(
          rangeContainer.getAttribute("data-facet-id"),
          e.pointerId,
        );
        markCustomRangeDragState(rangeContainer, true);
        if (targetThumb) {
          setActiveLengthThumb(rangeContainer, targetThumb);
        }
        try {
          rangePointerCaptureTarget = usesResponsivePriceRangeDrag(
            rangeContainer.getAttribute("data-range-kind") || "",
          )
            ? rail || target
            : target;
          rangePointerCaptureTarget.setPointerCapture?.(e.pointerId);
        } catch (_) { }
        if (rail || hitThumb !== targetThumb) {
          setLengthValueFromRailPointer(rangeContainer, e.clientX);
        }
      }

      /*
       * Price facets are re-rendered after each committed range. Delegate
       * their pointer start from the stable document so a replacement handle
       * remains draggable without rewiring the rest of the range controls.
       */
      listen(
        rangePointerEventTarget,
        "pointerdown",
        function (e) {
          var rangeContainer = getRangeContainerFromEl(e.target);
          if (
            !rangeContainer ||
            !usesResponsivePriceRangeDrag(
              rangeContainer.getAttribute("data-range-kind") || "",
            )
          ) {
            return;
          }
          if (!content.contains(rangeContainer)) {
            return;
          }
          beginCustomRangePointerDrag(e);
        },
        { passive: false, capture: true },
      );

      listen(
        content,
        "pointerdown",
        function (e) {
          var rangeContainer = getRangeContainerFromEl(e.target);
          if (
            rangeContainer &&
            usesResponsivePriceRangeDrag(
              rangeContainer.getAttribute("data-range-kind") || "",
            )
          ) {
            return;
          }
          beginCustomRangePointerDrag(e);
        },
        { passive: false, capture: true },
      );

      listen(
        rangePointerEventTarget,
        "pointermove",
        function (e) {
          if (!rangePointerDragContainer) return;
          if (
            rangePointerDragPointerId != null &&
            e.pointerId != null &&
            e.pointerId !== rangePointerDragPointerId
          ) {
            return;
          }
          if (e.pointerType === "mouse" && e.buttons === 0) {
            clearRangePointerDrag();
            return;
          }
          try {
            e.preventDefault();
          } catch (_) { }
          var coalescedEvents =
            typeof e.getCoalescedEvents === "function"
              ? e.getCoalescedEvents()
              : null;
          var latestEvent =
            coalescedEvents && coalescedEvents.length
              ? coalescedEvents[coalescedEvents.length - 1]
              : e;
          var dragKind =
            rangePointerDragContainer.getAttribute("data-range-kind") || "";
          if (usesResponsivePriceRangeDrag(dragKind)) {
            queueRangePointerMove(latestEvent.clientX);
          } else {
            setLengthValueFromRailPointer(
              rangePointerDragContainer,
              latestEvent.clientX,
            );
          }
        },
        { passive: false, capture: true },
      );

      function clearRangePointerDrag() {
        if (
          rangePointerFinalizing ||
          (!rangePointerDragContainer && rangePointerDragPointerId == null)
        ) {
          return;
        }
        rangePointerFinalizing = true;
        const releasedContainer = rangePointerDragContainer;
        const releasedPointerId = rangePointerDragPointerId;
        try {
          flushQueuedRangePointerMove();
          if (releasedContainer) {
            markCustomRangeDragState(releasedContainer, false);
            if (!shouldDeferRangeFacetCommitUntilApply()) {
              try {
                flushLengthRangeFacetCommit(releasedContainer);
              } catch (_) { }
            }
            const stabilizeToken =
              Number(releasedContainer._coveoCustomDragStabilizeToken || 0) + 1;
            releasedContainer._coveoCustomDragStabilizeToken = stabilizeToken;
            scheduleFrame(function () {
              scheduleFrame(function () {
                if (
                  releasedContainer._coveoCustomDragStabilizeToken !== stabilizeToken
                ) {
                  return;
                }
                try {
                  var releasedKind =
                    releasedContainer.getAttribute("data-range-kind") || "";
                  reapplyRememberedCustomRangeDragSelection(
                    releasedContainer,
                    usesResponsivePriceRangeDrag(releasedKind)
                      ? { preserveOnly: true }
                      : {
                        commitImmediately:
                          !shouldDeferRangeFacetCommitUntilApply(),
                      },
                  );
                } catch (_) { }
                delete releasedContainer._coveoLastCustomDragSelection;
              });
            });
            setActiveLengthThumb(releasedContainer, null);
          }
          if (
            rangePointerCaptureTarget &&
            releasedPointerId != null &&
            rangePointerCaptureTarget.hasPointerCapture?.(
              releasedPointerId,
            )
          ) {
            rangePointerCaptureTarget.releasePointerCapture?.(
              releasedPointerId,
            );
          }
        } catch (_) {
        } finally {
          rangePointerDragContainer = null;
          rangePointerDragPointerId = null;
          rangePointerCaptureTarget = null;
          rangePointerLatestClientX = null;
          const deferred = finishCoveoRangeUiInteraction(releasedPointerId);
          if (deferred) replayDeferredRangeUiRender(deferred);
          rangePointerFinalizing = false;
        }
      }

      function cancelRangePointerDragForTeardown() {
        const releasedContainer = rangePointerDragContainer;
        const releasedPointerId = rangePointerDragPointerId;
        cancelFrame(rangePointerMoveRaf);
        rangePointerMoveRaf = null;
        rangePointerLatestClientX = null;
        if (releasedContainer) {
          markCustomRangeDragState(releasedContainer, false);
          setActiveLengthThumb(releasedContainer, null);
        }
        try {
          if (
            rangePointerCaptureTarget &&
            releasedPointerId != null &&
            rangePointerCaptureTarget.hasPointerCapture?.(releasedPointerId)
          ) {
            rangePointerCaptureTarget.releasePointerCapture?.(releasedPointerId);
          }
        } catch (_) { }
        rangePointerDragContainer = null;
        rangePointerDragPointerId = null;
        rangePointerCaptureTarget = null;
        rangePointerFinalizing = false;
        if (releasedPointerId != null) {
          cancelCoveoRangeUiInteraction(releasedPointerId);
        }
      }

      lifecycle?.addCleanup(function () {
        delete content.dataset.mobileFacetControlsWired;
        content._coveoRangeUiRenderVersion =
          Number(content._coveoRangeUiRenderVersion || 0) + 1;
        Object.values(boatSearchFilterRafByFacet).forEach(cancelFrame);
        clearScheduled(lengthRangeCommitTimer);
        lengthRangeCommitTimer = null;
        const unlockTimers = content._coveoRangeUiUnlockTimerByFacet || {};
        Object.values(unlockTimers).forEach(clearScheduled);
        content._coveoRangeUiUnlockTimerByFacet = {};
        const makeModelState = getMakeModelFacetSearchState(content, false);
        if (makeModelState) {
          makeModelState.destroyed = true;
          Object.values(makeModelState.timersByFacetId || {}).forEach(
            clearScheduled,
          );
          makeModelState.timersByFacetId = {};
        }
        cancelRangePointerDragForTeardown();
      });

      listen(
        rangePointerEventTarget,
        "pointerup",
        function (e) {
          if (
            rangePointerDragPointerId != null &&
            e.pointerId != null &&
            e.pointerId !== rangePointerDragPointerId
          ) {
            return;
          }
          if (
            rangePointerDragContainer &&
            usesResponsivePriceRangeDrag(
              rangePointerDragContainer.getAttribute("data-range-kind") || "",
            ) &&
            Number.isFinite(e.clientX)
          ) {
            rangePointerLatestClientX = e.clientX;
          }
          try {
            // The last pointer coordinate is committed before teardown.
          } finally {
            clearRangePointerDrag();
          }
        },
        { passive: true, capture: true },
      );

      listen(
        rangePointerEventTarget,
        "pointercancel",
        function (e) {
          if (
            rangePointerDragPointerId != null &&
            e.pointerId != null &&
            e.pointerId !== rangePointerDragPointerId
          ) {
            return;
          }
          clearRangePointerDrag();
        },
        { passive: true, capture: true },
      );

      listen(
        rangePointerEventTarget,
        "lostpointercapture",
        function () {
          clearRangePointerDrag();
        },
        { passive: true, capture: true },
      );
      listen(window, "blur", function () {
        clearRangePointerDrag();
      });
      listen(document, "visibilitychange", function () {
        if (document.hidden) clearRangePointerDrag();
      });

      listen(content, "keydown", function (e) {
        var target = e.target;
        if (!target || e.key !== "Enter") return;
        if (
          !target.classList?.contains("coveo-mobile-length-input--min") &&
          !target.classList?.contains("coveo-mobile-length-input--max") &&
          !target.classList?.contains("coveo-mobile-price-input--min") &&
          !target.classList?.contains("coveo-mobile-price-input--max")
        ) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        var containerK = getRangeContainerFromEl(target);
        if (!containerK) return;
        target.blur?.();
      });

      listen(content, "change", function (e) {
        const target = e.target;
        if (!target) return;

        if (
          target.classList?.contains("coveo-mobile-length-input--min") ||
          target.classList?.contains("coveo-mobile-length-input--max")
        ) {
          var containerLen = getRangeContainerFromEl(target);
          if (containerLen) {
            if (containerLen.classList?.contains("is-frozen")) return;
            try {
              target.dispatchEvent(
                new Event("input", { bubbles: true, cancelable: true }),
              );
            } catch (_) { }
            if (shouldDeferRangeFacetCommitUntilApply()) {
              markLengthRangeFacetCommitPending(containerLen);
            } else {
              flushLengthRangeFacetCommit(containerLen);
            }
          }
          return;
        }

        if (
          target.classList?.contains("coveo-mobile-range-input") ||
          target.classList?.contains("coveo-mobile-range-input--min") ||
          target.classList?.contains("coveo-mobile-range-input--max")
        ) {
          var containerR = getRangeContainerFromEl(target);
          if (!containerR) return;
          if (containerR.classList?.contains("is-frozen")) return;
          if (shouldIgnoreNativeRangeEvent(containerR, target)) return;
          var kindR = containerR.getAttribute("data-range-kind") || "";
          if (
            (kindR === "length" ||
              kindR === "year" ||
              kindR === "numeric" ||
              kindR === "price")
          ) {
            if (shouldDeferRangeFacetCommitUntilApply()) {
              markLengthRangeFacetCommitPending(containerR);
            } else {
              flushLengthRangeFacetCommit(containerR);
            }
          }
          return;
        }

        if (
          target.classList?.contains("coveo-mobile-price-input--min") ||
          target.classList?.contains("coveo-mobile-price-input--max")
        ) {
          var containerP = getRangeContainerFromEl(target);
          if (!containerP) return;
          if (containerP.classList?.contains("is-frozen")) return;
          var kindP = containerP.getAttribute("data-range-kind") || "";
          if (kindP !== "price") return;
          var pointsP = parsePoints(containerP);
          if (!pointsP.length) return;

          var minField = containerP.querySelector(
            ".coveo-mobile-price-input--min",
          );
          var maxField = containerP.querySelector(
            ".coveo-mobile-price-input--max",
          );
          if (!minField || !maxField) return;

          /*
           * Price inputs are `type="text"` and present formatted strings
           * (e.g. "$1,234,000"). `parsePriceInputValue` strips the
           * non-digit chrome before we snap.
           */
          var rawMin = parsePriceInputValue(minField.value);
          var rawMax = parsePriceInputValue(maxField.value);
          if (Number.isNaN(rawMin) || Number.isNaN(rawMax)) return;

          /*
           * Always snap price inputs to the $1,000 grid so the slider, the
           * input fields, and the facet request agree on bucket boundaries.
           */
          var snappedMinP = roundPriceToStep(
            snapToNearest(rawMin, pointsP),
            "round",
          );
          var snappedMaxP = roundPriceToStep(
            snapToNearest(rawMax, pointsP),
            "round",
          );

          var loBoundP = parseFloat(
            String(containerP.getAttribute("data-range-lo") || ""),
          );
          var hiBoundP = parseFloat(
            String(containerP.getAttribute("data-range-hi") || ""),
          );
          if (Number.isFinite(loBoundP)) {
            snappedMinP = Math.max(loBoundP, snappedMinP);
            snappedMaxP = Math.max(loBoundP, snappedMaxP);
          }
          if (Number.isFinite(hiBoundP)) {
            snappedMinP = Math.min(hiBoundP, snappedMinP);
            snappedMaxP = Math.min(hiBoundP, snappedMaxP);
          }
          if (snappedMinP > snappedMaxP) {
            var tmp2 = snappedMinP;
            snappedMinP = snappedMaxP;
            snappedMaxP = tmp2;
          }

          var minRange = containerP.querySelector(
            ".coveo-mobile-range-input--min",
          );
          var maxRange = containerP.querySelector(
            ".coveo-mobile-range-input--max",
          );
          if (minRange && maxRange) {
            minField.value = formatPriceDisplay(snappedMinP);
            maxField.value = formatPriceDisplay(snappedMaxP);
            minRange.value = String(snappedMinP);
            maxRange.value = String(snappedMaxP);
            syncLengthDualSliderUi(
              containerP,
              snappedMinP,
              snappedMaxP,
              "price",
            );
            if (shouldDeferRangeFacetCommitUntilApply()) {
              markLengthRangeFacetCommitPending(containerP);
            } else {
              flushLengthRangeFacetCommit(containerP);
            }
            return;
          }

          var hiddenP = containerP.querySelector(".coveo-mobile-range__hidden");
          if (!hiddenP) return;
          hiddenP
            .querySelectorAll("input.coveo-mobile-range-hidden-checkbox")
            .forEach(function (cb) {
              var cbNum = parseFloat(String(cb.dataset.num));
              var shouldBeChecked =
                approxEqual(cbNum, snappedMinP) ||
                approxEqual(cbNum, snappedMaxP);
              if (cb.checked !== shouldBeChecked) {
                cb.checked = shouldBeChecked;
                cb.dispatchEvent(
                  new Event("change", { bubbles: true, cancelable: true }),
                );
              }
            });
          return;
        }
      });

      content._coveoFlushPendingLengthRangeCommits = function () {
        if (lengthRangeCommitTimer) {
          clearScheduled(lengthRangeCommitTimer);
          lengthRangeCommitTimer = null;
        }
        pendingLengthRangeContainers.forEach(function (pendingContainer) {
          flushLengthRangeFacetCommit(pendingContainer, {
            forceApply: true
          });
        });
        pendingLengthRangeContainers.clear();
        clearAllCoveoPendingRangeUiSnapshots({
          preserveSticky: true,
          preserveFrozen: true,
        });
      };

      content._coveoHasPendingLengthRangeCommits = function () {
        return pendingLengthRangeContainers.size > 0;
      };

      content._coveoFlushAllLengthRangeCommits = function () {
        if (lengthRangeCommitTimer) {
          clearScheduled(lengthRangeCommitTimer);
          lengthRangeCommitTimer = null;
        }
        var allLengthRanges = content.querySelectorAll(
          '.coveo-mobile-range[data-range-kind="length"], .coveo-mobile-range[data-range-kind="year"], .coveo-mobile-range[data-range-kind="numeric"], .coveo-mobile-range[data-range-kind="price"]',
        );
        allLengthRanges.forEach(function (rangeContainer) {
          flushLengthRangeFacetCommit(rangeContainer, { forceApply: true });
        });
        pendingLengthRangeContainers.clear();
        clearAllCoveoPendingRangeUiSnapshots({
          preserveSticky: true,
          preserveFrozen: true,
        });
      };

      content._coveoDiscardPendingLengthRangeCommits = function () {
        if (lengthRangeCommitTimer) {
          clearScheduled(lengthRangeCommitTimer);
          lengthRangeCommitTimer = null;
        }
        pendingLengthRangeContainers.clear();
        clearAllCoveoPendingRangeUiSnapshots();
      };
    }
  }

  const COVEO_CONDITION_ICON_NEW_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8 8H8.01M2 5.2L2 9.67451C2 10.1637 2 10.4083 2.05526 10.6385C2.10425 10.8425 2.18506 11.0376 2.29472 11.2166C2.4184 11.4184 2.59135 11.5914 2.93726 11.9373L10.6059 19.6059C11.7939 20.7939 12.388 21.388 13.0729 21.6105C13.6755 21.8063 14.3245 21.8063 14.927 21.6105C15.612 21.388 16.2061 20.7939 17.3941 19.6059L19.6059 17.3941C20.7939 16.2061 21.388 15.612 21.6105 14.927C21.8063 14.3245 21.8063 13.6755 21.6105 13.0729C21.388 12.388 20.7939 11.7939 19.6059 10.6059L11.9373 2.93726C11.5914 2.59135 11.4184 2.4184 11.2166 2.29472C11.0376 2.18506 10.8425 2.10425 10.6385 2.05526C10.4083 2 10.1637 2 9.67452 2L5.2 2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2ZM8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8Z" stroke="#1F2A37" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const COVEO_CONDITION_ICON_USED_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M13 19H17.2942C19.1594 19 20.092 19 20.6215 18.6092C21.0832 18.2685 21.3763 17.7459 21.4263 17.1743C21.4836 16.5187 20.9973 15.7229 20.0247 14.1313L19.0278 12.5M6.13014 10.6052L3.97528 14.1314C3.00267 15.7229 2.51637 16.5187 2.57372 17.1743C2.62372 17.7459 2.91681 18.2685 3.37846 18.6092C3.90799 19 4.84059 19 6.70578 19H8.5M16.8889 8.99999L14.7305 5.46808C13.8277 3.99079 13.3763 3.25214 12.7952 3.00033C12.2879 2.78049 11.7121 2.78049 11.2048 3.00033C10.6237 3.25214 10.1723 3.99079 9.2695 5.46809L8.24967 7.13689M18 5.00006L16.9019 9.09813L12.8038 8.00006M2 11.5981L6.09808 10.5L7.19615 14.5981M15.5 22L12.5 19L15.5 16" stroke="#083667" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const COVEO_CONDITION_ICON_BROKERAGE_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M11.875 20.5004C11.9584 20.5004 12.0542 20.4796 12.1625 20.4379C12.2709 20.3962 12.3584 20.3421 12.425 20.2754L20.85 11.8254C21.0667 11.6087 21.2292 11.3629 21.3375 11.0879C21.4459 10.8129 21.5 10.5337 21.5 10.2504C21.5 9.96705 21.4459 9.6837 21.3375 9.4004C21.2292 9.11705 21.0667 8.86705 20.85 8.6504L16.35 4.15039C16.1334 3.93373 15.8834 3.77123 15.6 3.66289C15.3167 3.55456 15.0334 3.50039 14.75 3.50039C14.4667 3.50039 14.1875 3.55456 13.9125 3.66289C13.6376 3.77123 13.3917 3.93373 13.175 4.15039L12.725 4.60039L14.75 6.6504C14.9667 6.8837 15.1584 7.15455 15.3251 7.4629C15.4918 7.7712 15.5751 8.1087 15.5751 8.4754C15.5751 9.1087 15.3293 9.66705 14.8376 10.1504C14.3459 10.6337 13.7834 10.8754 13.1501 10.8754C12.7334 10.8754 12.3875 10.8129 12.1125 10.6879C11.8376 10.5629 11.5834 10.3837 11.35 10.1504L9.52505 8.3254L5.00005 12.8504C4.91673 12.9337 4.8584 13.0212 4.82506 13.1129C4.79173 13.2046 4.77506 13.3004 4.77506 13.4004C4.77506 13.6171 4.8459 13.7962 4.98756 13.9379C5.12925 14.0796 5.3084 14.1504 5.52505 14.1504C5.62505 14.1504 5.7209 14.1254 5.81255 14.0754C5.90425 14.0254 5.9834 13.9671 6.05005 13.9004L8.97505 10.9754C9.12505 10.8254 9.30005 10.7504 9.50005 10.7504C9.70005 10.7504 9.87505 10.8254 10.0251 10.9754C10.175 11.1254 10.25 11.3004 10.25 11.5004C10.25 11.7004 10.175 11.8754 10.0251 12.0254L7.12505 14.9254C7.04175 15.0087 6.9834 15.1004 6.95005 15.2004C6.91675 15.3004 6.90005 15.4004 6.90005 15.5004C6.90005 15.7004 6.97505 15.8754 7.12505 16.0254C7.27505 16.1754 7.45005 16.2504 7.65005 16.2504C7.75005 16.2504 7.8459 16.2296 7.93755 16.1879C8.02925 16.1462 8.1084 16.0921 8.17505 16.0254L11.1 13.1004C11.25 12.9504 11.425 12.8754 11.625 12.8754C11.825 12.8754 12.0001 12.9504 12.1501 13.1004C12.3 13.2504 12.375 13.4254 12.375 13.6254C12.375 13.8254 12.3 14.0004 12.1501 14.1504L9.25005 17.0504C9.1834 17.1171 9.12925 17.2046 9.08755 17.3129C9.0459 17.4212 9.02505 17.5254 9.02505 17.6254C9.02505 17.8254 9.10005 18.0004 9.25005 18.1504C9.40005 18.3004 9.57505 18.3754 9.77505 18.3754C9.87505 18.3754 9.96675 18.3587 10.05 18.3254C10.1334 18.292 10.2168 18.2337 10.3 18.1504L13.225 15.2254C13.375 15.0754 13.55 15.0004 13.75 15.0004C13.95 15.0004 14.1251 15.0754 14.2751 15.2254C14.425 15.3754 14.5 15.5504 14.5 15.7504C14.5 15.9504 14.425 16.1254 14.2751 16.2754L11.35 19.2004C11.2668 19.2837 11.2084 19.3754 11.175 19.4754C11.1417 19.5754 11.125 19.6671 11.125 19.7504C11.125 19.9837 11.1918 20.167 11.3251 20.3004C11.4584 20.4337 11.6417 20.5004 11.875 20.5004ZM11.875 22.0004C11.325 22.0004 10.8334 21.7962 10.4001 21.3879C9.96675 20.9795 9.7084 20.4754 9.62505 19.8754C9.0584 19.7921 8.5834 19.5587 8.20005 19.1754C7.81675 18.792 7.5834 18.3171 7.50005 17.7504C6.9334 17.6671 6.46255 17.4296 6.08755 17.0379C5.71255 16.6462 5.4834 16.1754 5.40005 15.6254C4.7834 15.5421 4.27506 15.2921 3.87506 14.8754C3.47506 14.4587 3.27506 13.9587 3.27506 13.3754C3.27506 13.0921 3.32923 12.8087 3.43756 12.5254C3.5459 12.2421 3.7084 11.9921 3.92506 11.7754L8.47505 7.2254C8.7584 6.94205 9.1084 6.8004 9.52505 6.8004C9.94175 6.8004 10.2917 6.94205 10.5751 7.2254L12.2751 8.9254C12.4084 9.0587 12.5542 9.1629 12.7126 9.2379C12.8709 9.3129 13.0251 9.3504 13.175 9.3504C13.3917 9.3504 13.5959 9.25455 13.7875 9.0629C13.9792 8.8712 14.0751 8.66705 14.0751 8.4504C14.0751 8.3504 14.0459 8.2379 13.9875 8.1129C13.9292 7.9879 13.8334 7.8587 13.7001 7.7254L10.125 4.15039C9.9084 3.93373 9.6584 3.77123 9.37505 3.66289C9.09175 3.55456 8.8084 3.50039 8.52505 3.50039C8.24175 3.50039 7.96255 3.55456 7.68755 3.66289C7.41255 3.77123 7.16675 3.93373 6.95005 4.15039L3.15006 7.9504C2.81673 8.2837 2.61256 8.6879 2.53756 9.1629C2.46256 9.6379 2.51673 10.0921 2.70006 10.5254C2.7834 10.7087 2.7834 10.8962 2.70006 11.0879C2.61673 11.2796 2.4834 11.4171 2.30006 11.5004C2.11673 11.5837 1.92506 11.5837 1.72506 11.5004C1.52506 11.4171 1.3834 11.2837 1.30006 11.1004C1.01673 10.3504 0.9334 9.60455 1.05006 8.8629C1.16673 8.1212 1.51673 7.4587 2.10006 6.8754L5.87505 3.10039C6.24175 2.73373 6.6584 2.46289 7.12505 2.28789C7.59175 2.11289 8.06675 2.02539 8.55005 2.02539C9.0334 2.02539 9.50425 2.11289 9.96255 2.28789C10.4209 2.46289 10.8334 2.73373 11.2001 3.10039L11.6501 3.55039L12.1 3.10039C12.4668 2.73373 12.8834 2.46289 13.35 2.28789C13.8167 2.11289 14.2917 2.02539 14.7751 2.02539C15.2584 2.02539 15.7292 2.11289 16.1875 2.28789C16.6459 2.46289 17.0584 2.73373 17.4251 3.10039L21.9 7.5754C22.2667 7.94205 22.5417 8.3587 22.725 8.8254C22.9084 9.29205 23 9.76705 23 10.2504C23 10.7337 22.9084 11.2046 22.725 11.6629C22.5417 12.1212 22.2667 12.5337 21.9 12.9004L13.475 21.3254C13.2584 21.542 13.0125 21.7087 12.7375 21.8254C12.4626 21.942 12.175 22.0004 11.875 22.0004Z" fill="#083667"/></svg>';
  const COVEO_CONDITION_SELECTED_X_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none" aria-hidden="true"><path d="M7.41667 0.75L0.75 7.41667M0.75 0.75L7.41667 7.41667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const COVEO_BOAT_SEARCH_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM21 21l-4.35-4.35" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function renderFacetGroup(facet, openFacetIds = new Set(), renderCtx = {}) {
    const state = facet.state || {};
    const facetId = facet.facetId || state.facetId || "filter";
    if (shouldHideCollectionBrandFacetFromUi(facetId)) {
      return "";
    }
    const resolvedLabel = getFacetDisplayLabel(
      facetId,
      String(state.displayName || state.label || facetId || "Filter").trim(),
    );
    const rawValues = normalizeFacetStateValues(state);
    const isConditionFacet =
      facetIdsMatchCondition(facetId) ||
      resolvedLabel.toLowerCase() === "condition";
    const label = isConditionFacet ? "Condition" : resolvedLabel;
    const values =
      isConditionFacet
        ? sortConditionFacetValues(
          ensureCanonicalConditionFacetValues(
            rawValues,
            renderCtx.conditionSelectedValues,
          ),
        )
        : sortFacetValuesSelectedFirst(rawValues);
    const selectedValueCount = values.filter((v) => {
      if (v?.state !== "selected") return false;
      const valueStr = String(facetItemRawValue(v));
      if (isAutoAppliedCollectionBrandFacetValue(facetId, valueStr)) {
        return false;
      }
      return !shouldSuppressFacetValue(facetId, label, valueStr);
    }).length;

    function renderSummaryMeta(showSelectedCountBadge, customBadgeHtml = "") {
      return `<span class="coveo-facet-summary-meta">
        ${customBadgeHtml || (showSelectedCountBadge && selectedValueCount > 0 ? `<span class="coveo-facet-summary-badge">${selectedValueCount}</span>` : "")}
        <svg class="coveo-facet-accordion__chevron" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true">
          <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>`;
    }

    function formatLengthSummaryLabel(bounds) {
      if (!bounds) return "";
      const lo = Math.round(Number(bounds.lo));
      const hi = Math.round(Number(bounds.hi));
      if (!Number.isFinite(lo) || !Number.isFinite(hi)) return "";
      return `${lo}'-${hi}'`;
    }

    function formatPriceSummaryLabel(bounds) {
      if (!bounds) return "";
      const lo = Number(bounds.lo);
      const hi = Number(bounds.hi);
      if (!Number.isFinite(lo) || !Number.isFinite(hi)) return "";
      return `${formatCompactPriceSummaryValue(lo)}-${formatCompactPriceSummaryValue(hi)}`;
    }

    function formatYearSummaryLabel(bounds) {
      if (!bounds) return "";
      const lo = Math.round(Number(bounds.lo));
      const hi = Math.round(Number(bounds.hi));
      if (!Number.isFinite(lo) || !Number.isFinite(hi)) return "";
      return `${lo}\u2013${hi}`;
    }

    function getRangeFacetSummaryLabel(kind) {
      return kind === "length"
        ? formatLengthSummaryLabel(resolveRangeChipBounds(facet, facetId, kind))
        : kind === "price"
          ? formatPriceSummaryLabel(resolveRangeChipBounds(facet, facetId, kind))
          : kind === "year"
            ? formatYearSummaryLabel(resolveRangeChipBounds(facet, facetId, kind))
          : "";
    }

    function getSelectedNumericEndpoints(vs) {
      const out = [];
      vs.forEach((v) => {
        if (v?.state !== "selected") return;
        const bounds = facetItemNumericBounds(v);
        if (!bounds) return;
        out.push(bounds.lo, bounds.hi);
      });
      return out;
    }

    function uniqueSorted(nums) {
      const s = Array.from(new Set(nums));
      s.sort((a, b) => a - b);
      return s;
    }

    function snapToNearest(num, points) {
      if (!points || !points.length) return num;
      let best = points[0];
      let bestDist = Math.abs(num - best);
      for (let i = 1; i < points.length; i++) {
        const d = Math.abs(num - points[i]);
        if (d < bestDist) {
          best = points[i];
          bestDist = d;
        }
      }
      return best;
    }

    function renderDefaultFacetValues() {
      const valsHtml = values
        .map((v) => {
          const raw = facetItemRawValue(v);
          const valueStr = String(raw);
          if (shouldSuppressFacetValue(facetId, label, valueStr)) return "";
          const checked =
            v.state === "selected" &&
            !isAutoAppliedCollectionBrandFacetValue(facetId, valueStr);
          const cnt = v.count ?? v.numberOfResults ?? 0;
          return `<label class="coveo-facet-value ${checked ? "is-selected" : ""}">
            <input type="checkbox" ${checked ? "checked" : ""} data-facet-id="${escapeAttr(facetId)}" data-value="${escapeAttr(valueStr)}" />
            <span class="coveo-facet-value__check" aria-hidden="true">${COVEO_FILTER_CHECK_SVG}</span>
            <span class="coveo-facet-value__text">${escapeHtml(valueStr)} (${cnt})</span>
          </label>`;
        })
        .filter(Boolean)
        .join("");
      return valsHtml;
    }

    /** Coveo returns a limited page of facet values; show more/less calls controller APIs. */
    function renderFacetShowMoreLessButtons() {
      const useInfiniteScrollFacet =
        facetIdsMatchMake(facetId) ||
        facetIdsMatchModel(facetId) ||
        label === "Boat Type";
      if (useInfiniteScrollFacet) return "";
      const hasApi =
        typeof facet.showMoreValues === "function" ||
        typeof facet.showLessValues === "function";
      if (!hasApi) return "";
      const canMore = Boolean(state.canShowMoreValues);
      const canLess = Boolean(state.canShowLessValues);
      if (!canMore && !canLess) return "";
      const idAttr = escapeAttr(facetId);
      return `
        <div class="coveo-facet-moreless">
          <button type="button" class="coveo-facet-moreless__btn" data-coveo-facet-show-more="${idAttr}"${canMore ? "" : " hidden"}>
            Show more
          </button>
          <button type="button" class="coveo-facet-moreless__btn" data-coveo-facet-show-less="${idAttr}"${canLess ? "" : " hidden"}>
            Show less
          </button>
        </div>`;
    }

    function renderConditionFacetValues() {
      const iconSvgFor = (v) => {
        const s = String(v || "").toLowerCase();
        if (s.includes("new")) return COVEO_CONDITION_ICON_NEW_SVG;
        if (s.includes("used")) return COVEO_CONDITION_ICON_USED_SVG;
        if (s.includes("broker")) return COVEO_CONDITION_ICON_BROKERAGE_SVG;
        return COVEO_CONDITION_ICON_NEW_SVG;
      };

      const hasSelectedCondition = values.some(function (value) {
        return value.state === "selected";
      });
      const isAllConditionSelected = !hasSelectedCondition;
      const allTile = `<label class="coveo-mobile-condition-tile ${isAllConditionSelected ? "is-selected" : ""}">
              <input
                type="checkbox"
                ${isAllConditionSelected ? "checked" : ""}
                data-condition-all="true"
                data-facet-id="${escapeAttr(facetId)}"
              />
              <span class="coveo-mobile-condition-tile__text">${escapeHtml(COVEO_CONDITION_ALL_LABEL)}</span>
              <span class="coveo-mobile-condition-tile__selected-x" aria-hidden="true">${COVEO_CONDITION_SELECTED_X_SVG}</span>
            </label>`;

      const conditionTiles = values
        .map((v) => {
          const valueStr = String(facetItemRawValue(v));
          if (shouldSuppressFacetValue(facetId, label, valueStr)) return "";
          const checked =
            v.state === "selected" &&
            !isAutoAppliedCollectionBrandFacetValue(facetId, valueStr);
          return `<label class="coveo-mobile-condition-tile ${checked ? "is-selected" : ""
            }">
              <input
                type="checkbox"
                ${checked ? "checked" : ""}
                data-facet-id="${escapeAttr(facetId)}"
                data-value="${escapeAttr(valueStr)}"
                ${v.__coveoSyntheticConditionOption ? 'data-condition-synthetic="true"' : ""}
              />
              <span class="coveo-mobile-condition-tile__text">${escapeHtml(
              valueStr,
            )}</span>
              <span class="coveo-mobile-condition-tile__icon" aria-hidden="true">${iconSvgFor(
              valueStr,
            )}</span>
              <span class="coveo-mobile-condition-tile__selected-x" aria-hidden="true">${COVEO_CONDITION_SELECTED_X_SVG}</span>
            </label>`;
        })
        .filter(Boolean)
        .join("");
      return allTile + conditionTiles;
    }

    /** Scrollable list + type-to-filter (shared by Boat Type, Make, and similar facets). */
    function renderSearchableCheckboxFacetValues(placeholder, ariaLabel, options = {}) {
      const isDisabled = !!options.disabled;
      const disabledMessage = String(options.disabledMessage || "").trim();
      const isMakeFacet = facetIdsMatchMake(facetId);
      const usesPagedBoatOptions = facetUsesPagedBoatOptionsUi(facetId);
      const rememberedBoatQ = getRememberedBoatSearchQuery(facetId);
      const searchableValues = getRenderedSearchableFacetValues(
        facet,
        facetId,
        values,
      );
      const loadMoreGapHtml =
        usesPagedBoatOptions && Boolean(state.canShowMoreValues)
          ? '<div class="coveo-mobile-boat-options__load-gap" aria-hidden="true"></div>'
          : "";
      const optionsHtml = searchableValues
        .map((v) => {
          return renderSearchableFacetOptionMarkup(facetId, label, v, {
            disabled: isDisabled,
          });
        })
        .filter(Boolean)
        .join("");

      return `
        <div class="coveo-mobile-boat-facet-inner ${isDisabled ? "is-disabled" : ""}${usesPagedBoatOptions ? " coveo-mobile-boat-facet-inner--paged" : ""}${isMakeFacet ? " coveo-mobile-boat-facet-inner--make" : ""}">
          <div class="coveo-mobile-boat-search" data-boat-search-for="${escapeAttr(
        facetId,
      )}">
            <input
              type="search"
              class="coveo-mobile-boat-search__input"
              placeholder="${escapeAttr(isDisabled ? (disabledMessage || placeholder) : placeholder)}"
              value="${escapeAttr(isDisabled ? "" : rememberedBoatQ)}"
              autocomplete="off"
              aria-label="${escapeAttr(ariaLabel)}"
              ${isDisabled ? 'disabled aria-disabled="true"' : ""}
            />
            <button type="button" class="coveo-mobile-boat-search__btn" aria-label="${escapeAttr(ariaLabel)}"${isDisabled ? ' disabled aria-disabled="true"' : ""}>
              <span class="coveo-mobile-boat-search__btn-icon">${COVEO_BOAT_SEARCH_ICON_SVG}</span>
            </button>
          </div>
          ${isDisabled ? `<p class="coveo-mobile-boat-facet__hint">${escapeHtml(disabledMessage || "Select a make first to choose a model.")}</p>` : ""}
          <div class="coveo-mobile-boat-options${usesPagedBoatOptions ? " coveo-mobile-boat-options--paged" : ""}${isMakeFacet ? " coveo-mobile-boat-options--make" : ""}" data-boat-options-for="${escapeAttr(
        facetId,
      )}"${isDisabled ? ' aria-disabled="true"' : ""}>
            ${optionsHtml}${loadMoreGapHtml}
          </div>
          ${renderFacetShowMoreLessButtons()}
        </div>
      `;
    }

    function formatGenericNumericDisplay(n) {
      if (!Number.isFinite(n)) return "";
      const x = Number(n);
      if (
        Math.abs(x) >= 10000 &&
        Math.abs(x - Math.round(x)) < Math.max(1e-6, Math.abs(x) * 1e-9)
      ) {
        return String(Math.round(x));
      }
      const t = String(Number(x.toPrecision(12)));
      return t.replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
    }

  function renderRangeFacetValues(kind) {
      function snapRangeValue(value, points) {
        // Every integer year is selectable, even when the display points are sampled.
        return kind === "year" ? Math.round(value) : snapToNearest(value, points);
      }

      const facetTitle = String(label || "").trim() || "Value";
      /*
       * The NumericFacet controller already exposes the exact response domain.
       * Using it directly keeps slider rails synchronized with the primary
       * Listing/Search response and avoids separate baseline API requests.
       */
      const controllerRangeDomain =
        kind === "length" || kind === "price" || kind === "year"
          ? deriveCoveoManagedRangeServerDomain(facetId, state)
          : tryFacetNumericDomain(state);
      const authoritativeRangeDomain = controllerRangeDomain;
      const rangeState = state;
      const rangeValues = values;
      function buildPriceHistogramBuckets(maxBars, domainLo, domainHi) {
        if (kind !== "price") return [];
        const limit = Number.isFinite(maxBars) && maxBars > 0 ? Math.floor(maxBars) : 14;
        const rawBuckets = rangeValues
          .map((v) => {
            const bounds = facetItemNumericBounds(v);
            if (!bounds) return null;
            const lo = normalizeCoveoFacetPriceDollars(bounds.lo);
            const hi = normalizeCoveoFacetPriceDollars(bounds.hi);
            if (!Number.isFinite(lo) || !Number.isFinite(hi)) return null;
            const count = Number(v.count ?? v.numberOfResults ?? 0);
            return {
              lo,
              hi,
              center: (lo + hi) / 2,
              count: Number.isFinite(count) ? Math.max(0, count) : 0,
            };
          })
          .filter(Boolean)
          .sort(function (a, b) {
            return a.center - b.center;
          });
        if (!rawBuckets.length) return [];
        if (rawBuckets.length >= 6 && rawBuckets.length <= limit) return rawBuckets;

        if (rawBuckets.length > limit) {
          const chunkSize = Math.ceil(rawBuckets.length / limit);
          const merged = [];
          for (let i = 0; i < rawBuckets.length; i += chunkSize) {
            const group = rawBuckets.slice(i, i + chunkSize);
            if (!group.length) continue;
            const lo = group[0].lo;
            const hi = group[group.length - 1].hi;
            const count = group.reduce(function (sum, bucket) {
              return sum + (Number(bucket.count) || 0);
            }, 0);
            merged.push({
              lo,
              hi,
              center: (lo + hi) / 2,
              count,
            });
          }
          return merged;
        }

        const lo =
          Number.isFinite(domainLo) ? domainLo : rawBuckets[0].lo;
        const hi =
          Number.isFinite(domainHi) ? domainHi : rawBuckets[rawBuckets.length - 1].hi;
        if (!Number.isFinite(lo) || !Number.isFinite(hi) || hi <= lo) {
          return rawBuckets;
        }
        const fallbackProfile = [
          0.28, 0.55, 0.42, 0.68, 0.36, 0.84, 1, 0.79, 0.47, 0.61, 0.88, 0.74, 0.52, 0.39,
        ];
        const rawMaxCount = rawBuckets.reduce(function (max, bucket) {
          return Math.max(max, Number(bucket.count) || 0);
        }, 0);
        const rawCenters = rawBuckets.map(function (bucket) {
          return bucket.center;
        });
        const step = (hi - lo) / limit;
        const synthesized = [];
        for (let i = 0; i < limit; i++) {
          const bucketLo = lo + i * step;
          const bucketHi = i === limit - 1 ? hi : bucketLo + step;
          const center = (bucketLo + bucketHi) / 2;
          const profileRatio = fallbackProfile[i % fallbackProfile.length];
          let dataInfluence = profileRatio;
          if (rawCenters.length >= 2 && rawMaxCount > 0) {
            let nearestIdx = 0;
            let nearestDist = Infinity;
            for (let idx = 0; idx < rawCenters.length; idx++) {
              const dist = Math.abs(rawCenters[idx] - center);
              if (dist < nearestDist) {
                nearestDist = dist;
                nearestIdx = idx;
              }
            }
            const nearestBucket = rawBuckets[nearestIdx];
            const nextBucket =
              rawBuckets[Math.min(rawBuckets.length - 1, nearestIdx + (center >= nearestBucket.center ? 1 : 0))] ||
              nearestBucket;
            const prevBucket =
              rawBuckets[Math.max(0, nearestIdx - (center < nearestBucket.center ? 1 : 0))] ||
              nearestBucket;
            const left = prevBucket.center <= nextBucket.center ? prevBucket : nextBucket;
            const right = prevBucket.center <= nextBucket.center ? nextBucket : prevBucket;
            const span = Math.max(1, right.center - left.center);
            const t = Math.max(0, Math.min(1, (center - left.center) / span));
            const leftRatio = (Number(left.count) || 0) / rawMaxCount;
            const rightRatio = (Number(right.count) || 0) / rawMaxCount;
            dataInfluence = leftRatio + (rightRatio - leftRatio) * t;
          }
          const mixedRatio = rawMaxCount > 0
            ? profileRatio * 0.45 + dataInfluence * 0.55
            : profileRatio;
          synthesized.push({
            lo: bucketLo,
            hi: bucketHi,
            center,
            count: Math.max(0.12, mixedRatio),
          });
        }
        return synthesized;
      }

      const numericPoints = [];
      const countedNumericBuckets = [];
      rangeValues.forEach((v) => {
        const bounds = facetItemNumericBounds(v, {
          allowNumericValueFallback: kind === "year",
        });
        if (bounds) {
          numericPoints.push(bounds.lo, bounds.hi);
          countedNumericBuckets.push({
            lo: bounds.lo,
            hi: bounds.hi,
            count: Number(v.count ?? v.numberOfResults ?? 0),
          });
        }
        if (kind === "year") {
          const y = parseDiscreteYearValue(facetItemRawValue(v));
          if (Number.isFinite(y)) numericPoints.push(y);
        }
      });

      let facetBucketPoints = uniqueSorted(numericPoints);
      let points;
      let rangeAttrMin;
      let rangeAttrMax;
      let stepStr = "any";
      let priceApiScale = 1;

      if (kind === "length") {
        const nonEmptyLengthBuckets = countedNumericBuckets
          .filter(function (bucket) {
            return (
              Number.isFinite(bucket.lo) &&
              Number.isFinite(bucket.hi) &&
              Number(bucket.count) > 0
            );
          })
          .map(function (bucket) {
            return {
              lo: Math.min(bucket.lo, bucket.hi),
              hi: Math.max(bucket.lo, bucket.hi),
            };
          });
        facetBucketPoints = uniqueSorted(
          facetBucketPoints
            .map((n) =>
              Math.min(
                COVEO_LENGTH_SLIDER_MAX,
                Math.max(COVEO_LENGTH_SLIDER_MIN, n),
              ),
            )
            .filter((n) => Number.isFinite(n)),
        );
        const domL = tryFacetNumericDomain(rangeState);
        let loDyn = COVEO_LENGTH_SLIDER_MIN;
        let hiDyn = COVEO_LENGTH_SLIDER_MAX;
        if (domL && domL.hi > domL.lo) {
          loDyn = Math.max(COVEO_LENGTH_SLIDER_MIN, domL.lo);
          hiDyn = Math.min(COVEO_LENGTH_SLIDER_MAX, domL.hi);
        } else if (nonEmptyLengthBuckets.length > 0) {
          loDyn = Math.min(
            ...nonEmptyLengthBuckets.map(function (bucket) {
              return bucket.lo;
            }),
          );
          hiDyn = Math.max(
            ...nonEmptyLengthBuckets.map(function (bucket) {
              return bucket.hi;
            }),
          );
        } else if (facetBucketPoints.length > 0) {
          loDyn = facetBucketPoints[0];
          hiDyn = facetBucketPoints[facetBucketPoints.length - 1];
        } else {
          return renderDefaultFacetValues();
        }
        /*
         * Length slider runs in whole feet only. Coveo can hand us fractional
         * domain bounds (e.g. 1 → 133.2); rounding to integers keeps the
         * slider thumb labels AND the Min/Max number inputs on clean ft
         * increments and matches the formatting we render below.
         */
        loDyn = Math.floor(loDyn);
        hiDyn = Math.ceil(hiDyn);
        if (hiDyn <= loDyn) {
          hiDyn = loDyn + 1;
        }
        if (nonEmptyLengthBuckets.length > 0) {
          facetBucketPoints = uniqueSorted(
            nonEmptyLengthBuckets
              .flatMap(function (bucket) {
                return [bucket.lo, bucket.hi];
              })
              .map(function (n) {
                return Math.min(
                  COVEO_LENGTH_SLIDER_MAX,
                  Math.max(COVEO_LENGTH_SLIDER_MIN, n),
                );
              })
              .filter((n) => Number.isFinite(n)),
          );
        }
        facetBucketPoints = uniqueSorted(
          facetBucketPoints.filter((n) => n >= loDyn && n <= hiDyn),
        );
        points = [];
        for (let foot = loDyn; foot <= hiDyn; foot++) {
          points.push(Math.round(foot));
        }
        points = uniqueSorted(points);
        rangeAttrMin = loDyn;
        rangeAttrMax = hiDyn;
        stepStr = "1";
      } else if (kind === "year") {
        const domY = tryFacetNumericDomain(rangeState);
        let loY;
        let hiY;
        const yearPts = collectYearPointsFromFacetValues(rangeValues, rangeState);
        const ptVals = uniqueSorted(
          yearPts.length ? yearPts : numericPoints,
        );
        if (
          domY &&
          Number.isFinite(domY.lo) &&
          Number.isFinite(domY.hi) &&
          domY.hi > domY.lo
        ) {
          loY = Math.floor(domY.lo);
          hiY = Math.ceil(domY.hi);
        } else if (ptVals.length >= 2) {
          loY = Math.floor(Math.min(...ptVals));
          hiY = Math.ceil(Math.max(...ptVals));
        } else if (ptVals.length === 1) {
          loY = Math.floor(ptVals[0]);
          hiY = Math.ceil(ptVals[0]);
        } else {
          const fallback = defaultYearFacetDomain();
          loY = fallback.lo;
          hiY = fallback.hi;
        }
        if (hiY <= loY) hiY = loY + 1;
        const spanY = hiY - loY;
        const maxYearTicks = 80;
        if (spanY <= maxYearTicks) {
          points = [];
          for (let yy = loY; yy <= hiY; yy++) points.push(yy);
        } else {
          points = uniqueSorted(
            buildNumericPointsFromDomain(
              { lo: loY, hi: hiY },
              maxYearTicks,
            ).map((n) => Math.round(n)),
          );
        }
        rangeAttrMin = loY;
        rangeAttrMax = hiY;
        stepStr = "1";
      } else if (kind === "price" || kind === "numeric") {
        const domPN = tryFacetNumericDomain(rangeState);
        if (kind === "price") {
          const priceScaleCandidates = numericPoints.slice();
          if (domPN) priceScaleCandidates.push(domPN.lo, domPN.hi);
          priceApiScale = coveoPriceFacetApiScale(priceScaleCandidates);
          points = uniqueSorted(
            numericPoints.map((n) => normalizeCoveoFacetPriceDollars(n)),
          );
          const domPrice = domPN
            ? {
              lo: normalizeCoveoFacetPriceDollars(domPN.lo),
              hi: normalizeCoveoFacetPriceDollars(domPN.hi),
            }
            : null;
          if (!points.length && domPrice) {
            points = buildNumericPointsFromDomain(domPrice);
          } else if (domPrice && domPrice.hi > domPrice.lo && points.length <= 2) {
            const interp = buildNumericPointsFromDomain(domPrice, 64);
            points = uniqueSorted([...points, ...interp]);
          }
        } else {
          points = uniqueSorted(numericPoints);
          if (!points.length && domPN) {
            points = buildNumericPointsFromDomain(domPN);
          } else if (domPN && domPN.hi > domPN.lo && points.length <= 2) {
            const interp = buildNumericPointsFromDomain(domPN, 64);
            points = uniqueSorted([...points, ...interp]);
          }
        }
        if (!points.length) return renderDefaultFacetValues();
        rangeAttrMin = points[0];
        rangeAttrMax = points[points.length - 1];
        if (rangeAttrMax <= rangeAttrMin) {
          rangeAttrMax =
            rangeAttrMin + Math.max(1, Math.abs(rangeAttrMin) * 0.01);
        }
        if (points.length >= 2) {
          let minDiff = Infinity;
          for (let i = 1; i < points.length; i++) {
            const d = points[i] - points[i - 1];
            if (d > 0 && d < minDiff) minDiff = d;
          }
          if (Number.isFinite(minDiff) && minDiff > 0 && minDiff < Infinity) {
            stepStr = String(
              minDiff >= 1
                ? Math.round(minDiff * 1000) / 1000
                : Math.round(minDiff * 1e6) / 1e6,
            );
          }
        }

        /*
         * For price facets we always snap the slider domain and the user's
         * current selection to the configured $1,000 step. Coveo's bucket
         * boundaries can be arbitrary (e.g. $11,218 / $41,139,218) which
         * leaks into the slider and the Min/Max inputs as ugly raw values.
         * Aligning the bounds + step here keeps the entire UI on a clean
         * $1,000 grid.
         */
        if (kind === "price") {
          const flo = roundPriceToStep(rangeAttrMin, "floor");
          const cei = roundPriceToStep(rangeAttrMax, "ceil");
          rangeAttrMin = flo;
          rangeAttrMax = cei > flo ? cei : flo + COVEO_PRICE_SLIDER_STEP;
          points = uniqueSorted(
            [
              ...points,
              ...buildNumericPointsFromDomain(
                { lo: rangeAttrMin, hi: rangeAttrMax },
                64,
              ),
              rangeAttrMin,
              rangeAttrMax,
            ].map((n) => roundPriceToStep(n, "round")),
          );
          stepStr = String(COVEO_PRICE_SLIDER_STEP);
        }
      } else {
        return renderDefaultFacetValues();
      }

      const stableRangeDomain = authoritativeRangeDomain
        ? rememberCoveoStableRangeDomain(
          facetId,
          kind,
          authoritativeRangeDomain,
        )
        : getCoveoStableRangeDomain(facetId, kind);
      if (stableRangeDomain) {
        let stableLo = Number(stableRangeDomain.lo);
        let stableHi = Number(stableRangeDomain.hi);
        if (kind === "length" || kind === "year") {
          stableLo = Math.floor(stableLo);
          stableHi = Math.ceil(stableHi);
        } else if (kind === "price") {
          stableLo = roundPriceToStep(stableLo, "floor");
          stableHi = roundPriceToStep(stableHi, "ceil");
        }
        if (Number.isFinite(stableLo) && Number.isFinite(stableHi)) {
          rangeAttrMin = Math.min(rangeAttrMin, stableLo);
          rangeAttrMax = Math.max(rangeAttrMax, stableHi);
          if (kind === "length") {
            points = [];
            for (let foot = rangeAttrMin; foot <= rangeAttrMax; foot++) {
              points.push(Math.round(foot));
            }
          } else {
            points = uniqueSorted([
              ...points,
              ...buildNumericPointsFromDomain(
                { lo: rangeAttrMin, hi: rangeAttrMax },
                kind === "year" ? 80 : 64,
              ).map(function (value) {
                if (kind === "year") return Math.round(value);
                if (kind === "price") return roundPriceToStep(value, "round");
                return value;
              }),
              rangeAttrMin,
              rangeAttrMax,
            ]);
          }
        }
      }

      /*
       * A range facet response can be constrained by the range that was just
       * applied. Keep the committed selection inside the next slider domain
       * so a Coveo re-render cannot snap the handles back to the response
       * bounds while the summary/chip still shows the selected range.
       */
      let committedRangeUi = null;
      if (kind === "length" || kind === "price" || kind === "year") {
        const resolvedCommittedRange = resolveRangeChipBounds(
          facet,
          facetId,
          kind,
        );
        if (
          resolvedCommittedRange &&
          Number.isFinite(Number(resolvedCommittedRange.lo)) &&
          Number.isFinite(Number(resolvedCommittedRange.hi))
        ) {
          let committedLo = Math.min(
            Number(resolvedCommittedRange.lo),
            Number(resolvedCommittedRange.hi),
          );
          let committedHi = Math.max(
            Number(resolvedCommittedRange.lo),
            Number(resolvedCommittedRange.hi),
          );

          if (kind === "length") {
            committedLo = Math.round(
              Math.min(
                COVEO_LENGTH_SLIDER_MAX,
                Math.max(COVEO_LENGTH_SLIDER_MIN, committedLo),
              ),
            );
            committedHi = Math.round(
              Math.min(
                COVEO_LENGTH_SLIDER_MAX,
                Math.max(COVEO_LENGTH_SLIDER_MIN, committedHi),
              ),
            );
          } else if (kind === "year") {
            committedLo = Math.round(committedLo);
            committedHi = Math.round(committedHi);
          } else {
            committedLo = roundPriceToStep(committedLo, "round");
            committedHi = roundPriceToStep(committedHi, "round");
          }

          rangeAttrMin = Math.min(rangeAttrMin, committedLo);
          rangeAttrMax = Math.max(rangeAttrMax, committedHi);
          const restoredDomainPoints = buildNumericPointsFromDomain(
            { lo: rangeAttrMin, hi: rangeAttrMax },
            64,
          ).map(function (value) {
            return kind === "length" || kind === "year"
              ? Math.round(value)
              : roundPriceToStep(value, "round");
          });
          points = uniqueSorted([
            ...points,
            ...restoredDomainPoints,
            rangeAttrMin,
            rangeAttrMax,
            committedLo,
            committedHi,
          ]);
          committedRangeUi = { lo: committedLo, hi: committedHi };
        }
      }

      if (kind !== "length" && kind !== "year" && !points.length) {
        return renderDefaultFacetValues();
      }
      if (
        (kind === "length" || kind === "year") &&
        (!points || !points.length)
      ) {
        return renderDefaultFacetValues();
      }

      const loBound =
        kind === "length" || kind === "year" ? rangeAttrMin : points[0];
      const hiBound =
        kind === "length" || kind === "year"
          ? rangeAttrMax
          : points[points.length - 1];
      const currentRangeDomain = { lo: loBound, hi: hiBound };

      if (kind === "year" && facetIdsMatchYear(facetId)) {
        const normalizedYearSel = normalizeCoveoYearSelectionCandidate(
          getCoveoYearFacetSelection(),
          null,
        );
        if (!normalizedYearSel) {
          clearCoveoYearFacetSelection();
        } else if (!normalizedYearSel.fullRange) {
          setCoveoYearFacetSelection(normalizedYearSel);
        }
      } else if (kind === "price" || kind === "length") {
        const normalizedStoredRange = normalizeCoveoFacetRangeSelectionCandidate(
          getCoveoFacetRangeSelection(facetId),
          null,
          kind,
        );
        if (!normalizedStoredRange) {
          clearCoveoFacetRangeSelection(facetId);
        } else if (!normalizedStoredRange.fullRange) {
          setCoveoFacetRangeSelection(facetId, normalizedStoredRange);
        }
      }
      syncCoveoPendingRangeUiSelectionToDomain(
        facetId,
        kind,
        currentRangeDomain,
      );
      const pendingUi = getCoveoPendingRangeUiRawSnapshot(facetId);
      const liveUi = getCoveoLiveRangeUiSnapshot(
        facetId,
        kind,
        currentRangeDomain,
      );
      const stickyUi = getCoveoStickyRangeUiSnapshot(
        facetId,
        kind,
        currentRangeDomain,
      );
      const rangeUiFrozen = isCoveoRangeUiFrozen(facetId);

      const rawSelected = uniqueSorted(getSelectedNumericEndpoints(rangeValues));
      let selectedNums =
        kind === "length"
          ? uniqueSorted(
            rawSelected
              .map((n) =>
                Math.min(
                  COVEO_LENGTH_SLIDER_MAX,
                  Math.max(COVEO_LENGTH_SLIDER_MIN, n),
                ),
              )
              .map((n) => Math.round(n))
              .filter((n) => Number.isFinite(n)),
          )
          : kind === "year"
            ? uniqueSorted(
              rawSelected
                .map((n) =>
                  Math.min(hiBound, Math.max(loBound, Math.round(n))),
                )
                .filter((n) => Number.isFinite(n)),
            )
            : kind === "price"
              ? uniqueSorted(
                rawSelected
                  .map((n) => normalizeCoveoFacetPriceDollars(n))
                  .filter((n) => Number.isFinite(n)),
              )
              : rawSelected;
      const hasFacetSelectedRange = selectedNums.length > 0;
      const hasEphemeralRangeUi =
        !!rangeUiFrozen ||
        !!(pendingUi && pendingUi.kind === kind) ||
        !!(liveUi && !liveUi.fullRange) ||
        !!(stickyUi && !stickyUi.fullRange);
      if (
        (kind === "price" || kind === "length") &&
        !hasFacetSelectedRange &&
        !hasEphemeralRangeUi
      ) {
        clearCoveoFacetRangeSelection(facetId);
      }

      let minNum = loBound;
      let maxNum = hiBound;
      if (kind === "length") {
        if (selectedNums.length === 0) {
          minNum = loBound;
          maxNum = hiBound;
        } else if (selectedNums.length === 1) {
          const s = selectedNums[0];
          minNum = snapRangeValue(s, points);
          maxNum = minNum;
        } else {
          minNum = Math.min(...selectedNums);
          maxNum = Math.max(...selectedNums);
        }
      } else if (kind === "year") {
        if (selectedNums.length === 0) {
          minNum = loBound;
          maxNum = hiBound;
        } else if (selectedNums.length === 1) {
          const s = selectedNums[0];
          minNum = snapRangeValue(s, points);
          maxNum = minNum;
        } else {
          minNum = Math.min(...selectedNums);
          maxNum = Math.max(...selectedNums);
        }
      } else if (selectedNums.length === 1) {
        minNum = selectedNums[0];
        maxNum = selectedNums[0];
      } else if (selectedNums.length >= 2) {
        minNum = Math.min(...selectedNums);
        maxNum = Math.max(...selectedNums);
      }

      minNum = snapRangeValue(minNum, points);
      maxNum = snapRangeValue(maxNum, points);
      if (minNum > maxNum) {
        const t = minNum;
        minNum = maxNum;
        maxNum = t;
      }
      minNum = Math.min(Math.max(minNum, rangeAttrMin), rangeAttrMax);
      maxNum = Math.min(Math.max(maxNum, rangeAttrMin), rangeAttrMax);

      /*
       * Facet state can lag behind committed/pending slider values (especially
       * year cq + price setRanges). Prefer stored/pending bounds so Apply does
       * not flash the drawer back to the full domain before it closes.
       */
      if (kind === "year" && facetIdsMatchYear(facetId)) {
        const yearSelUi = getCoveoYearFacetSelection();
        if (yearSelUi && !yearSelUi.fullRange) {
          minNum = snapRangeValue(
            Math.min(
              hiBound,
              Math.max(loBound, Math.round(yearSelUi.lo)),
            ),
            points,
          );
          maxNum = snapRangeValue(
            Math.min(
              hiBound,
              Math.max(loBound, Math.round(yearSelUi.hi)),
            ),
            points,
          );
        }
      } else if (kind === "price" || kind === "length") {
        const storedUi = getCoveoFacetRangeSelection(facetId);
        if (storedUi) {
          let loUi = storedUi.lo;
          let hiUi = storedUi.hi;
          if (kind === "length") {
            loUi = Math.round(loUi);
            hiUi = Math.round(hiUi);
          } else if (kind === "price") {
            loUi = roundPriceToStep(loUi, "round");
            hiUi = roundPriceToStep(hiUi, "round");
          }
          minNum = snapRangeValue(
            Math.min(hiBound, Math.max(loBound, loUi)),
            points,
          );
          maxNum = snapRangeValue(
            Math.min(hiBound, Math.max(loBound, hiUi)),
            points,
          );
        }
      }
      if (committedRangeUi) {
        minNum = snapRangeValue(
          Math.min(hiBound, Math.max(loBound, committedRangeUi.lo)),
          points,
        );
        maxNum = snapRangeValue(
          Math.min(hiBound, Math.max(loBound, committedRangeUi.hi)),
          points,
        );
      }
      if (liveUi) {
        if (liveUi.fullRange) {
          minNum = loBound;
          maxNum = hiBound;
        } else {
          let lLo = liveUi.lo;
          let lHi = liveUi.hi;
          if (kind === "length" || kind === "year") {
            lLo = Math.round(lLo);
            lHi = Math.round(lHi);
          } else if (kind === "price") {
            lLo = roundPriceToStep(lLo, "round");
            lHi = roundPriceToStep(lHi, "round");
          }
          minNum = snapRangeValue(
            Math.min(hiBound, Math.max(loBound, lLo)),
            points,
          );
          maxNum = snapRangeValue(
            Math.min(hiBound, Math.max(loBound, lHi)),
            points,
          );
        }
      }
      if (
        stickyUi &&
        !liveUi &&
        !(pendingUi && pendingUi.kind === kind)
      ) {
        if (stickyUi.fullRange) {
          minNum = loBound;
          maxNum = hiBound;
        } else {
          let sLo = stickyUi.lo;
          let sHi = stickyUi.hi;
          if (kind === "length" || kind === "year") {
            sLo = Math.round(sLo);
            sHi = Math.round(sHi);
          } else if (kind === "price") {
            sLo = roundPriceToStep(sLo, "round");
            sHi = roundPriceToStep(sHi, "round");
          }
          minNum = snapRangeValue(
            Math.min(hiBound, Math.max(loBound, sLo)),
            points,
          );
          maxNum = snapRangeValue(
            Math.min(hiBound, Math.max(loBound, sHi)),
            points,
          );
        }
      }
      if (
        pendingUi &&
        pendingUi.kind === kind &&
        Number.isFinite(pendingUi.lo) &&
        Number.isFinite(pendingUi.hi)
      ) {
        let pLo = pendingUi.lo;
        let pHi = pendingUi.hi;
        if (kind === "length" || kind === "year") {
          pLo = Math.round(pLo);
          pHi = Math.round(pHi);
        } else if (kind === "price") {
          pLo = roundPriceToStep(pLo, "round");
          pHi = roundPriceToStep(pHi, "round");
        }
        minNum = snapRangeValue(
          Math.min(hiBound, Math.max(loBound, pLo)),
          points,
        );
        maxNum = snapRangeValue(
          Math.min(hiBound, Math.max(loBound, pHi)),
          points,
        );
      }

      if (kind === "length") {
        minNum = Math.round(minNum);
        maxNum = Math.round(maxNum);
      }

      if (kind === "price") {
        minNum = roundPriceToStep(minNum, "round");
        maxNum = roundPriceToStep(maxNum, "round");
        minNum = Math.min(Math.max(minNum, rangeAttrMin), rangeAttrMax);
        maxNum = Math.min(Math.max(maxNum, rangeAttrMin), rangeAttrMax);
      }

      const formatLengthChip = (n) =>
        Number.isFinite(n) ? formatLengthFeetWhole(n) : "";
      const displayMin =
        kind === "length"
          ? formatLengthChip(minNum)
          : kind === "year"
            ? String(Math.round(minNum))
            : kind === "price"
              ? Math.abs(minNum - rangeAttrMin) < 0.000001 ||
                Math.abs(minNum - rangeAttrMax) < 0.000001
                ? formatPriceBoundaryDisplay(minNum)
                : formatPriceDisplay(minNum)
              : kind === "numeric"
                ? formatGenericNumericDisplay(minNum)
                : String(minNum);
      const displayMax =
        kind === "length"
          ? formatLengthChip(maxNum)
          : kind === "year"
            ? String(Math.round(maxNum))
            : kind === "price"
              ? Math.abs(maxNum - rangeAttrMin) < 0.000001 ||
                Math.abs(maxNum - rangeAttrMax) < 0.000001
                ? formatPriceBoundaryDisplay(maxNum)
                : formatPriceDisplay(maxNum)
              : kind === "numeric"
                ? formatGenericNumericDisplay(maxNum)
                : String(maxNum);

      const hiddenInputs =
        kind === "length" ||
          kind === "year" ||
          kind === "numeric" ||
          kind === "price"
          ? ""
          : rangeValues
            .map((v) => {
              const raw = facetItemRawValue(v);
              const bounds = facetItemNumericBounds(v);
              if (!bounds) return "";
              const num = (bounds.lo + bounds.hi) / 2;
              const valueStr =
                raw !== "" && raw != null ? String(raw) : String(num);
              const shouldBeChecked = v.state === "selected";
              return `<input
                    type="checkbox"
                    class="coveo-mobile-range-hidden-checkbox"
                    ${shouldBeChecked ? "checked" : ""}
                    data-facet-id="${escapeAttr(facetId)}"
                    data-value="${escapeAttr(valueStr)}"
                    data-num="${num}"
                    data-num-lo="${bounds.lo}"
                    data-num-hi="${bounds.hi}"
                  />`;
            })
            .filter(Boolean)
            .join("");

      const labelMin =
        kind === "length"
          ? "Min Length"
          : kind === "year"
            ? "Min Year"
            : kind === "numeric"
              ? "Min"
              : "Min Price";
      const labelMax =
        kind === "length"
          ? "Max Length"
          : kind === "year"
            ? "Max Year"
            : kind === "numeric"
              ? "Max"
              : "Max Price";

      const ariaRangeMin =
        kind === "length"
          ? "Minimum length"
          : kind === "year"
            ? "Minimum year"
            : kind === "numeric"
              ? `Minimum ${facetTitle}`
              : kind === "price"
                ? "Minimum price"
                : "Minimum value";
      const ariaRangeMax =
        kind === "length"
          ? "Maximum length"
          : kind === "year"
            ? "Maximum year"
            : kind === "numeric"
              ? `Maximum ${facetTitle}`
              : kind === "price"
                ? "Maximum price"
                : "Maximum value";
      const minPlaceholderDisplay =
        kind === "length"
          ? formatLengthFeetWhole(rangeAttrMin)
          : kind === "year"
            ? String(Math.round(rangeAttrMin))
            : kind === "price"
              ? formatPriceBoundaryDisplay(rangeAttrMin)
              : kind === "numeric"
                ? formatGenericNumericDisplay(rangeAttrMin)
                : String(rangeAttrMin);
      const maxPlaceholderDisplay =
        kind === "length"
          ? formatLengthFeetWhole(rangeAttrMax)
          : kind === "year"
            ? String(Math.round(rangeAttrMax))
            : kind === "price"
              ? formatPriceBoundaryDisplay(rangeAttrMax)
              : kind === "numeric"
                ? formatGenericNumericDisplay(rangeAttrMax)
                : String(rangeAttrMax);
      const numPhMin = minPlaceholderDisplay || "Enter Min";
      const numPhMax = maxPlaceholderDisplay || "Enter Max";
      const numAriaMin =
        kind === "length"
          ? "Minimum length in feet"
          : kind === "year"
            ? "Minimum year"
            : kind === "numeric"
              ? `Minimum value for ${facetTitle}`
              : kind === "price"
                ? "Minimum price"
                : "Minimum value";
      const numAriaMax =
        kind === "length"
          ? "Maximum length in feet"
          : kind === "year"
            ? "Maximum year"
            : kind === "numeric"
              ? `Maximum value for ${facetTitle}`
              : kind === "price"
                ? "Maximum price"
                : "Maximum value";
      const numStepAttr =
        kind === "year"
          ? "1"
          : kind === "price"
            ? String(COVEO_PRICE_SLIDER_STEP)
            : kind === "numeric"
              ? "1"
              : stepStr !== "any"
                ? stepStr
                : "any";
      /** Coveo recommended step=1000 for price (and integer steps elsewhere) to avoid 411.0000000006-style decimals. */
      const dualRangeStepAttr =
        kind === "price"
          ? String(COVEO_PRICE_SLIDER_STEP)
          : kind === "numeric"
            ? "1"
            : String(stepStr);
      const numInputmode =
        kind === "year" || kind === "price" || kind === "length"
          ? "numeric"
          : "decimal";
      // Native Length and Year spinners must step from the selected endpoints,
      // not empty fields whose placeholders only look like full-range values.
      const showRangeInputPlaceholdersOnly =
        kind !== "length" &&
        kind !== "year" &&
        Math.abs(minNum - loBound) < 0.000001 &&
        Math.abs(maxNum - hiBound) < 0.000001;
      const priceHistogramBuckets = buildPriceHistogramBuckets(14, loBound, hiBound);
      const priceHistogramMaxCount = priceHistogramBuckets.reduce(function (max, bucket) {
        return Math.max(max, Number(bucket.count) || 0);
      }, 0);
      const priceHistogramHtml =
        kind === "price" && priceHistogramBuckets.length
          ? `<div class="coveo-mobile-price-histogram" aria-hidden="true">${priceHistogramBuckets
            .map(function (bucket) {
              const ratio =
                priceHistogramMaxCount > 0
                  ? (Number(bucket.count) || 0) / priceHistogramMaxCount
                  : 0;
              const barHeightPercent = Math.max(22, Math.round(22 + ratio * 78));
              const isActive =
                !showRangeInputPlaceholdersOnly &&
                bucket.center >= minNum &&
                bucket.center <= maxNum;
              return `<span class="coveo-mobile-price-histogram__bar${isActive ? " is-active" : ""
                }" style="--coveo-price-bar-height:${escapeAttr(String(barHeightPercent))}%"></span>`;
            })
            .join("")}</div>`
          : "";

      const vspan = hiBound - loBound || 1;
      const pctMin0 = ((minNum - loBound) / vspan) * 100;
      const pctMax0 = ((maxNum - loBound) / vspan) * 100;
      const fillW0 = Math.max(0, pctMax0 - pctMin0);
      const minBubbleDisplay =
        kind === "length"
          ? formatLengthBubbleDisplay(minNum)
          : kind === "price"
            ? formatCompactPriceBubbleValue(minNum)
            : displayMin;
      const maxBubbleDisplay =
        kind === "length"
          ? formatLengthBubbleDisplay(maxNum)
          : kind === "price"
            ? formatCompactPriceBubbleValue(maxNum)
            : displayMax;
      const rangeFrozenClass = rangeUiFrozen ? " is-frozen" : "";
      const rangeInputDisabledAttr = rangeUiFrozen ? " disabled" : "";

      return `
        <div class="coveo-mobile-range${rangeFrozenClass}" data-range-kind="${escapeAttr(kind)}" data-facet-id="${escapeAttr(
        facetId,
      )}"${facet._isSyntheticYearFacet ? ' data-synthetic-year-facet="1"' : ""}${kind === "price" ? ` data-price-api-scale="${escapeAttr(String(priceApiScale))}"` : ""} data-range-lo="${escapeAttr(String(loBound))}" data-range-hi="${escapeAttr(String(hiBound))}" data-points="${escapeAttr(points.join(","))}">
                <div class="coveo-mobile-length-dual" style="--l-pct-a: ${escapeAttr(String(pctMin0))}%; --l-pct-b: ${escapeAttr(String(pctMax0))}%;">
                  <div class="coveo-mobile-length-dual__bubble-layer" aria-hidden="true">
                    <span class="coveo-mobile-length-dual__bubble coveo-mobile-length-dual__bubble--min">${escapeHtml(
                      minBubbleDisplay,
                    )}</span>
                    <span class="coveo-mobile-length-dual__bubble coveo-mobile-length-dual__bubble--max">${escapeHtml(
                      maxBubbleDisplay,
                    )}</span>
                  </div>
                  <div class="coveo-mobile-length-dual__rail">
                    <div class="coveo-mobile-length-dual__track-bg no-empty" aria-hidden="true"></div>
                    <div class="coveo-mobile-length-dual__track-fill no-empty" aria-hidden="true" style="left: ${escapeAttr(String(pctMin0))}%; width: ${escapeAttr(String(fillW0))}%;"></div>
                    <span class="coveo-mobile-length-dual__handle coveo-mobile-length-dual__handle--min" aria-hidden="true"></span>
                    <span class="coveo-mobile-length-dual__handle coveo-mobile-length-dual__handle--max" aria-hidden="true"></span>
                    <input type="range" min="${escapeAttr(
        String(rangeAttrMin),
      )}" max="${escapeAttr(String(rangeAttrMax))}" step="${escapeAttr(dualRangeStepAttr)}"
                      value="${escapeAttr(String(minNum))}" class="coveo-mobile-range-input coveo-mobile-range-input--min coveo-mobile-length-dual__input" aria-label="${escapeAttr(ariaRangeMin)}"${rangeInputDisabledAttr} />
                    <input type="range" min="${escapeAttr(
        String(rangeAttrMin),
      )}" max="${escapeAttr(String(rangeAttrMax))}" step="${escapeAttr(dualRangeStepAttr)}"
                      value="${escapeAttr(String(maxNum))}" class="coveo-mobile-range-input coveo-mobile-range-input--max coveo-mobile-length-dual__input" aria-label="${escapeAttr(ariaRangeMax)}"${rangeInputDisabledAttr} />
                  </div>
                </div>
                <div class="coveo-mobile-length-inputs coveo-mobile-price-inputs">
                  ${(() => {
          /*
           * Price inputs render as `type="text"` so we can show the
           * formatted currency value (e.g. "$1,000,000") instead of
           * a raw integer. All other ranges keep the native number
           * input + spinner controls.
           */
          const isPrice = kind === "price";
          const inputType = isPrice ? "text" : "number";
          const stepAttr = isPrice
            ? ""
            : ` step="${escapeAttr(numStepAttr)}"`;
          const minAttrSrc = showRangeInputPlaceholdersOnly
            ? ""
            : isPrice
              ? Math.abs(minNum - rangeAttrMin) < 0.000001 ||
                Math.abs(minNum - rangeAttrMax) < 0.000001
                ? formatPriceBoundaryDisplay(minNum)
                : formatPriceDisplay(minNum)
              : kind === "length"
                ? formatLengthFeetWhole(minNum)
                : String(minNum);
          const maxAttrSrc = showRangeInputPlaceholdersOnly
            ? ""
            : isPrice
              ? Math.abs(maxNum - rangeAttrMin) < 0.000001 ||
                Math.abs(maxNum - rangeAttrMax) < 0.000001
                ? formatPriceBoundaryDisplay(maxNum)
                : formatPriceDisplay(maxNum)
              : kind === "length"
                ? formatLengthFeetWhole(maxNum)
                : String(maxNum);
          const minMaxAttrs = isPrice
            ? ` data-range-lo="${escapeAttr(String(rangeAttrMin))}" data-range-hi="${escapeAttr(String(rangeAttrMax))}"`
            : ` min="${escapeAttr(String(rangeAttrMin))}" max="${escapeAttr(String(rangeAttrMax))}"`;
          return `
                  <label class="coveo-mobile-price-field">
                    <span class="coveo-mobile-price-label">${escapeHtml(
            labelMin,
          )}</span>
                    <input type="${inputType}" inputmode="${escapeAttr(numInputmode)}"${stepAttr}${minMaxAttrs} class="coveo-mobile-price-input coveo-mobile-price-input--min coveo-mobile-length-input coveo-mobile-length-input--min" value="${escapeHtml(
            minAttrSrc,
          )}" placeholder="${escapeAttr(numPhMin)}" aria-label="${escapeAttr(numAriaMin)}" autocomplete="off"${rangeInputDisabledAttr} />
                  </label>
                  <label class="coveo-mobile-price-field">
                    <span class="coveo-mobile-price-label">${escapeHtml(
            labelMax,
          )}</span>
                    <input type="${inputType}" inputmode="${escapeAttr(numInputmode)}"${stepAttr}${minMaxAttrs} class="coveo-mobile-price-input coveo-mobile-price-input--max coveo-mobile-length-input coveo-mobile-length-input--max" value="${escapeHtml(
            maxAttrSrc,
          )}" placeholder="${escapeAttr(numPhMax)}" aria-label="${escapeAttr(numAriaMax)}" autocomplete="off"${rangeInputDisabledAttr} />
                  </label>`;
        })()}
                </div>
                ${priceHistogramHtml}

          <div class="coveo-mobile-range__hidden">
            ${hiddenInputs}
          </div>
        </div>
      `;
    }

    const isOpen = openFacetIds.has(facetId);

    if (isConditionFacet) {
      return `<details class="coveo-facet-accordion accordion-details facet-accordion-details" is="accordion-details" data-facet-id="${escapeAttr(
        facetId,
      )}"${isOpen ? " open" : ""}>
      <summary class="coveo-facet-accordion__summary accordion-details__summary flex items-center justify-between">
        <span class="coveo-facet-accordion__title">${escapeHtml(label)}</span>
        ${renderSummaryMeta(true)}
      </summary>
      <div class="coveo-facet-accordion__content accordion-details__content">
        <div class="coveo-mobile-condition-grid" data-condition-facet="${escapeAttr(
        facetId,
      )}">
          ${renderConditionFacetValues()}
        </div>
      </div>
    </details>`;
    }

    if (label === "Make" || facetIdsMatchMake(facetId)) {
      return `<details class="coveo-facet-accordion accordion-details facet-accordion-details" is="accordion-details" data-facet-id="${escapeAttr(
        facetId,
      )}"${isOpen ? " open" : ""}>
      <summary class="coveo-facet-accordion__summary accordion-details__summary flex items-center justify-between">
        <span class="coveo-facet-accordion__title">${escapeHtml(label)}</span>
        ${renderSummaryMeta(true)}
      </summary>
      <div class="coveo-facet-accordion__content accordion-details__content">
        ${renderSearchableCheckboxFacetValues(
        "Search Brands...",
        "Search makes and filter brand list",
      )}
      </div>
    </details>`;
    }

    const dependency = getFacetDependencyConfig(facetId);
    const dependencyBlocked =
      dependency &&
      isFacetDependencyBlocked(renderCtx.desiredDrawerSnapshot, facetId);

    if (label === "Model" || facetIdsMatchModel(facetId)) {
      const modelDisabledBadge = dependencyBlocked
        ? `<span class="coveo-facet-summary-badge coveo-facet-summary-badge--disabled">${escapeHtml(
            dependency?.disabledBadge || "Select make first",
          )}</span>`
        : "";
      return `<details class="coveo-facet-accordion accordion-details facet-accordion-details${dependencyBlocked ? " is-disabled" : ""}" is="accordion-details" data-facet-id="${escapeAttr(
        facetId,
      )}"${isOpen && !dependencyBlocked ? " open" : ""}${dependencyBlocked ? ' aria-disabled="true" data-facet-disabled="true"' : ""}>
      <summary class="coveo-facet-accordion__summary accordion-details__summary flex items-center justify-between${dependencyBlocked ? " is-disabled" : ""}"${dependencyBlocked ? ' aria-disabled="true"' : ""}>
        <span class="coveo-facet-accordion__title">${escapeHtml(label)}</span>
        ${renderSummaryMeta(true, modelDisabledBadge)}
      </summary>
      <div class="coveo-facet-accordion__content accordion-details__content">
        ${renderSearchableCheckboxFacetValues(
        "Search models",
        "Search models and filter model list",
        {
          disabled: dependencyBlocked,
          disabledMessage: dependency?.disabledMessage || "Select a make first",
        },
      )}
      </div>
    </details>`;
    }

    if (label === "Boat Type") {
      return `<details class="coveo-facet-accordion accordion-details facet-accordion-details" is="accordion-details" data-facet-id="${escapeAttr(
        facetId,
      )}"${isOpen ? " open" : ""}>
      <summary class="coveo-facet-accordion__summary accordion-details__summary flex items-center justify-between">
        <span class="coveo-facet-accordion__title">${escapeHtml(label)}</span>
        ${renderSummaryMeta(true)}
      </summary>
      <div class="coveo-facet-accordion__content accordion-details__content">
        ${renderSearchableCheckboxFacetValues("Search", "Search boat types")}
      </div>
    </details>`;
    }

    if (shouldUseRangeFacetUi(facet, facetId, label)) {
      const rangeKind = numericalRangeUiKind(facetId, label);
      const rangeSummaryLabel = getRangeFacetSummaryLabel(rangeKind);
      return `<details class="coveo-facet-accordion accordion-details facet-accordion-details" is="accordion-details" data-facet-id="${escapeAttr(
        facetId,
      )}"${isOpen ? " open" : ""}>
      <summary class="coveo-facet-accordion__summary accordion-details__summary flex items-center justify-between">
        <span class="coveo-facet-accordion__title">${escapeHtml(label)}</span>
        ${renderSummaryMeta(
          false,
          rangeSummaryLabel
            ? `<span class="coveo-facet-summary-badge coveo-facet-summary-badge--range">${escapeHtml(rangeSummaryLabel)}</span>`
            : "",
        )}
      </summary>
      <div class="coveo-facet-accordion__content accordion-details__content">
        ${renderRangeFacetValues(rangeKind)}
      </div>
    </details>`;
    }

    const valsHtml = renderDefaultFacetValues();
    const moreLessHtml = renderFacetShowMoreLessButtons();
    return `<details class="coveo-facet-accordion accordion-details facet-accordion-details" is="accordion-details" data-facet-id="${escapeAttr(facetId)}"${isOpen ? " open" : ""}>
      <summary class="coveo-facet-accordion__summary accordion-details__summary flex items-center justify-between">
        <span class="coveo-facet-accordion__title">${escapeHtml(label)}</span>
        ${renderSummaryMeta(true)}
      </summary>
      <div class="coveo-facet-accordion__content accordion-details__content">
        <div class="coveo-facet-default-wrap">${valsHtml}${moreLessHtml}</div>
      </div>
    </details>`;
  }

  function unwrapFieldValue(value) {
    let current = value;
    const visited = new Set();
    while (
      current != null &&
      typeof current === "object" &&
      !Array.isArray(current) &&
      Object.prototype.hasOwnProperty.call(current, "value") &&
      !visited.has(current)
    ) {
      visited.add(current);
      current = current.value;
    }
    return current;
  }

  function isEmptyField(value) {
    const unwrapped = unwrapFieldValue(value);
    if (unwrapped == null) return true;
    if (typeof unwrapped === "string") return unwrapped.trim() === "";
    if (Array.isArray(unwrapped)) {
      return unwrapped.length === 0 || unwrapped.every(isEmptyField);
    }
    return false;
  }

  const coveoProductFieldIndexCache = new WeakMap();

  function normalizeCoveoProductFieldKey(key) {
    return String(key == null ? "" : key)
      .replace(/^@/, "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "");
  }

  function getProductFieldByNormalizedKey(source, key) {
    if (!source || typeof source !== "object") return null;
    let index = coveoProductFieldIndexCache.get(source);
    if (!index) {
      index = new Map();
      Object.keys(source).forEach(function (sourceKey) {
        const normalized = normalizeCoveoProductFieldKey(sourceKey);
        if (normalized && !index.has(normalized)) {
          index.set(normalized, sourceKey);
        }
      });
      coveoProductFieldIndexCache.set(source, index);
    }
    const sourceKey = index.get(normalizeCoveoProductFieldKey(key));
    return sourceKey == null ? null : source[sourceKey];
  }

  function getByDottedPath(obj, path) {
    if (!obj || typeof obj !== "object" || !path || !path.includes("."))
      return null;
    const parts = path.split(".");
    let cur = obj;
    for (const part of parts) {
      if (cur == null || typeof cur !== "object") return null;
      cur = cur[part];
    }
    return isEmptyField(cur) ? null : cur;
  }

  function getProductField(p, keys) {
    if (!p || typeof p !== "object") return null;
    const af = p.additionalFields;
    const afObj = af && typeof af === "object" && !Array.isArray(af) ? af : {};
    const arRaw =
      p.additional_retrieved_fields || p.additionalRetrievedFields || null;
    const arObj =
      arRaw && typeof arRaw === "object" && !Array.isArray(arRaw) ? arRaw : {};
    const sources = [p, afObj, arObj];
    for (const k of keys) {
      if (k == null) continue;
      const kStr = String(k);
      const withoutAt = kStr.replace(/^@/, "");
      const underscored = withoutAt.replace(/[.\-\s]+/g, "_");
      const variants = [
        ...new Set([kStr, withoutAt, underscored]),
      ];
      for (const src of sources) {
        if (!src || typeof src !== "object") continue;
        for (const vk of variants) {
          let v = src[vk];
          if (isEmptyField(v) && vk.includes(".")) {
            v = getByDottedPath(src, vk);
          }
          if (isEmptyField(v) && src !== p && vk.includes(".")) {
            v = getByDottedPath(p, vk);
          }
          let unwrapped = unwrapFieldValue(v);
          if (!isEmptyField(unwrapped)) {
            return unwrapped;
          }
        }
        const normalizedValue = unwrapFieldValue(
          getProductFieldByNormalizedKey(src, withoutAt),
        );
        if (!isEmptyField(normalizedValue)) return normalizedValue;
      }
    }
    return null;
  }

  function firstMeaningfulProductFieldValue(value) {
    const unwrapped = unwrapFieldValue(value);
    if (Array.isArray(unwrapped)) {
      for (const item of unwrapped) {
        const normalized = firstMeaningfulProductFieldValue(item);
        if (!isEmptyField(normalized)) return normalized;
      }
      return null;
    }
    if (isEmptyField(unwrapped)) return null;
    return typeof unwrapped === "string" ? unwrapped.trim() : unwrapped;
  }

  const COVEO_PRODUCT_CARD_LENGTH_FIELDS = Object.freeze([
    "ec_length_nominal",
    "ec_custom_field_length_nominal",
    "ec_custom_field_iiq-length_nominal",
    "iiq_length_nominal",
    "iiq.length_nominal",
    "iiq-length_nominal",
    "length_nominal",
    "lengthnominal",
  ]);

  const COVEO_PRODUCT_CARD_CONDITION_FIELDS = Object.freeze([
    "condition_iiq",
    "ec_condition",
    "ec_boat_status",
    "ec_custom_field_condition_iiq",
    "ec_custom_field_iiq-boat_status",
    "iiq_condition",
    "iiq.condition",
    "iiq.boat_status",
    "iiq_boat_status",
    "iiq-boat_status",
    "boat_status",
    "condition",
  ]);

  const COVEO_PRODUCT_CARD_ACTIVE_PROMOTION_FIELDS = Object.freeze([
    "iiq-active_promotion_data.name",
    "iiq_active_promotion_data.name",
    "active_promotion_data.name",
    "iiq.active_promotion_data.name",
    "ec_active_promotion_data_name",
    "iiq_active_promotion_name",
  ]);

  function getProductCardLength(product) {
    return firstMeaningfulProductFieldValue(
      getProductField(product, COVEO_PRODUCT_CARD_LENGTH_FIELDS),
    );
  }

  function getProductCardCondition(product) {
    return firstMeaningfulProductFieldValue(
      getProductField(product, COVEO_PRODUCT_CARD_CONDITION_FIELDS),
    );
  }

  function normalizeActivePromotionName(raw) {
    if (Array.isArray(raw)) {
      for (const value of raw) {
        const label = normalizeActivePromotionName(value);
        if (label) return label;
      }
      return "";
    }
    if (raw && typeof raw === "object") {
      return normalizeActivePromotionName(raw.name ?? raw.value ?? "");
    }
    if (typeof raw !== "string") return "";
    const label = raw.trim();
    return ["n/a", "na", "none", "null", "-", "—"].includes(label.toLowerCase())
      ? ""
      : label;
  }

  function slugPromoModifier(label) {
    const s = String(label || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
    return s || "iiq-promo";
  }

  function promoBadgeFromActivePromotionLabel(label) {
    const t = String(label || "").trim();
    if (!t) return null;
    const lower = t.toLowerCase();
    if (lower === "new arrival") return { label: t, modifier: "new-arrival" };
    if (lower === "last chance") return { label: t, modifier: "last-chance" };
    if (lower === "exceptional savings")
      return { label: t, modifier: "exceptional" };
    if (lower === "hot deal" || lower === "hot deals")
      return { label: t, modifier: "hot-deal" };
    return { label: t, modifier: slugPromoModifier(t) };
  }

  function resolveBoatPromoBadge(p) {
    const activePromoRaw = getProductField(
      p,
      COVEO_PRODUCT_CARD_ACTIVE_PROMOTION_FIELDS,
    );
    const activePromoLabel = normalizeActivePromotionName(activePromoRaw);
    return promoBadgeFromActivePromotionLabel(activePromoLabel);
  }

  const CHECK_CIRCLE_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';

  const OFF_MARKET_BADGE_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none" aria-hidden="true"><path opacity="0.1" d="M50.6243 35.0002H9.37433V38.3578C9.37433 39.3128 9.91843 40.1844 10.7764 40.6038L15.7267 43.0236C24.7326 47.4258 35.266 47.4258 44.2718 43.0236L49.2222 40.6038C50.0802 40.1844 50.6243 39.3128 50.6243 38.3578V35.0002Z" fill="white" stroke="white" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/><path d="M50.6243 35.0002L54.6608 28.3951C56.1879 25.8961 55.2499 22.6255 52.6304 21.3157L42.2977 16.1493C34.5557 12.2783 25.443 12.2783 17.701 16.1493L7.36825 21.3157C4.74874 22.6255 3.81074 25.8961 5.33791 28.3951L9.37434 35.0002M50.6243 35.0002L29.9993 34.4446L9.37434 35.0002M50.6243 35.0002V38.3577C50.6243 39.3127 50.0802 40.1843 49.2222 40.6037L44.2719 43.0235C35.266 47.4257 24.7326 47.4257 15.7267 43.0235L10.7764 40.6037C9.91844 40.1843 9.37434 39.3127 9.37434 38.3577V35.0002" stroke="white" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/><path d="M34.9976 27.6786L29.9976 28.75L24.9976 27.6786M29.9976 28.75V23.3929M29.9976 21.25V23.3929M29.9976 23.3929H27.4976M29.9976 23.3929H32.4976" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /** Coveo / catalog titles often repeat as "Name - Name"; strip for parity with Figma. */
  function dedupeCoveoListingTitle(raw) {
    const t = String(raw || "").trim();
    if (!t) return t;
    const parts = t.split(/\s+[-\u2013]\s+/);
    if (parts.length >= 2) {
      const first = parts[0].trim();
      const rest = parts.slice(1).join(" - ").trim();
      if (first && first === rest) return first;
    }
    return t;
  }

  function getCoveoCardTitleText(p) {
    const name =
      getProductField(p, ["ec_name", "ec_product_name", "name", "title"]) ||
      "Product";
    const brand = getProductField(p, ["ec_brand", "brand"]);
    const model = getProductField(p, ["ec_model", "model"]);
    const year = getProductField(p, [
      "year1",
      "year_iiq",
      "ec_year",
      "year",
      "iiq_year",
    ]);
    const titleParts = [year, brand, model].filter(Boolean);
    return name && name !== "Product"
      ? dedupeCoveoListingTitle(name)
      : titleParts.length
        ? dedupeCoveoListingTitle(titleParts.join(" "))
        : "This boat";
  }

  const COVEO_PRODUCT_LAT_FIELD_KEYS = [
    "iiq-dealer.lat",
    "iiq_dealer_lat",
    "iiq-dealer_lat",
    "dealer_lat",
    "dealer_latitude",
    "ec_dealer_lat",
    "ec_latitude",
    "latitude",
    "lat",
    "iiq.lat",
    "iiq_lat",
    "store_latitude",
    "location_lat",
    "ec_custom_field_iiq-dealer_lat",
  ];

  const COVEO_PRODUCT_LNG_FIELD_KEYS = [
    "iiq-dealer.long",
    "iiq-dealer.lng",
    "iiq_dealer_long",
    "iiq_dealer_lng",
    "iiq-dealer_long",
    "iiq-dealer_lng",
    "dealer_long",
    "dealer_lng",
    "dealer_longitude",
    "ec_dealer_lng",
    "ec_dealer_long",
    "ec_longitude",
    "longitude",
    "lng",
    "long",
    "iiq.long",
    "iiq_lng",
    "store_longitude",
    "location_lng",
    "location_long",
    "ec_custom_field_iiq-dealer_long",
    "ec_custom_field_iiq-dealer_lng",
  ];

  function parseGeoCoordinate(value) {
    if (value == null || value === "") return NaN;
    const n = parseFloat(String(value).trim());
    return Number.isFinite(n) ? n : NaN;
  }

  function getProductGeoCoordinates(product) {
    if (!product || typeof product !== "object") return null;
    const stableKey = getCoveoStableProductKey(product);
    const cached =
      stableKey && window.__coveoProductGeoByKey instanceof Map
        ? window.__coveoProductGeoByKey.get(stableKey)
        : null;
    if (cached && Number.isFinite(cached.lat) && Number.isFinite(cached.lng)) {
      return cached;
    }
    const lat = parseGeoCoordinate(
      getProductField(product, COVEO_PRODUCT_LAT_FIELD_KEYS),
    );
    const lng = parseGeoCoordinate(
      getProductField(product, COVEO_PRODUCT_LNG_FIELD_KEYS),
    );
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
    return { lat, lng };
  }

  function getCardDealerPlaceOpts(card) {
    if (!card) return null;
    const place = (card.getAttribute("data-dealer-place") || "").trim();
    const city = (card.getAttribute("data-dealer-city") || "").trim();
    const state = (card.getAttribute("data-dealer-state") || "").trim();
    const zip = (card.getAttribute("data-dealer-zip") || "").trim();
    if (!place && !city && !state && !zip) return null;
    return { place, city, state, zip };
  }

  /** Normalize US ZIP to 5-digit prefix for same-area matching. */
  function normalizeUsZipPrefix(zip) {
    const digits = String(zip || "")
      .replace(/\D/g, "")
      .slice(0, 5);
    return digits.length >= 5 ? digits : "";
  }

  function cardMatchesUserZipRadius(card, userZip, radiusMiles) {
    const cardZip = normalizeUsZipPrefix(
      card.getAttribute("data-dealer-zip") || "",
    );
    const searchZip = normalizeUsZipPrefix(userZip);
    if (!cardZip || !searchZip) return false;
    if (cardZip === searchZip) return true;
    /*
     * Same 3-digit ZIP prefix ≈ same sectional center (often within ~50 mi).
     * Used only when lat/lng are absent on the card.
     */
    if (Number(radiusMiles) >= 50 && cardZip.slice(0, 3) === searchZip.slice(0, 3)) {
      return true;
    }
    return false;
  }

  function getCoveoDistanceCardFromGridItem(item) {
    if (!item || item.nodeType !== 1) return null;
    if (
      item.matches(".coveo-search-card, .coveo-boat-card, .coveo-product-card")
    ) {
      return item;
    }
    return item.querySelector(
      ".coveo-search-card, .coveo-boat-card, .coveo-product-card",
    );
  }

  function setColumnDistanceFiltered(col, reason) {
    col.hidden = true;
    col.setAttribute("hidden", "");
    col.style.setProperty("display", "none", "important");
    col.classList.add("is-distance-filtered-out");
    col.setAttribute("data-distance-filtered", reason || "filtered");
    col.setAttribute("aria-hidden", "true");
  }

  function setColumnDistanceVisible(col, sortOrder) {
    col.hidden = false;
    col.removeAttribute("hidden");
    col.style.removeProperty("display");
    col.classList.remove("is-distance-filtered-out");
    col.removeAttribute("data-distance-filtered");
    col.removeAttribute("aria-hidden");
    if (sortOrder != null) {
      col.style.order = String(sortOrder);
    } else {
      col.style.removeProperty("order");
    }
  }

  function applyDistanceToColumn(col, card, userLat, userLng, radius, Loc) {
    const lat = parseGeoCoordinate(card.getAttribute("data-dealer-lat"));
    const lng = parseGeoCoordinate(card.getAttribute("data-dealer-lng"));
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      setColumnDistanceFiltered(col, "no-geo");
      return { withGeo: false, visible: false };
    }
    const miles = Loc.haversineDistanceMiles(userLat, userLng, lat, lng);
    if (Number.isFinite(miles) && miles <= radius) {
      setColumnDistanceVisible(col, Math.round(miles * 100));
      return { withGeo: true, visible: true };
    }
    setColumnDistanceFiltered(col, "out-of-range");
    return { withGeo: true, visible: false };
  }

  function applyNearestSortToProductGrid(productsEl) {
    if (!productsEl) return false;
    const userLocation = getStoredCoveoLocationContextWithoutRadius({
      ignoreSuppression: true,
    });
    const userLat = Number(userLocation?.location?.latitude);
    const userLng = Number(userLocation?.location?.longitude);
    const haversine =
      window.CoveoLocationService?.haversineDistanceMiles;
    if (
      !Number.isFinite(userLat) ||
      !Number.isFinite(userLng) ||
      typeof haversine !== "function"
    ) {
      return false;
    }

    const rankedItems = getCoveoDistanceGridItems(productsEl).map(function (
      item,
      index,
    ) {
      const card = getCoveoDistanceCardFromGridItem(item);
      const lat = parseGeoCoordinate(card?.getAttribute("data-dealer-lat"));
      const lng = parseGeoCoordinate(card?.getAttribute("data-dealer-lng"));
      const miles =
        Number.isFinite(lat) && Number.isFinite(lng)
          ? haversine(userLat, userLng, lat, lng)
          : NaN;
      return {
        item: item,
        index: index,
        miles: Number.isFinite(miles) ? miles : Infinity,
      };
    });
    if (
      !rankedItems.some(function (entry) {
        return Number.isFinite(entry.miles);
      })
    ) {
      return false;
    }

    rankedItems
      .sort(function (a, b) {
        return a.miles - b.miles || a.index - b.index;
      })
      .forEach(function (entry, index) {
        entry.item.style.order = String(index);
        entry.item.setAttribute(
          "data-nearest-distance-miles",
          Number.isFinite(entry.miles) ? String(entry.miles) : "",
        );
        productsEl.appendChild(entry.item);
      });
    return true;
  }

  function renderBoatCard(p) {
    const url = p.clickUri || "#";

    const name =
      getProductField(p, ["ec_name", "ec_product_name", "name", "title"]) ||
      "Product";

    const img =
      (p.ec_thumbnails && p.ec_thumbnails[0]) ||
      (p.ec_images && p.ec_images[0]) ||
      "";

    const boatStatus = resolveCoveoCardCondition(p);

    const promotionBadge = resolveBoatPromoBadge(p);

    const lengthNominal = resolveCoveoCardLength(p);

    const productId = (() => {
      const raw = getProductField(p, [
        "iiq_stock_number",
        "iiq.stock_number",
        "stock_number",
        "ec_sku",
        "sku",
      ]);
      if (!raw) return "";
      const s = String(raw).trim();
      if (s.includes("/")) return s.split("/").pop().trim();
      const cleaned = s.replace(/^#/, "").trim();
      if (/^\d{12,}$/.test(cleaned)) return "";
      return cleaned;
    })();

    const locationOffsite = getProductField(p, [
      "location_offsite",
      "location.offsite",
      "ec_custom_field_location_offsite",
      "ec_location_offsite",
      "location_offsite_value",
    ]);

    const listPrice = parsePrice(
      p.ec_price ?? getProductField(p, ["ec_price", "price", "list_price"]),
    );
    const promoPrice = parsePrice(
      p.ec_promo_price ??
      getProductField(p, ["ec_promo_price", "promo_price", "sale_price"]),
    );
    const price =
      promoPrice != null &&
        listPrice != null &&
        promoPrice < listPrice
        ? promoPrice
        : listPrice ?? promoPrice;
    const origPrice =
      promoPrice != null &&
        listPrice != null &&
        promoPrice < listPrice
        ? listPrice
        : null;

    const isNew = /^new(\s+boat)?$/i.test(String(boatStatus || "").trim());
    const hasDiscount =
      origPrice != null && price != null && origPrice > price;
    const msrpPrice = parsePrice(
      getProductField(p, [
        "iiq_price_msrp",
        "iiq.price_msrp",
        "iiq_msrp",
        "iiq.msrp",
        "ec_msrp",
        "msrp",
      ]),
    );
    const showMsrpLabel =
      !hasDiscount &&
      msrpPrice != null &&
      price != null &&
      Math.abs(msrpPrice - price) < 0.005;
    const showMsrpCompareLabel =
      hasDiscount &&
      msrpPrice != null &&
      origPrice != null &&
      Math.abs(msrpPrice - origPrice) < 0.005;
    const newTag =
      isNew && promotionBadge?.modifier !== "new-arrival"
        ? `<span class="coveo-boat-card__tag coveo-boat-card__tag--new">New</span>`
        : "";
    const saveTag = hasDiscount
      ? `<span class="coveo-boat-card__tag coveo-boat-card__tag--savings">Save ${formatPrice(origPrice - price)}</span>`
      : "";

    const formatLength = (val) => {
      if (!val) return "";
      const s = String(val).trim();
      return /['"]$/.test(s) ? s : s + "'";
    };

    const titleText = getCoveoCardTitleText(p);

    const promoBadgeHtml = promotionBadge
      ? `<div class="coveo-search-card__tag-badge coveo-search-card__tag-badge--${promotionBadge.modifier}"><span class="coveo-search-card__tag-badge-text">${escapeHtml(promotionBadge.label)}</span></div>`
      : "";
    const metaInner = [
      lengthNominal
        ? `<span class="coveo-search-card__length">${escapeHtml(formatLength(lengthNominal))}</span>`
        : "",
      lengthNominal && boatStatus
        ? `<span class="coveo-search-card__meta-sep">|</span>`
        : "",
      boatStatus
        ? `<span class="coveo-search-card__condition">${escapeHtml(boatStatus)}</span>`
        : "",
    ]
      .filter(Boolean)
      .join("");
    const topRowHtml = `<div class="coveo-search-card__top-row"><div class="coveo-search-card__meta">${metaInner}</div><div class="coveo-search-card__tag-badges">${promoBadgeHtml}</div></div>`;

    const stockLineHtml = productId
      ? `<span class="coveo-search-card__stock-id"># ${escapeHtml(productId)}</span>`
      : `<span class="coveo-search-card__stock-id coveo-search-card__stock-id--placeholder" aria-hidden="true">&nbsp;</span>`;

    const locationLineHtml = locationOffsite
      ? `<p class="coveo-boat-card__location-line">${CHECK_CIRCLE_SVG}<span>${escapeHtml(locationOffsite)}</span></p>`
      : "";

    let priceWrapInner = "";
    if (price != null) {
      const sale = escapeHtml(formatPrice(price));
      if (hasDiscount && origPrice != null) {
        const reg = escapeHtml(formatPrice(origPrice));
        const msrpRegular = showMsrpCompareLabel ? `MSRP ${reg}` : reg;
        priceWrapInner = `<div class="f-price f-price--on-sale"><div class="f-price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span><span class="f-price-item f-price-item--regular">${msrpRegular}</span></div><div class="f-price__sale"><span class="visually-hidden visually-hidden--inline">Sale price</span><span class="f-price-item f-price-item--sale">${sale}</span><span class="visually-hidden visually-hidden--inline">Regular price</span><span class="f-price-item f-price-item--regular"><s>${msrpRegular}</s></span></div></div>`;
      } else {
        const regularLabel = showMsrpLabel ? `MSRP ${sale}` : sale;
        priceWrapInner = `<div class="f-price"><div class="f-price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span><span class="f-price-item f-price-item--regular">${regularLabel}</span></div><div class="f-price__sale"></div></div>`;
      }
    }

    const coveoKey = getCoveoStableProductKey(p);
    const coveoKeyAttr = coveoKey
      ? ` data-coveo-product-key="${escapeAttr(coveoKey)}"`
      : "";
    const dealerLat = parseGeoCoordinate(
      getProductField(p, COVEO_PRODUCT_LAT_FIELD_KEYS),
    );
    const dealerLng = parseGeoCoordinate(
      getProductField(p, COVEO_PRODUCT_LNG_FIELD_KEYS),
    );
    const dealerCity = getProductField(p, [
      "iiq.city",
      "iiq_city",
      "ec_city",
      "city",
    ]);
    const dealerState = getProductField(p, [
      "iiq.state",
      "iiq_state",
      "ec_state",
      "state",
    ]);
    const dealerZip = getProductField(p, [
      "iiq-dealer.zip",
      "iiq_dealer_zip",
      "iiq-dealer_zip",
      "dealer_zip",
      "ec_dealer_zip",
      "postal_code",
      "zip",
    ]);
    const dealerPlace =
      locationOffsite ||
      getProductField(p, [
        "location.name",
        "location_name",
        "iiq-dealer.name",
        "iiq_dealer_name",
        "dealer_name",
      ]);
    const dealerGeoAttrs = [
      Number.isFinite(dealerLat)
        ? ` data-dealer-lat="${escapeAttr(dealerLat)}"`
        : "",
      Number.isFinite(dealerLng)
        ? ` data-dealer-lng="${escapeAttr(dealerLng)}"`
        : "",
      dealerCity
        ? ` data-dealer-city="${escapeAttr(String(dealerCity))}"`
        : "",
      dealerState
        ? ` data-dealer-state="${escapeAttr(String(dealerState))}"`
        : "",
      dealerPlace
        ? ` data-dealer-place="${escapeAttr(String(dealerPlace))}"`
        : "",
      dealerZip
        ? ` data-dealer-zip="${escapeAttr(String(dealerZip))}"`
        : "",
    ].join("");
    return `
      <div class="f-column card coveo-search-card-wrapper" role="listitem"${coveoKeyAttr}>
      <div class="coveo-search-card"${dealerGeoAttrs}>
        <a href="${escapeAttr(url)}" class="coveo-search-card__link">
          <div class="coveo-search-card__image-wrap">
            ${img ? `<img src="${escapeAttr(img)}" alt="${escapeAttr(name)}" loading="lazy" class="coveo-search-card__image" />` : '<div class="coveo-search-card__placeholder"></div>'}
            ${newTag}
            ${saveTag}
          </div>
          <div class="coveo-search-card__info">
            ${topRowHtml}
            <div class="coveo-search-card__heading-block">
              <h3 class="coveo-search-card__title">${escapeHtml(titleText)}</h3>
              ${locationLineHtml}
            </div>
            <hr class="coveo-search-card__divider" />
            <div class="coveo-search-card__footer">
              <div class="coveo-search-card__footer-main">
                <div class="coveo-search-card__price-wrap">
                  ${priceWrapInner}
                </div>
                ${stockLineHtml}
              </div>
            </div>
          </div>
        </a>
      </div>
      </div>`;
  }

  function renderOffMarketCard(p) {
    const titleText = getCoveoCardTitleText(p);
    const hasSearchableTitle =
      titleText && titleText !== "Product" && titleText !== "This boat";
    const soldTitleText =
      hasSearchableTitle
        ? titleText
        : "This boat";
    const offMarketSearchUrl = buildSearchResultsUrl(
      hasSearchableTitle ? titleText : "",
    );
    const coveoKey = getCoveoStableProductKey(p);
    const coveoKeyAttr = coveoKey
      ? ` data-coveo-product-key="${escapeAttr(coveoKey)}"`
      : "";

    return `
      <div class="f-column card coveo-search-card-wrapper" role="listitem"${coveoKeyAttr}>
        <div class="coveo-search-card coveo-search-card--off-market">
          <a href="${escapeAttr(offMarketSearchUrl)}" class="coveo-search-card__link coveo-search-card__off-market-link" aria-label="${escapeAttr(`Explore search results for ${soldTitleText}`)}">
          <div class="coveo-search-card__off-market" aria-label="Off the Market">
            <span class="coveo-search-card__off-market-icon">${OFF_MARKET_BADGE_SVG}</span>
            <h3 class="coveo-search-card__off-market-title">Off the Market</h3>
            <p class="coveo-search-card__off-market-copy"><strong>${escapeHtml(soldTitleText)}</strong> just sold. Explore similar listings still available.</p>
          </div>
          </a>
        </div>
      </div>`;
  }

  function parsePrice(val) {
    if (val == null) return null;
    const num =
      typeof val === "number"
        ? val
        : parseFloat(String(val).replace(/[^0-9.-]/g, ""));
    if (!Number.isFinite(num)) return null;
    /*
     * Coveo Commerce v2 returns `ec_price` / `ec_promo_price` as **dollar**
     * amounts (integer or decimal), not Shopify-style cents. A prior heuristic
     * divided every integer ≥ 1_000_000 by 100 under the assumption it was
     * cents — that broke all million-dollar listings (e.g. $1,537,131 → $15,371).
     *
     * If a feed ever sends cents as a raw integer, it would need to be ≥ ~$100M
     * in cents before we treat it as cents (10_000_000_000). Normal boat prices
     * never hit that in dollars, so this is a safe escape hatch only.
     */
    if (num >= 1e10 && Number.isInteger(num)) {
      return num / 100;
    }
    return num;
  }

  /** Coveo may still return sold/draft rows; Liquid enrichment shows Shopify's ~$19.99 placeholder. */
  const COVEO_PLACEHOLDER_SOLD_GHOST_PRICE_USD = 19.99;

  function isCoveoPlaceholderSoldGhostProduct(p) {
    if (!p || typeof p !== "object") return false;
    const raw =
      p.ec_promo_price ??
      p.ec_price ??
      getProductField(p, ["ec_promo_price", "ec_price", "price"]);
    const n = parsePrice(raw);
    if (n == null || !Number.isFinite(n)) return false;
    return Math.abs(n - COVEO_PLACEHOLDER_SOLD_GHOST_PRICE_USD) < 0.01;
  }

  let mmLastViewItemListSig = "";

  function mmCoveoProductToDatalayerItem(p) {
    if (!p || typeof p !== "object") return null;
    const id = String(
      getProductField(p, [
        "shopify_product_id",
        "productid",
        "product_id",
        "ec_item_group_id",
        "permanentid",
      ]) ||
      p.permanentid ||
      "",
    ).trim();
    const name = String(
      getProductField(p, ["ec_name", "ec_product_name", "title", "name"]) || "",
    ).trim();
    const brand = String(
      getProductField(p, ["ec_brand", "brand", "vendor"]) || "",
    ).trim();
    const priceRaw = getProductField(p, [
      "ec_price",
      "price",
      "ec_promo_price",
    ]);
    let price = parsePrice(priceRaw);
    if (!Number.isFinite(price)) price = null;
    if (!id && !name) return null;
    return {
      item_id: id || "",
      item_name: name || "",
      item_brand: brand || "",
      price,
    };
  }

  function mmScheduleViewItemListPush(container, products, state) {
    try {
      if (!products || !products.length) return;
      window.dataLayer = window.dataLayer || [];
      const coll = document.getElementById("coveo-headless-collection");
      const searchRoot = document.getElementById("coveo-headless-search");
      let listName = "inventory_search";
      let listId = "inventory_search";
      if (coll && coll.dataset.collectionTitle) {
        listName = coll.dataset.collectionTitle;
        listId = coll.dataset.collectionHandle || coll.dataset.collectionTitle;
      } else if (searchRoot) {
        listName = "search";
        listId = "search";
      }
      const items = products
        .slice(0, 20)
        .map(mmCoveoProductToDatalayerItem)
        .filter(Boolean);
      if (!items.length) return;
      const sig = `${listId}::${state?.responseId || ""}::${products.map((p) => p.permanentid || "").join(",")}`;
      if (sig === mmLastViewItemListSig) return;
      mmLastViewItemListSig = sig;
      window.dataLayer.push({
        event: "view_item_list",
        item_list_name: listName,
        item_list_id: String(listId),
        ecommerce: { currency: "USD", items },
      });
    } catch (_) { }
  }

  /** MarineMax data layer: map Coveo facet id to allowed `filter_type` values. */
  function mmGetCoveoSearchTerm(search) {
    try {
      const raw =
        search?.state?.query ??
        search?.state?.input ??
        search?.state?.keyword ??
        "";
      const s = String(raw || "").trim();
      return s || null;
    } catch (_) {
      return null;
    }
  }

  function mmCoveoFacetIdToMarineMaxFilterType(facetId) {
    if (facetIdsMatchPrice(facetId)) return "price";
    if (facetIdsMatchLength(facetId)) return "length";
    if (facetIdsMatchYear(facetId)) return "year";
    const id = String(facetId || "").toLowerCase();
    if (
      id.includes("condition") ||
      id.includes("boat_status") ||
      id.includes("newused") ||
      id === "condition_iiq"
    ) {
      return "condition";
    }
    if (
      id.includes("location") ||
      id.includes("store") ||
      id.includes("dealer") ||
      id.includes("city") ||
      id.includes("region") ||
      id.includes("distance") ||
      id.includes("zip")
    ) {
      return "location";
    }
    if (facetIdsMatchMake(facetId) || facetIdsMatchModel(facetId)) {
      return "brand";
    }
    return "brand";
  }

  function mmPushFilterAppliedForFacet(facetId, filterValue, search) {
    const ft = mmCoveoFacetIdToMarineMaxFilterType(facetId);
    const fv = String(filterValue != null ? filterValue : "").trim();
    if (!fv) return;
    const st = mmGetCoveoSearchTerm(search);
    try {
      if (
        window.MarineMaxDataLayer &&
        typeof window.MarineMaxDataLayer.pushFilterApplied === "function"
      ) {
        window.MarineMaxDataLayer.pushFilterApplied(ft, fv, st || undefined);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "filter_applied",
          filter_type: ft,
          filter_value: fv,
          search_term: st,
        });
      }
    } catch (_) { }
  }

  function formatPrice(val) {
    if (val == null || typeof val !== "number") return "";
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(val);
  }

  function escapeHtml(str) {
    if (!str) return "";
    const div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  function escapeAttr(str) {
    if (str == null) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function wireCollectionToolbarSearch(
    engine,
    mod,
    collectionHandle,
    controller,
    lifecycle,
  ) {
    const input =
      lifecycle?.root?.querySelector?.("#coveo-collection-search-input") ||
      document.getElementById("coveo-collection-search-input");
    const form = input?.closest("form");
    if (!input || !form || !engine) return;
    if (form.dataset.coveoCollectionSearchWired) return;
    form.dataset.coveoCollectionSearchWired = "true";
    lifecycle?.addCleanup(function () {
      delete form.dataset.coveoCollectionSearchWired;
    });
    const clearBtn = form.querySelector("[data-coveo-clear-toolbar-search]");
    const collectionContainer =
      lifecycle?.root ||
      document.getElementById("coveo-headless-collection");
    const syncToolbarSearchClearButton = (rawValue) => {
      if (!clearBtn) return;
      const hasValue = String(rawValue ?? "").length > 0;
      clearBtn.classList.toggle("hidden", !hasValue);
      clearBtn.setAttribute("aria-hidden", hasValue ? "false" : "true");
    };

    const queueCollectionQuery = function (
      trimmed,
      retiredInitialHydration,
      routeIntent,
    ) {
      return enqueueCoveoUiMutation(
        collectionContainer,
        async function (lease) {
          const isCurrent = function () {
            const leaseIsCurrent =
              !lease ||
              typeof lease.isCurrent !== "function" ||
              lease.isCurrent();
            const lifecycleIsCurrent =
              !lifecycle ||
              (lifecycle.active &&
                lifecycle.isCurrent() &&
                collectionContainer?.isConnected !== false);
            const routeIsCurrent =
              !routeIntent ||
              typeof routeIntent.isCurrent !== "function" ||
              routeIntent.isCurrent();
            return leaseIsCurrent && lifecycleIsCurrent && routeIsCurrent;
          };

          await waitForRetiredInitialCoveoUrlHydration(
            retiredInitialHydration,
            3000,
          );
          if (!isCurrent()) return;

          const endMutation = beginCoveoUiMutation(
            collectionContainer,
            900,
          );
          try {
            const activeController =
              collectionContainer?._coveoSearch || controller;
            setLastSubmittedKeywordQuery(
              activeController,
              collectionContainer,
              trimmed,
            );
            if ((input.value || "").trim() === trimmed) {
              input.value = trimmed;
            }
            await dispatchCoveoSearch(activeController, engine, mod, {
              isCurrent,
              resetPagination: true,
              routeIntent,
            });
            if (!isCurrent()) return;

            try {
              const url = new URL(window.location.href);
              if (trimmed) url.searchParams.set("q", trimmed);
              else url.searchParams.delete("q");
              url.searchParams.delete("page");
              replaceCoveoHistoryUrl(url.toString());
            } catch (_) { }
            const headerInput = document.querySelector(
              "#coveo-search-wrapper input[name='q']",
            );
            if (headerInput) headerInput.value = trimmed;
            syncToolbarSearchClearButton(input.value || "");
          } catch (e) {
            console.warn(
              "[Coveo Collection] Toolbar search update failed:",
              e,
            );
          } finally {
            endMutation();
          }
        },
        5000,
      );
    };

    const listen = function (target, type, listener) {
      if (lifecycle) return lifecycle.listen(target, type, listener);
      target.addEventListener(type, listener);
      return listener;
    };

    listen(form, "submit", async (e) => {
      e.preventDefault();
      const trimmed = (input.value || "").trim();
      const retiredInitialHydration = retirePendingInitialCoveoUrlHydration();
      const routeIntent =
        collectionContainer?._coveoBeginCollectionRouteIntent?.() || null;
      await queueCollectionQuery(
        trimmed,
        retiredInitialHydration,
        routeIntent,
      );
    });

    listen(input, "input", function (e) {
      syncToolbarSearchClearButton(e.target?.value || "");
    });

    if (clearBtn) {
      listen(clearBtn, "click", async function (e) {
        e.preventDefault();
        const retiredInitialHydration = retirePendingInitialCoveoUrlHydration();
        const routeIntent =
          collectionContainer?._coveoBeginCollectionRouteIntent?.() || null;
        input.value = "";
        syncToolbarSearchClearButton("");
        await queueCollectionQuery(
          "",
          retiredInitialHydration,
          routeIntent,
        );
        input.focus();
      });
    }

    syncToolbarSearchClearButton(input.value || "");

  }
  window.initCoveoHeadlessCollectionPage = function (
    engine,
    config,
    collectionHandle,
  ) {
    const container = document.getElementById("coveo-headless-collection");
    if (!container) {
      return Promise.resolve();
    }

    const lifecycle = createCoveoPageLifecycleOwner(container, "collection");
    let lifecycleToken = container._coveoCollectionLifecycleToken;
    if (!lifecycleToken) {
      lifecycleToken = Object.freeze({ root: container });
      lifecycle.own(
        container,
        "_coveoCollectionLifecycleToken",
        lifecycleToken,
      );
      lifecycle.claim(
        window,
        "__coveoCollectionPageOwner",
        lifecycleToken,
      );
      lifecycle.addCleanup(function () {
        if (window.__coveoCollectionPageOwner !== lifecycleToken) return;
        delete window.__coveoCollectionScopePrefetchLoading;
        delete window.__coveoCollectionDistancePoolLoading;
      });
    }
    const isCurrentCollectionLifecycle = function () {
      return (
        lifecycle.active &&
        lifecycle.isCurrent() &&
        window.__coveoCollectionPageOwner === lifecycleToken &&
        container.isConnected !== false
      );
    };
    const setCollectionLifecycleState = function (key, value) {
      if (isCurrentCollectionLifecycle()) window[key] = value;
    };

    return runCoveoPageInitializationOnce(container, "collection", async function () {
    try {
    if (!lifecycle.active) return lifecycle;
    primePendingInitialCoveoUrlState();
    const urlParams = new URLSearchParams(window.location.search);
    const searchQuery = (urlParams.get("q") || "").trim();
    /*
     * Restore the visitor's shared Distance choice before controller routing
     * and the first request. Active radius selections therefore carry across
     * collections, while a persisted explicit-All choice remains unfiltered.
     */
    window.__coveoSuppressInitialCollectionDistance = false;
    coveoLastSyncedLocationCtxKey = null;
    initializeStoredLocationDistanceRadius();
    const collectionSearchInput =
      container.querySelector("#coveo-collection-search-input") ||
      document.getElementById("coveo-collection-search-input");
    if (collectionSearchInput) {
      collectionSearchInput.value = searchQuery;
    }
    setLastSubmittedKeywordQuery(null, container, searchQuery);
    lifecycle.addCleanup(function () {
      delete container._coveoLastSubmittedKeywordQuery;
    });

    const preferSearchOverListing =
      container?.dataset?.coveoPreferSearch === "true";
    lifecycle.own(container, "_coveoCollectionScopeMembership", null);
    lifecycle.own(container, "_coveoCollectionScopeMembershipHandle", "");
    lifecycle.own(container, "_coveoCollectionScopeMembershipPromise", null);
      const mod = window.CoveoCommerceModule || (await import(COMMERCE_ESM));
      if (!lifecycle.active) return lifecycle;
      if (!window.CoveoCommerceModule) window.CoveoCommerceModule = mod;

      const exportKeys = Object.keys(mod).filter(function (k) {
        return typeof mod[k] === "function";
      });

      const api =
        mod && mod.default && typeof mod.default === "object"
          ? mod.default
          : mod;
      const buildProductListing =
        mod.buildProductListing || api.buildProductListing;
      const buildSearch =
        mod.buildSearch || mod.search || api.buildSearch || api.search;
      let controller;
      let subControllers;
      let activeMode = "";

      const listingController =
        typeof buildProductListing === "function"
          ? buildProductListing(engine)
          : null;
      if (listingController) {
        listingController.__coveoControllerType = "productListing";
        lifecycle.claim(
          window,
          "CoveoProductListingController",
          listingController,
        );
      }

      const scopedSearchController =
        typeof buildSearch === "function" ? buildSearch(engine) : null;
      if (scopedSearchController) {
        scopedSearchController.__coveoControllerType = "search";
        lifecycle.claim(window, "CoveoSearchController", scopedSearchController);
      }

      if (!listingController && !scopedSearchController) {
        console.error(
          "[Coveo Collection] Neither buildProductListing nor buildSearch found in module exports:",
          exportKeys,
        );
        return lifecycle;
      }

      function createSubControllersFor(controllerRef) {
        let facetGen, paginationCtrl, summaryCtrl, sortCtrl;
        try {
          facetGen = controllerRef.facetGenerator && controllerRef.facetGenerator();
          paginationCtrl = controllerRef.pagination && controllerRef.pagination();
          summaryCtrl = controllerRef.summary && controllerRef.summary();
          sortCtrl =
            typeof controllerRef.sort === "function" ? controllerRef.sort() : null;
        } catch (e) {
          console.warn("[Coveo Collection] Sub-controller creation error:", e);
        }
        return {
          facetGen,
          paginationCtrl,
          summaryCtrl,
          sortCtrl,
        };
      }

      const controllerBundles = {
        productListing: listingController
          ? {
              controller: listingController,
              subControllers: createSubControllersFor(listingController),
            }
          : null,
        search: scopedSearchController
          ? {
              controller: scopedSearchController,
              subControllers: createSubControllersFor(scopedSearchController),
            }
          : null,
      };
      lifecycle.addCleanup(function () {
        Object.values(controllerBundles).forEach(function (bundle) {
          if (bundle?.controller) {
            delete bundle.controller._coveoLastSubmittedKeywordQuery;
          }
        });
      });

      function getCollectionControllerProducts(controllerRef) {
        const state = controllerRef?.state || {};
        const products =
          state.products ||
          state.results ||
          state.response?.products ||
          state.response?.results ||
          state.data?.products ||
          state.data?.results ||
          state.data?.response?.products ||
          state.data?.response?.results ||
          [];
        return Array.isArray(products) ? products : [];
      }

      function syncCollectionProductListingDistancePageSize(bundle) {
        if (!bundle?.subControllers?.paginationCtrl) return;
        const paginationCtrl = bundle.subControllers.paginationCtrl;
        const desiredPageSize = getActiveCoveoLocationContext()
          ? COVEO_COLLECTION_CLIENT_DISTANCE_PAGE_SIZE
          : SEARCH_PAGE_RESULTS_PER_PAGE;
        if (Number(paginationCtrl.state?.pageSize) === desiredPageSize) return;
        try {
          paginationCtrl.setPageSize?.(desiredPageSize);
        } catch (_) { }
      }

      async function fetchMoreCollectionProducts(bundle) {
        const paginationCtrl = bundle?.subControllers?.paginationCtrl;
        const controllerRef = bundle?.controller;
        if (!controllerRef) return false;
        const beforeCount = getCollectionControllerProducts(controllerRef).length;
        const totalEntries = Number(
          paginationCtrl?.state?.totalEntries ??
            paginationCtrl?.state?.totalCount ??
            paginationCtrl?.state?.totalResults,
        );
        if (Number.isFinite(totalEntries) && beforeCount >= totalEntries) {
          return false;
        }

        /*
         * The pagination controller method returns void after dispatching its
         * thunk. Use the official Product Listing action first so this helper
         * resolves only after Coveo has fulfilled/rejected the network request;
         * otherwise a following sort could overlap the still-running page load.
         */
        try {
          const productListingActions = mod.loadProductListingActions?.(engine);
          if (productListingActions?.fetchMoreProducts) {
            const result = await engine.dispatch(
              productListingActions.fetchMoreProducts(),
            );
            if (result?.meta?.requestStatus === "rejected") return false;
            return (
              getCollectionControllerProducts(controllerRef).length >
              beforeCount
            );
          }
        } catch (_) {
          return false;
        }

        if (!paginationCtrl?.fetchMoreProducts || !controllerRef.subscribe) {
          return false;
        }

        return new Promise(function (resolve) {
          let settled = false;
          let unsubscribe = null;
          let timeoutId = null;
          let sawLoading = false;
          const initialError = controllerRef.state?.error || null;
          const finish = function (didProgress) {
            if (settled) return;
            settled = true;
            if (timeoutId != null) lifecycle.clearTimeout(timeoutId);
            lifecycle.signal.removeEventListener("abort", onAbort);
            try {
              unsubscribe?.();
            } catch (_) { }
            resolve(didProgress);
          };
          const onAbort = function () {
            finish(false);
          };
          const checkForProgress = function () {
            const nextCount = getCollectionControllerProducts(controllerRef).length;
            const state = controllerRef.state || {};
            const isLoading = !!(state.isLoading || state.isLoadingMore);
            if (isLoading) sawLoading = true;
            if (nextCount > beforeCount && !isLoading) {
              finish(true);
              return;
            }
            if (
              !isLoading &&
              (state.error && state.error !== initialError || sawLoading)
            ) {
              finish(false);
            }
          };
          timeoutId = lifecycle.setTimeout(function () {
            finish(false);
          }, 10000);
          lifecycle.signal.addEventListener("abort", onAbort, { once: true });
          if (lifecycle.signal.aborted) {
            finish(false);
            return;
          }
          try {
            unsubscribe = controllerRef.subscribe(checkForProgress);
            const result = paginationCtrl.fetchMoreProducts();
            if (result && typeof result.catch === "function") {
              result.catch(function () {
                finish(false);
              });
            }
            checkForProgress();
          } catch (_) {
            finish(false);
          }
        });
      }

      async function fetchCollectionMembershipFromListingFacet(
        bundle,
        targetCount,
        signal,
      ) {
        const snapshot = container._coveoCollectionListingTemplateRequest;
        const normalizedHandle = normalizeCoveoCollectionHandleValue(
          collectionHandle,
        );
        if (
          !bundle?.controller ||
          !snapshot?.url ||
          !snapshot?.body ||
          snapshot.successful !== true ||
          snapshot.failed === true ||
          snapshot.handle !== normalizedHandle ||
          !/\/commerce\/v2\/listing(?:[/?]|$)/i.test(String(snapshot.url)) ||
          getCoveoCollectionHandleFromViewUrl(
            snapshot.body.context?.view?.url,
          ) !== normalizedHandle
        ) {
          return null;
        }

        const requestedValues = Math.max(
          1,
          Math.min(
            COVEO_COLLECTION_CLIENT_DISTANCE_MAX_PRODUCTS,
            Number(targetCount) ||
              COVEO_COLLECTION_CLIENT_DISTANCE_MAX_PRODUCTS,
          ),
        );
        const body = JSON.parse(JSON.stringify(snapshot.body));
        body._mmCollectionMembershipPage = true;
        body.page = 0;
        body.perPage = 1;
        delete body.pageSize;
        delete body.numberOfResults;
        body.facets = (Array.isArray(body.facets) ? body.facets : [])
          .filter(function (facet) {
            return String(facet?.facetId || facet?.field || "").toLowerCase() !==
              "permanentid";
          });
        body.facets.push({
          initialNumberOfValues: requestedValues,
          facetId: "permanentid",
          displayName: "Collection membership",
          numberOfValues: requestedValues,
          field: "permanentid",
          type: "regular",
          values: [],
          freezeCurrentValues: false,
          preventAutoSelect: true,
        });

        try {
          const response = await fetch(
            snapshot.url,
            Object.assign({}, snapshot.init || {}, {
              method: "POST",
              body: JSON.stringify(body),
              signal,
              _mmCollectionMembershipPage: true,
            }),
          );
          if (!response.ok) return null;
          const payload = await response.json().catch(function () {
            return null;
          });
          if (!payload) return null;
          const responseRoot =
            payload.response && typeof payload.response === "object"
              ? payload.response
              : payload;
          const pagination =
            responseRoot.pagination || payload.pagination || {};
          const totalCandidates = [
            pagination.totalEntries,
            pagination.totalProducts,
            pagination.totalCount,
            pagination.totalResults,
            responseRoot.totalNumberOfProducts,
            responseRoot.totalCount,
            responseRoot.totalResults,
          ];
          let total = null;
          for (const candidate of totalCandidates) {
            const parsed = Number(candidate);
            if (Number.isFinite(parsed)) {
              total = parsed;
              break;
            }
          }
          const facets = Array.isArray(responseRoot.facets)
            ? responseRoot.facets
            : [];
          const membershipFacet = facets.find(function (facet) {
            return String(facet?.facetId || facet?.field || "").toLowerCase() ===
              "permanentid";
          });
          const variantIds = new Set(
            (Array.isArray(membershipFacet?.values)
              ? membershipFacet.values
              : [])
              .map(function (value) {
                return String(value?.value || "").trim();
              })
              .filter(Boolean),
          );
          return {
            complete: !!(
              Number.isInteger(total) &&
              total > 0 &&
              total <= requestedValues &&
              variantIds.size === total
            ),
            total: Number.isInteger(total) ? total : null,
            variantIds,
            canonicalField: "permanentid",
          };
        } catch (error) {
          if (error?.name === "AbortError" || signal?.aborted) return null;
          return null;
        }
      }

      async function fetchCollectionMembershipFromListingSnapshot(
        bundle,
        targetCount,
        signal,
      ) {
        const snapshot = container._coveoCollectionListingTemplateRequest;
        const normalizedHandle = normalizeCoveoCollectionHandleValue(
          collectionHandle,
        );
        if (
          !bundle?.controller ||
          !snapshot?.url ||
          !snapshot?.body ||
          snapshot.successful !== true ||
          snapshot.failed === true ||
          snapshot.handle !== normalizedHandle ||
          !/\/commerce\/v2\/listing(?:[/?]|$)/i.test(String(snapshot.url)) ||
          getCoveoCollectionHandleFromViewUrl(
            snapshot.body.context?.view?.url,
          ) !== normalizedHandle
        ) {
          return null;
        }

        const extractListingResponse = function (payload) {
          const responseRoot =
            payload?.response && typeof payload.response === "object"
              ? payload.response
              : payload;
          const directProducts = Array.isArray(responseRoot?.products)
            ? responseRoot.products
            : [];
          const mixedResults = Array.isArray(responseRoot?.results)
            ? responseRoot.results
            : [];
          const source = directProducts.length ? directProducts : mixedResults;
          const products = source
            .map(function (entry) {
              if (!entry || typeof entry !== "object") return null;
              const resultType = String(entry.resultType || "").toLowerCase();
              if (resultType && resultType !== "product") return null;
              return entry.product || entry.document || entry.result || entry;
            })
            .filter(function (entry) {
              return entry && typeof entry === "object";
            });
          const pagination =
            responseRoot?.pagination || payload?.pagination || {};
          const firstFiniteNumber = function (values) {
            for (const value of values) {
              const parsed = Number(value);
              if (Number.isFinite(parsed)) return parsed;
            }
            return null;
          };
          return {
            products,
            page: firstFiniteNumber([
              pagination.page,
              responseRoot?.page,
            ]),
            perPage: firstFiniteNumber([
              pagination.perPage,
              pagination.pageSize,
              responseRoot?.perPage,
            ]),
            total: firstFiniteNumber([
              pagination.totalEntries,
              pagination.totalProducts,
              pagination.totalCount,
              pagination.totalResults,
              responseRoot?.totalNumberOfProducts,
              responseRoot?.totalCount,
              responseRoot?.totalResults,
            ]),
            totalPages: firstFiniteNumber([
              pagination.totalPages,
              responseRoot?.totalPages,
            ]),
          };
        };
        const fetchPage = async function (page, perPage, requestSignal) {
          for (let attempt = 0; attempt < 2; attempt += 1) {
            if (requestSignal?.aborted) return null;
            try {
              const body = JSON.parse(JSON.stringify(snapshot.body));
              body._mmCollectionMembershipPage = true;
              body.page = page;
              body.perPage = perPage;
              delete body.pageSize;
              delete body.numberOfResults;
              const response = await fetch(
                snapshot.url,
                Object.assign({}, snapshot.init || {}, {
                  method: "POST",
                  body: JSON.stringify(body),
                  signal: requestSignal,
                  _mmCollectionMembershipPage: true,
                }),
              );
              if (!response.ok) {
                if (response.status >= 500 && attempt === 0) continue;
                return null;
              }
              const payload = await response.json().catch(function () {
                return null;
              });
              if (!payload) return null;
              return extractListingResponse(payload);
            } catch (error) {
              if (
                error?.name === "AbortError" ||
                requestSignal?.aborted
              ) {
                return null;
              }
              if (attempt > 0) return null;
            }
          }
          return null;
        };

        const siblingAbortController =
          typeof AbortController === "function" ? new AbortController() : null;
        const requestSignal = siblingAbortController?.signal || signal || null;
        const abortSiblings = function () {
          if (!siblingAbortController || siblingAbortController.signal.aborted) {
            return;
          }
          try {
            siblingAbortController.abort("collection-membership-page-failed");
          } catch (_) {
            siblingAbortController.abort();
          }
        };
        const onOuterAbort = function () {
          abortSiblings();
        };
        if (signal && siblingAbortController) {
          signal.addEventListener("abort", onOuterAbort, { once: true });
          if (signal.aborted) onOuterAbort();
        }

        try {
          /* Coveo may cap this value; the first response's `perPage` is the
           * authority for all following zero-based pages. */
          const requestedPerPage = 100;
          let firstPayload = snapshot.responsePayload || null;
          if (!firstPayload && snapshot.responsePromise) {
            firstPayload = await snapshot.responsePromise;
          }
          const firstPage = firstPayload
            ? extractListingResponse(firstPayload)
            : await fetchPage(0, requestedPerPage, requestSignal);
          if (!firstPage || requestSignal?.aborted) {
            return { complete: false, products: [], total: null };
          }

          const total = Number(firstPage.total);
          const effectivePerPage = Number(firstPage.perPage);
          if (
            firstPage.page !== 0 ||
            !Number.isInteger(total) ||
            total < 0 ||
            !Number.isInteger(effectivePerPage) ||
            effectivePerPage <= 0 ||
            (Number.isFinite(Number(targetCount)) &&
              Number(targetCount) > COVEO_COLLECTION_CLIENT_DISTANCE_MAX_PRODUCTS) ||
            total > COVEO_COLLECTION_CLIENT_DISTANCE_MAX_PRODUCTS
          ) {
            return {
              complete: false,
              products: firstPage.products,
              total: Number.isInteger(total) ? total : null,
            };
          }

          const pageCount = Math.ceil(total / effectivePerPage);
          const responseTotalPages = Number(firstPage.totalPages);
          if (
            Number.isFinite(responseTotalPages) &&
            responseTotalPages !== pageCount
          ) {
            return { complete: false, products: firstPage.products, total };
          }
          const expectedFirstPageCount = Math.min(effectivePerPage, total);
          if (firstPage.products.length !== expectedFirstPageCount) {
            return { complete: false, products: firstPage.products, total };
          }
          if (pageCount <= 1) {
            const variantIds = new Set(
              firstPage.products
                .map(function (product) {
                  return String(
                    product?.permanentid ||
                      product?.additionalFields?.permanentid ||
                      "",
                  ).trim();
                })
                .filter(Boolean),
            );
            const productIds = new Set(
              firstPage.products
                .map(function (product) {
                  return String(
                    product?.ec_product_id ||
                      product?.additionalFields?.ec_product_id ||
                      "",
                  ).trim();
                })
                .filter(Boolean),
            );
            const canonicalField =
              variantIds.size === total
                ? "permanentid"
                : productIds.size === total
                  ? "ec_product_id"
                  : "";
            return {
              complete: !!canonicalField,
              products: firstPage.products,
              total,
              canonicalField,
            };
          }

          const pages = Array.from(
            { length: pageCount - 1 },
            function (_value, index) {
              return index + 1;
            },
          );
          const productsByPage = new Map([[0, firstPage.products]]);
          let nextPageIndex = 0;
          let failed = false;
          const worker = async function () {
            while (!failed && !requestSignal?.aborted) {
              const index = nextPageIndex;
              nextPageIndex += 1;
              if (index >= pages.length) return;
              const page = pages[index];
              const pageResponse = await fetchPage(
                page,
                effectivePerPage,
                requestSignal,
              );
              const expectedCount = Math.min(
                effectivePerPage,
                total - page * effectivePerPage,
              );
              if (
                !pageResponse ||
                pageResponse.page !== page ||
                pageResponse.perPage !== effectivePerPage ||
                pageResponse.total !== total ||
                (Number.isFinite(Number(pageResponse.totalPages)) &&
                  Number(pageResponse.totalPages) !== pageCount) ||
                pageResponse.products.length !== expectedCount
              ) {
                failed = true;
                abortSiblings();
                return;
              }
              productsByPage.set(page, pageResponse.products);
            }
          };
          await Promise.all(
            Array.from({ length: Math.min(4, pages.length) }, function () {
              return worker();
            }),
          );
          const products = Array.from(
            { length: pageCount },
            function (_value, page) {
              return productsByPage.get(page) || [];
            },
          ).flat();
          const variantIds = new Set(
            products
              .map(function (product) {
                return String(
                  product?.permanentid ||
                    product?.additionalFields?.permanentid ||
                    "",
                ).trim();
              })
              .filter(Boolean),
          );
          const productIds = new Set(
            products
              .map(function (product) {
                return String(
                  product?.ec_product_id ||
                    product?.additionalFields?.ec_product_id ||
                    "",
                ).trim();
              })
              .filter(Boolean),
          );
          const canonicalField =
            variantIds.size === total
              ? "permanentid"
              : productIds.size === total
                ? "ec_product_id"
                : "";
          return {
            complete:
              !failed &&
              !requestSignal?.aborted &&
              productsByPage.size === pageCount &&
              products.length === total &&
              !!canonicalField,
            products,
            total,
            canonicalField,
          };
        } finally {
          if (signal && siblingAbortController) {
            signal.removeEventListener("abort", onOuterAbort);
          }
        }
      }

      function waitForCollectionProducts(bundle, minimumCount) {
        const controllerRef = bundle?.controller;
        const requiredCount = Math.max(1, Number(minimumCount) || 1);
        if (!controllerRef?.subscribe) return Promise.resolve(false);
        if (getCollectionControllerProducts(controllerRef).length >= requiredCount) {
          return Promise.resolve(true);
        }

        return new Promise(function (resolve) {
          let settled = false;
          let unsubscribe = null;
          let timeoutId = null;
          const finish = function (ready) {
            if (settled) return;
            settled = true;
            if (timeoutId != null) lifecycle.clearTimeout(timeoutId);
            lifecycle.signal.removeEventListener("abort", onAbort);
            try {
              unsubscribe?.();
            } catch (_) { }
            resolve(ready);
          };
          const onAbort = function () {
            finish(false);
          };
          const check = function () {
            if (
              getCollectionControllerProducts(controllerRef).length >=
              requiredCount
            ) {
              finish(true);
            }
          };
          timeoutId = lifecycle.setTimeout(function () {
            finish(false);
          }, 10000);
          lifecycle.signal.addEventListener("abort", onAbort, { once: true });
          if (lifecycle.signal.aborted) {
            finish(false);
            return;
          }
          try {
            unsubscribe = controllerRef.subscribe(check);
            check();
          } catch (_) {
            finish(false);
          }
        });
      }

      function addControllerProductsToCollectionMembership(
        membership,
        products,
      ) {
        return addCoveoProductsToCollectionMembership(
          membership,
          products,
          collectionHandle,
        );
      }

      let collectionSearchMembershipOperation = null;

      function abortCollectionSearchMembership(reason) {
        const controller =
          collectionSearchMembershipOperation?.abortController || null;
        if (!controller || controller.signal.aborted) return;
        try {
          controller.abort(reason || "collection-route-superseded");
        } catch (_) {
          controller.abort();
        }
      }

      async function ensureCanonicalCollectionSearchMembership(options) {
        const consumerIsCurrent =
          typeof options?.isCurrent === "function"
            ? options.isCurrent
            : () => true;
        const cancelledResult = function () {
          return { status: "cancelled", membership: null };
        };
        const scopeClause = getCoveoCollectionScopeClause(collectionHandle);
        if (!scopeClause) {
          return { status: "not-required", membership: null };
        }
        if (!isCurrentCollectionLifecycle() || !consumerIsCurrent()) {
          return cancelledResult();
        }

        const runningOperation = collectionSearchMembershipOperation;
        if (runningOperation) {
          if (runningOperation.signal?.aborted === true) {
            try {
              await runningOperation.promise;
            } catch (_) { }
            if (!isCurrentCollectionLifecycle() || !consumerIsCurrent()) {
              return cancelledResult();
            }
            return ensureCanonicalCollectionSearchMembership(options);
          }
          return runningOperation.promise;
        }

        const rawShopifyCollectionCount = String(
          container?.dataset?.shopifyCollectionCount || "",
        ).trim();
        const parsedShopifyCollectionCount = rawShopifyCollectionCount
          ? Number(rawShopifyCollectionCount)
          : null;
        const expectedShopifyProductCount = Number.isFinite(
          parsedShopifyCollectionCount,
        )
          ? Math.max(0, parsedShopifyCollectionCount)
          : null;
        const getMembershipCanonicalIdentifierCount = function (membership) {
          return membership?._coveoCanonicalMembershipField === "ec_product_id"
            ? membership?.productGids?.size || 0
            : membership?.variantGids?.size || 0;
        };
        const isReusableMembership = function (membership) {
          if (
            !isCompleteCoveoCollectionMembershipForHandle(
              membership,
              collectionHandle,
            )
          ) {
            return false;
          }
          if (membership._coveoMembershipSource === "shopify") {
            const productCount = Math.max(
              membership.productGids?.size || 0,
              membership.productPaths?.size || 0,
              membership.productHandles?.size || 0,
            );
            return (
              productCount > 0 &&
              (expectedShopifyProductCount == null ||
                productCount >= expectedShopifyProductCount)
            );
          }
          if (membership._coveoMembershipSource !== "productListing") {
            return true;
          }
          const listingBundle = controllerBundles.productListing;
          const liveListingTotal = getCoveoTotalCountFromControllerState(
            listingBundle?.controller,
            listingBundle?.subControllers,
          );
          if (
            !Number.isInteger(liveListingTotal) ||
            liveListingTotal <= 0 ||
            membership._coveoListingTotal !== liveListingTotal ||
            getMembershipCanonicalIdentifierCount(membership) < liveListingTotal
          ) {
            return false;
          }
          const liveProducts = getCollectionControllerProducts(
            listingBundle?.controller,
          );
          const canonicalIds =
            membership._coveoCanonicalMembershipField === "ec_product_id"
              ? membership.productGids
              : membership.variantGids;
          return liveProducts.every(function (product) {
            const additionalFields = product?.additionalFields || {};
            const id = String(
              membership._coveoCanonicalMembershipField === "ec_product_id"
                ? product?.ec_product_id || additionalFields.ec_product_id || ""
                : product?.permanentid || additionalFields.permanentid || "",
            ).trim();
            return !!id && canonicalIds.has(id);
          });
        };

        const existing =
          container._coveoCollectionScopeMembership ||
          (typeof readCachedCoveoCollectionMembership === "function"
            ? readCachedCoveoCollectionMembership(collectionHandle)
            : null);
        if (existing && !container._coveoCollectionScopeMembership) {
          container._coveoCollectionScopeMembership = existing;
        }
        if (isReusableMembership(existing)) {
          return { status: "ready", membership: existing };
        }
        if (!isCurrentCollectionLifecycle() || !consumerIsCurrent()) {
          return cancelledResult();
        }

        const hydrationAbortController =
          typeof AbortController === "function" ? new AbortController() : null;
        const hydrationSignal = hydrationAbortController?.signal || null;

        const operationToken = Object.freeze({});
        const operation = {
          token: operationToken,
          abortController: hydrationAbortController,
          signal: hydrationSignal,
          promise: null,
          blocksProductListing: false,
          locksRender: false,
          managesMembershipRender: true,
        };
        collectionSearchMembershipOperation = operation;
        container._coveoCollectionMembershipManagedRender = true;
        const isHydrationCurrent = function () {
          return (
            isCurrentCollectionLifecycle() &&
            hydrationSignal?.aborted !== true &&
            collectionSearchMembershipOperation?.token === operationToken
          );
        };
        operation.promise = (async function () {
          let shopifyMembership = null;
          const shouldUseProductListingAuthority =
            expectedShopifyProductCount === 0 ||
            existing?._coveoMembershipSource === "productListing";
          if (!shouldUseProductListingAuthority) {
            shopifyMembership = await ensureCoveoCollectionMembership(
              container,
              collectionHandle,
              lifecycle,
              hydrationSignal,
            );
            if (!isHydrationCurrent()) return cancelledResult();

            const shopifyProductCount = Math.max(
              shopifyMembership?.productGids?.size || 0,
              shopifyMembership?.productPaths?.size || 0,
              shopifyMembership?.productHandles?.size || 0,
            );
            const hasAuthoritativeShopifyMembership = !!(
              shopifyMembership?._coveoShopifyPaginationComplete === true &&
              shopifyProductCount > 0 &&
              (expectedShopifyProductCount == null ||
                shopifyProductCount >= expectedShopifyProductCount)
            );
            if (hasAuthoritativeShopifyMembership) {
              shopifyMembership._coveoCanonicalMembershipField =
                shopifyMembership.variantGids?.size > 0
                  ? "permanentid"
                  : "ec_product_id";
              shopifyMembership._coveoProductListingComplete = true;
              shopifyMembership._coveoMembershipSource = "shopify";
              container._coveoCollectionScopeMembership = shopifyMembership;
              cacheCoveoCollectionMembership(shopifyMembership);
              return { status: "ready", membership: shopifyMembership };
            }
          }

          const bundle = controllerBundles.productListing;
          if (!bundle?.controller) {
            const partialMembership = shopifyMembership || existing;
            return partialMembership
              ? { status: "incomplete", membership: partialMembership }
              : cancelledResult();
          }

          operation.blocksProductListing = true;
          operation.locksRender = true;
          setCollectionLifecycleState(
            "__coveoCollectionScopePrefetchLoading",
            true,
          );
          const previousClientOnlyDistanceFilter =
            window.__coveoClientOnlyDistanceFilter;
          window.__coveoClientOnlyDistanceFilter = true;
          try {
            const canFetchFromListingSnapshot =
              typeof fetchCollectionMembershipFromListingSnapshot ===
              "function";
            if (canFetchFromListingSnapshot) {
              const template =
                container._coveoCollectionListingTemplateRequest;
              const hasSuccessfulTemplate = !!(
                template?.successful === true &&
                template?.failed !== true &&
                template?.handle ===
                  normalizeCoveoCollectionHandleValue(collectionHandle)
              );
              if (!hasSuccessfulTemplate) {
                const dispatched = await dispatchCoveoCommerceQuery(
                  engine,
                  mod,
                  {
                    controller: bundle.controller,
                    syncLocation: false,
                    isCurrent: isHydrationCurrent,
                  },
                );
                if (!dispatched && isHydrationCurrent()) {
                  const firstProductsReady = waitForCollectionProducts(
                    bundle,
                    1,
                  );
                  try {
                    bundle.controller.executeFirstRequest?.();
                  } catch (_) { }
                  await firstProductsReady;
                }
                if (!isHydrationCurrent()) return cancelledResult();
              }

              const liveListingTotal = getCoveoTotalCountFromControllerState(
                bundle.controller,
                bundle.subControllers,
              );
              if (
                Number.isFinite(liveListingTotal) &&
                liveListingTotal >
                  COVEO_COLLECTION_CLIENT_DISTANCE_MAX_PRODUCTS
              ) {
                return {
                  status: "incomplete",
                  membership:
                    shopifyMembership ||
                    existing ||
                  buildCoveoCollectionMembership(collectionHandle),
                };
              }
              const facetMembershipResult =
                typeof fetchCollectionMembershipFromListingFacet === "function"
                  ? await fetchCollectionMembershipFromListingFacet(
                      bundle,
                      liveListingTotal,
                      hydrationSignal,
                    )
                  : null;
              if (!isHydrationCurrent()) return cancelledResult();
              if (
                facetMembershipResult?.complete === true &&
                Number.isInteger(facetMembershipResult.total) &&
                (!Number.isFinite(liveListingTotal) ||
                  facetMembershipResult.total >= liveListingTotal)
              ) {
                const facetMembership = buildCoveoCollectionMembership(
                  collectionHandle,
                );
                facetMembershipResult.variantIds.forEach(function (id) {
                  facetMembership.variantGids.add(id);
                });
                facetMembership._coveoCanonicalMembershipField =
                  "permanentid";
                facetMembership._coveoMembershipSource = "productListing";
                facetMembership._coveoListingTotal =
                  facetMembershipResult.total;
                facetMembership._coveoProductListingComplete = true;
                container._coveoCollectionScopeMembership = facetMembership;
                cacheCoveoCollectionMembership(facetMembership);
                return { status: "ready", membership: facetMembership };
              }
              const listingResult =
                await fetchCollectionMembershipFromListingSnapshot(
                  bundle,
                  liveListingTotal,
                  hydrationSignal,
                );
              if (!isHydrationCurrent()) return cancelledResult();
              if (!listingResult) {
                return {
                  status: "incomplete",
                  membership:
                    shopifyMembership ||
                    existing ||
                    buildCoveoCollectionMembership(collectionHandle),
                };
              }

              const membership = addControllerProductsToCollectionMembership(
                buildCoveoCollectionMembership(collectionHandle),
                listingResult.products,
              );
              membership._coveoCanonicalMembershipField =
                listingResult.canonicalField || "permanentid";
              membership._coveoMembershipSource = "productListing";
              membership._coveoListingTotal = Number.isInteger(
                listingResult.total,
              )
                ? listingResult.total
                : null;
              const canonicalIdentifierCount =
                getMembershipCanonicalIdentifierCount(membership);
              membership._coveoProductListingComplete = !!(
                listingResult.complete === true &&
                Number.isInteger(listingResult.total) &&
                canonicalIdentifierCount === listingResult.total &&
                (!Number.isFinite(liveListingTotal) ||
                  listingResult.total >= liveListingTotal)
              );
              container._coveoCollectionScopeMembership = membership;
              if (membership._coveoProductListingComplete) {
                cacheCoveoCollectionMembership(membership);
              }
              return {
                status: membership._coveoProductListingComplete
                  ? "ready"
                  : "incomplete",
                membership,
              };
            }

            let products = getCollectionControllerProducts(bundle.controller);
            const controllerTotal = getCoveoTotalCountFromControllerState(
              bundle.controller,
              bundle.subControllers,
            );
            const hasAuthoritativeListingTotal =
              Number.isFinite(controllerTotal) && controllerTotal > 0;
            const total = hasAuthoritativeListingTotal
              ? controllerTotal
              : products.length;
            const target = Math.min(
              total,
              COVEO_COLLECTION_CLIENT_DISTANCE_MAX_PRODUCTS,
            );
            const totalPages = Number(
              bundle.subControllers?.paginationCtrl?.state?.totalPages,
            );
            const maxFetchAttempts = Math.max(
              Number.isFinite(totalPages) ? totalPages : 0,
              Math.ceil(target / SEARCH_PAGE_RESULTS_PER_PAGE) + 1,
            );
            let fetchAttempts = 0;
            let membership = addControllerProductsToCollectionMembership(
              shopifyMembership || existing,
              products,
            );

            while (
              isHydrationCurrent() &&
              Math.max(
                products.length,
                membership?.variantGids?.size || 0,
                membership?.productGids?.size || 0,
              ) < target &&
              fetchAttempts < maxFetchAttempts
            ) {
              fetchAttempts += 1;
              const didProgress = await fetchMoreCollectionProducts(bundle);
              products = getCollectionControllerProducts(bundle.controller);
              membership = addControllerProductsToCollectionMembership(
                membership,
                products,
              );
              if (!didProgress) break;
            }

            if (!isHydrationCurrent()) return cancelledResult();
            const resolvedMembershipCount = Math.max(
              membership.variantGids.size,
              membership.productGids.size,
            );
            membership._coveoProductListingComplete =
              hasAuthoritativeListingTotal &&
              resolvedMembershipCount >= controllerTotal;
            membership._coveoCanonicalMembershipField =
              membership.variantGids?.size > 0
                ? "permanentid"
                : "ec_product_id";
            membership._coveoMembershipSource = "productListing";
            membership._coveoListingTotal = hasAuthoritativeListingTotal
              ? controllerTotal
              : null;
            container._coveoCollectionScopeMembership = membership;
            if (membership._coveoProductListingComplete) {
              cacheCoveoCollectionMembership(membership);
            }
            return {
              status: membership._coveoProductListingComplete
                ? "ready"
                : "incomplete",
              membership,
            };
          } finally {
            if (isCurrentCollectionLifecycle()) {
              window.__coveoClientOnlyDistanceFilter =
                previousClientOnlyDistanceFilter;
            }
          }
        })().finally(function () {
          if (collectionSearchMembershipOperation?.token !== operationToken) {
            return;
          }
          if (operation.managesMembershipRender) {
            delete container._coveoCollectionMembershipManagedRender;
          }
          collectionSearchMembershipOperation = null;
          if (operation.locksRender) {
            setCollectionLifecycleState(
              "__coveoCollectionScopePrefetchLoading",
              false,
            );
            container._coveoCollectionPrefetchRenderPending = true;
          }
        });

        return operation.promise;
      }

      let distanceProductPoolPromise = null;
      let requestCollectionRender = function () { };
      function flushPendingCollectionPrefetchRender() {
        if (!container._coveoCollectionPrefetchRenderPending) return;
        delete container._coveoCollectionPrefetchRenderPending;
        requestCollectionRender();
      }
      async function ensureCollectionDistanceProductPool() {
        if (distanceProductPoolPromise) return distanceProductPoolPromise;
        if (activeMode !== "productListing") return false;
        if (!getActiveCoveoLocationContext()) return false;

        const bundle = controllerBundles.productListing;
        const paginationCtrl = bundle?.subControllers?.paginationCtrl;
        if (!bundle?.controller || !paginationCtrl) return false;

        distanceProductPoolPromise = (async function () {
          syncCollectionProductListingDistancePageSize(bundle);
          setCollectionLifecycleState("__coveoCollectionDistancePoolLoading", true);
          try {
            let products = getCollectionControllerProducts(bundle.controller);
            let total = getCoveoTotalCountFromControllerState(
              bundle.controller,
              bundle.subControllers,
            );
            if (!Number.isFinite(total) || total <= 0) total = products.length;
            const target = Math.min(
              total,
              COVEO_COLLECTION_CLIENT_DISTANCE_MAX_PRODUCTS,
            );
            const pageSize = Math.max(
              1,
              Number(paginationCtrl.state?.pageSize) ||
                COVEO_COLLECTION_CLIENT_DISTANCE_PAGE_SIZE,
            );
            const maxFetchAttempts = Math.ceil(target / pageSize) + 1;
            let fetchAttempts = 0;

            while (
              isCurrentCollectionLifecycle() &&
              products.length < target &&
              fetchAttempts < maxFetchAttempts
            ) {
              fetchAttempts += 1;
              const didProgress = await fetchMoreCollectionProducts(bundle);
              if (!didProgress) break;
              products = getCollectionControllerProducts(bundle.controller);
            }
            return products.length >= target;
          } finally {
            setCollectionLifecycleState(
              "__coveoCollectionDistancePoolLoading",
              false,
            );
            if (isCurrentCollectionLifecycle()) requestCollectionRender();
          }
        })().finally(function () {
          distanceProductPoolPromise = null;
        });
        return distanceProductPoolPromise;
      }

      container._coveoEnsureDistanceProductPool =
        ensureCollectionDistanceProductPool;

      try {
        if (mod.loadPaginationActions && engine) {
          const paginationActions = mod.loadPaginationActions(engine);
          if (paginationActions?.setPageSize) {
            engine.dispatch(
              paginationActions.setPageSize({
                pageSize: SEARCH_PAGE_RESULTS_PER_PAGE,
              }),
            );
          } else if (paginationActions?.updatePageSize) {
            engine.dispatch(
              paginationActions.updatePageSize({
                pageSize: SEARCH_PAGE_RESULTS_PER_PAGE,
              }),
            );
          }
        }
      } catch (e) {
        console.warn("[Coveo Collection] setPageSize dispatch failed:", e);
      }

      function resolveCurrentCollectionQuery() {
        return String(
          getActiveKeywordQuery(container._coveoSearch || controller, container) ||
            "",
        ).trim();
      }

      function resolveDesiredCollectionMode() {
        const queryText = resolveCurrentCollectionQuery();
        const sortValue = String(
          activeMode
            ? window.__coveoActiveSortValue?.() || ""
            : getPendingInitialCoveoUrlState()?.sort ||
                window.__coveoPendingInitialSortValue ||
                "",
        ).trim();
        if (controllerBundles.search) {
          if (preferSearchOverListing) return "search";
          if (normalizeCoveoCollectionHandleValue(collectionHandle) === "all") {
            return "search";
          }
          if (queryText) return "search";
          /*
           * Geo filtering and nearest sorting run through Commerce Search so
           * Coveo returns the final total in one response. Search is constrained
           * by the canonical Shopify variant IDs loaded for this collection,
           * rather than by a guessed Make or the unreliable collection field.
           */
          if (sortValue === "nearest") {
            return "search";
          }
          if (getActiveCoveoLocationContext()) return "search";
        }
        if (controllerBundles.productListing) return "productListing";
        if (controllerBundles.search) return "search";
        return "";
      }

      let activeCollectionRouteAbortController = null;
      function beginCollectionRouteIntent() {
        if (activeCollectionRouteAbortController) {
          try {
            activeCollectionRouteAbortController.abort(
              "collection-route-superseded",
            );
          } catch (_) {
            activeCollectionRouteAbortController.abort();
          }
        }
        const abortController =
          typeof AbortController === "function" ? new AbortController() : null;
        activeCollectionRouteAbortController = abortController;
        const revision =
          Number(container._coveoCollectionRouteIntentRevision || 0) + 1;
        container._coveoCollectionRouteIntentRevision = revision;
        return Object.freeze({
          revision,
          signal: abortController?.signal || null,
          isCurrent() {
            return (
              isCurrentCollectionLifecycle() &&
              Number(container._coveoCollectionRouteIntentRevision || 0) ===
                revision
            );
          },
        });
      }
      lifecycle.addCleanup(function () {
        if (!activeCollectionRouteAbortController) return;
        try {
          activeCollectionRouteAbortController.abort(
            "collection-lifecycle-destroyed",
          );
        } catch (_) {
          activeCollectionRouteAbortController.abort();
        }
        activeCollectionRouteAbortController = null;
        abortCollectionSearchMembership("collection-lifecycle-destroyed");
      });
      container._coveoBeginCollectionRouteIntent =
        beginCollectionRouteIntent;

      async function resetCollectionPaginationState(isCurrent) {
        const guard =
          typeof isCurrent === "function"
            ? isCurrent
            : isCurrentCollectionLifecycle;
        if (!guard()) return false;
        try {
          const paginationActions = mod.loadPaginationActions?.(engine);
          if (paginationActions?.selectPage) {
            await engine.dispatch(
              paginationActions.selectPage({ page: 0 }),
            );
          }
        } catch (error) {
          console.warn(
            "[Coveo Collection] Failed to reset pagination state:",
            error,
          );
        }
        return guard();
      }

      async function syncScopedCollectionSearchState(queryText, options) {
        const callerIsCurrent =
          typeof options?.isCurrent === "function"
            ? options.isCurrent
            : () => true;
        const isCurrent = function () {
          return isCurrentCollectionLifecycle() && callerIsCurrent();
        };
        if (!isCurrent()) return false;
        if (!controllerBundles.search || !mod.loadQueryActions) return true;
        try {
          const queryActions = mod.loadQueryActions(engine);
          if (!queryActions?.updateQuery) return true;
          const updates = { query: String(queryText || "").trim() };
          const hasCanonicalMembership =
            hasCoveoCanonicalCollectionMembership(collectionHandle);
          const scopeClauses = [
            hasCanonicalMembership
              ? ""
              : getCoveoCollectionScopeClause(collectionHandle),
            getCoveoCollectionBrandScopeClause(),
          ].filter(Boolean);
          updates.cq = scopeClauses
            .map(function (clause) {
              return clause.includes(" OR ") ? `(${clause})` : clause;
            })
            .join(" AND ");
          await engine.dispatch(queryActions.updateQuery(updates));
        } catch (e) {
          console.warn("[Coveo Collection] Failed to sync scoped search state:", e);
        }
        return isCurrent();
      }

      async function activateCollectionControllerMode(nextMode, options) {
        async function waitForCurrentCollectionRouteOperation(
          operation,
          isCurrent,
          signals,
        ) {
          const guard =
            typeof isCurrent === "function"
              ? isCurrent
              : isCurrentCollectionLifecycle;
          const abortSignals = (Array.isArray(signals) ? signals : [signals])
            .filter(function (signal, index, allSignals) {
              return (
                signal &&
                typeof signal.addEventListener === "function" &&
                allSignals.indexOf(signal) === index
              );
            });
          if (
            !guard() ||
            abortSignals.some(function (signal) { return signal.aborted; })
          ) {
            return false;
          }
          if (abortSignals.length === 0) {
            const value = await operation;
            return guard() ? value : false;
          }

          let operationError = null;
          let onAbort = null;
          const operationFinished = Promise.resolve(operation).then(
            function (value) {
              return { completed: true, value };
            },
            function (error) {
              operationError = error;
              return { completed: true, value: null };
            },
          );
          const aborted = new Promise(function (resolve) {
            onAbort = function () {
              resolve({ completed: false, value: null });
            };
            abortSignals.forEach(function (signal) {
              signal.addEventListener("abort", onAbort, { once: true });
            });
            if (
              abortSignals.some(function (signal) { return signal.aborted; })
            ) {
              onAbort();
            }
          });

          try {
            const result = await Promise.race([operationFinished, aborted]);
            if (!result.completed) return false;
            if (operationError) throw operationError;
            return guard() &&
              !abortSignals.some(function (signal) { return signal.aborted; })
              ? result.value
              : false;
          } finally {
            if (onAbort) {
              abortSignals.forEach(function (signal) {
                signal.removeEventListener("abort", onAbort);
              });
            }
          }
        }

        const opts = options || {};
        const routeIntent =
          opts.routeIntent ||
          (typeof opts.isCurrent !== "function"
            ? beginCollectionRouteIntent()
            : null);
        const callerIsCurrent =
          typeof opts.isCurrent === "function" ? opts.isCurrent : () => true;
        const isCurrent = function () {
          return (
            isCurrentCollectionLifecycle() &&
            callerIsCurrent() &&
            (!routeIntent || routeIntent.isCurrent())
          );
        };
        if (!isCurrent()) return null;
        const normalizedMode =
          nextMode === "search" && controllerBundles.search
            ? "search"
            : controllerBundles.productListing
              ? "productListing"
              : "search";
        const bundle = controllerBundles[normalizedMode];
        if (!bundle) return null;
        const queryText =
          normalizedMode === "search" ? resolveCurrentCollectionQuery() : "";
        const shouldResetPagination =
          opts.resetPagination === true ||
          !!(activeMode && normalizedMode !== activeMode);

        if (
          normalizedMode === "productListing" &&
          collectionSearchMembershipOperation
        ) {
          const membershipOperation = collectionSearchMembershipOperation;
          abortCollectionSearchMembership(
            "collection-product-listing-reactivated",
          );
          if (membershipOperation.blocksProductListing) {
            await waitForCurrentCollectionRouteOperation(
              membershipOperation.promise,
              isCurrent,
              [opts.signal || null, routeIntent?.signal || null],
            );
            if (!isCurrent()) return null;
          }
        }

        if (normalizedMode === "search") {
          const membershipState = await waitForCurrentCollectionRouteOperation(
            ensureCanonicalCollectionSearchMembership({ isCurrent }),
            isCurrent,
            [opts.signal || null, routeIntent?.signal || null],
          );
          const membershipIsReady =
            membershipState?.status === "not-required"
              ? !getCoveoCollectionScopeClause(collectionHandle)
              : membershipState?.status === "ready" &&
                isCompleteCoveoCollectionMembershipForHandle(
                  membershipState.membership,
                  collectionHandle,
                );
          if (
            !membershipIsReady ||
            !isCurrent()
          ) {
            if (isCurrent()) flushPendingCollectionPrefetchRender();
            return null;
          }
        }

        if (shouldResetPagination) {
          await resetCollectionPaginationState(isCurrent);
          if (!isCurrent()) return null;
        }

        if (normalizedMode === "search") {
          setLastSubmittedKeywordQuery(bundle.controller, container, queryText);
          await syncScopedCollectionSearchState(queryText, { isCurrent });
          if (!isCurrent()) return null;
        } else {
          setLastSubmittedKeywordQuery(bundle.controller, container, "");
        }

        if (!isCurrent()) return null;
        activeMode = normalizedMode;
        controller = bundle.controller;
        subControllers = bundle.subControllers;
        container._coveoCollectionMode = normalizedMode;
        container._coveoCollectionResolvedQuery = queryText;
        container._coveoSearch = controller;
        container._coveoMod = mod;
        container._coveoSubControllers = subControllers;
        window.__coveoClientOnlyDistanceFilter = normalizedMode !== "search";

        if (normalizedMode === "productListing") {
          syncCollectionProductListingDistancePageSize(bundle);
        }

        flushPendingCollectionPrefetchRender();

        return bundle;
      }

      container._coveoResolveActiveControllerBundle = function () {
        return activeMode ? controllerBundles[activeMode] : null;
      };
      container._coveoWillUseServerDistanceFiltering = function () {
        return resolveDesiredCollectionMode() === "search";
      };
      container._coveoGetCollectionCountDebug = function () {
        const activeBundle = activeMode ? controllerBundles[activeMode] : null;
        const activeController = activeBundle?.controller || controller || null;
        const activeSubControllers =
          activeBundle?.subControllers || subControllers || null;
        const shopifyCount = Number(
          container?.dataset?.shopifyCollectionCount || "",
        );
        const coveoCount = getCoveoTotalCountFromControllerState(
          activeController,
          activeSubControllers,
        );
        return {
          collectionHandle: String(collectionHandle || ""),
          collectionTitle: String(container?.dataset?.collectionTitle || ""),
          mode: activeMode || "",
          shopifyCount: Number.isFinite(shopifyCount) ? shopifyCount : null,
          coveoCount,
          query:
            typeof resolveCurrentCollectionQuery === "function"
              ? resolveCurrentCollectionQuery()
              : "",
        };
      };
      container._coveoResolveDispatchController = async function (
        _requestedController,
        options,
      ) {
        const opts = options || {};
        const routeIntent =
          opts.routeIntent ||
          container._coveoBeginCollectionRouteIntent?.() ||
          beginCollectionRouteIntent();
        const callerIsCurrent =
          typeof opts.isCurrent === "function" ? opts.isCurrent : () => true;
        const isCurrent = function () {
          return (
            isCurrentCollectionLifecycle() &&
            callerIsCurrent() &&
            routeIntent.isCurrent()
          );
        };
        if (!isCurrent()) return null;
        const desiredMode = resolveDesiredCollectionMode();
        if (!desiredMode) return isCurrent() ? controller : null;
        const queryText = resolveCurrentCollectionQuery();
        const lastResolvedQuery = Object.prototype.hasOwnProperty.call(
          container,
          "_coveoCollectionResolvedQuery",
        )
          ? String(container._coveoCollectionResolvedQuery || "").trim()
          : String(
              controllerBundles.search?.controller?.state?.query || "",
            ).trim();
        const submittedQueryChanged =
          desiredMode === "search" &&
          activeMode === "search" &&
          queryText !== lastResolvedQuery;
        const shouldActivate =
          desiredMode !== activeMode ||
          opts.resetPagination === true ||
          submittedQueryChanged;

        if (shouldActivate) {
          const nextBundle = await activateCollectionControllerMode(
            desiredMode,
            {
              isCurrent,
              resetPagination:
                opts.resetPagination === true || submittedQueryChanged,
              routeIntent,
              signal: opts.signal || null,
            },
          );
          if (!isCurrent() || !nextBundle) return null;
          return nextBundle.controller;
        }
        if (desiredMode === "search") {
          await syncScopedCollectionSearchState(queryText, { isCurrent });
          if (!isCurrent()) return null;
          container._coveoCollectionResolvedQuery = queryText;
        } else if (desiredMode === "productListing") {
          syncCollectionProductListingDistancePageSize(
            controllerBundles.productListing,
          );
        }
        return isCurrent() ? controller : null;
      };

      await activateCollectionControllerMode(resolveDesiredCollectionMode());
      if (!isCurrentCollectionLifecycle()) return lifecycle;
      setCollectionLifecycleState(
        "__coveoCollectionDistancePoolLoading",
        !!(
          activeMode === "productListing" && getActiveCoveoLocationContext()
        ),
      );

      let renderCount = 0;
      const doRender = createAsyncCoveoRender(() => {
        if (!isCurrentCollectionLifecycle()) return;
        if (window.__coveoCollectionScopePrefetchLoading) return;
        renderCount += 1;
        render(controller, container, mod, subControllers);
      });
      requestCollectionRender = doRender;
      Object.values(controllerBundles).forEach(function (bundle) {
        if (!bundle?.controller) return;
        lifecycle.subscribe(bundle.controller, doRender);
        lifecycle.subscribe(bundle.subControllers?.paginationCtrl, doRender);
        lifecycle.subscribe(bundle.subControllers?.summaryCtrl, doRender);
        lifecycle.subscribe(bundle.subControllers?.facetGen, doRender);
        lifecycle.subscribe(bundle.subControllers?.sortCtrl, doRender);
      });
      // Coveo Delivery Assurance fix: subscribe to engine itself so the UI
      // always reflects the latest engine.state (filters/results don't get
      // "stuck" on stale selections after a search returns).
      lifecycle.subscribe(engine, doRender);

      container._coveoEngine = engine;
      lifecycle.claim(window, "__coveoGetCollectionCountDebug", function () {
        return container._coveoGetCollectionCountDebug
          ? container._coveoGetCollectionCountDebug()
          : null;
      });
      lifecycle.claim(window, "__coveoLogCollectionCounts", function () {
        const info = window.__coveoGetCollectionCountDebug?.();
        if (!info) {
          console.warn("[Coveo Collection Debug] Collection debug info unavailable.");
          return null;
        }
        console.info(
          "[Coveo Collection Debug]",
          `${info.collectionHandle || "collection"} | Shopify: ${
            info.shopifyCount ?? "n/a"
          } | Coveo: ${info.coveoCount ?? "n/a"} | mode: ${info.mode || "n/a"}${
            info.query ? ` | query: ${info.query}` : ""
          }`,
          info,
        );
        return info;
      });
      wireActiveFiltersStrip(container, lifecycle);
      wireFiltersDrawer(
        controller,
        subControllers,
        engine,
        mod,
        container,
        lifecycle,
      );
      wireSortDropdown(controller, subControllers, engine, mod, lifecycle);
      try {
        const initialSortValue = String(
          window.__coveoActiveSortValue?.() || "",
        ).trim();
        let initialSortCriterion = buildHeadlessCommerceSortCriterion(
          window.__coveoActiveSortPayload?.(),
          mod,
        );
        if (initialSortValue === "nearest") {
          await syncCoveoEngineLocationContext(engine, mod);
          if (activeMode === "productListing") {
            const paginationActions = mod.loadPaginationActions?.(engine);
            if (paginationActions?.setPageSize) {
              await engine.dispatch(
                paginationActions.setPageSize({
                  pageSize: COVEO_COLLECTION_CLIENT_DISTANCE_PAGE_SIZE,
                }),
              );
            }
            initialSortCriterion =
              typeof mod.buildRelevanceSortCriterion === "function"
                ? mod.buildRelevanceSortCriterion()
                : { by: mod?.SortBy?.Relevance || "relevance" };
          }
        }
        if (initialSortCriterion && mod.loadSortActions) {
          const sortActions = mod.loadSortActions(engine);
          if (sortActions?.applySort) {
            await engine.dispatch(sortActions.applySort(initialSortCriterion));
          }
        }
      } catch (e) {
        console.warn("[Coveo Collection] Initial sort sync failed:", e);
      }
      if (!isCurrentCollectionLifecycle()) return lifecycle;
      doRender();

      // Swap `btn--primary` <-> `btn--secondary` for collection search submit button.
      wireSearchSubmitButtonClassToggle(container, lifecycle);

      /*
       * Distance / nearest UX has its own DOM wiring step. Search pages already
       * run this, but collections previously skipped it, so the collection UI
       * rendered the controls without attaching ZIP / modal handlers.
       */
      lifecycle.setTimeout(() => {
        wireDistanceFilter(controller, engine, mod, lifecycle);
      }, 100);

      async function runFirstRequest() {
        if (!isCurrentCollectionLifecycle()) return;
        if (
          activeMode === "productListing" &&
          typeof controller.executeFirstRequest === "function"
        ) {
          await Promise.resolve(controller.executeFirstRequest()).catch(
            function (e) {
              console.error("[Coveo Collection] executeFirstRequest error:", e);
            },
          );
          return;
        }
        if (typeof controller.executeFirstSearch === "function") {
          await Promise.resolve(controller.executeFirstSearch()).catch(
            function (e) {
              console.error("[Coveo Collection] executeFirstSearch error:", e);
            },
          );
          return;
        }
        if (mod.loadSearchActions && engine) {
          try {
            const searchActions = mod.loadSearchActions(engine);
            if (searchActions && searchActions.executeSearch) {
              await engine.dispatch(searchActions.executeSearch());
            }
          } catch (e) {
            console.error(
              "[Coveo Collection] dispatch executeSearch error:",
              e,
            );
          }
        }
      }
      await runFirstRequest();
      if (!isCurrentCollectionLifecycle()) return lifecycle;
      await ensureCollectionDistanceProductPool();
      if (!isCurrentCollectionLifecycle()) return lifecycle;
      wireCoveoHeadlessProductClickAnalytics(lifecycle);
      if (controllerBundles.search?.controller) {
        wireCollectionToolbarSearch(
          engine,
          mod,
          collectionHandle,
          controllerBundles.search.controller,
          lifecycle,
        );
      }
      return lifecycle;
      } catch (err) {
        lifecycle.destroy();
        console.error("[Coveo Collection] Collection page init error:", err);
        throw err;
      }
    });
  };

  function syncCoveoFiltersDrawerViewport() {
    setFiltersDrawerMode();
    var drawer = document.getElementById("CoveoFiltersDrawer");
    if (!drawer) return;
    var isMobile = window.matchMedia("(max-width: 767.98px)").matches;
    if (!isMobile) {
      document.documentElement.classList.remove("coveo-filters-scroll-lock");
      document.body.classList.remove("coveo-filters-scroll-lock");
    }
  }

  setFiltersDrawerMode();
  window.addEventListener("resize", syncCoveoFiltersDrawerViewport);
})();
